webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , core      = __webpack_require__(25)
	  , hide      = __webpack_require__(13)
	  , redefine  = __webpack_require__(14)
	  , ctx       = __webpack_require__(26)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(61)('wks')
	  , uid        = __webpack_require__(40)
	  , Symbol     = __webpack_require__(3).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(4)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(2)
	  , IE8_DOM_DEFINE = __webpack_require__(97)
	  , toPrimitive    = __webpack_require__(24)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(31)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(20);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8)
	  , createDesc = __webpack_require__(30);
	module.exports = __webpack_require__(7) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , hide      = __webpack_require__(13)
	  , has       = __webpack_require__(11)
	  , SRC       = __webpack_require__(40)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(25).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(4)
	  , defined = __webpack_require__(20)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(50)
	  , defined = __webpack_require__(20);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(51)
	  , createDesc     = __webpack_require__(30)
	  , toIObject      = __webpack_require__(16)
	  , toPrimitive    = __webpack_require__(24)
	  , has            = __webpack_require__(11)
	  , IE8_DOM_DEFINE = __webpack_require__(97)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(11)
	  , toObject    = __webpack_require__(10)
	  , IE_PROTO    = __webpack_require__(78)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(4);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(26)
	  , IObject  = __webpack_require__(50)
	  , toObject = __webpack_require__(10)
	  , toLength = __webpack_require__(9)
	  , asc      = __webpack_require__(128);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1)
	  , core    = __webpack_require__(25)
	  , fails   = __webpack_require__(4);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(5);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(12);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(113)
	  , $export = __webpack_require__(1)
	  , shared  = __webpack_require__(61)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(116)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(7)){
	  var LIBRARY             = __webpack_require__(33)
	    , global              = __webpack_require__(3)
	    , fails               = __webpack_require__(4)
	    , $export             = __webpack_require__(1)
	    , $typed              = __webpack_require__(62)
	    , $buffer             = __webpack_require__(85)
	    , ctx                 = __webpack_require__(26)
	    , anInstance          = __webpack_require__(32)
	    , propertyDesc        = __webpack_require__(30)
	    , hide                = __webpack_require__(13)
	    , redefineAll         = __webpack_require__(37)
	    , toInteger           = __webpack_require__(31)
	    , toLength            = __webpack_require__(9)
	    , toIndex             = __webpack_require__(39)
	    , toPrimitive         = __webpack_require__(24)
	    , has                 = __webpack_require__(11)
	    , same                = __webpack_require__(110)
	    , classof             = __webpack_require__(49)
	    , isObject            = __webpack_require__(5)
	    , toObject            = __webpack_require__(10)
	    , isArrayIter         = __webpack_require__(70)
	    , create              = __webpack_require__(34)
	    , getPrototypeOf      = __webpack_require__(18)
	    , gOPN                = __webpack_require__(35).f
	    , getIterFn           = __webpack_require__(87)
	    , uid                 = __webpack_require__(40)
	    , wks                 = __webpack_require__(6)
	    , createArrayMethod   = __webpack_require__(22)
	    , createArrayIncludes = __webpack_require__(52)
	    , speciesConstructor  = __webpack_require__(79)
	    , ArrayIterators      = __webpack_require__(88)
	    , Iterators           = __webpack_require__(43)
	    , $iterDetect         = __webpack_require__(58)
	    , setSpecies          = __webpack_require__(38)
	    , arrayFill           = __webpack_require__(63)
	    , arrayCopyWithin     = __webpack_require__(90)
	    , $DP                 = __webpack_require__(8)
	    , $GOPD               = __webpack_require__(17)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(40)('meta')
	  , isObject = __webpack_require__(5)
	  , has      = __webpack_require__(11)
	  , setDesc  = __webpack_require__(8).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(4)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = false;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(2)
	  , dPs         = __webpack_require__(103)
	  , enumBugKeys = __webpack_require__(66)
	  , IE_PROTO    = __webpack_require__(78)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(65)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(68).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(105)
	  , hiddenKeys = __webpack_require__(66).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(105)
	  , enumBugKeys = __webpack_require__(66);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(14);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(3)
	  , dP          = __webpack_require__(8)
	  , DESCRIPTORS = __webpack_require__(7)
	  , SPECIES     = __webpack_require__(6)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(6)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(26)
	  , call        = __webpack_require__(99)
	  , isArrayIter = __webpack_require__(70)
	  , anObject    = __webpack_require__(2)
	  , toLength    = __webpack_require__(9)
	  , getIterFn   = __webpack_require__(87)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = {};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(8).f
	  , has = __webpack_require__(11)
	  , TAG = __webpack_require__(6)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , defined = __webpack_require__(20)
	  , fails   = __webpack_require__(4)
	  , spaces  = __webpack_require__(83)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(19)
	  , TAG = __webpack_require__(6)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(19);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(16)
	  , toLength  = __webpack_require__(9)
	  , toIndex   = __webpack_require__(39);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(3)
	  , $export           = __webpack_require__(1)
	  , redefine          = __webpack_require__(14)
	  , redefineAll       = __webpack_require__(37)
	  , meta              = __webpack_require__(29)
	  , forOf             = __webpack_require__(42)
	  , anInstance        = __webpack_require__(32)
	  , isObject          = __webpack_require__(5)
	  , fails             = __webpack_require__(4)
	  , $iterDetect       = __webpack_require__(58)
	  , setToStringTag    = __webpack_require__(44)
	  , inheritIfRequired = __webpack_require__(69);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(13)
	  , redefine = __webpack_require__(14)
	  , fails    = __webpack_require__(4)
	  , defined  = __webpack_require__(20)
	  , wks      = __webpack_require__(6);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(2);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(5)
	  , cof      = __webpack_require__(19)
	  , MATCH    = __webpack_require__(6)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(6)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(33)|| !__webpack_require__(4)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(3)[K];
	});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3)
	  , hide   = __webpack_require__(13)
	  , uid    = __webpack_require__(40)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(10)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(9);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(8)
	  , createDesc      = __webpack_require__(30);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5)
	  , document = __webpack_require__(3).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(6)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3).document && document.documentElement;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(5)
	  , setPrototypeOf = __webpack_require__(77).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(43)
	  , ITERATOR   = __webpack_require__(6)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(19);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(34)
	  , descriptor     = __webpack_require__(30)
	  , setToStringTag = __webpack_require__(44)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(13)(IteratorPrototype, __webpack_require__(6)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(33)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(14)
	  , hide           = __webpack_require__(13)
	  , has            = __webpack_require__(11)
	  , Iterators      = __webpack_require__(43)
	  , $iterCreate    = __webpack_require__(72)
	  , setToStringTag = __webpack_require__(44)
	  , getPrototypeOf = __webpack_require__(18)
	  , ITERATOR       = __webpack_require__(6)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ }),
/* 75 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(3)
	  , macrotask = __webpack_require__(84).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(19)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(5)
	  , anObject = __webpack_require__(2);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(26)(Function.call, __webpack_require__(17).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(61)('keys')
	  , uid    = __webpack_require__(40);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(2)
	  , aFunction = __webpack_require__(12)
	  , SPECIES   = __webpack_require__(6)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31)
	  , defined   = __webpack_require__(20);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(57)
	  , defined  = __webpack_require__(20);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(31)
	  , defined   = __webpack_require__(20);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(26)
	  , invoke             = __webpack_require__(56)
	  , html               = __webpack_require__(68)
	  , cel                = __webpack_require__(65)
	  , global             = __webpack_require__(3)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(19)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(3)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , LIBRARY        = __webpack_require__(33)
	  , $typed         = __webpack_require__(62)
	  , hide           = __webpack_require__(13)
	  , redefineAll    = __webpack_require__(37)
	  , fails          = __webpack_require__(4)
	  , anInstance     = __webpack_require__(32)
	  , toInteger      = __webpack_require__(31)
	  , toLength       = __webpack_require__(9)
	  , gOPN           = __webpack_require__(35).f
	  , dP             = __webpack_require__(8).f
	  , arrayFill      = __webpack_require__(63)
	  , setToStringTag = __webpack_require__(44)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(3)
	  , core           = __webpack_require__(25)
	  , LIBRARY        = __webpack_require__(33)
	  , wksExt         = __webpack_require__(112)
	  , defineProperty = __webpack_require__(8).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(49)
	  , ITERATOR  = __webpack_require__(6)('iterator')
	  , Iterators = __webpack_require__(43);
	module.exports = __webpack_require__(25).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(41)
	  , step             = __webpack_require__(100)
	  , Iterators        = __webpack_require__(43)
	  , toIObject        = __webpack_require__(16);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(73)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(19);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(10)
	  , toIndex  = __webpack_require__(39)
	  , toLength = __webpack_require__(9);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(42);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(12)
	  , toObject  = __webpack_require__(10)
	  , IObject   = __webpack_require__(50)
	  , toLength  = __webpack_require__(9);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(12)
	  , isObject   = __webpack_require__(5)
	  , invoke     = __webpack_require__(56)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(8).f
	  , create      = __webpack_require__(34)
	  , redefineAll = __webpack_require__(37)
	  , ctx         = __webpack_require__(26)
	  , anInstance  = __webpack_require__(32)
	  , defined     = __webpack_require__(20)
	  , forOf       = __webpack_require__(42)
	  , $iterDefine = __webpack_require__(73)
	  , step        = __webpack_require__(100)
	  , setSpecies  = __webpack_require__(38)
	  , DESCRIPTORS = __webpack_require__(7)
	  , fastKey     = __webpack_require__(29).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(49)
	  , from    = __webpack_require__(91);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(37)
	  , getWeak           = __webpack_require__(29).getWeak
	  , anObject          = __webpack_require__(2)
	  , isObject          = __webpack_require__(5)
	  , anInstance        = __webpack_require__(32)
	  , forOf             = __webpack_require__(42)
	  , createArrayMethod = __webpack_require__(22)
	  , $has              = __webpack_require__(11)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(7) && !__webpack_require__(4)(function(){
	  return Object.defineProperty(__webpack_require__(65)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(5)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(2);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(36)
	  , gOPS     = __webpack_require__(60)
	  , pIE      = __webpack_require__(51)
	  , toObject = __webpack_require__(10)
	  , IObject  = __webpack_require__(50)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(4)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(8)
	  , anObject = __webpack_require__(2)
	  , getKeys  = __webpack_require__(36);
	
	module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(16)
	  , gOPN      = __webpack_require__(35).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(11)
	  , toIObject    = __webpack_require__(16)
	  , arrayIndexOf = __webpack_require__(52)(false)
	  , IE_PROTO     = __webpack_require__(78)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(36)
	  , toIObject = __webpack_require__(16)
	  , isEnum    = __webpack_require__(51).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(35)
	  , gOPS     = __webpack_require__(60)
	  , anObject = __webpack_require__(2)
	  , Reflect  = __webpack_require__(3).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(3).parseFloat
	  , $trim       = __webpack_require__(45).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(83) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(3).parseInt
	  , $trim     = __webpack_require__(45).trim
	  , ws        = __webpack_require__(83)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(9)
	  , repeat   = __webpack_require__(82)
	  , defined  = __webpack_require__(20);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(6);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(94);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(53)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(7) && /./g.flags != 'g')__webpack_require__(8).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(55)
	});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(94);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(53)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(22)(0)
	  , redefine     = __webpack_require__(14)
	  , meta         = __webpack_require__(29)
	  , assign       = __webpack_require__(102)
	  , weak         = __webpack_require__(96)
	  , isObject     = __webpack_require__(5)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(53)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(306);
	
	__webpack_require__(307);
	
	__webpack_require__(126);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(135);
	module.exports = __webpack_require__(25).RegExp.escape;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(5)
	  , isArray  = __webpack_require__(71)
	  , SPECIES  = __webpack_require__(6)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(127);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(2)
	  , toPrimitive = __webpack_require__(24)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(36)
	  , gOPS    = __webpack_require__(60)
	  , pIE     = __webpack_require__(51);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(36)
	  , toIObject = __webpack_require__(16);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(133)
	  , invoke    = __webpack_require__(56)
	  , aFunction = __webpack_require__(12);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3);

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1)
	  , $re     = __webpack_require__(134)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(90)});
	
	__webpack_require__(41)('copyWithin');

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $every  = __webpack_require__(22)(4);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', {fill: __webpack_require__(63)});
	
	__webpack_require__(41)('fill');

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $filter = __webpack_require__(22)(2);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(22)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(41)(KEY);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1)
	  , $find   = __webpack_require__(22)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(41)(KEY);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(1)
	  , $forEach = __webpack_require__(22)(0)
	  , STRICT   = __webpack_require__(21)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(26)
	  , $export        = __webpack_require__(1)
	  , toObject       = __webpack_require__(10)
	  , call           = __webpack_require__(99)
	  , isArrayIter    = __webpack_require__(70)
	  , toLength       = __webpack_require__(9)
	  , createProperty = __webpack_require__(64)
	  , getIterFn      = __webpack_require__(87);
	
	$export($export.S + $export.F * !__webpack_require__(58)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , $indexOf      = __webpack_require__(52)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(71)});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(16)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(50) != Object || !__webpack_require__(21)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(1)
	  , toIObject     = __webpack_require__(16)
	  , toInteger     = __webpack_require__(31)
	  , toLength      = __webpack_require__(9)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(21)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $map    = __webpack_require__(22)(1);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(1)
	  , createProperty = __webpack_require__(64);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(92);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $reduce = __webpack_require__(92);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(1)
	  , html       = __webpack_require__(68)
	  , cof        = __webpack_require__(19)
	  , toIndex    = __webpack_require__(39)
	  , toLength   = __webpack_require__(9)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(4)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $some   = __webpack_require__(22)(3);
	
	$export($export.P + $export.F * !__webpack_require__(21)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(12)
	  , toObject  = __webpack_require__(10)
	  , fails     = __webpack_require__(4)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(21)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(38)('Array');

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1)
	  , fails   = __webpack_require__(4)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(1)
	  , toObject    = __webpack_require__(10)
	  , toPrimitive = __webpack_require__(24);
	
	$export($export.P + $export.F * __webpack_require__(4)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(6)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(13)(proto, TO_PRIMITIVE, __webpack_require__(129));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(14)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', {bind: __webpack_require__(93)});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(5)
	  , getPrototypeOf = __webpack_require__(18)
	  , HAS_INSTANCE   = __webpack_require__(6)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(8).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(8).f
	  , createDesc = __webpack_require__(30)
	  , has        = __webpack_require__(11)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1)
	  , log1p   = __webpack_require__(101)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1)
	  , sign    = __webpack_require__(75);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1)
	  , $expm1  = __webpack_require__(74);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(1)
	  , sign      = __webpack_require__(75)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(101)});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {sign: __webpack_require__(75)});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(74)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1)
	  , expm1   = __webpack_require__(74)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(3)
	  , has               = __webpack_require__(11)
	  , cof               = __webpack_require__(19)
	  , inheritIfRequired = __webpack_require__(69)
	  , toPrimitive       = __webpack_require__(24)
	  , fails             = __webpack_require__(4)
	  , gOPN              = __webpack_require__(35).f
	  , gOPD              = __webpack_require__(17).f
	  , dP                = __webpack_require__(8).f
	  , $trim             = __webpack_require__(45).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(34)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(7) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(14)(global, NUMBER, $Number);
	}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(1)
	  , _isFinite = __webpack_require__(3).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(98)});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(1)
	  , isInteger = __webpack_require__(98)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(108);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(109);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , toInteger    = __webpack_require__(31)
	  , aNumberValue = __webpack_require__(89)
	  , repeat       = __webpack_require__(82)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(4)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $fails       = __webpack_require__(4)
	  , aNumberValue = __webpack_require__(89)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(102)});

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(34)});

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperties: __webpack_require__(103)});

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperty: __webpack_require__(8).f});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(29).onFreeze;
	
	__webpack_require__(23)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(16)
	  , $getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	__webpack_require__(23)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(23)('getOwnPropertyNames', function(){
	  return __webpack_require__(104).f;
	});

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(10)
	  , $getPrototypeOf = __webpack_require__(18);
	
	__webpack_require__(23)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(23)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(23)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(5);
	
	__webpack_require__(23)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {is: __webpack_require__(110)});

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(10)
	  , $keys    = __webpack_require__(36);
	
	__webpack_require__(23)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(29).onFreeze;
	
	__webpack_require__(23)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(5)
	  , meta     = __webpack_require__(29).onFreeze;
	
	__webpack_require__(23)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(77).set});

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(49)
	  , test    = {};
	test[__webpack_require__(6)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(14)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(1)
	  , $parseFloat = __webpack_require__(108);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , $parseInt = __webpack_require__(109);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(33)
	  , global             = __webpack_require__(3)
	  , ctx                = __webpack_require__(26)
	  , classof            = __webpack_require__(49)
	  , $export            = __webpack_require__(1)
	  , isObject           = __webpack_require__(5)
	  , aFunction          = __webpack_require__(12)
	  , anInstance         = __webpack_require__(32)
	  , forOf              = __webpack_require__(42)
	  , speciesConstructor = __webpack_require__(79)
	  , task               = __webpack_require__(84).set
	  , microtask          = __webpack_require__(76)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(6)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(37)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(44)($Promise, PROMISE);
	__webpack_require__(38)(PROMISE);
	Wrapper = __webpack_require__(25)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(58)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(1)
	  , aFunction = __webpack_require__(12)
	  , anObject  = __webpack_require__(2)
	  , rApply    = (__webpack_require__(3).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(4)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(1)
	  , create     = __webpack_require__(34)
	  , aFunction  = __webpack_require__(12)
	  , anObject   = __webpack_require__(2)
	  , isObject   = __webpack_require__(5)
	  , fails      = __webpack_require__(4)
	  , bind       = __webpack_require__(93)
	  , rConstruct = (__webpack_require__(3).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(8)
	  , $export     = __webpack_require__(1)
	  , anObject    = __webpack_require__(2)
	  , toPrimitive = __webpack_require__(24);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(4)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(1)
	  , gOPD     = __webpack_require__(17).f
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(2);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(72)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(17)
	  , $export  = __webpack_require__(1)
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(1)
	  , getProto = __webpack_require__(18)
	  , anObject = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(17)
	  , getPrototypeOf = __webpack_require__(18)
	  , has            = __webpack_require__(11)
	  , $export        = __webpack_require__(1)
	  , isObject       = __webpack_require__(5)
	  , anObject       = __webpack_require__(2);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(1)
	  , anObject      = __webpack_require__(2)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(107)});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(1)
	  , anObject           = __webpack_require__(2)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(1)
	  , setProto = __webpack_require__(77);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(8)
	  , gOPD           = __webpack_require__(17)
	  , getPrototypeOf = __webpack_require__(18)
	  , has            = __webpack_require__(11)
	  , $export        = __webpack_require__(1)
	  , createDesc     = __webpack_require__(30)
	  , anObject       = __webpack_require__(2)
	  , isObject       = __webpack_require__(5);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(3)
	  , inheritIfRequired = __webpack_require__(69)
	  , dP                = __webpack_require__(8).f
	  , gOPN              = __webpack_require__(35).f
	  , isRegExp          = __webpack_require__(57)
	  , $flags            = __webpack_require__(55)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(4)(function(){
	  re2[__webpack_require__(6)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(14)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(38)('RegExp');

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(54)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(54)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(54)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(54)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(57)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(114);
	var anObject    = __webpack_require__(2)
	  , $flags      = __webpack_require__(55)
	  , DESCRIPTORS = __webpack_require__(7)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(14)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(4)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(15)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(15)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(15)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(15)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(80)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(1)
	  , toLength  = __webpack_require__(9)
	  , context   = __webpack_require__(81)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(67)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(15)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(15)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(15)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(1)
	  , toIndex        = __webpack_require__(39)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(1)
	  , context  = __webpack_require__(81)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(67)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(15)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(80)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(73)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(15)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(1)
	  , toIObject = __webpack_require__(16)
	  , toLength  = __webpack_require__(9);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(82)
	});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(15)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(1)
	  , toLength    = __webpack_require__(9)
	  , context     = __webpack_require__(81)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(67)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(15)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(15)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(15)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(45)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(3)
	  , has            = __webpack_require__(11)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , $export        = __webpack_require__(1)
	  , redefine       = __webpack_require__(14)
	  , META           = __webpack_require__(29).KEY
	  , $fails         = __webpack_require__(4)
	  , shared         = __webpack_require__(61)
	  , setToStringTag = __webpack_require__(44)
	  , uid            = __webpack_require__(40)
	  , wks            = __webpack_require__(6)
	  , wksExt         = __webpack_require__(112)
	  , wksDefine      = __webpack_require__(86)
	  , keyOf          = __webpack_require__(131)
	  , enumKeys       = __webpack_require__(130)
	  , isArray        = __webpack_require__(71)
	  , anObject       = __webpack_require__(2)
	  , toIObject      = __webpack_require__(16)
	  , toPrimitive    = __webpack_require__(24)
	  , createDesc     = __webpack_require__(30)
	  , _create        = __webpack_require__(34)
	  , gOPNExt        = __webpack_require__(104)
	  , $GOPD          = __webpack_require__(17)
	  , $DP            = __webpack_require__(8)
	  , $keys          = __webpack_require__(36)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(35).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(51).f  = $propertyIsEnumerable;
	  __webpack_require__(60).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(33)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(13)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(1)
	  , $typed       = __webpack_require__(62)
	  , buffer       = __webpack_require__(85)
	  , anObject     = __webpack_require__(2)
	  , toIndex      = __webpack_require__(39)
	  , toLength     = __webpack_require__(9)
	  , isObject     = __webpack_require__(5)
	  , ArrayBuffer  = __webpack_require__(3).ArrayBuffer
	  , speciesConstructor = __webpack_require__(79)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(4)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(38)(ARRAY_BUFFER);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(62).ABV, {
	  DataView: __webpack_require__(85).DataView
	});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(28)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(96);
	
	// 23.4 WeakSet Objects
	__webpack_require__(53)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(1)
	  , $includes = __webpack_require__(52)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(41)('includes');

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(1)
	  , microtask = __webpack_require__(76)()
	  , process   = __webpack_require__(3).process
	  , isNode    = __webpack_require__(19)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1)
	  , cof     = __webpack_require__(19);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(95)('Map')});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(10)
	  , aFunction       = __webpack_require__(12)
	  , $defineProperty = __webpack_require__(8);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(59), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(1)
	  , toObject        = __webpack_require__(10)
	  , aFunction       = __webpack_require__(12)
	  , $defineProperty = __webpack_require__(8);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(59), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(1)
	  , $entries = __webpack_require__(106)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(1)
	  , ownKeys        = __webpack_require__(107)
	  , toIObject      = __webpack_require__(16)
	  , gOPD           = __webpack_require__(17)
	  , createProperty = __webpack_require__(64);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(10)
	  , toPrimitive              = __webpack_require__(24)
	  , getPrototypeOf           = __webpack_require__(18)
	  , getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(59), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(1)
	  , toObject                 = __webpack_require__(10)
	  , toPrimitive              = __webpack_require__(24)
	  , getPrototypeOf           = __webpack_require__(18)
	  , getOwnPropertyDescriptor = __webpack_require__(17).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(59), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1)
	  , $values = __webpack_require__(106)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(1)
	  , global      = __webpack_require__(3)
	  , core        = __webpack_require__(25)
	  , microtask   = __webpack_require__(76)()
	  , OBSERVABLE  = __webpack_require__(6)('observable')
	  , aFunction   = __webpack_require__(12)
	  , anObject    = __webpack_require__(2)
	  , anInstance  = __webpack_require__(32)
	  , redefineAll = __webpack_require__(37)
	  , hide        = __webpack_require__(13)
	  , forOf       = __webpack_require__(42)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(38)('Observable');

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(27)
	  , anObject                  = __webpack_require__(2)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(27)
	  , anObject               = __webpack_require__(2)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(115)
	  , from                    = __webpack_require__(91)
	  , metadata                = __webpack_require__(27)
	  , anObject                = __webpack_require__(2)
	  , getPrototypeOf          = __webpack_require__(18)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(27)
	  , anObject               = __webpack_require__(2)
	  , getPrototypeOf         = __webpack_require__(18)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(27)
	  , anObject                = __webpack_require__(2)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(27)
	  , anObject               = __webpack_require__(2)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(27)
	  , anObject               = __webpack_require__(2)
	  , getPrototypeOf         = __webpack_require__(18)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(27)
	  , anObject               = __webpack_require__(2)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(27)
	  , anObject                  = __webpack_require__(2)
	  , aFunction                 = __webpack_require__(12)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(95)('Set')});

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1)
	  , $at     = __webpack_require__(80)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(1)
	  , defined     = __webpack_require__(20)
	  , toLength    = __webpack_require__(9)
	  , isRegExp    = __webpack_require__(57)
	  , getFlags    = __webpack_require__(55)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(72)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(111);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1)
	  , $pad    = __webpack_require__(111);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(45)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(45)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(86)('asyncIterator');

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(86)('observable');

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', {global: __webpack_require__(3)});

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(88)
	  , redefine      = __webpack_require__(14)
	  , global        = __webpack_require__(3)
	  , hide          = __webpack_require__(13)
	  , Iterators     = __webpack_require__(43)
	  , wks           = __webpack_require__(6)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1)
	  , $task   = __webpack_require__(84);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(3)
	  , $export    = __webpack_require__(1)
	  , invoke     = __webpack_require__(56)
	  , partial    = __webpack_require__(132)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(255);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(195);
	__webpack_require__(198);
	__webpack_require__(200);
	__webpack_require__(205);
	__webpack_require__(199);
	__webpack_require__(197);
	__webpack_require__(207);
	__webpack_require__(206);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(201);
	__webpack_require__(193);
	__webpack_require__(204);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(161);
	__webpack_require__(163);
	__webpack_require__(162);
	__webpack_require__(211);
	__webpack_require__(210);
	__webpack_require__(181);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(190);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(166);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(242);
	__webpack_require__(247);
	__webpack_require__(254);
	__webpack_require__(245);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(243);
	__webpack_require__(248);
	__webpack_require__(250);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(244);
	__webpack_require__(246);
	__webpack_require__(249);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(156);
	__webpack_require__(158);
	__webpack_require__(157);
	__webpack_require__(160);
	__webpack_require__(159);
	__webpack_require__(145);
	__webpack_require__(143);
	__webpack_require__(149);
	__webpack_require__(146);
	__webpack_require__(152);
	__webpack_require__(154);
	__webpack_require__(142);
	__webpack_require__(148);
	__webpack_require__(139);
	__webpack_require__(153);
	__webpack_require__(137);
	__webpack_require__(151);
	__webpack_require__(150);
	__webpack_require__(144);
	__webpack_require__(147);
	__webpack_require__(136);
	__webpack_require__(138);
	__webpack_require__(141);
	__webpack_require__(140);
	__webpack_require__(155);
	__webpack_require__(88);
	__webpack_require__(227);
	__webpack_require__(232);
	__webpack_require__(114);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(212);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(267);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(262);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(260);
	__webpack_require__(263);
	__webpack_require__(261);
	__webpack_require__(264);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(213);
	__webpack_require__(214);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(220);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(226);
	__webpack_require__(225);
	__webpack_require__(268);
	__webpack_require__(294);
	__webpack_require__(297);
	__webpack_require__(296);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(295);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(279);
	__webpack_require__(282);
	__webpack_require__(278);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(271);
	__webpack_require__(293);
	__webpack_require__(302);
	__webpack_require__(270);
	__webpack_require__(272);
	__webpack_require__(274);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(287);
	__webpack_require__(286);
	__webpack_require__(289);
	__webpack_require__(288);
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(269);
	__webpack_require__(283);
	__webpack_require__(305);
	__webpack_require__(304);
	__webpack_require__(303);
	module.exports = __webpack_require__(25);

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Framework7 Vue 0.8.5
	 * Build full featured iOS & Android apps using Framework7 & Vue
	 * http://www.framework7.io/vue/
	 * 
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: March 2, 2017
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.Framework7Vue=t()}(this,function(){function e(e,t,o){if(!e.allowPageChange)return!1;var n=t.url,a=t.pageElement;if(n&&a||!n||"#"===n)return!0;var i=e.history.indexOf(n)>=0,r=e.pagesCache[n];return!(!i||!r)||o(n,e,t)}var t={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"statusbar-overlay"})},staticRenderFns:[]},o={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"panel",class:e.classesObject,on:{"panel:open":e.onOpen,"panel:opened":e.onOpened,"panel:close":e.onClose,"panel:closed":e.onClosed,"panel:overlay-click":e.onOverlayClick,"panel:swipe":e.onPanelSwipe}},[e._t("default")],2)},staticRenderFns:[],props:{side:String,effect:String,cover:Boolean,reveal:Boolean,left:Boolean,right:Boolean,theme:String,layout:String,opened:Boolean},computed:{classesObject:function(){var e=this,t=e.side||(e.left?"left":"right"),o=e.effect||(e.reveal?"reveal":"cover"),n={};return n["panel-"+t]=!0,n["panel-"+o]=!0,e.layout&&(n["layout-"+e.layout]=!0),e.theme&&(n["theme-"+e.theme]=!0),n.active=e.opened,n}},watch:{opened:function(e){var t=this;if(t.$f7){var o=t.side||(t.left?"left":"right");e?t.$f7.openPanel(o):t.$f7.closePanel(o)}}},mounted:function(){var e=this;e.opened&&(e.$el.style.display="block");var t=e.$$;if(t){var o=e.side||(e.left?"left":"right"),n=e.effect||(e.reveal?"reveal":"cover");e.opened&&t("body").addClass("with-panel-"+o+"-"+n)}},methods:{onOpen:function(e){this.$emit("panel:open",e)},onOpened:function(e){this.$emit("panel:opened",e)},onClose:function(e){this.$emit("panel:open",e)},onClosed:function(e){this.$emit("panel:closed",e)},onOverlayClick:function(e){this.$emit("panel:overlay-click",e)},onPanelSwipe:function(e){this.$emit("panel:swipe",e)},onF7Init:function(){var e=this.$$;e&&0===e(".panel-overlay").length&&e('<div class="panel-overlay"></div>').insertBefore(this.$el)},open:function(e){var t=this;if(t.$f7){var o=t.side||(t.left?"left":"right");t.$f7.openPanel(o,e)}},close:function(e){var t=this;t.$f7&&t.$f7.closePanel(e)}}},n={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"views",class:e.classObject},[e._t("default")],2)},staticRenderFns:[],props:{"navbar-fixed":Boolean,"navbar-through":Boolean,"toolbar-fixed":Boolean,"toolbar-through":Boolean,"tabbar-fixed":Boolean,"tabbar-through":Boolean,"tabbar-labels-fixed":Boolean,"tabbar-labels-through":Boolean,tabs:Boolean,theme:String,layout:String},computed:{classObject:function(){var e={tabs:this.tabs,"navbar-fixed":this.navbarFixed||this.navbarThrough&&this.$theme.material,"navbar-through":this.navbarThrough,"toolbar-fixed":this.toolbarFixed,"toolbar-through":this.toolbarThrough,"tabbar-fixed":this.tabbarFixed,"tabbar-through":this.tabbarThrough,"tabbar-labels-fixed":this.tabbarLabelsFixed,"tabbar-labels-through":this.tabbarLabelsThrough};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}}},a={render:function(e){var t,o,n,a,i=this;if(i.$slots.default)for(var r=0;r<i.$slots.default.length;r++){var s=i.$slots.default[r];s.tag&&s.tag.indexOf("navbar")>=0&&(t=!0),s.tag&&s.tag.indexOf("pages")>=0&&(o=!0)}return o||(n=e("f7-pages")),!t&&i.$theme.ios&&(i.dynamicNavbar||i.navbarThrough)&&(a=e("f7-navbar")),e("div",{class:i.classesObject,on:{"swipeback:move":i.onSwipeBackMove,"swipeback:beforechange":i.onSwipeBackBeforeChange,"swipeback:afterchange":i.onSwipeBackAfterChange,"swipeback:beforereset":i.onSwipeBackBeforeReset,"swipeback:afterreset":i.onSwipeBackAfterReset,"tab:show":i.onTabShow,"tab:hide":i.onTabHide}},[a,n,i.$slots.default])},beforeDestroy:function(){var e=this;e.f7View&&e.f7View.destroy&&e.f7View.destroy()},props:{main:Boolean,"navbar-fixed":Boolean,"navbar-through":Boolean,"toolbar-fixed":Boolean,"toolbar-through":Boolean,"tabbar-fixed":Boolean,"tabbar-through":Boolean,"tabbar-labels-fixed":Boolean,"tabbar-labels-through":Boolean,tab:Boolean,active:Boolean,"dynamic-navbar":Boolean,"dom-cache":Boolean,"links-view":[String,Object],"reload-pages":Boolean,"unique-history":Boolean,"unique-history-ignore-get-parameters":Boolean,"allow-duplicate-urls":Boolean,"swipe-back-page":Boolean,"swipe-back-page-animate-shadow":Boolean,"swipe-back-page-animate-opacity":Boolean,"swipe-back-page-active-area":Boolean,"swipe-back-page-threshold":Boolean,"animate-pages":Boolean,"preload-previous-page":Boolean,name:String,params:Object,url:String,init:{type:Boolean,default:!0},theme:String,layout:String},computed:{classesObject:function(){var e={view:!0,"view-main":this.main,active:this.active,tab:this.tab,"navbar-fixed":this.navbarFixed||this.navbarThrough&&this.$theme.material,"navbar-through":this.navbarThrough,"toolbar-fixed":this.toolbarFixed,"toolbar-through":this.toolbarThrough,"tabbar-fixed":this.tabbarFixed,"tabbar-through":this.tabbarThrough,"tabbar-labels-fixed":this.tabbarLabelsFixed,"tabbar-labels-through":this.tabbarLabesThrough};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{onF7Init:function(e){var t=this;if(t.init){var o=t.$options.propsData,n=t.params||{name:t.name,url:t.url,dynamicNavbar:o.dynamicNavbar,domCache:"undefined"==typeof o.domCache||o.domCache,linksView:o.linksView,reloadPages:o.reloadPages,uniqueHistory:o.uniqueHistory,uniqueHistoryIgnoreGetParameters:o.uniqueHistoryIgnoreGetParameters,allowDuplicateUrls:o.allowDuplicateUrls,swipeBackPage:o.swipeBackPage,swipeBackPageAnimateShadow:o.swipeBackPageAnimateShadow,swipeBackPageAnimateOpacity:o.swipeBackPageAnimateOpacity,swipeBackPageActiveArea:o.swipeBackPageActiveArea,swipeBackPageThreshold:o.swipeBackPageThreshold,animatePages:o.animatePages,preloadPreviousPage:o.preloadPreviousPage};t.f7View=e.addView(t.$el,n),t.f7View&&0===t.f7View.pagesContainer.querySelectorAll(".page").length&&t.f7View.router.load({url:t.url,reload:!0})}},onSwipeBackMove:function(e){this.$emit("swipeback:move",e,e.detail)},onSwipeBackBeforeChange:function(e){this.$emit("swipeback:beforechange",e,e.detail)},onSwipeBackAfterChange:function(e){this.$emit("swipeback:afterchange",e,e.detail)},onSwipeBackBeforeReset:function(e){this.$emit("swipeback:beforereset",e,e.detail)},onSwipeBackAfterReset:function(e){this.$emit("swipeback:afterreset",e,e.detail)},onTabShow:function(e){this.$emit("tab:show",e)},onTabHide:function(e){this.$emit("tab:hide",e)}}},i={render:function(e){var t=this,o=[];for(var n in t.pages){var a=t.pages[n];o.push(e(a.component,{tag:"component",props:t.$route.params,key:n}))}return e("div",{staticClass:"pages",ref:"pages",class:t.classesObject,on:{"page:beforeremove":t.onPageBeforeRemove}},[t.$slots.default,o])},props:{"navbar-fixed":Boolean,"navbar-through":Boolean,"toolbar-fixed":Boolean,"toolbar-through":Boolean,"tabbar-fixed":Boolean,"tabbar-through":Boolean,"tabbar-labels-fixed":Boolean,"tabbar-labels-through":Boolean,theme:String,layout:String},data:function(){return{pages:{}}},computed:{classesObject:function(){var e={"navbar-fixed":this.navbarFixed||this.navbarThrough&&this.$theme.material,"navbar-through":this.navbarThrough,"toolbar-fixed":this.toolbarFixed,"toolbar-through":this.toolbarThrough,"tabbar-fixed":this.tabbarFixed,"tabbar-through":this.tabbarThrough,"tabbar-labels-fixed":this.tabbarLabelsFixed,"tabbar-labels-through":this.tabbarLabesThrough};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{onPageBeforeRemove:function(e){var t,o=this;for(var n in o.pages)if(e.target===o.pages[n].pageElement){t=n;break}t&&this.$delete(this.pages,t)},onRouteChange:function(e){var t=this,o=e.route.component,n=e.view,a=t.$parent.f7View||t.$parent.$el.f7View;if(n===a){var i=t.$route.router.findMatchingRoute(n.url)||{route:{path:"/",pagePath:"/"}},r=i.route.pagePath!==e.route.pagePath,s=!r&&i.route.path!==e.route.path,l=r||!s&&(e.options.reload||n.params.allowDuplicateUrls);if(l){var c=(new Date).getTime();t.$set(t.pages,c,{component:o}),n.allowPageChange=!1,t.$nextTick(function(){var o=n.pagesContainer.querySelector(".page:last-child");t.pages[c].pageElement=o,n.allowPageChange=!0;var a=Object.assign(e.options,{pageElement:o});a.isBack?n.router.back(a):n.router.load(a)})}}}}},r={render:function(e){var t,o,n,a,i=[],r=[],s=this;s.pullToRefresh&&s.ptrLayer&&s.pullToRefreshLayer&&(n=e("div",{class:{"pull-to-refresh-layer":!0}},[e("div",{class:{preloader:!0}}),e("div",{class:{"pull-to-refresh-arrow":!0}})])),(s.infiniteScroll||""===s.infiniteScroll)&&s.infiniteScrollPreloader&&(a=e("div",{class:{"infinite-scroll-preloader":!0}},[e("div",{class:{preloader:!0}})]));var l,c,u,d,p,f,h,m="navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button".split(" ");if(s.$slots.default)for(f=0;f<s.$slots.default.length;f++)if(c=s.$slots.default[f],l=c.tag){var b=!1;for(l.indexOf("messages")>=0&&(d=!0),l.indexOf("subnavbar")>=0&&(u=!0),l.indexOf("searchbar")>=0&&(p=!0),h=0;h<m.length;h++)l.indexOf(m[h])>=0&&(b=!0);b?i.push(c):r.push(c)}else r.push(c);if(i.length>0&&p&&i.push(e("div",{class:{"searchbar-overlay":!0}})),d&&(s.classesObjectPageContent["messages-content"]=!0),s.noPageContent)if(o=[],s.$slots.default&&i.length>0)for(f=0;f<s.$slots.default.length;f++)i.indexOf(s.$slots.default[f])<0&&o.push(s.$slots.default[f]);else o=[s.$slots.default];else o=e("div",{staticClass:"page-content",class:s.classesObjectPageContent,attrs:{"data-ptr-distance":s.pullToRefreshDistance||s.ptrDistance,"data-distance":s.infiniteScrollDistance},on:{"ptr:pullstart":s.onPtrPullstart,"ptr:pullmove":s.onPtrPullmove,"ptr:pullend":s.onPtrPullend,"ptr:refresh":s.onPtrRefresh,"ptr:done":s.onPtrRefreshdone,infinite:s.onInfinite}},"top"===s.infiniteScroll?[n,a,s.$slots.static,r]:[n,s.$slots.static,r,a]);return i.push(s.$slots.fixed),u&&(s.classesObjectPage["with-subnavbar"]=!0),t=e("div",{staticClass:"page",class:s.classesObjectPage,attrs:{"data-page":s.name},on:{"page:beforeinit":s.onPageBeforeInit,"page:init":s.onPageInit,"page:reinit":s.onPageReinit,"page:beforeanimation":s.onPageBeforeAnimation,"page:afteranimation":s.onPageAfterAnimation,"page:beforeremove":s.onPageBeforeRemove,"page:back":s.onPageBack,"page:afterback":s.onPageAfterBack}},[i,o])},props:{name:String,cached:Boolean,"navbar-fixed":Boolean,"navbar-through":Boolean,"toolbar-fixed":Boolean,"toolbar-through":Boolean,"tabbar-fixed":Boolean,"tabbar-through":Boolean,"tabbar-labels-fixed":Boolean,"tabbar-labels-through":Boolean,"with-subnavbar":Boolean,subnavbar:Boolean,"no-navbar":Boolean,"no-toolbar":Boolean,"no-tabbar":Boolean,"pull-to-refresh":Boolean,"pull-to-refresh-distance":Number,"ptr-distance":Number,"pull-to-refresh-layer":{type:Boolean,default:!0},"ptr-layer":{type:Boolean,default:!0},"infinite-scroll":[Boolean,String],"infinite-scroll-distance":Number,"infinite-scroll-preloader":{type:Boolean,default:!0},"hide-bars-on-scroll":Boolean,"hide-navbar-on-scroll":Boolean,"hide-toolbar-on-scroll":Boolean,"hide-tabbar-on-scroll":Boolean,messages:Boolean,tabs:Boolean,"no-page-content":Boolean,"login-screen":Boolean,theme:String,layout:String,"no-swipeback":Boolean},computed:{classesObjectPage:function(){var e={cached:this.cached,"navbar-fixed":this.navbarFixed||this.navbarThrough&&this.$theme.material,"navbar-through":this.navbarThrough,"toolbar-fixed":this.toolbarFixed,"toolbar-through":this.toolbarThrough,"tabbar-fixed":this.tabbarFixed,"tabbar-through":this.tabbarThrough,"tabbar-labels-fixed":this.tabbarLabelsFixed,"tabbar-labels-through":this.tabbarLabelsThrough,"with-subnavbar":this.subnavbar||this.withSubnavbar,"no-navbar":this.noNavbar,"no-toolbar":this.noToolbar,"no-tabbar":this.noTabbar,tabs:this.tabs,"no-swipeback":this.noSwipeBack};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e},classesObjectPageContent:function(){return{"pull-to-refresh-content":this.pullToRefresh,"infinite-scroll":this.infiniteScroll||""===this.infiniteScroll,"infinite-scroll-top":"top"===this.infiniteScroll,"hide-bars-on-scroll":this.hideBarsOnScroll,"hide-navbar-on-scroll":this.hideNavbarOnScroll,"hide-toolbar-on-scroll":this.hideToolbarOnScroll,"hide-tabbar-on-scroll":this.hideTabbarOnScroll,"messages-content":this.messages,"login-screen-content":this.loginScreen}}},methods:{onPtrPullstart:function(e){this.$emit("ptr:pullstart",e)},onPtrPullmove:function(e){this.$emit("ptr:pullmove",e)},onPtrPullend:function(e){this.$emit("ptr:pullend",e)},onPtrRefresh:function(e){this.$emit("ptr:refresh",e,e.detail.done)},onPtrRefreshdone:function(e){this.$emit("ptr:done",e)},onInfinite:function(e){this.$emit("infinite",e)},onPageBeforeInit:function(e){this.f7PageData=e.detail.page,this.$emit("page:beforeinit",e,e.detail.page)},onPageInit:function(e){this.$emit("page:init",e,e.detail.page)},onPageReinit:function(e){this.$emit("page:reinit",e,e.detail.page)},onPageBeforeAnimation:function(e){this.$emit("page:beforeanimation",e,e.detail.page)},onPageAfterAnimation:function(e){this.$emit("page:afteranimation",e,e.detail.page)},onPageBeforeRemove:function(e){this.$emit("page:beforeremove",e,e.detail.page)},onPageBack:function(e){this.$emit("page:back",e,e.detail.page)},onPageAfterBack:function(e){this.$emit("page:afterback",e,e.detail.page)}}},s={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"page-content",class:e.classesObject,on:{"tab:show":e.onTabShow,"tab:hide":e.onTabHide}},[e._t("default")],2)},staticRenderFns:[],props:{tab:Boolean,active:Boolean},computed:{classesObject:function(){var e=this;return{tab:e.tab,active:e.active}}},methods:{onTabShow:function(e){this.$emit("tab:show",e)},onTabHide:function(e){this.$emit("tab:hide",e)}}},l={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"navbar",class:e.classesObject,on:{"navbar:beforeinit":e.onBeforeInit,"navbar:init":e.onInit,"navbar:reinit":e.onReinit,"navbar:beforeremove":e.onBeforeRemove}},[e._t("before-inner"),e._v(" "),o("div",{staticClass:"navbar-inner"},[e.backLink?o("f7-nav-left",{attrs:{"back-link":e.backLink,sliding:e.sliding,"back-link-href":e.backLinkUrl||e.backLinkHref},on:{"back-click":e.onBackClick}}):e._e(),e._v(" "),e.title?o("f7-nav-center",{attrs:{title:e.title,sliding:e.sliding}}):e._e(),e._v(" "),e._t("default")],2),e._v(" "),e._t("after-inner")],2)},staticRenderFns:[],updated:function(){var e=this;e.$nextTick(function(){e.$f7.sizeNavbars()})},props:{backLink:[Boolean,String],backLinkUrl:String,backLinkHref:String,sliding:Boolean,title:String,theme:String,layout:String,hidden:Boolean},computed:{classesObject:function(){var e={"navbar-hidden":this.hidden};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{hide:function(e){if(this.$f7)return this.$f7.hideNavbar(this.$el,e)},show:function(e){if(this.$f7)return this.$f7.showNavbar(this.$el,e)},size:function(){if(this.$f7&&!this.$theme.material)return this.$f7.sizeNavbars()},onBeforeInit:function(e){this.$emit("navbar:beforeinit",e)},onInit:function(e){this.$emit("navbar:init",e)},onReinit:function(e){this.$emit("navbar:reinit",e)},onBeforeRemove:function(e){this.$emit("navbar:beforeremove",e)},onBackClick:function(e){this.$emit("back-click",e),this.$emit("click:back",e)}}},c={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"center",class:{sliding:e.sliding}},[e._t("default",[e._v(e._s(e.title))])],2)},staticRenderFns:[],props:{sliding:Boolean,title:String}},u={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"left",class:{sliding:e.sliding}},[e.backLink?o("f7-link",{class:{"icon-only":e.backLink===!0||e.backLink&&e.$theme.material},attrs:{href:e.backLinkUrl||e.backLinkHref||"#",back:"",icon:"icon-back",text:e.backLink===!0||e.$theme.material?void 0:e.backLink},on:{click:e.onBackClick}}):e._e(),e._v(" "),e._t("default")],2)},staticRenderFns:[],props:{backLink:[Boolean,String],backLinkUrl:String,backLinkHref:String,sliding:Boolean},methods:{onBackClick:function(e){this.$emit("back-click",e),this.$emit("click:back",e)}}},d={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"right",class:{sliding:e.sliding}},[e._t("default")],2)},staticRenderFns:[],props:{sliding:Boolean}},p={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"subnavbar",class:!!e.sliding&&"sliding"},[e._t("default")],2)},staticRenderFns:[],props:{sliding:Boolean}},f={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"toolbar",class:e.classesObject},[e._t("before-inner"),e._v(" "),o("div",{staticClass:"toolbar-inner"},[e._t("default")],2),e._v(" "),e._t("after-inner")],2)},staticRenderFns:[],props:{bottom:Boolean,tabbar:Boolean,labels:Boolean,scrollable:Boolean,theme:String,layout:String,hidden:Boolean},computed:{classesObject:function(){var e={"toolbar-bottom":this.bottom,tabbar:this.tabbar,"tabbar-labels":this.labels,"tabbar-scrollable":this.scrollable,"toolbar-hidden":this.hidden};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{hide:function(e){if(this.$f7)return this.$f7.hideToolbar(this.$el,e)},show:function(e){if(this.$f7)return this.$f7.showToolbar(this.$el,e)}}},h={render:function(e){var t,o,n,a,i=this;return i.title&&(t=e("f7-card-header",{domProps:{innerHTML:i.title}})),i.content&&(n=e("div",{domProps:{innerHTML:i.content}}),o=e("f7-card-content",{props:{inner:i.inner}},[n])),i.footer&&(a=e("f7-card-footer",{domProps:{innerHTML:i.footer}})),e("div",{staticClass:"card"},[t,o,a,i.$slots.default])},props:{title:[String,Number],content:[String,Number],footer:[String,Number],inner:{type:Boolean,default:!0}}},m={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"card-header"},[e._t("default")],2)},staticRenderFns:[]},b={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"card-footer"},[e._t("default")],2)},staticRenderFns:[]},g={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"card-content"},[e.inner?o("div",{staticClass:"card-content-inner"},[e._t("default")],2):e._t("default")],2)},staticRenderFns:[],props:{inner:{type:Boolean,default:!0}}},v={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"content-block",class:e.classesObject,on:{"tab:show":e.onTabShow,"tab:hide":e.onTabHide}},[e.inner?o("div",{staticClass:"content-block-inner"},[e._t("default")],2):e._t("default")],2)},staticRenderFns:[],props:{inset:Boolean,"tablet-inset":Boolean,inner:Boolean,tabs:Boolean,tab:Boolean,active:Boolean,"no-hairlines":Boolean,"no-hairlines-between":Boolean},computed:{classesObject:function(){var e=this;return{inset:e.inset,"tablet-inset":e.tabletInset,tabs:e.tabs,tab:e.tab,active:e.active,"no-hairlines":e.noHairlines,"no-hairlines-between":e.noHairlinesBetween}}},methods:{onTabShow:function(e){this.$emit("tab:show",e)},onTabHide:function(e){this.$emit("tab:hide",e)}}},$={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"content-block-title"},[e._t("default")],2)},staticRenderFns:[]},k={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("span",{staticClass:"badge",class:e.color?"color-"+e.color:""},[e._t("default")],2)},staticRenderFns:[],props:{color:String}},S={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("i",{staticClass:"icon",class:e.classesObject,style:{"font-size":e.sizeComputed}},[e._v(e._s(e.iconTextComputed)),e._t("default")],2)},staticRenderFns:[],props:{color:String,material:String,f7:String,ion:String,fa:String,icon:String,"if-material":String,"if-ios":String,size:[String,Number]},computed:{sizeComputed:function(){var e=this,t=e.size;return"number"!=typeof t&&parseFloat(t)!==1*t||(t+="px"),t},iconTextComputed:function(){var e=this,t=e.material||e.f7;return e.ifMaterial&&e.$theme.material&&(e.ifMaterial.indexOf("material:")>=0||e.ifMaterial.indexOf("f7:")>=0)?t=e.ifMaterial.split(":")[1]:e.ifIos&&e.$theme.ios&&(e.ifIos.indexOf("material:")>=0||e.ifIos.indexOf("f7:")>=0)&&(t=e.ifIos.split(":")[1]),t},classesObject:function(){var e={},t=this;if(t.ifMaterial||t.ifIos){var o=t[t.$theme.material?"ifMaterial":"ifIos"].split(":"),n=o[0],a=o[1];"material"!==n&&"fa"!==n&&"f7"!==n||(e.fa="fa"===n,e["material-icons"]="material"===n,e["f7-icons"]="f7"===n),"fa"!==n&&"ion"!==n||(e[n+"-"+a]=!0),"icon"===n&&(e[a]=!0)}else e={"material-icons":this.material,"f7-icons":this.f7,fa:this.fa},this.ion&&(e["ion-"+this.ion]=!0),this.fa&&(e["fa-"+this.fa]=!0),this.icon&&(e[this.icon]=!0);return this.color&&(e["color-"+this.color]=!0),e}}},B={beforeDestroy:function(){var e=this;e.virtual&&e.virtualInit&&e.f7VirtualList&&e.f7VirtualList.destroy&&e.f7VirtualList.destroy()},watch:{virtualItems:function(){var e=this;e.virtual&&e.virtualInit&&e.f7VirtualList&&e.f7VirtualList.replaceAllItems(e.virtualItems)}},render:function(e){var t,o,n=this;o=n.grouped?n.$slots.default:e("ul",{},n.$slots.default);var a=[],i=[];if(n.$slots.default)for(var r=0;r<n.$slots.default.length;r++){var s=n.$slots.default[r].tag;s&&!("li"==s||s.indexOf("list-item")>=0||s.indexOf("list-button")>=0)?a.push(n.$slots.default[r]):i.push(n.$slots.default[r])}return t=e(n.form?"form":"div",{staticClass:"list-block",class:{inset:n.inset,"tablet-inset":n.tabletInset,"media-list":n.mediaList,sortable:n.sortable,"accordion-list":n.accordion,"contacts-block":n.contacts,"virtual-list":n.virtual,tab:n.tab,active:n.active,"no-hairlines":n.noHairlines,"no-hairlines-between":n.noHairlinesBetween,"store-data":n.storeData},on:{"sortable:open":n.onSortableOpen,"sortable:close":n.onSortableClose,"sortable:sort":n.onSortableSort,"tab:show":n.onTabShow,"tab:hide":n.onTabHide}},[i.length>0?[e("ul",{},i),a]:a])},props:{inset:Boolean,"tablet-inset":Boolean,"media-list":Boolean,grouped:Boolean,sortable:Boolean,label:String,accordion:Boolean,contacts:Boolean,"no-hairlines":Boolean,"no-hairlines-between":Boolean,tab:Boolean,active:Boolean,form:Boolean,"store-data":Boolean,virtual:Boolean,"virtual-init":{type:Boolean,default:!0},"virtual-items":[Array,Object],"virtual-height":[Number,Function],"virtual-rows-before":Number,"virtual-rows-after":Number,"virtual-cols":{type:Number,default:1},"virtual-cache":{type:Boolean,default:!0},"virtual-filtered-only":{type:Boolean,default:!1},"virtual-search-by-item":Function,"virtual-search-all":Function,"virtual-render-item":Function,"virtual-empty-template":String},methods:{onSortableOpen:function(e){this.$emit("sortable:open",e)},onSortableClose:function(e){this.$emit("sortable:close",e)},onSortableSort:function(e){this.$emit("sortable:sort",e,e.detail)},onTabShow:function(e){this.$emit("tab:show",e)},onTabHide:function(e){this.$emit("tab:hide",e)},onF7Init:function(e){var t=this;if(t.virtual&&t.virtualInit){var o=t.$$,n=o(t.$el).find("script").html();(n||t.virtualRenderItem)&&(n&&(n=t.$t7.compile(n)),t.f7VirtualList=e.virtualList(t.$el,{items:t.virtualItems||[],template:n,height:t.virtualHeight||void 0,cols:t.virtualCols,rowsBefore:t.virtualRowsBefore||void 0,rowsAfter:t.virtualRowsAfter||void 0,showFilteredItemsOnly:t.virtualFilteredOnly,searchByItem:t.virtualSearchByItem,searchAll:t.virtualSearchAll,renderItem:t.virtualRenderItem,emptyTemplate:t.virtualEmptyTemplate,onItemBeforeInsert:function(e,o){t.$emit("virtual:itembeforeinsert",e,o)},onBeforeClear:function(e,o){t.$emit("virtual:beforeclear",e,o)},onItemsBeforeInsert:function(e,o){t.$emit("virtual:itemsbeforeinsert",e,o)},onItemsAfterInsert:function(e,o){t.$emit("virtual:itemsafterinsert",e,o)}}))}}}},C={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"list-block-group"},[o("ul",[e._t("default")],2)])},staticRenderFns:[],props:{"media-list":Boolean,sortable:Boolean},computed:{sortableComputed:function(){return this.sortable||this.$parent.sortable},mediaListComputed:function(){return this.mediaList||this.$parent.mediaList}},data:function(){return{}}},y={render:function(e){function t(e){return!(!e&&""!==e)}function o(e){return"string"==typeof e&&""!==e}var n,a,i,r=this;if(i=e("f7-list-item-content",{props:{title:r.title,text:r.text,media:r.media,subtitle:r.subtitle,after:r.after,badge:r.badge,"badge-color":r.badgeColor,"media-list":r.mediaListComputed,"accordion-item":r.accordionItem,checkbox:r.checkbox,checked:r.checkedComputed,radio:r.radio,name:r.name,value:r.valueComputed,readonly:r.readonly,required:r.required,disabled:r.disabled},on:r.link||r.accordionItem||r.smartSelect?{}:{click:r.onClick,change:r.onChange}},[r.$slots["content-start"],r.$slots.content,r.$slots["media-start"],r.$slots.media,r.$slots["inner-start"],r.$slots.inner,r.$slots["after-start"],r.$slots.after,r.swipeout||r.accordionItem?[]:r.$slots.default]),(r.link||r.accordionItem||r.smartSelect)&&(a=e("a",{attrs:{href:r.link===!0||r.accordionItem||r.smartSelect?"#":r.link,target:r.linkTarget,"data-searchbar":r.smartSelectSearchbar,"data-searchbar-placeholder":r.smartSelectSearchbarPlaceholder,"data-searchbar-cancel":r.smartSelectSearchbarCancel,"data-page-title":r.smartSelectPageTitle,"data-back-text":r.smartSelectBackText,"data-back-on-select":r.smartSelectBackOnSelect,"data-virtual-list":r.smartSelectVirtualList,"data-virtual-list-height":r.smartSelectVirtualListHeight,"data-open-in":r.smartSelectOpenIn,"data-navbar-theme":r.smartSelectNavbarTheme,"data-form-theme":r.smartSelectFormTheme,"data-view":!!o(r.linkView)&&r.linkView,"data-panel":!!o(r.linkOpenPanel)&&r.linkOpenPanel,"data-popup":!!o(r.linkOpenPopup)&&r.linkOpenPopup,"data-popover":!!o(r.linkOpenPopover)&&r.linkOpenPopover,"data-picker":!!o(r.linkOpenPicker)&&r.linkOpenPicker,"data-login-screen":!!o(r.linkOpenLoginScreen)&&r.linkOpenLoginScreen,"data-sortable":o(r.linkOpenSortable)?r.linkOpenSortable:!!o(r.linkToggleSortable)&&r.linkToggleSortable,"data-force":r.linkForce,"data-reload":r.linkReload,"data-animate-pages":"linkAnimatePages"in r.$options.propsData?r.linkAnimatePages.toString():void 0,"data-ignore-cache":r.linkIgnoreCache,"data-page-name":"string"==typeof r.linkPageName&&r.linkPageName,"data-template":"string"==typeof r.linkTemplate&&r.linkTemplate},class:{"item-link":!0,external:r.linkExternal,back:r.linkBack,"no-fastclick":r.linkNoFastclick,"smart-select":r.smartSelect,"close-panel":t(r.linkClosePanel),"open-panel":r.linkOpenPanel||""===r.linkOpenPanel,"close-popup":t(r.linkClosePopup),"open-popup":r.linkOpenPopup||""===r.linkOpenPopup,"close-popover":t(r.linkClosePopover),"open-popover":r.linkOpenPopover||""===r.linkOpenPopover,"close-picker":t(r.linkClosePicker),"open-picker":r.linkOpenPicker||""===r.linkOpenPicker,"close-login-screen":t(r.linkCloseLoginScreen),"open-login-screen":r.linkOpenLoginScreen||""===r.linkOpenLoginScreen,"close-sortable":t(r.linkCloseSortable),"open-sortable":r.linkOpenSortable||""===r.linkOpenSortable,"toggle-sortable":r.linkToggleSortable||""===r.linkToggleSortable},on:{click:r.onClick}},[i])),r.dividerOrGroupTitle)n=[e("span",r.$slots.default||r.title)];else{var s=r.link||r.smartSelect||r.accordionItem?a:i;n=r.swipeout?[e("div",{class:{"swipeout-content":!0}},[s])]:[s],r.sortableComputed&&n.push(e("div",{class:{"sortable-handler":!0}})),(r.swipeout||r.accordionItem)&&n.push(r.$slots.default),n.unshift(r.$slots["root-start"]),n.push(r.$slots.root)}return e("li",{class:{"item-divider":r.divider,"list-group-title":r.groupTitle,swipeout:r.swipeout,"accordion-item":r.accordionItem},on:{"swipeout:open":r.onSwipeoutOpen,"swipeout:opened":r.onSwipeoutOpened,"swipeout:close":r.onSwipeoutClose,"swipeout:closed":r.onSwipeoutClosed,"swipeout:delete":r.onSwipeoutDelete,"swipeout:deleted":r.onSwipeoutDeleted,swipeout:r.onSwipeout,"accordion:open":r.onAccOpen,"accordion:opened":r.onAccOpened,"accordion:close":r.onAccClose,"accordion:closed":r.onAccClosed}},n)},props:{title:[String,Number],text:[String,Number],media:String,subtitle:[String,Number],link:[Boolean,String],"link-external":Boolean,"link-back":Boolean,"link-no-fastclick":Boolean,"link-force":Boolean,"link-reload":Boolean,"link-animate-pages":Boolean,"link-ignore-cache":Boolean,"link-page-name":String,"link-template":String,"link-target":String,"link-view":String,"link-open-panel":[Boolean,String],"link-close-panel":[Boolean,String],"link-open-popup":[Boolean,String],"link-close-popup":[Boolean,String],"link-open-popover":[Boolean,String],"link-close-popover":[Boolean,String],"link-open-login-screen":[Boolean,String],"link-close-login-screen":[Boolean,String],"link-open-picker":[Boolean,String],"link-close-picker":[Boolean,String],after:[String,Number],badge:[String,Number],"badge-color":String,"media-item":Boolean,"media-list-item":Boolean,"media-list":Boolean,divider:Boolean,"group-title":Boolean,swipeout:Boolean,sortable:Boolean,"accordion-item":Boolean,"smart-select":Boolean,"smart-select-searchbar":Boolean,"smart-select-searchbar-placeholder":String,"smart-select-searchbar-cancel":String,"smart-select-page-title":String,"smart-select-back-text":String,"smart-select-back-on-select":Boolean,"smart-select-virtual-list":Boolean,"smart-select-virtual-list-height":Number,"smart-select-open-in":String,"smart-select-navbar-theme":String,"smart-select-form-theme":String,checkbox:Boolean,checked:Boolean,radio:Boolean,name:String,value:[String,Number,Boolean,Array],"input-value":[String,Number],readonly:Boolean,required:Boolean,disabled:Boolean},computed:{dividerOrGroupTitle:function(){return this.divider||this.groupTitle},sortableComputed:function(){return this.sortable||this.$parent.sortable||this.$parent.sortableComputed},mediaListComputed:function(){return this.mediaList||this.mediaItem||this.$parent.mediaList||this.$parent.mediaListComputed},hasCheckboxModel:function(){var e=this;return e.checkbox&&("undefined"!=typeof e.$options.propsData.value&&"boolean"==typeof e.value||Array.isArray(e.value))},hasRadioModel:function(){var e=this;return e.radio&&"undefined"!=typeof e.inputValue},valueComputed:function(){var e=this;return e.inputValue?e.inputValue:e.hasCheckboxModel?void 0:e.value},checkedComputed:function(){var e=this;return e.hasCheckboxModel?e.inputValue&&Array.isArray(e.value)?e.value.indexOf(e.inputValue)>=0:e.value:e.hasRadioModel?typeof e.value!=typeof e.inputValue?e.value.toString()===e.inputValue.toString():e.value===e.inputValue:e.checked}},methods:{onClick:function(e){"input"!==e.target.tagName.toLowerCase()&&this.$emit("click",e)},onSwipeoutDeleted:function(e){this.$emit("swipeout:deleted",e)},onSwipeoutDelete:function(e){this.$emit("swipeout:delete",e)},onSwipeoutClose:function(e){this.$emit("swipeout:close",e)},onSwipeoutClosed:function(e){this.$emit("swipeout:closed",e)},onSwipeoutOpen:function(e){this.$emit("swipeout:open",e)},onSwipeoutOpened:function(e){this.$emit("swipeout:opened",e)},onSwipeout:function(e){this.$emit("swipeout",e)},onAccClose:function(e){this.$emit("accordion:close",e)},onAccClosed:function(e){this.$emit("accordion:closed",e)},onAccOpen:function(e){this.$emit("accordion:open",e)},onAccOpened:function(e){this.$emit("accordion:opened",e)},onChange:function(e){var t=this;t.hasCheckboxModel?(Array.isArray(t.value)?e.target.checked?t.value.push(e.target.value):t.value.splice(t.value.indexOf(e.target.value),1):t.$emit("input",e.target.checked),t.$emit("change",e)):t.hasRadioModel?t.$emit("input",e.target.value):t.$emit("change",e)}}},w={render:function(e){var t,o,n,a,i,r,s,l,c,u,d,p=this,f=[],h=[],m=[],b=[],g=[],v=[],$=[],k=[];if(p.$slots.default&&p.$slots.default.length>0)for(var S=0;S<p.$slots.default.length;S++){var B=p.$slots.default[S].data?p.$slots.default[S].data.slot:void 0;B&&"content-start"===B&&f.push(p.$slots.default[S]),B&&"content"===B&&h.push(p.$slots.default[S]),
	B&&"after-start"===B&&g.push(p.$slots.default[S]),B&&"after"===B&&v.push(p.$slots.default[S]),B&&"media-start"===B&&$.push(p.$slots.default[S]),B&&"media"===B&&k.push(p.$slots.default[S]),B&&"inner-start"===B&&m.push(p.$slots.default[S]),(!B||B&&"inner"===B)&&b.push(p.$slots.default[S])}if((p.radio||p.checkbox)&&(u=e("input",{attrs:{value:p.value,name:p.name,checked:p.checked,readonly:p.readonly,disabled:p.disabled,required:p.required,type:p.radio?"radio":"checkbox"},on:{change:p.onChange},domProps:{checked:p.checked}})),p.media||p.checkbox||p.radio&&p.$theme.material||$.length||k.length)if(p.checkbox||p.radio&&p.$theme.material)if(p.media)d='<i class="icon icon-form-'+(p.radio?"radio":"checkbox")+'"></i>',c=e("div",{class:{"item-media":!0},domProps:{innerHTML:d+(p.media?p.media:"")}});else{var C={icon:!0};C["icon-form-"+(p.radio?"radio":"checkbox")]=!0,d=e("i",{class:C}),c=e("div",{class:{"item-media":!0}},[$,d,k])}else c=p.media?e("div",{staticClass:"item-media",domProps:{innerHTML:p.media}}):e("div",{staticClass:"item-media"},[$,k]);return p.title&&(t=e("div",{staticClass:"item-title",domProps:{innerHTML:p.title}},[p.title])),p.subtitle&&(s=e("div",{staticClass:"item-subtitle",domProps:{innerHTML:p.subtitle}},[p.subtitle])),p.text&&(l=e("div",{staticClass:"item-text",domProps:{innerHTML:p.text}})),(p.after||p.badge||v.length)&&(p.after&&(n=e("span",{domProps:{innerHTML:p.after}})),p.badge&&(a=e("f7-badge",{props:{color:p.badgeColor}},[p.badge])),o=e("div",{staticClass:"item-after"},[g,n,a,v])),p.mediaList&&(r=e("div",{staticClass:"item-title-row"},[t,o])),i=e("div",{staticClass:"item-inner"},p.mediaList?[m,r,s,l,b]:[m,t,o,b]),e(p.checkbox||p.radio?"label":"div",{staticClass:"item-content",class:{"label-checkbox":p.checkbox,"label-radio":p.radio},on:{click:p.onClick}},[f,u,c,i,h])},props:{title:[String,Number],text:[String,Number],media:String,subtitle:[String,Number],after:[String,Number],badge:[String,Number],"badge-color":String,"media-list":Boolean,checkbox:Boolean,checked:Boolean,radio:Boolean,name:String,value:[String,Number,Boolean,Array],"input-value":[String,Number],readonly:Boolean,required:Boolean,disabled:Boolean},methods:{onClick:function(e){this.$emit("click",e)},onChange:function(e){this.$emit("change",e)}}},_={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{class:"swipeout-actions-"+e.sideComputed},[e._t("default")],2)},staticRenderFns:[],props:{left:Boolean,right:Boolean,side:String},computed:{sideComputed:function(){return this.side?this.side:this.left?"left":(this.right,"right")}},data:function(){return{}}},P={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("a",{class:e.classObject,attrs:{href:"#"},on:{click:e.onClick}},[e._t("default")],2)},staticRenderFns:[],props:{overswipe:Boolean,close:Boolean,delete:Boolean,color:String,bg:String},computed:{classObject:function(){var e={"swipeout-overswipe":this.overswipe,"swipeout-delete":this.delete,"swipeout-close":this.close};return this.color&&(e["bg-"+this.color]=!0),this.bg&&(e["bg-"+this.bg]=!0),e}},data:function(){return{}},methods:{onClick:function(e){this.$emit("click",e)}}},x={render:function(e){var t,o=this;return t=o.title?e("a",{staticClass:"item-link list-button",attrs:o.attrsObject,class:o.classesObject,domProps:{innerHTML:o.title},on:{click:o.onClick}}):e("a",{staticClass:"item-link list-button",attrs:o.attrsObject,class:o.classesObject,on:{click:o.onClick}},[o.$slots.default]),e("li",{},[t])},props:{title:[String,Number],link:[Boolean,String],href:[Boolean,String],external:Boolean,"link-external":Boolean,back:Boolean,"link-back":Boolean,"no-fastclick":Boolean,"link-no-fastlick":Boolean,color:String,force:Boolean,reload:Boolean,animatePages:Boolean,ignoreCache:Boolean,pageName:String,template:String,view:String,openPanel:[Boolean,String],closePanel:[Boolean,String],openPopup:[Boolean,String],closePopup:[Boolean,String],openPopover:[Boolean,String],closePopover:[Boolean,String],openLoginScreen:[Boolean,String],closeLoginScreen:[Boolean,String],openPicker:[Boolean,String],closePicker:[Boolean,String],tabLink:[Boolean,String],openSortable:[Boolean,String],closeSortable:[Boolean,String],toggleSortable:[Boolean,String]},computed:{attrsObject:function(){function e(e){return"string"==typeof e&&""!==e}var t=this,o={href:"boolean"==typeof t.link&&"boolean"==typeof t.href?"#":t.link||t.href},n=t.$options.propsData;return"force"in n&&(o["data-force"]=t.force),"reload"in n&&(o["data-reload"]="true"),"animatePages"in n&&"boolean"==typeof n.animatePages&&(o["data-animate-pages"]=n.animatePages.toString()),"ignoreCache"in n&&(o["data-ignore-cache"]="true"),t.pageName&&(o["data-page-name"]=t.pageName),t.template&&(o["data-template"]=t.template),t.view&&(o["data-view"]=t.view),e(t.openPanel)&&(o["data-panel"]=t.openPanel),e(t.openPopup)&&(o["data-popup"]=t.openPopup),e(t.openPopover)&&(o["data-popover"]=t.openPopover),e(t.openPicker)&&(o["data-picker"]=t.openPicker),e(t.openLoginScreen)&&(o["data-login-screen"]=t.openLoginScreen),e(t.openSortable)&&(o["data-sortable"]=t.openSortable),e(t.toggleSortable)&&(o["data-sortable"]=t.toggleSortable),e(t.closePopup)&&(o["data-popup"]=t.closePopup),e(t.closePopover)&&(o["data-popover"]=t.closePopover),e(t.closePicker)&&(o["data-picker"]=t.closePicker),e(t.closeLoginScreen)&&(o["data-login-screen"]=t.closeLoginScreen),e(t.closeSortable)&&(o["data-sortable"]=t.closeSortable),e(t.tabLink)&&(o["data-tab"]=t.tabLink),o},classesObject:function(){function e(e){return!(!e&&""!==e)}var t=this,o={external:t.external||t.linkExternal,back:t.back||t.linkBack,"no-fastclick":t.noFastclick||t.linkNoFastclick};return e(t.closePanel)&&(o["close-panel"]=!0),(t.openPanel||""===t.openPanel)&&(o["open-panel"]=!0),e(t.closePopup)&&(o["close-popup"]=!0),(t.openPopup||""===t.openPopup)&&(o["open-popup"]=!0),e(t.closePopover)&&(o["close-popover"]=!0),(t.openPopover||""===t.openPopover)&&(o["open-popover"]=!0),e(t.closePicker)&&(o["close-picker"]=!0),(t.openPicker||""===t.openPicker)&&(o["open-picker"]=!0),e(t.closeLoginScreen)&&(o["close-login-screen"]=!0),(t.openLoginScreen||""===t.openLoginScreen)&&(o["open-login-screen"]=!0),e(t.closeSortable)&&(o["close-sortable"]=!0),(t.openSortable||""===t.openSortable)&&(o["open-sortable"]=!0),(t.toggleSortable||""===t.toggleSortable)&&(o["toggle-sortable"]=!0),e(t.tabLink)&&(o["tab-link"]=!0),t.color&&(o["color-"+t.color]=!0),o}},methods:{onClick:function(e){this.$emit("click",e)}}},O={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"list-block-label"},[e._t("default")],2)},staticRenderFns:[]},M={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"accordion-list"},[e._t("default")],2)},staticRenderFns:[]},L={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"accordion-item",on:{"accordion:open":e.onOpen,"accordion:opened":e.onOpened,"accordion:close":e.onClose,"accordion:closed":e.onClosed}},[e._t("default")],2)},staticRenderFns:[],methods:{onOpen:function(e){this.$emit("accordion:open",e)},onOpened:function(e){this.$emit("accordion:opened",e)},onClose:function(e){this.$emit("accordion:close",e)},onClosed:function(e){this.$emit("accordion:closed",e)}}},T={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"accordion-item-toggle"},[e._t("default")],2)},staticRenderFns:[]},I={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"accordion-item-content"},[e._t("default")],2)},staticRenderFns:[]},F={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"buttons-row",class:e.colorComputed?"theme-"+e.colorComputed:""},[e._t("default")],2)},staticRenderFns:[],props:{color:String,theme:String,bg:String},computed:{colorComputed:function(){return this.color||this.theme||this.bg}}},R={data:function(){return{routeInfo:{activeTab:this.$route&&this.$route.route.tab}}},props:{noLinkClass:Boolean,noFastclick:Boolean,external:Boolean,color:String,bg:String,theme:String,text:String,iconOnly:Boolean,icon:String,iconMaterial:String,iconIon:String,iconFa:String,iconF7:String,iconIfMaterial:String,iconIfIos:String,iconSize:[String,Number],rippleColor:String,href:{type:String,default:"#"},round:Boolean,fill:Boolean,big:Boolean,raised:Boolean,force:Boolean,reload:Boolean,animatePages:Boolean,ignoreCache:Boolean,pageName:String,template:String,view:String,openPanel:[Boolean,String],closePanel:[Boolean,String],openPopup:[Boolean,String],closePopup:[Boolean,String],openPopover:[Boolean,String],closePopover:[Boolean,String],openLoginScreen:[Boolean,String],closeLoginScreen:[Boolean,String],openPicker:[Boolean,String],closePicker:[Boolean,String],tabLink:[Boolean,String],routeTabLink:[Boolean,String],openSortable:[Boolean,String],closeSortable:[Boolean,String],toggleSortable:[Boolean,String],active:Boolean,badge:[String,Number],iconBadge:[String,Number],badgeColor:[String],back:Boolean},computed:{attrsObject:function(){function e(e){return"string"==typeof e&&""!==e}var t=this,o={href:t.href},n=t.$options.propsData;return"force"in n&&(o["data-force"]=t.force),"reload"in n&&(o["data-reload"]="true"),"animatePages"in n&&"boolean"==typeof n.animatePages&&(o["data-animate-pages"]=n.animatePages.toString()),"ignoreCache"in n&&(o["data-ignore-cache"]="true"),t.pageName&&(o["data-page-name"]=t.pageName),t.template&&(o["data-template"]=t.template),t.view&&(o["data-view"]=t.view),e(t.openPanel)&&(o["data-panel"]=t.openPanel),e(t.openPopup)&&(o["data-popup"]=t.openPopup),e(t.openPopover)&&(o["data-popover"]=t.openPopover),e(t.openPicker)&&(o["data-picker"]=t.openPicker),e(t.openLoginScreen)&&(o["data-login-screen"]=t.openLoginScreen),e(t.openSortable)&&(o["data-sortable"]=t.openSortable),e(t.toggleSortable)&&(o["data-sortable"]=t.toggleSortable),e(t.closePopup)&&(o["data-popup"]=t.closePopup),e(t.closePopover)&&(o["data-popover"]=t.closePopover),e(t.closePicker)&&(o["data-picker"]=t.closePicker),e(t.closeLoginScreen)&&(o["data-login-screen"]=t.closeLoginScreen),e(t.closeSortable)&&(o["data-sortable"]=t.closeSortable),e(t.tabLink)&&(o["data-tab"]=t.tabLink),o},classesObject:function(){function e(e){return!(!e&&""!==e)}var t=this,o={};t.$options.propsData;if(t.rippleColor&&(o["ripple-color-"+t.rippleColor]=!0),t.color&&(o["color-"+t.color]=!0),t.theme&&(o["theme-"+t.theme]=!0),t.bg&&(o["bg-"+t.bg]=!0),o.back=t.back,o.external=t.external,o["no-fastclick"]=t.noFastclick,["round","fill","big","raised"].forEach(function(e,n){t[e]&&(o["button-"+e]=!0)}),t.routeInfo.activeTab){var n=t.routeTabLink&&t.routeTabLink.replace("#","")===t.routeInfo.activeTab.tabId;o.active=n}else o.active=t.active;return e(t.closePanel)&&(o["close-panel"]=!0),(t.openPanel||""===t.openPanel)&&(o["open-panel"]=!0),e(t.closePopup)&&(o["close-popup"]=!0),(t.openPopup||""===t.openPopup)&&(o["open-popup"]=!0),e(t.closePopover)&&(o["close-popover"]=!0),(t.openPopover||""===t.openPopover)&&(o["open-popover"]=!0),e(t.closePicker)&&(o["close-picker"]=!0),(t.openPicker||""===t.openPicker)&&(o["open-picker"]=!0),e(t.closeLoginScreen)&&(o["close-login-screen"]=!0),(t.openLoginScreen||""===t.openLoginScreen)&&(o["open-login-screen"]=!0),e(t.closeSortable)&&(o["close-sortable"]=!0),(t.openSortable||""===t.openSortable)&&(o["open-sortable"]=!0),(t.toggleSortable||""===t.toggleSortable)&&(o["toggle-sortable"]=!0),(t.tabLink||""===t.tabLink)&&(o["tab-link"]=!0),o}},methods:{onClick:function(e){this.$emit("click",e)},onRouteChange:function(e){e.route.tab&&this.$set(this.routeInfo,"activeTab",e.route.tab)}}},j={mixins:[R],render:function(e){var t,o,n,a,i,r=this;n=(r.tabLink||""===r.tabLink)&&r.$parent&&r.$parent.tabbar&&r.$parent.labels,r.text&&(r.badge&&(a=e("f7-badge",{props:{color:r.badgeColor}},r.badge)),o=e("span",{class:{"tabbar-label":n}},[r.text,a])),(r.icon||r.iconMaterial||r.iconIon||r.iconFa||r.iconF7||r.iconIfMaterial||r.iconIfIos)&&(r.iconBadge&&(i=e("f7-badge",{props:{color:r.badgeColor}},r.iconBadge)),t=e("f7-icon",{props:{material:r.iconMaterial,ion:r.iconIon,fa:r.iconFa,f7:r.iconF7,icon:r.icon,ifMaterial:r.iconIfMaterial,ifIos:r.iconIfIos,size:r.iconSize}},[i])),(!r.text&&r.$slots.default&&0===r.$slots.default.length||r.iconOnly||!r.text&&!r.$slots.default)&&(r.classesObject["icon-only"]=!0),r.classesObject.link=!r.noLinkClass&&!n;var s=e("a",{class:r.classesObject,attrs:r.attrsObject,on:{click:r.onClick}},[t,o,r.$slots.default]);return s},methods:{onClick:function(e){this.$emit("click",e)}}},N={render:function(e){var t,o,n=this;n.text&&(o=e("span",{},n.text)),(n.icon||n.iconMaterial||n.iconIon||n.iconFa||n.iconF7||n.iconIfMaterial||n.iconIfIos)&&(t=e("f7-icon",{props:{material:n.iconMaterial,ion:n.iconIon,fa:n.iconFa,f7:n.iconF7,icon:n.icon,ifMaterial:n.iconIfMaterial,ifIos:n.iconIfIos,size:n.iconSize}})),n.classesObject.button=!0;var a=e("a",{class:n.classesObject,attrs:n.attrsObject,on:{click:n.onClick}},[t,o,n.$slots.default]);return a},mixins:[R],methods:{onClick:function(e){this.$emit("click",e)}}},E={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"row",class:{"no-gutter":e.noGutter}},[e._t("default")],2)},staticRenderFns:[],props:{"no-gutter":Boolean},data:function(){return{}}},A={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{class:"col-"+e.width+(e.tabletWidth?" tablet-"+e.tabletWidth:"")},[e._t("default")],2)},staticRenderFns:[],props:{width:{type:[Number,String],default:"auto"},"tablet-width":{type:[Number,String]}},data:function(){return{}}},H={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("span",{staticClass:"preloader",class:e.color?"color-"+e.color+" preloader-"+e.color:"",style:{width:e.sizeComputed?e.sizeComputed+"px":"",height:e.sizeComputed?e.sizeComputed+"px":""}},[e.$theme.material?o("span",{staticClass:"preloader-inner"},[o("span",{staticClass:"preloader-inner-gap"}),e._v(" "),e._m(0),e._v(" "),e._m(1)]):e._e()])},staticRenderFns:[function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("span",{staticClass:"preloader-inner-left"},[o("span",{staticClass:"preloader-inner-half-circle"})])},function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("span",{staticClass:"preloader-inner-right"},[o("span",{staticClass:"preloader-inner-half-circle"})])}],props:{color:String,size:[Number,String]},computed:{sizeComputed:function(){var e=this.size;return e&&"string"==typeof e&&e.indexOf("px")>=0&&(e=e.replace("px","")),e}}},D={render:function(e){var t=this,o=t.color,n=t.progress,a=t.infinite;return e("span",{staticClass:"progressbar",class:[o?"color-"+o+" progressbar-"+o:"",a?"progressbar-infinite":""].join(" ")},[e("span",{style:{transform:n?"translate3d("+(-100+n)+"%,0,0)":""}})])},props:{color:String,progress:Number,infinite:Boolean},methods:{set:function(e,t){var o=this;if(o.$f7)return o.$f7.setProgressbar(o.$el,e,t)},show:function(e,t,o){var n=this;if(n.$f7)return n.$f7.showProgressbar(e,t,o)}}},z={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"item-title",class:{label:!e.floating,"floating-label":e.floating}},[e._t("default")],2)},staticRenderFns:[],props:{floating:Boolean}},V={render:function(e){var t,o=this,n={name:o.name,type:o.type,placeholder:o.placeholder,id:o.id,value:o.valueComputed,size:o.size,accept:o.accept,autocomplete:o.autocomplete,autocorrect:o.autocorrect,autocapitalize:o.autocapitalize,spellcheck:o.spellcheck,autofocus:o.autofocus,autosave:o.autosave,checked:o.checkedComputed,disabled:o.disabled,max:o.max,maxlength:o.maxlength,min:o.min,minlength:o.minlength,step:o.step,multiple:o.multiple,readonly:o.readonly,required:o.required,style:o.style,color:o.color,pattern:o.pattern},a={focus:o.onFocus,blur:o.onBlur,input:o.onInput,change:o.onChange,click:o.onClick,keypress:o.onKeyPress,keyup:o.onKeyUp,keydown:o.onKeyDown,beforeinput:o.onBeforeInput,compositionstart:o.onCompositionStart,compositionupdate:o.onCompositionUpdate,compositionend:o.onCompositionEnd,focusin:o.onFocusIn,focusout:o.onFocusOut,dblclick:o.onDblClick,mousedown:o.onMouseDown,mouseenter:o.onMouseEnter,mouseleave:o.onMouseLeave,mousemove:o.onMouseMove,mouseout:o.onMouseOut,mouseover:o.onMouseOver,mouseup:o.onMouseUp,wheel:o.onWheel,select:o.onSelect};"select"===o.type||"textarea"===o.type||"file"===o.type?(delete n.value,t="select"===o.type?o.hasSelectModel?e("select",{attrs:n,on:a},o.$slots.default):e("select",{attrs:n,on:a,domProps:{value:o.valueComputed}},o.$slots.default):"file"===o.type?e("input",{attrs:n,on:a},o.$slots.default):e("textarea",{attrs:n,on:a,domProps:{value:o.valueComputed}},o.$slots.default)):t=o.$slots.default&&o.$slots.default.length>0||!o.type?o.$slots.default:"switch"===o.type?e("f7-switch",{props:n,on:a}):"range"===o.type?e("f7-range",{props:n,on:a}):e("input",{attrs:n,on:a,domProps:{value:o.valueComputed,checked:o.checkedComputed}});var i=o.wrap?e("div",{staticClass:"item-input"},[t]):t;return i},watch:{value:function(){var e=this;if(e.hasSelectModel){var t=e.$$;t(e.$el).find("option").each(function(t,o){e.value.indexOf(o.value)>=0?o.selected=!0:o.selected=!1})}}},mounted:function(){var e=this;if(e.hasSelectModel){var t=e.$$;t(e.$el).find("option").each(function(t,o){e.value.indexOf(o.value)>=0?o.selected=!0:o.selected=!1})}},props:{type:String,name:String,placeholder:String,id:String,value:[String,Number,Boolean,Array,Object],inputValue:[String,Number],size:[String,Number],accept:[String,Number],autocomplete:[String],autocorrect:[String],autocapitalize:[String],spellcheck:[String],autofocus:Boolean,autosave:String,checked:Boolean,disabled:Boolean,max:[String,Number],min:[String,Number],step:[String,Number],maxlength:[String,Number],minlength:[String,Number],multiple:Boolean,readonly:Boolean,required:Boolean,style:String,pattern:String,color:String,wrap:{type:Boolean,default:!0}},computed:{hasCheckboxModel:function(){var e=this;return("checkbox"===e.type||"switch"===e.type)&&("undefined"!=typeof e.$options.propsData.value&&"boolean"==typeof e.value||Array.isArray(e.value))},hasRadioModel:function(){var e=this;return"radio"===e.type&&"undefined"!=typeof e.inputValue},hasSelectModel:function(){var e=this;return"select"===e.type&&Array.isArray(e.value)},valueComputed:function(){var e=this;if(e.inputValue)return e.inputValue;if(!e.hasCheckboxModel)return e.$options.propsData&&void 0!==e.$options.propsData.value?e.value:!e.hasCheckboxModel&&!e.hasRadioModel&&!e.hasSelectModel&&"value"in e.$options.propsData?e.value:void 0},checkedComputed:function(){var e=this;return e.hasCheckboxModel?e.inputValue&&Array.isArray(e.value)?e.value.indexOf(e.inputValue)>=0:e.value:e.hasRadioModel?typeof e.value!=typeof e.inputValue?e.value.toString()===e.inputValue.toString():e.value===e.inputValue:e.checked}},methods:{onInput:function(e){this.hasSelectModel||(e&&e.type&&"input"===e.type?this.$emit("input",e.target.value):this.$emit("input",e))},onFocus:function(e){this.$emit("focus",e)},onBlur:function(e){this.$emit("blur",e)},onChange:function(e){var t=this;if(t.hasCheckboxModel)Array.isArray(t.value)?e.target.checked?t.value.push(e.target.value):t.value.splice(t.value.indexOf(e.target.value),1):t.$emit("input",e.target.checked),t.$emit("change",e);else if(t.hasRadioModel)t.$emit("input",e.target.value);else if(t.hasSelectModel){var o=Array.prototype.filter.call(e.target.options,function(e){return e.selected}).map(function(e){var t="_value"in e?e._value:e.value;return t});t.$emit("input",o)}else t.$emit("change",e)},onClick:function(e){this.$emit("click",e)},onKeyPress:function(e){this.$emit("keypress",e)},onKeyUp:function(e){this.$emit("keyup",e)},onKeyDown:function(e){this.$emit("keydown",e)},onBeforeInput:function(e){this.$emit("beforeinput",e)},onCompositionStart:function(e){this.$emit("compositionstart",e)},onCompositionUpdate:function(e){this.$emit("compositionupdate",e)},onCompositionEnd:function(e){this.$emit("compositionend",e)},onFocusIn:function(e){this.$emit("focusin",e)},onFocusOut:function(e){this.$emit("focusout",e)},onDblClick:function(e){this.$emit("dblclick",e)},onMouseDown:function(e){this.$emit("mousedown",e)},onMouseEnter:function(e){this.$emit("mouseenter",e)},onMouseLeave:function(e){this.$emit("mouseleave",e)},onMouseMove:function(e){this.$emit("mousemove",e)},onMouseOut:function(e){this.$emit("mouseout",e)},onMouseOver:function(e){this.$emit("mouseover",e)},onMouseUp:function(e){this.$emit("mouseup",e)},onWheel:function(e){this.$emit("wheel",e)},onSelect:function(e){this.$emit("select",e)}}},q={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("label",{staticClass:"label-switch",class:e.color?"color-"+e.color:"",on:{click:e.onClick}},[o("input",{style:e.style,attrs:{type:"checkbox",name:e.name,id:e.id,disabled:e.disabled,readonly:e.readonly,required:e.required},domProps:{value:e.valueComputed,checked:e.checkedComputed},on:{input:e.onInput,change:e.onChange}}),e._v(" "),o("div",{staticClass:"checkbox"})])},staticRenderFns:[],props:{name:String,id:String,value:[String,Number,Boolean,Array],inputValue:[String,Number],checked:Boolean,disabled:Boolean,readonly:Boolean,required:Boolean,style:String,color:String},computed:{hasCheckboxModel:function(){return"boolean"==typeof this.value||Array.isArray(this.value)},valueComputed:function(){var e=this;if(e.inputValue)return e.inputValue;if(!e.hasCheckboxModel)return e.$options.propsData&&e.$options.propsData.value?e.value:void 0},checkedComputed:function(){var e=this;return e.hasCheckboxModel?e.inputValue&&Array.isArray(e.value)?e.value.indexOf(e.inputValue)>=0:e.value:e.checked}},methods:{onInput:function(e){this.$emit("input",e)},onChange:function(e){var t=this;t.hasCheckboxModel?Array.isArray(t.value)?(e.target.checked?t.value.push(e.target.value):t.value.splice(t.value.indexOf(e.target.value),1),t.$emit("change",e)):t.$emit("input",e.target.checked):t.$emit("change",e)},onClick:function(e){this.$emit("click",e)}}},U={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"range-slider",class:e.color?"color-"+e.color:""},[o("input",{style:e.style,attrs:{type:"range",name:e.name,id:e.id,disabled:e.disabled,readonly:e.readonly,required:e.required,max:e.max,min:e.min,step:e.step},domProps:{value:e.value},on:{input:e.onInput,change:e.onChange,click:e.onClick}})])},staticRenderFns:[],props:{name:String,id:String,value:[String,Number],disabled:Boolean,readonly:Boolean,required:Boolean,style:String,max:[String,Number],min:[String,Number],step:[String,Number],color:String},methods:{onInput:function(e){this.$emit("input",e.target.value)},onChange:function(e){this.$emit("change",e)},onClick:function(e){this.$emit("click",e)}}},G={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("span",{staticClass:"chip",class:e.chipClassObject,on:{click:e.onClick}},[e.media?o("span",{staticClass:"chip-media",class:e.mediaClassObject,domProps:{innerHTML:e._s(e.media)}}):e._e(),e._v(" "),e.text?o("span",{staticClass:"chip-label",domProps:{innerHTML:e._s(e.text)}}):e._e(),e._v(" "),e.deleteable?o("a",{staticClass:"chip-delete",attrs:{href:"#"},on:{click:e.onDeleteClick}}):e._e()])},staticRenderFns:[],props:{media:String,text:[String,Number],deleteable:Boolean,color:String,bg:String,mediaBg:String,mediaColor:String},computed:{mediaClassObject:function(){var e={};return this.mediaColor&&(e["color-"+this.mediaColor]=!0),this.mediaBg&&(e["color-"+this.mediaBg]=!0),e},chipClassObject:function(){var e={};return this.color&&(e["color-"+this.color]=!0),this.bg&&(e["bg-"+this.bg]=!0),e}},methods:{onClick:function(e){this.$emit("click",e)},onDeleteClick:function(e){this.$emit("delete",e)}}},K={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("a",{staticClass:"floating-button",class:!!e.color&&"color-"+e.color,attrs:{href:"#"},on:{click:e.onClick}},[e._t("default")],2)},staticRenderFns:[],props:{color:String},methods:{onClick:function(e){this.$emit("click",e)}}},W={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"speed-dial",class:!!e.theme&&"theme-"+e.theme},[e._t("default")],2)},staticRenderFns:[],props:{theme:String}},Z={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"speed-dial-buttons",class:!!e.theme&&"theme-"+e.theme},[e._t("default")],2)},staticRenderFns:[],props:{theme:String}},Q={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("a",{class:e.classesObject,attrs:{href:"#"},on:{click:e.onClick}},[e._t("default")],2)},staticRenderFns:[],props:{color:String,closeSpeedDial:Boolean},computed:{classesObject:function(){var e={};return this.color&&(e["color-"+this.color]=!0),this.closeSpeedDial&&(e["close-speed-dial"]=!0),e}},methods:{onClick:function(e){this.$emit("click",e)}}},J={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"swiper-container"},[o("div",{staticClass:"swiper-wrapper"},[e._t("default")],2),e._v(" "),e.paginationComputed===!0?o("div",{staticClass:"swiper-pagination"}):e._e(),e._v(" "),e.scrollbarComputed===!0?o("div",{staticClass:"swiper-scrollbar"}):e._e(),e._v(" "),e.nextButtonComputed===!0?o("div",{staticClass:"swiper-button-next"}):e._e(),e._v(" "),e.prevButtonComputed===!0?o("div",{staticClass:"swiper-button-prev"}):e._e()])},staticRenderFns:[],beforeDestroy:function(){var e=this;e.init&&e.swiper&&e.swiper.destroy&&e.swiper.destroy()},props:{params:Object,pagination:[Boolean,String,Object],scrollbar:[Boolean,String,Object],"next-button":[Boolean,String,Object],"prev-button":[Boolean,String,Object],init:{type:Boolean,default:!0}},computed:{paramsComputed:function(){return this.params||{}},paginationComputed:function(){var e=this;return e.pagination===!0||""===e.pagination?(e.paramsComputed.pagination=".swiper-pagination",!0):("object"==typeof e.pagination||"string"==typeof e.pagination)&&(e.paramsComputed.pagination=e.pagination,!0)},scrollbarComputed:function(){var e=this;return e.scrollbar||""===e.scrollbar?(e.paramsComputed.scrollbar=".swiper-scrollbar",!0):("object"==typeof e.scrollbar||"string"==typeof e.scrollbar)&&(e.paramsComputed.scrollbar=e.scrollbar,!0)},nextButtonComputed:function(){var e=this;return e.nextButton||""===e.nextButton?(e.paramsComputed.nextButton=".swiper-button-next",!0):("object"==typeof e.nextButton||"string"==typeof e.nextButton)&&(e.paramsComputed.nextButton=e.nextButton,!0)},prevButtonComputed:function(){var e=this;return e.prevButton||""===e.prevButton?(e.paramsComputed.prevButton=".swiper-button-prev",!0):("object"==typeof e.prevButton||"string"==typeof e.prevButton)&&(e.paramsComputed.prevButton=e.prevButton,!0)}},methods:{onF7Init:function(){this.init&&(this.swiper=new window.Swiper(this.$el,this.paramsComputed))}}},X={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"swiper-slide"},[e.zoom?o("div",{staticClass:"swiper-zoom-container"},[e._t("default")],2):e._t("default")],2)},staticRenderFns:[],props:{zoom:Boolean}},Y={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"messages"},[e._t("default")],2)},staticRenderFns:[],beforeDestroy:function(){this.f7Messages&&this.f7Messages.destroy&&this.f7Messages.destroy()},beforeUpdate:function(e,t){var o=this;o.init&&o.$children.forEach(function(e){o.$$(e.$el).addClass("message-appeared")})},updated:function(e,t){var o=this;o.init&&(o.$children.forEach(function(e){var t=o.$$(e.$el);t.hasClass("message-appeared")||t.addClass("message-appear-from-bottom")}),this.f7Messages&&this.f7Messages.layout&&this.autoLayout&&this.f7Messages.layout(),this.f7Messages&&this.f7Messages.layout&&this.autoLayout&&this.f7Messages.scrollMessages())},props:{autoLayout:{type:Boolean,default:!0},newMessagesFirst:Boolean,messages:Array,scrollMessages:{type:Boolean,default:!0},scrollMessagesOnlyOnEdge:Boolean,init:{type:Boolean,default:!0}},methods:{addMessage:function(e,t,o){if(this.f7Messages)return this.f7Messages.addMessage(e,t,o)},appendMessage:function(e,t){if(this.f7Messages)return this.f7Messages.appendMessage(e,t)},prependMessage:function(e,t){if(this.f7Messages)return this.f7Messages.prependMessage(e,t)},addMessages:function(e,t,o){if(this.f7Messages)return this.f7Messages.addMessages(e,t,o)},removeMessage:function(e){if(this.f7Messages)return this.f7Messages.removeMessage(e)},removeMessages:function(e){if(this.f7Messages)return this.f7Messages.removeMessages(e)},scroll:function(){if(this.f7Messages)return this.f7Messages.scrollMessages()},layout:function(){if(this.f7Messages)return this.f7Messages.layout()},clean:function(){if(this.f7Messages)return this.f7Messages.clean()},onF7Init:function(e){var t=this;t.init&&(t.f7Messages=e.messages(t.$el,{autoLayout:t.autoLayout,newMessagesFirst:t.newMessagesFirst,messages:t.messages,scrollMessages:t.scrollMessages,scrollMessagesOnlyOnEdge:t.scrollMessagesOnlyOnEdge}))}}},ee={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{class:e.classesObject,on:{click:e.onClick}},[e._v("\n  "+e._s(e.day)+" "),e.time?o("span",[e._v(e._s(e.time))]):e._e(),e._v(" "),e._t("start"),e._v(" "),e.name?o("div",{staticClass:"message-name",on:{click:e.onNameClick}},[e._v(e._s(e.name))]):e._e(),e._v(" "),o("div",{staticClass:"message-text",on:{click:e.onTextClick}},[e._t("default",[e._v(e._s(e.text))]),e._v(" "),e.date?o("div",{staticClass:"message-date"},[e._v(e._s(e.date))]):e._e()],2),e._v(" "),e.avatar?o("div",{staticClass:"message-avatar",style:{"background-image":"url("+e.avatar+")"},on:{click:e.onAvatarClick}}):e._e(),e._v(" "),e.label?o("div",{staticClass:"message-label"},[e._v(e._s(e.label))]):e._e(),e._v(" "),e._t("end")],2)},staticRenderFns:[],props:{text:String,name:String,avatar:String,type:{type:String,default:"sent"},label:String,day:String,date:String,time:String,last:{type:Boolean,default:!0},first:{type:Boolean,default:!0}},computed:{classesObject:function(){var e={},t=this;if(t.day||t.time)e["messages-date"]=t.day||t.time;else{var o="bottom";t.$parent.newFirst&&(o="top"),e["message-date"]=t.day||t.time,e.message=!(t.day||t.time),e["message-"+t.type]=!0,e["message-with-avatar"]=t.avatar,e["message-first"]=t.first,e["message-last"]=t.last,e["message-with-tail"]=t.last}return e}},methods:{onClick:function(e){this.$emit("click",e)},onNameClick:function(e){this.$emit("click:name",e)},onTextClick:function(e){this.$emit("click:text",e)},onAvatarClick:function(e){this.$emit("click:avatar",e)}}},te={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"toolbar messagebar"},[e._t("before-inner"),e._v(" "),o("div",{staticClass:"toolbar-inner"},[e._t("before-textarea"),e._v(" "),o("textarea",{ref:"area",attrs:{placeholder:e.placeholder,disabled:e.disabled,name:e.name,readonly:e.readonly},on:{input:e.onInput,change:e.onChange,focus:e.onFocus,blur:e.onBlur}},[e._v(e._s(e.value))]),e._v(" "),e._t("after-textarea"),e._v(" "),e.sendLink&&e.sendLink.indexOf("<")>=0?o("f7-link",{domProps:{innerHTML:e._s(e.sendLink)},on:{click:e.onClick}}):o("f7-link",{on:{click:e.onClick}},[e._t("send-link",[e._v(e._s(e.sendLink))])],2),e._v(" "),e._t("default")],2),e._v(" "),e._t("after-inner")],2)},staticRenderFns:[],beforeDestroy:function(){this.f7Messagebar&&this.f7Messagebar.destroy&&this.f7Messagebar.destroy()},props:{placeholder:{type:String,default:"Message"},init:{type:Boolean,default:!0},maxHeight:Number,sendLink:String,value:[String,Number],disabled:Boolean,readonly:Boolean,name:String},methods:{getValue:function(){if(this.f7Messagebar)return this.f7Messagebar.value()},setValue:function(e){if(this.f7Messagebar)return this.f7Messagebar.value(e)},clear:function(){if(this.f7Messagebar)return this.f7Messagebar.clear()},onChange:function(e){this.$emit("change",e)},onInput:function(e){this.$emit("input",e.target.value)},onFocus:function(e){this.$emit("focus",e);
	},onBlur:function(e){this.$emit("blur",e)},onClick:function(e){var t=this.$refs.area.value,o=this.f7Messagebar?this.f7Messagebar.clear:function(){};this.$emit("submit",t,o),this.$emit("click",e)},onF7Init:function(){var e=this;e.init&&(e.f7Messagebar=e.$f7.messagebar(e.$el,{maxHeight:e.maxHeight}))}}},oe={render:function(e){var t,o,n,a,i=this;return n=e("input",{attrs:{placeholder:i.placeholder,type:"search"},on:{input:i.onInput,change:i.onChange,focus:i.onFocus,blur:i.onBlur}}),i.clearButtonComputed&&(t=e("a",{staticClass:"searchbar-clear",attrs:{href:"#"},on:{click:i.onClearClick}})),i.cancelLink&&(o=e("a",{staticClass:"searchbar-cancel",attrs:{href:"#"},domProps:{innerHTML:i.cancelLink},on:{click:i.onCancelClick}})),a=e("div",{staticClass:"searchbar-input"},[n,t]),e(i.form?"form":"div",{staticClass:"searchbar",on:{submit:i.onSubmit,"searchbar:search":i.onSearch,"searchbar:enable":i.onEnable,"searchbar:disable":i.onDisable,"searchbar:clear":i.onClear}},[i.$slots["before-input"],a,i.$slots["after-input"],o,i.$slots.default])},beforeDestroy:function(){this.f7Searchbar&&this.f7Searchbar.destroy&&this.f7Searchbar.destroy()},props:{form:{type:Boolean,default:!0},placeholder:{type:String,default:"Search"},cancelLink:String,clear:Boolean,clearButton:{type:Boolean,default:!0},params:Object,searchList:[String,Object],searchIn:{type:String,default:".item-title"},searchBy:String,found:[String,Object],notFound:[String,Object],overlay:[String,Object],ignore:{type:String,default:".searchbar-ignore"},customSearch:{type:Boolean,default:!1},removeDiacritics:{type:Boolean,default:!1},hideDividers:{type:Boolean,default:!0},hideGroups:{type:Boolean,default:!0},init:{type:Boolean,default:!0}},computed:{clearButtonComputed:function(){var e=this,t=e.clearButton;return e.$options.propsData.clear===!1&&(t=!1),t}},methods:{search:function(e){if(this.f7Searchbar)return this.f7Searchbar.search(e)},enable:function(){if(this.f7Searchbar)return this.f7Searchbar.enable()},disable:function(){if(this.f7Searchbar)return this.f7Searchbar.disable()},empty:function(){if(this.f7Searchbar)return this.f7Searchbar.clear()},onChange:function(e){this.$emit("change",e)},onInput:function(e){this.$emit("input",e.target.value)},onFocus:function(e){this.$emit("focus",e)},onBlur:function(e){this.$emit("blur",e)},onSubmit:function(e){this.$emit("submit",e)},onSearch:function(e){e.detail&&this.$emit("searchbar:search",e.detail.query,e.detail.foundItems)},onClear:function(e){this.$emit("searchbar:clear",e)},onEnable:function(e){this.$emit("searchbar:enable",e)},onDisable:function(e){this.$emit("searchbar:disable",e)},onClearClick:function(e){this.$emit("click:clear",e)},onCancelClick:function(e){this.$emit("click:cancel",e)},onF7Init:function(){var e=this;e.init&&(e.f7Searchbar=e.$f7.searchbar(e.$el,e.params||{searchList:e.searchList,searchIn:e.searchIn,searchBy:e.searchBy,found:e.found,notFound:e.notFound,overlay:e.overlay,ignore:e.ignore,customSearch:e.customSearch,removeDiacritics:e.removeDiacritics,hideDividers:e.hideDividers,hideGroups:e.hideGroups}))}}},ne={render:function(e){var t=this,o=e("div",{staticClass:"tabs"},[t.$slots.default]);return t.animated||t.swipeable?e("div",{class:t.classesObject},[o]):o},props:{animated:Boolean,swipeable:Boolean},computed:{classesObject:function(){return{"tabs-animated-wrap":this.animated,"tabs-swipeable-wrap":this.swipeable}}}},ae={props:{active:Boolean,routeTabId:String},data:function(){return{routeInfo:{activeTab:this.$route&&this.$route.route.tab}}},render:function(e){var t=this,o=t.routeInfo.activeTab;return e("div",{staticClass:"tab",class:{active:o?o.tabId===t.routeTabId:t.active},on:{"tab:show":t.onTabShow,"tab:hide":t.onTabHide}},[o&&o.tabId===t.routeTabId?e(o.component,{tag:"component",props:t.$route.params}):t.$slots.default])},methods:{show:function(e){this.$f7&&this.$f7.showTab(this.$el,e)},onTabShow:function(e){this.$emit("tab:show",e)},onTabHide:function(e){this.$emit("tab:hide",e)},onRouteChange:function(e){if(e.route.tab){var t=this.routeInfo.activeTab&&this.routeInfo.activeTab.tabId,o=e.route.tab.tabId,n=this.routeTabId;n===t&&o!==n?this.$$(this.$el).trigger("tab:hide"):n!==t&&o===n&&this.$$(this.$el).trigger("tab:show"),this.$set(this.routeInfo,"activeTab",e.route.tab)}}}},ie={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"popover",on:{"popover:open":e.onOpen,"popover:opened":e.onOpened,"popover:close":e.onClose,"popover:closed":e.onClosed}},[o("div",{staticClass:"popover-angle"}),e._v(" "),o("div",{staticClass:"popover-content"},[e._t("default")],2)])},staticRenderFns:[],methods:{onOpen:function(e){this.$emit("popover:open",e)},onOpened:function(e){this.$emit("popover:opened",e)},onClose:function(e){this.$emit("popover:close",e)},onClosed:function(e){this.$emit("popover:closed",e)},open:function(e,t){var o=this;if(o.$f7)return o.$f7.popover(o.$el,e,void 0,t)},close:function(e){var t=this;if(t.$f7)return t.$f7.closeModal(t.$el,e)}}},re={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"popup",class:e.classesObject,on:{"popup:open":e.onOpen,"popup:opened":e.onOpened,"popup:close":e.onClose,"popup:closed":e.onClosed}},[e._t("default")],2)},staticRenderFns:[],mounted:function(){var e=this;e.opened&&(e.$el.style.display="block")},watch:{opened:function(e){var t=this;if(t.$f7){var o=t.$$;if(e)t.$f7.popup(t.$el);else{if(!o(t.$el).hasClass("modal-in"))return;t.$f7.closeModal(t.$el)}}}},props:{"tablet-fullscreen":Boolean,theme:String,layout:String,opened:Boolean},computed:{classesObject:function(){var e={"tablet-fullscreen":this.tabletFullscreen,"modal-in":this.opened,"modal-out":!this.opened};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{onOpen:function(e){this.$emit("popup:open",e)},onOpened:function(e){this.$emit("popup:opened",e)},onClose:function(e){this.$emit("popup:close",e)},onClosed:function(e){this.$emit("popup:closed",e)},onF7Init:function(){var e=this.$$;e&&0===e(".popup-overlay").length&&e('<div class="popup-overlay '+(this.opened?" modal-overlay-visible":"")+'"></div>').insertBefore(this.$el)},open:function(e){var t=this;if(t.$f7)return t.$f7.popup(t.$el,void 0,e)},close:function(e){var t=this;if(t.$f7)return t.$f7.closeModal(t.$el,e)}}},se={render:function(e){var t,o,n,a=[],i=[],r=this,s="navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button".split(" ");if(r.$slots.default)for(var l=0;l<r.$slots.default.length;l++)if(n=r.$slots.default[l],o=n.tag){for(var c=!1,u=0;u<s.length;u++)o.indexOf(s[u])>=0&&(c=!0);c?a.push(n):i.push(n)}else i.push(n);return t=e("div",{staticClass:"picker-modal-inner"},i),e("div",{class:r.classesObject,staticClass:"picker-modal",on:{"picker:open":r.onOpen,"picker:opened":r.onOpened,"picker:close":r.onClose,"picker:closed":r.onClosed}},[a,t])},mounted:function(){var e=this;e.opened&&(e.$el.style.display="block")},watch:{opened:function(e){var t=this;t.$f7&&(e?t.$f7.pickerModal(t.$el):t.$f7.closeModal(t.$el))}},props:{opened:Boolean,theme:String,layout:String,overlay:Boolean},computed:{classesObject:function(){var e={"modal-in":this.opened,"modal-out":!this.opened};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{onOpen:function(e){this.overlay&&this.$$(".picker-modal-overlay").addClass("modal-overlay-visible"),this.$emit("picker:open",e)},onOpened:function(e){this.$emit("picker:opened",e)},onClose:function(e){this.overlay&&this.$$(".picker-modal-overlay").removeClass("modal-overlay-visible"),this.$emit("picker:close",e)},onClosed:function(e){this.$emit("picker:closed",e)},onF7Init:function(){var e=this.$$;e&&0===e(".picker-modal-overlay").length&&(this.$theme&&this.$theme.material||this.overlay)&&e('<div class="picker-modal-overlay '+(this.opened?" modal-overlay-visible":"")+'"></div>').insertBefore(this.$el)},open:function(e){var t=this;if(t.$f7)return t.$f7.pickerModal(t.$el,void 0,e)},close:function(e){var t=this;if(t.$f7)return t.$f7.closeModal(t.$el,e)}}},le={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"login-screen",class:e.classesObject,on:{"loginscreen:open":e.onOpen,"loginscreen:opened":e.onOpened,"loginscreen:close":e.onClose,"loginscreen:closed":e.onClosed}},[e._t("default")],2)},staticRenderFns:[],mounted:function(){var e=this;e.opened&&(e.$el.style.display="block")},watch:{opened:function(e){var t=this;if(t.$f7){var o=t.$$;if(e)t.$f7.loginScreen(t.$el);else{if(!o(t.$el).hasClass("modal-in"))return;t.$f7.closeModal(t.$el)}}}},props:{theme:String,layout:String,opened:Boolean},computed:{classesObject:function(){var e={"modal-in":this.opened,"modal-out":!this.opened};return this.theme&&(e["theme-"+this.theme]=!0),this.layout&&(e["layout-"+this.layout]=!0),e}},methods:{onOpen:function(e){this.$emit("loginscreen:open",e)},onOpened:function(e){this.$emit("loginscreen:opened",e)},onClose:function(e){this.$emit("loginscreen:close",e)},onClosed:function(e){this.$emit("loginscreen:closed",e)},open:function(e){var t=this;if(t.$f7)return t.$f7.loginScreen(t.$el,e)},close:function(e){var t=this;if(t.$f7)return t.$f7.closeModal(t.$el,e)}}},ce={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"login-screen-title"},[e._t("default")],2)},staticRenderFns:[]},ue={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"actions-modal keep-on-close",class:{"modal-in":e.opened},on:{"actions:open":e.onOpen,"actions:opened":e.onOpened,"actions:close":e.onClose,"actions:closed":e.onClosed}},[e._t("default")],2)},staticRenderFns:[],mounted:function(){var e=this;e.opened&&(e.$el.style.display="block")},watch:{opened:function(e){var t=this;t.$f7&&(e?t.$f7.openModal(t.$el):t.$f7.closeModal(t.$el))}},props:{opened:Boolean},methods:{onOpen:function(e){this.$emit("actions:open",e)},onOpened:function(e){this.$emit("actions:opened",e)},onClose:function(e){this.$emit("actions:close",e)},onClosed:function(e){this.$emit("actions:closed",e)},onF7Init:function(){var e=this.$$;e&&0===e(".modal-overlay").length&&e('<div class="modal-overlay'+(this.opened?" modal-overlay-visible":"")+'"></div>').insertBefore(this.$el)},open:function(e){var t=this;if(t.$f7)return t.$f7.openModal(t.$el,e)},close:function(e){var t=this;if(t.$f7)return t.$f7.closeModal(t.$el,e)}}},de={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"actions-modal-group"},[e._t("default")],2)},staticRenderFns:[]},pe={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"actions-modal-button",class:e.classesObject,on:{click:e.onClick}},[e._t("default")],2)},staticRenderFns:[],props:{color:String,bold:Boolean,close:{type:Boolean,default:!0}},computed:{classesObject:function(){var e=this,t={"actions-modal-button-bold":e.bold};return e.color&&(t["color-"+e.color]=!0),t}},methods:{onClick:function(e){this.close&&this.$f7&&this.$f7.closeModal(this.$parent.$parent.$el),this.$emit("click",e)}}},fe={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"actions-modal-label",class:e.classesObject,on:{click:e.onClick}},[e._t("default")],2)},staticRenderFns:[],props:{color:String,bold:Boolean},computed:{classesObject:function(){var e=this,t={"actions-modal-button-bold":e.bold};return e.color&&(t["color-"+e.color]=!0),t}},methods:{onClick:function(e){this.$emit("click",e)}}},he={render:function(){},beforeDestroy:function(){var e=this;e.f7PhotoBrowser&&e.f7PhotoBrowser.destroy&&e.f7PhotoBrowser.destroy()},props:{init:{type:Boolean,default:!0},params:Object,photos:Array,initialSlide:Number,spaceBetween:Number,speed:Number,zoom:Boolean,zoomMax:Number,zoomMin:Number,exposition:Boolean,expositionHideCaptions:Boolean,type:String,navbar:Boolean,toolbar:Boolean,theme:String,captionsTheme:String,swipeToClose:Boolean,backLinkText:String,ofText:String,loop:Boolean,lazyLoading:Boolean,lazyLoadingInPrevNext:Boolean,lazyLoadingOnTransitionStart:Boolean},methods:{open:function(e){return this.f7PhotoBrowser.open(e)},close:function(){return this.f7PhotoBrowser.close()},toggleZoom:function(){return this.f7PhotoBrowser.toggleZoom()},toggleExposition:function(){return this.f7PhotoBrowser.toggleExposition()},enableExposition:function(){return this.f7PhotoBrowser.enableExposition()},disableExposition:function(){return this.f7PhotoBrowser.disableExposition()},onF7Init:function(e){var t=this;if(t.init){var o=t.$options.propsData;t.f7PhotoBrowser=e.photoBrowser(t.params||{photos:o.photos,initialSlide:o.initialSlide,spaceBetween:o.spaceBetween,speed:o.speed,zoom:o.zoom,zoomMax:o.zoomMax,zoomMin:o.zoomMin,exposition:o.exposition,expositionHideCaptions:o.expositionHideCaptions,type:o.type,navbar:o.navbar,toolbar:o.toolbar,theme:o.theme,captionsTheme:o.captionsTheme,swipeToClose:o.swipeToClose,backLinkText:o.backLinkText,ofText:o.ofText,loop:o.loop,lazyLoading:o.lazyLoading,lazyLoadingInPrevNext:o.lazyLoadingInPrevNext,lazyLoadingOnTransitionStart:o.lazyLoadingOnTransitionStart,onOpen:function(e){t.$emit("open",e)},onClose:function(e){t.$emit("close",e)},onSwipeToClose:function(e){t.$emit("swipeToClose",e)},onSlideChangeStart:function(e){t.$emit("slideChangeStart",e)},onSlideChangeEnd:function(e){t.$emit("slideChangeEnd",e)},onTransitionStart:function(e){t.$emit("transitionStart",e)},onTransitionEnd:function(e){t.$emit("transitionEnd",e)},onClick:function(e,o){t.$emit("click",e,o)},onTap:function(e,o){t.$emit("tap",e,o)},onDoubleTap:function(e,o){t.$emit("doubleTap",e,o)},onLazyImageLoad:function(e,o){t.$emit("lazyImageLoad",e,o)},onLazyImageReady:function(e,o){t.$emit("lazyImageReady",e,o)}})}}}},me={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"timeline",class:e.classesObject},[e._t("default")],2)},staticRenderFns:[],props:{sides:Boolean,"tablet-sides":Boolean,col:[Number,String],"tablet-col":[Number,String],horizontal:Boolean},computed:{classesObject:function(){var e={},t=this;return t.sides&&(e["timeline-sides"]=!0),t.tabletSides&&(e["tablet-sides"]=!0),t.horizontal&&(e["timeline-horizontal"]=!0),t.col&&(e["col-"+t.col]=!0),t.tabletCol&&(e["tablet-"+t.tabletCol]=!0),e}}},be={render:function(e){var t,o,n,a,i,r,s,l,c=this;return i=c.day||c.month?e("div",{staticClass:"timeline-item-date",domProps:{innerHTML:[c.day,"<small>"+c.month+"</small>"].join(" ")}}):e("div",{staticClass:"timeline-item-date",domProps:{innerHTML:c.date}}),r=e("div",{staticClass:"timeline-item-divider"}),c.time&&(t=e("div",{staticClass:"timeline-item-time",domProps:{innerHTML:c.time}})),c.title&&(o=e("div",{staticClass:"timeline-item-title",domProps:{innerHTML:c.title}})),c.subtitle&&(n=e("div",{staticClass:"timeline-item-subtitle",domProps:{innerHTML:c.subtitle}})),c.text&&(a=e("div",{staticClass:"timeline-item-text",domProps:{innerHTML:c.text}})),l=c.inner?c.content?e("div",{staticClass:"timeline-item-inner",domProps:{innerHTML:c.content}}):e("div",{staticClass:"timeline-item-inner"},[t,o,n,a,c.$slots.default]):[t,o,n,a,c.$slots.default],s=c.content&&!c.inner?e("div",{staticClass:"timeline-item-content",domProps:{innerHTML:c.content}}):e("div",{staticClass:"timeline-item-content"},[l]),e("div",{staticClass:"timeline-item",class:{"timeline-item-left":"left"===c.side,"timeline-item-right":"right"===c.side}},[i,r,s])},props:{date:[String,Number,Date],day:[String,Number],month:[String,Number],inner:Boolean,content:String,side:String,time:String,title:String,subtitle:String,text:String}},ge={render:function(e){var t,o,n,a,i=this;return i.time&&(t=e("div",{staticClass:"timeline-item-time",domProps:{innerHTML:i.time}})),i.title&&(o=e("div",{staticClass:"timeline-item-title",domProps:{innerHTML:i.title}})),i.subtitle&&(n=e("div",{staticClass:"timeline-item-subtitle",domProps:{innerHTML:i.subtitle}})),i.text&&(a=e("div",{staticClass:"timeline-item-text",domProps:{innerHTML:i.text}})),i.content?e("div",{class:{"timeline-item-inner":i.inner,"timeline-item-child":!i.inner},domProps:{innerHTML:i.content}}):e("div",{class:{"timeline-item-inner":i.inner,"timeline-item-child":!i.inner}},[t,o,n,a,i.$slots.default])},props:{inner:Boolean,content:String,time:String,title:String,subtitle:String,text:String}},ve={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"timeline-year"},[e.year||e.title?o("div",{staticClass:"timeline-year-title"},[o("span",{domProps:{innerHTML:e._s(e.year||e.title)}})]):e._e(),e._v(" "),e._t("default")],2)},staticRenderFns:[],props:{year:[Number,String],title:[Number,String]}},$e={render:function(){var e=this,t=e.$createElement,o=e._self._c||t;return o("div",{staticClass:"timeline-month"},[e.month||e.title?o("div",{staticClass:"timeline-month-title"},[o("span",{domProps:{innerHTML:e._s(e.month||e.title)}})]):e._e(),e._v(" "),e._t("default")],2)},staticRenderFns:[],props:{month:[Number,String],title:[Number,String]}},ke={render:function(e){return e("script",{attrs:{type:"text/template7"}},this.$slots.default)}},Se=function(){for(var e=[],t=arguments.length;t--;)e[t]=arguments[t];return e.join("/").replace(/\/+/g,"/")},Be=function(e,t,o){return o.map(function(o){return{path:Se(e.path,t.path,o.path),pagePath:e.path,component:e.component,tab:{tabId:t.tabId,component:o.component}}})},Ce=function(e,t){return t.reduce(function(t,o){var n;return n=o.routes?Be(e,o,o.routes):[{path:Se(e.path,o.path),pagePath:e.path,component:e.component,tab:{tabId:o.tabId,component:o.component}}],t.concat(n)},[])},ye=function(e){return void 0===e&&(e=[]),e.reduce(function(e,t){var o;return o=t.tabs?Ce(t,t.tabs):[Object.assign({},t,{pagePath:t.path})],e.concat(o)},[])},we=function(e){var t=[];return e.split("/").forEach(function(e){""!==e&&(0===e.indexOf(":")?t.push({name:e.replace(":","")}):t.push(e))}),t},_e=function(t,o,n){var a=this;this.routeChangeHandler=null,this.routes=ye(t),this.framework7=o,this.dom7=n;var i=o.params.preroute;o.params.routes=t,o.params.routerRemoveTimeout=!0,o.params.preroute=function(t,o){var n=!0;return i&&(n=i(t,o)),!!n&&e(t,o,a.changeRoute.bind(a))}};_e.prototype.setRouteChangeHandler=function(e){this.routeChangeHandler=e},_e.prototype.changeRoute=function(e,t,o){var n=this;void 0===t&&(t=null);var a=function(){return n.framework7.views&&n.framework7.views.reduce(function(e,t){return t.main?t:e},null)},i=this.findMatchingRoute(e);return!i||this.routeChangeHandler(Object.assign({},i,{view:t||a(),options:o,router:this}))},_e.prototype.findMatchingRoute=function(e){var t;if(!e)return t;var o,n,a=this.routes,i=this.dom7.parseUrlQuery(e),r=e.split("#")[1],s={},l=e.split("#")[0].split("?")[0],c=l.split("/").filter(function(e){if(""!==e)return e});for(o=0;o<a.length;o++)if(!t){var u=a[o],d=we(u.path);if(d.length===c.length){var p=0;for(n=0;n<d.length;n++)"string"==typeof d[n]&&c[n]===d[n]&&p++,"object"==typeof d[n]&&(s[d[n].name]=c[n],p++);p===c.length&&(t={query:i,hash:r,params:s,url:e,path:l,route:u})}}return t};var Pe={install:function(e,R){function Se(t){window.Framework7&&(t=t||{},"undefined"==typeof t.material&&e.prototype.$theme.material&&(t.material=!0),we=e.prototype.$f7=window.f7=new window.Framework7(t),Oe=new _e(t.routes,we,Ce),Oe.setRouteChangeHandler(function(e){Pe=e,xe=e.view.router,Be.$emit("route-change",e);var t=e.view.pagesContainer.__vue__;return!t}),Me=!0,Be.$emit("f7init",we))}R=R||{};var Be=new e,Ce=window.Dom7;e.prototype.Dom7=Ce,e.prototype.$$=Ce,e.prototype.Template7=window.Template7,e.prototype.$t7=window.Template7,e.prototype.$device=window.Framework7.prototype.device;var ye={ios:!1,material:!1};e.prototype.$theme=ye,"auto"===R.theme&&(window&&window.navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/)?ye.material=!0:ye.ios=!0),"material"===R.theme?(ye.ios=!1,ye.material=!0):"ios"===R.theme&&(ye.ios=!0,ye.material=!1);var we,Pe,xe,Oe,Me=!1;e.mixin({beforeCreate:function(){var e=this;Object.defineProperty(e,"$route",{get:function(){return Pe},enumerable:!0,configurable:!0}),Object.defineProperty(e,"$router",{get:function(){return xe},enumerable:!0,configurable:!0}),ye.ios===!1&&ye.material===!1&&(e.$root.$options.framework7&&e.$root.$options.framework7.material||e.$f7&&e.$f7.params.material||"material"===R.theme?ye.material=!0:ye.ios=!0),Be.$on("route-change",function(t){e.onRouteChange&&e.onRouteChange(t)})},mounted:function(){var e=this;return Me?void(e.onF7Init&&e.onF7Init(we)):(Be.$on("f7init",function(t){e.onF7Init&&e.onF7Init(t)}),void(e===e.$root&&Se(e.$options.framework7)))},components:{"f7-statusbar":t,"f7-views":n,"f7-panel":o,"f7-view":a,"f7-pages":i,"f7-page":r,"f7-page-content":s,"f7-navbar":l,"f7-nav-left":u,"f7-nav-center":c,"f7-nav-right":d,"f7-subnavbar":p,"f7-toolbar":f,"f7-block-title":$,"f7-content-block-title":$,"f7-list-block-title":$,"f7-content-block":v,"f7-block":v,"f7-card":h,"f7-card-header":m,"f7-card-footer":b,"f7-card-content":g,"f7-list":B,"f7-list-group":C,"f7-list-item":y,"f7-list-item-content":w,"f7-list-button":x,"f7-list-label":O,"f7-swipeout-actions":_,"f7-swipeout-button":P,"f7-accordion":M,"f7-accordion-item":L,"f7-accordion-toggle":T,"f7-accordion-content":I,"f7-badge":k,"f7-icon":S,"f7-link":j,"f7-buttons":F,"f7-segmented":F,"f7-button":N,"f7-grid":E,"f7-col":A,"f7-preloader":H,"f7-progressbar":D,"f7-label":z,"f7-input":V,"f7-switch":q,"f7-range":U,"f7-chip":G,"f7-fab":K,"f7-fab-speed-dial":W,"f7-fab-action":Q,"f7-fab-actions":Z,"f7-swiper":J,"f7-swiper-slide":X,"f7-messages":Y,"f7-message":ee,"f7-messagebar":te,"f7-searchbar":oe,"f7-tabs":ne,"f7-tab":ae,"f7-popover":ie,"f7-popup":re,"f7-login-screen":le,"f7-login-screen-title":ce,"f7-picker-modal":se,"f7-actions":ue,"f7-actions-group":de,"f7-actions-label":fe,"f7-actions-button":pe,"f7-photo-browser":he,"f7-timeline":me,"f7-timeline-item":be,"f7-timeline-item-child":ge,"f7-timeline-year":ve,"f7-timeline-month":$e,"t7-template":ke}})}};return Pe});
	//# sourceMappingURL=framework7-vue.min.js.map


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	/**
	 * Framework7 1.5.4
	 * Full featured mobile HTML framework for building iOS & Android apps
	 * 
	 * http://framework7.io/
	 * 
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 * 
	 * Licensed under MIT
	 * 
	 * Released on: March 13, 2017
	 */
	(function () {
	
	    'use strict';
	    /*===========================
	    Framework 7
	    ===========================*/
	    window.Framework7 = function (params) {
	        // App
	        var app = this;
	    
	        // Version
	        app.version = '1.5.4';
	    
	        // Default Parameters
	        app.params = {
	            //
	            root: 'body',
	            //
	            cache: true,
	            cacheIgnore: [],
	            cacheIgnoreGetParameters: false,
	            cacheDuration: 1000 * 60 * 10, // Ten minutes
	            preloadPreviousPage: true,
	            uniqueHistory: false,
	            uniqueHistoryIgnoreGetParameters: false,
	            dynamicPageUrl: 'content-{{index}}',
	            allowDuplicateUrls: false,
	            router: true,
	            routerRemoveTimeout: false,
	            routerRemoveWithTimeout: false,
	            // Push State
	            pushState: false,
	            pushStateRoot: undefined,
	            pushStateNoAnimation: false,
	            pushStateSeparator: '#!/',
	            pushStateOnLoad: true,
	            // Fast clicks
	            fastClicks: true,
	            fastClicksDistanceThreshold: 10,
	            fastClicksDelayBetweenClicks: 50,
	            fastClicksExclude: '', // CSS selector
	            // Tap Hold
	            tapHold: false,
	            tapHoldDelay: 750,
	            tapHoldPreventClicks: true,
	            // Active State
	            activeState: true,
	            activeStateElements: 'a, button, label, span',
	            // Animate Nav Back Icon
	            animateNavBackIcon: false,
	            // Swipe Back
	            swipeBackPage: true,
	            swipeBackPageThreshold: 0,
	            swipeBackPageActiveArea: 30,
	            swipeBackPageAnimateShadow: true,
	            swipeBackPageAnimateOpacity: true,
	            // Ajax
	            ajaxLinks: undefined, // or CSS selector
	            // External Links
	            externalLinks: '.external', // CSS selector
	            // Sortable
	            sortable: true,
	            // Scroll toolbars
	            hideNavbarOnPageScroll: false,
	            hideToolbarOnPageScroll: false,
	            hideTabbarOnPageScroll: false,
	            showBarsOnPageScrollEnd: true,
	            showBarsOnPageScrollTop: true,
	            // Swipeout
	            swipeout: true,
	            swipeoutActionsNoFold: false,
	            swipeoutNoFollow: false,
	            swipeoutRemoveWithTimeout: false,
	            // Smart Select Back link template
	            smartSelectOpenIn: 'page', // or 'popup' or 'picker'
	            smartSelectBackText: 'Back',
	            smartSelectPopupCloseText: 'Close',
	            smartSelectPickerCloseText: 'Done',
	            smartSelectSearchbar: false,
	            smartSelectBackOnSelect: false,
	            // Tap Navbar or Statusbar to scroll to top
	            scrollTopOnNavbarClick: false,
	            scrollTopOnStatusbarClick: false,
	            // Panels
	            panelLeftBreakpoint: null,
	            panelRightBreakpoint: null,
	            swipePanel: false, // or 'left' or 'right'
	            swipePanelActiveArea: 0,
	            swipePanelCloseOpposite: true,
	            swipePanelOnlyClose: false,
	            swipePanelNoFollow: false,
	            swipePanelThreshold: 0,
	            panelsCloseByOutside: true,
	            // Modals
	            modalButtonOk: 'OK',
	            modalButtonCancel: 'Cancel',
	            modalUsernamePlaceholder: 'Username',
	            modalPasswordPlaceholder: 'Password',
	            modalTitle: 'Framework7',
	            modalCloseByOutside: false,
	            actionsCloseByOutside: true,
	            popupCloseByOutside: true,
	            modalPreloaderTitle: 'Loading... ',
	            modalStack: true,
	            modalsMoveToRoot: true,
	            // Lazy Load
	            imagesLazyLoadThreshold: 0,
	            imagesLazyLoadSequential: true,
	            // Name space
	            viewClass: 'view',
	            viewMainClass: 'view-main',
	            viewsClass: 'views',
	            // Notifications defaults
	            notificationCloseOnClick: false,
	            notificationCloseIcon: true,
	            notificationCloseButtonText: 'Close',
	            // Animate Pages
	            animatePages: true,
	            // Template7
	            templates: {},
	            template7Data: {},
	            template7Pages: false,
	            precompileTemplates: false,
	            // Material
	            material: false,
	            materialPageLoadDelay: 0,
	            materialPreloaderSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg>',
	            materialPreloaderHtml:
	                '<span class="preloader-inner">' +
	                    '<span class="preloader-inner-gap"></span>' +
	                    '<span class="preloader-inner-left">' +
	                        '<span class="preloader-inner-half-circle"></span>' +
	                    '</span>' +
	                    '<span class="preloader-inner-right">' +
	                        '<span class="preloader-inner-half-circle"></span>' +
	                    '</span>' +
	                '</span>',
	            materialRipple: true,
	            materialRippleElements: '.ripple, a.link, a.item-link, .button, .modal-button, .tab-link, .label-radio, .label-checkbox, .actions-modal-button, a.searchbar-clear, a.floating-button, .floating-button > a, .speed-dial-buttons a',
	            // Auto init
	            init: true,
	        };
	    
	        // Extend defaults with parameters
	        for (var param in params) {
	            app.params[param] = params[param];
	        }
	    
	        // DOM lib
	        var $ = Dom7;
	    
	        // Template7 lib
	        var t7 = Template7;
	        app._compiledTemplates = {};
	    
	        // App Root
	        app.root = $(app.params.root);
	        app.root.eq(0).addClass('framework7-root');
	    
	        // Touch events
	        app.touchEvents = {
	            start: app.support.touch ? 'touchstart' : 'mousedown',
	            move: app.support.touch ? 'touchmove' : 'mousemove',
	            end: app.support.touch ? 'touchend' : 'mouseup'
	        };
	    
	        // Link to local storage
	        app.ls = window.localStorage;
	    
	        // RTL
	        app.rtl = $('body').css('direction') === 'rtl';
	        if (app.rtl) $('html').attr('dir', 'rtl');
	    
	        // Overwrite statusbar overlay
	        if (typeof app.params.statusbarOverlay !== 'undefined') {
	            if (app.params.statusbarOverlay) $('html').addClass('with-statusbar-overlay');
	            else $('html').removeClass('with-statusbar-overlay');
	        }
	        else if (app.device.ios && (window.cordova || window.phonegap)) {
	            $(document).on('resume', function () {
	                if (app.device.needsStatusBar()) {
	                    $('html').addClass('with-statusbar-overlay');
	                }
	            }, false);
	        }
	    
	
	        /*======================================================
	        ************   Views   ************
	        ======================================================*/
	        app.views = [];
	        var View = function (selector, params) {
	            var defaults = {
	                dynamicNavbar: false,
	                domCache: false,
	                linksView: undefined,
	                reloadPages: false,
	                uniqueHistory: app.params.uniqueHistory,
	                uniqueHistoryIgnoreGetParameters: app.params.uniqueHistoryIgnoreGetParameters,
	                allowDuplicateUrls: app.params.allowDuplicateUrls,
	                swipeBackPage: app.params.swipeBackPage,
	                swipeBackPageAnimateShadow: app.params.swipeBackPageAnimateShadow,
	                swipeBackPageAnimateOpacity: app.params.swipeBackPageAnimateOpacity,
	                swipeBackPageActiveArea: app.params.swipeBackPageActiveArea,
	                swipeBackPageThreshold: app.params.swipeBackPageThreshold,
	                animatePages: app.params.animatePages,
	                preloadPreviousPage: app.params.preloadPreviousPage
	            };
	            var i;
	        
	            // Params
	            params = params || {};
	        
	            // Disable dynamic navbar for material theme
	            if (params.dynamicNavbar && app.params.material) params.dynamicNavbar = false;
	        
	            // Extend params with defaults
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            // View
	            var view = this;
	            view.params = params;
	        
	            // Selector
	            view.selector = selector;
	        
	            // Container
	            var container = $(selector);
	            view.container = container[0];
	        
	            // Fix Selector
	        
	            if (typeof selector !== 'string') {
	                // Supposed to be HTMLElement or Dom7
	                selector = (container.attr('id') ? '#' + container.attr('id') : '') + (container.attr('class') ? '.' + container.attr('class').replace(/ /g, '.').replace('.active', '') : '');
	                view.selector = selector;
	            }
	        
	            // Is main
	            view.main = container.hasClass(app.params.viewMainClass);
	        
	            // Content cache
	            view.contentCache = {};
	        
	            // Context cache
	            view.contextCache = {};
	        
	            // Pages cache
	            view.pagesCache = {};
	            view.pageElementsCache = {};
	        
	            // Store View in element for easy access
	            container[0].f7View = view;
	        
	            // Pages
	            view.pagesContainer = container.find('.pages')[0];
	            view.initialPages = [];
	            view.initialPagesUrl = [];
	            view.initialNavbars = [];
	            if (view.params.domCache) {
	                var initialPages = container.find('.page');
	                for (i = 0; i < initialPages.length; i++) {
	                    view.initialPages.push(initialPages[i]);
	                    view.initialPagesUrl.push('#' + initialPages.eq(i).attr('data-page'));
	                }
	                if (view.params.dynamicNavbar) {
	                    var initialNavbars = container.find('.navbar-inner');
	                    for (i = 0; i < initialNavbars.length; i++) {
	                        view.initialNavbars.push(initialNavbars[i]);
	                    }
	                }
	        
	            }
	        
	            view.allowPageChange = true;
	        
	            // Location
	            var docLocation = document.location.href;
	        
	            // History
	            view.history = [];
	            var viewURL = docLocation;
	            var pushStateSeparator = app.params.pushStateSeparator;
	            var pushStateRoot = app.params.pushStateRoot;
	            if (app.params.pushState && view.main) {
	                if (pushStateRoot) {
	                    viewURL = pushStateRoot;
	                }
	                else {
	                    if (pushStateSeparator && viewURL.indexOf(pushStateSeparator) >= 0 && viewURL.indexOf(pushStateSeparator + '#') < 0) viewURL = viewURL.split(pushStateSeparator)[0];
	                }
	        
	            }
	        
	            // Active Page
	            var currentPage, currentPageData;
	            if (!view.activePage) {
	                currentPage = $(view.pagesContainer).find('.page-on-center');
	                if (currentPage.length === 0) {
	                    currentPage = $(view.pagesContainer).find('.page:not(.cached)');
	                    currentPage = currentPage.eq(currentPage.length - 1);
	                }
	                if (currentPage.length > 0) {
	                    currentPageData = currentPage[0].f7PageData;
	                }
	            }
	        
	            // View startup URL
	            if (view.params.domCache && currentPage) {
	                view.url = container.attr('data-url') || view.params.url || '#' + currentPage.attr('data-page');   
	                view.pagesCache[view.url] = currentPage.attr('data-page');
	            }
	            else view.url = container.attr('data-url') || view.params.url || viewURL;
	        
	            // Update current page Data
	            if (currentPageData) {
	                currentPageData.view = view;
	                currentPageData.url = view.url;
	                if (view.params.domCache && view.params.dynamicNavbar && !currentPageData.navbarInnerContainer) {
	                    currentPageData.navbarInnerContainer = view.initialNavbars[view.initialPages.indexOf(currentPageData.container)];
	                }
	                view.activePage = currentPageData;
	                currentPage[0].f7PageData = currentPageData;
	            }
	        
	            // Store to history main view's url
	            if (view.url) {
	                view.history.push(view.url);
	            }
	        
	            // Touch events
	            var isTouched = false,
	                isMoved = false,
	                touchesStart = {},
	                isScrolling,
	                activePage = [],
	                previousPage = [],
	                viewContainerWidth,
	                touchesDiff,
	                allowViewTouchMove = true,
	                touchStartTime,
	                activeNavbar = [],
	                previousNavbar = [],
	                activeNavElements,
	                previousNavElements,
	                activeNavBackIcon,
	                previousNavBackIcon,
	                dynamicNavbar,
	                pageShadow,
	                el;
	        
	            view.handleTouchStart = function (e) {
	                if (!allowViewTouchMove || !view.params.swipeBackPage || isTouched || app.swipeoutOpenedEl || !view.allowPageChange) return;
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	                dynamicNavbar = view.params.dynamicNavbar && container.find('.navbar-inner').length > 1;
	            };
	        
	            view.handleTouchMove = function (e) {
	                if (!isTouched) return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling || e.f7PreventSwipeBack || app.preventSwipeBack) {
	                    isTouched = false;
	                    return;
	                }
	                if (!isMoved) {
	                    var cancel = false;
	                    // Calc values during first move fired
	                    viewContainerWidth = container.width();
	                    var target = $(e.target);
	                    var swipeout = target.hasClass('swipeout') ? target : target.parents('.swipeout');
	                    if (swipeout.length > 0) {
	                        if (!app.rtl && swipeout.find('.swipeout-actions-left').length > 0) cancel = true;
	                        if (app.rtl && swipeout.find('.swipeout-actions-right').length > 0) cancel = true;
	                    }
	                    activePage = target.is('.page') ? target : target.parents('.page');
	                    if (activePage.hasClass('no-swipeback')) cancel = true;
	                    previousPage = container.find('.page-on-left:not(.cached)');
	                    var notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	                    if (app.rtl) {
	                        notFromBorder = touchesStart.x < container.offset().left - container[0].scrollLeft + viewContainerWidth - view.params.swipeBackPageActiveArea;
	                    }
	                    else {
	                        notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	                    }
	                    if (notFromBorder) cancel = true;
	                    if (previousPage.length === 0 || activePage.length === 0) cancel = true;
	                    if (cancel) {
	                        isTouched = false;
	                        return;
	                    }
	        
	                    if (view.params.swipeBackPageAnimateShadow && !app.device.android) {
	                        pageShadow = activePage.find('.swipeback-page-shadow');
	                        if (pageShadow.length === 0) {
	                            pageShadow = $('<div class="swipeback-page-shadow"></div>');
	                            activePage.append(pageShadow);
	                        }
	                    }
	        
	                    if (dynamicNavbar) {
	                        activeNavbar = container.find('.navbar-on-center:not(.cached)');
	                        previousNavbar = container.find('.navbar-on-left:not(.cached)');
	                        activeNavElements = activeNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                        previousNavElements = previousNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                        if (app.params.animateNavBackIcon) {
	                            activeNavBackIcon = activeNavbar.find('.left.sliding .back .icon');
	                            previousNavBackIcon = previousNavbar.find('.left.sliding .back .icon');
	                        }
	                    }
	        
	                    // Close/Hide Any Picker
	                    if ($('.picker-modal.modal-in').length > 0) {
	                        app.closeModal($('.picker-modal.modal-in'));
	                    }
	                }
	                e.f7PreventPanelSwipe = true;
	                isMoved = true;
	                e.preventDefault();
	        
	                // RTL inverter
	                var inverter = app.rtl ? -1 : 1;
	        
	                // Touches diff
	                touchesDiff = (pageX - touchesStart.x - view.params.swipeBackPageThreshold) * inverter;
	                if (touchesDiff < 0) touchesDiff = 0;
	                var percentage = touchesDiff / viewContainerWidth;
	        
	                // Swipe Back Callback
	                var callbackData = {
	                    percentage: percentage,
	                    activePage: activePage[0],
	                    previousPage: previousPage[0],
	                    activeNavbar: activeNavbar[0],
	                    previousNavbar: previousNavbar[0]
	                };
	                if (view.params.onSwipeBackMove) {
	                    view.params.onSwipeBackMove(callbackData);
	                }
	                container.trigger('swipeBackMove swipeback:move', callbackData);
	        
	                // Transform pages
	                var activePageTranslate = touchesDiff * inverter;
	                var previousPageTranslate = (touchesDiff / 5 - viewContainerWidth / 5) * inverter;
	                if (app.device.pixelRatio === 1) {
	                    activePageTranslate = Math.round(activePageTranslate);
	                    previousPageTranslate = Math.round(previousPageTranslate);
	                }
	        
	                activePage.transform('translate3d(' + activePageTranslate + 'px,0,0)');
	                if (view.params.swipeBackPageAnimateShadow && !app.device.android) pageShadow[0].style.opacity = 1 - 1 * percentage;
	        
	                previousPage.transform('translate3d(' + previousPageTranslate + 'px,0,0)');
	                if (view.params.swipeBackPageAnimateOpacity) previousPage[0].style.opacity = 0.9 + 0.1 * percentage;
	        
	                // Dynamic Navbars Animation
	                if (dynamicNavbar) {
	                    var i;
	                    for (i = 0; i < activeNavElements.length; i++) {
	                        el = $(activeNavElements[i]);
	                        if (!el.is('.subnavbar.sliding')) el[0].style.opacity = (1 - percentage * 1.3);
	                        if (el[0].className.indexOf('sliding') >= 0) {
	                            var activeNavTranslate = percentage * el[0].f7NavbarRightOffset;
	                            if (app.device.pixelRatio === 1) activeNavTranslate = Math.round(activeNavTranslate);
	                            el.transform('translate3d(' + activeNavTranslate + 'px,0,0)');
	                            if (app.params.animateNavBackIcon) {
	                                if (el[0].className.indexOf('left') >= 0 && activeNavBackIcon.length > 0) {
	                                    activeNavBackIcon.transform('translate3d(' + -activeNavTranslate + 'px,0,0)');
	                                }
	                            }
	                        }
	                    }
	                    for (i = 0; i < previousNavElements.length; i++) {
	                        el = $(previousNavElements[i]);
	                        if (!el.is('.subnavbar.sliding')) el[0].style.opacity = percentage * 1.3 - 0.3;
	                        if (el[0].className.indexOf('sliding') >= 0) {
	                            var previousNavTranslate = el[0].f7NavbarLeftOffset * (1 - percentage);
	                            if (app.device.pixelRatio === 1) previousNavTranslate = Math.round(previousNavTranslate);
	                            el.transform('translate3d(' + previousNavTranslate + 'px,0,0)');
	                            if (app.params.animateNavBackIcon) {
	                                if (el[0].className.indexOf('left') >= 0 && previousNavBackIcon.length > 0) {
	                                    previousNavBackIcon.transform('translate3d(' + -previousNavTranslate + 'px,0,0)');
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	        
	            view.handleTouchEnd = function (e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                isTouched = false;
	                isMoved = false;
	                if (touchesDiff === 0) {
	                    $([activePage[0], previousPage[0]]).transform('').css({opacity: '', boxShadow: ''});
	                    if (dynamicNavbar) {
	                        activeNavElements.transform('').css({opacity: ''});
	                        previousNavElements.transform('').css({opacity: ''});
	                        if (activeNavBackIcon && activeNavBackIcon.length > 0) activeNavBackIcon.transform('');
	                        if (previousNavBackIcon && activeNavBackIcon.length > 0) previousNavBackIcon.transform('');
	                    }
	                    return;
	                }
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var pageChanged = false;
	                // Swipe back to previous page
	                if (
	                        timeDiff < 300 && touchesDiff > 10 ||
	                        timeDiff >= 300 && touchesDiff > viewContainerWidth / 2
	                    ) {
	                    activePage.removeClass('page-on-center').addClass('page-on-right');
	                    previousPage.removeClass('page-on-left').addClass('page-on-center');
	                    if (dynamicNavbar) {
	                        activeNavbar.removeClass('navbar-on-center').addClass('navbar-on-right');
	                        previousNavbar.removeClass('navbar-on-left').addClass('navbar-on-center');
	                    }
	                    pageChanged = true;
	                }
	                // Reset custom styles
	                // Add transitioning class for transition-duration
	                $([activePage[0], previousPage[0]]).transform('').css({opacity: '', boxShadow: ''}).addClass('page-transitioning');
	                if (dynamicNavbar) {
	                    activeNavElements.css({opacity: ''})
	                    .each(function () {
	                        var translate = pageChanged ? this.f7NavbarRightOffset : 0;
	                        var sliding = $(this);
	                        sliding.transform('translate3d(' + translate + 'px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && activeNavBackIcon.length > 0) {
	                                activeNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                            }
	                        }
	        
	                    }).addClass('page-transitioning');
	        
	                    previousNavElements.transform('').css({opacity: ''}).each(function () {
	                        var translate = pageChanged ? 0 : this.f7NavbarLeftOffset;
	                        var sliding = $(this);
	                        sliding.transform('translate3d(' + translate + 'px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && previousNavBackIcon.length > 0) {
	                                previousNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                            }
	                        }
	                    }).addClass('page-transitioning');
	                }
	                allowViewTouchMove = false;
	                view.allowPageChange = false;
	                // Swipe Back Callback
	                var callbackData = {
	                    activePage: activePage[0],
	                    previousPage: previousPage[0],
	                    activeNavbar: activeNavbar[0],
	                    previousNavbar: previousNavbar[0]
	                };
	                if (pageChanged) {
	                    // Update View's URL
	                    var url = view.history[view.history.length - 2];
	                    view.url = url;
	        
	                    // Page before animation callback
	                    app.pageBackCallback('before', view, {pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true});
	                    app.pageAnimCallback('before', view, {pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true});
	        
	                    if (view.params.onSwipeBackBeforeChange) {
	                        view.params.onSwipeBackBeforeChange(callbackData);
	                    }
	                    container.trigger('swipeBackBeforeChange swipeback:beforechange', callbackData);
	                }
	                else {
	                    if (view.params.onSwipeBackBeforeReset) {
	                        view.params.onSwipeBackBeforeReset(callbackData);
	                    }
	                    container.trigger('swipeBackBeforeReset swipeback:beforereset', callbackData);
	                }
	        
	                activePage.transitionEnd(function () {
	                    $([activePage[0], previousPage[0]]).removeClass('page-transitioning');
	                    if (dynamicNavbar) {
	                        activeNavElements.removeClass('page-transitioning').css({opacity: ''});
	                        previousNavElements.removeClass('page-transitioning').css({opacity: ''});
	                        if (activeNavBackIcon && activeNavBackIcon.length > 0) activeNavBackIcon.removeClass('page-transitioning');
	                        if (previousNavBackIcon && previousNavBackIcon.length > 0) previousNavBackIcon.removeClass('page-transitioning');
	                    }
	                    allowViewTouchMove = true;
	                    view.allowPageChange = true;
	                    if (pageChanged) {
	                        if (app.params.pushState && view.main) history.back();
	                        // Page after animation callback
	                        app.pageBackCallback('after', view, {pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true});
	                        app.pageAnimCallback('after', view, {pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true});
	                        app.router.afterBack(view, activePage, previousPage);
	        
	                        if (view.params.onSwipeBackAfterChange) {
	                            view.params.onSwipeBackAfterChange(callbackData);
	                        }
	                        container.trigger('swipeBackAfterChange swipeback:afterchange', callbackData);
	                    }
	                    else {
	                        if (view.params.onSwipeBackAfterReset) {
	                            view.params.onSwipeBackAfterReset(callbackData);
	                        }
	                        container.trigger('swipeBackAfterReset swipeback:afterreset', callbackData);
	                    }
	                    if (pageShadow && pageShadow.length > 0) pageShadow.remove();
	                });
	            };
	            view.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	                var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	                container[action](app.touchEvents.start, view.handleTouchStart, passiveListener);
	                container[action](app.touchEvents.move, view.handleTouchMove, activeListener);
	                container[action](app.touchEvents.end, view.handleTouchEnd, passiveListener);
	            };
	            view.detachEvents = function () {
	                view.attachEvents(true);
	            };
	        
	            // Init
	            if (view.params.swipeBackPage && !app.params.material) {
	                view.attachEvents();
	            }
	        
	            // Check view name to delete unwanted characters
	            if (view.params.name) view.params.name = view.params.name.replace(/[^a-zA-Z]/g, '');
	          
	            // Add view to app
	            app.views.push(view);
	            if (view.main) {
	                app.mainView = view;
	                app.views.main = view;
	            }
	            else if(view.params.name) {
	                app[view.params.name + 'View'] = view;
	                app.views[view.params.name] = view;
	            }
	        
	            // Router
	            view.router = {
	                load: function (options) {
	                    return app.router.load(view, options);
	                },
	                back: function (options) {
	                    return app.router.back(view, options);
	                },
	                // Shortcuts
	                loadPage: function (options) {
	                    options = options || {};
	                    if (typeof options === 'string') {
	                        var url = options;
	                        options = {};
	                        if (url && url.indexOf('#') === 0 && view.params.domCache) {
	                            options.pageName = url.split('#')[1];
	                        }
	                        else options.url = url;
	                    }
	                    return app.router.load(view, options);
	                },
	                loadContent: function (content) {
	                    return app.router.load(view, {content: content});
	                },
	                reloadPage: function (url) {
	                    return app.router.load(view, {url: url, reload: true});
	                },
	                reloadContent: function (content) {
	                    return app.router.load(view, {content: content, reload: true});
	                },
	                reloadPreviousPage: function (url) {
	                    return app.router.load(view, {url: url, reloadPrevious: true, reload: true});
	                },
	                reloadPreviousContent: function (content) {
	                    return app.router.load(view, {content: content, reloadPrevious: true, reload: true});
	                },
	                refreshPage: function () {
	                    var options = {
	                        url: view.url,
	                        reload: true,
	                        ignoreCache: true
	                    };
	                    if (options.url && options.url.indexOf('#') === 0) {
	                        if (view.params.domCache && view.pagesCache[options.url]) {
	                            options.pageName = view.pagesCache[options.url];
	                            options.url = undefined;
	                            delete options.url;
	                        }
	                        else if (view.contentCache[options.url]) {
	                            options.content = view.contentCache[options.url];
	                            options.url = undefined;
	                            delete options.url;
	                        }
	                    }
	                    return app.router.load(view, options);
	                },
	                refreshPreviousPage: function () {
	                    var options = {
	                        url: view.history[view.history.length - 2],
	                        reload: true,
	                        reloadPrevious: true,
	                        ignoreCache: true
	                    };
	                    if (options.url && options.url.indexOf('#') === 0 && view.params.domCache && view.pagesCache[options.url]) {
	                        options.pageName = view.pagesCache[options.url];
	                        options.url = undefined;
	                        delete options.url;
	                    }
	                    return app.router.load(view, options);
	                }
	            };
	        
	            // Aliases for temporary backward compatibility
	            view.loadPage = view.router.loadPage;
	            view.loadContent = view.router.loadContent;
	            view.reloadPage = view.router.reloadPage;
	            view.reloadContent = view.router.reloadContent;
	            view.reloadPreviousPage = view.router.reloadPreviousPage;
	            view.reloadPreviousContent = view.router.reloadPreviousContent;
	            view.refreshPage = view.router.refreshPage;
	            view.refreshPreviousPage = view.router.refreshPreviousPage;
	            view.back = view.router.back;
	        
	            // Bars methods
	            view.hideNavbar = function (animated) {
	                return app.hideNavbar(container.find('.navbar'), animated);
	            };
	            view.showNavbar = function (animated) {
	                return app.showNavbar(container.find('.navbar'), animated);
	            };
	            view.hideToolbar = function (animated) {
	                return app.hideToolbar(container.find('.toolbar'), animated);
	            };
	            view.showToolbar = function (animated) {
	                return app.showToolbar(container.find('.toolbar'), animated);
	            };
	        
	            // Push State on load
	            if (app.params.pushState && app.params.pushStateOnLoad && view.main) {
	                var pushStateUrl;
	                var pushStateUrlSplit = docLocation.split(pushStateSeparator)[1];
	                if (pushStateRoot) {
	                    pushStateUrl = docLocation.split(app.params.pushStateRoot + pushStateSeparator)[1];
	                }
	                else if (pushStateSeparator && docLocation.indexOf(pushStateSeparator) >= 0 && docLocation.indexOf(pushStateSeparator + '#') < 0) {
	                    pushStateUrl = pushStateUrlSplit;
	                }
	                var pushStateAnimatePages = app.params.pushStateNoAnimation ? false : undefined;
	                var historyState = history.state;
	                if (pushStateUrl) {
	                    if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && historyState && historyState.pageName && 'viewIndex' in historyState) {
	                        app.router.load(view, {pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false});
	                    }
	                    else if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && view.initialPagesUrl.indexOf(pushStateUrl) >= 0) {
	                        app.router.load(view, {pageName: pushStateUrl.replace('#',''), animatePages: pushStateAnimatePages, pushState: false});
	                    }
	                    else app.router.load(view, {url: pushStateUrl, animatePages: pushStateAnimatePages, pushState: false});
	                }
	                else if (view.params.domCache && docLocation.indexOf(pushStateSeparator + '#') >= 0) {
	                    if (historyState && historyState.pageName && 'viewIndex' in historyState) {
	                        app.router.load(view, {pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false});
	                    }
	                    else if (pushStateSeparator && pushStateUrlSplit.indexOf('#') === 0) {
	                        if (view.initialPagesUrl.indexOf(pushStateUrlSplit)) {
	                            app.router.load(view, {pageName: pushStateUrlSplit.replace('#', ''), animatePages: pushStateAnimatePages, pushState: false});
	                        }
	                    }
	                }
	            }
	        
	            // Destroy
	            view.destroy = function () {
	                view.detachEvents();
	                if (view.main) {
	                    app.mainView = null;
	                    delete app.mainView;
	                    app.views.main = null;
	                    delete app.views.main;
	                }
	                else if(view.params.name) {
	                    app[view.params.name + 'View'] = null;
	                    delete app[view.params.name + 'View'];
	                    app.views[view.params.name] = null;
	                    delete app.views[view.params.name];
	                }
	                container.removeAttr('data-page');
	                container[0].f7View = null;
	                delete container[0].f7View;
	                
	                app.views.splice(app.views.indexOf(view), 1);
	        
	                // Delete props & methods
	                for (var prop in view) {
	                    if (view.hasOwnProperty(prop)) {
	                        view[prop] = null;
	                        delete view[prop];
	                    }
	                }
	                view = null;
	            };
	        
	            // Plugin hook
	            app.pluginHook('addView', view);
	        
	            // Return view
	            return view;
	        };
	        
	        app.addView = function (selector, params) {
	            return new View(selector, params);
	        };
	        
	        app.getCurrentView = function (index) {
	            var popoverView = $('.popover.modal-in .view');
	            var popupView = $('.popup.modal-in .view');
	            var panelView = $('.panel.active .view');
	            var appViews = $('.views');
	            // Find active view as tab
	            var appView = appViews.children('.view');
	            // Propably in tabs or split view
	            if (appView.length > 1) {
	                if (appView.hasClass('tab')) {
	                    // Tabs
	                    appView = appViews.children('.view.active');
	                }
	                else {
	                    // Split View, leave appView intact
	                }
	            }
	            if (popoverView.length > 0 && popoverView[0].f7View) return popoverView[0].f7View;
	            if (popupView.length > 0 && popupView[0].f7View) return popupView[0].f7View;
	            if (panelView.length > 0 && panelView[0].f7View) return panelView[0].f7View;
	            if (appView.length > 0) {
	                if (appView.length === 1 && appView[0].f7View) return appView[0].f7View;
	                if (appView.length > 1) {
	                    var currentViews = [];
	                    for (var i = 0; i < appView.length; i++) {
	                        if (appView[i].f7View) currentViews.push(appView[i].f7View);
	                    }
	                    if (currentViews.length > 0 && typeof index !== 'undefined') return currentViews[index];
	                    if (currentViews.length > 1) return currentViews;
	                    if (currentViews.length === 1) return currentViews[0];
	                    return undefined;
	                }
	            }
	            return undefined;
	        };
	        
	
	        /*======================================================
	        ************   Navbars && Toolbars   ************
	        ======================================================*/
	        // On Navbar Init Callback
	        app.navbarInitCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	            if (!navbarContainer && navbarInnerContainer) navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	            if (!navbarInnerContainer || navbarInnerContainer.f7NavbarInitialized && view && !view.params.domCache) return;
	            var navbarData = {
	                container: navbarContainer,
	                innerContainer: navbarInnerContainer
	            };
	            var pageData = pageContainer && pageContainer.f7PageData;
	        
	            var eventData = {
	                page: pageData,
	                navbar: navbarData
	            };
	        
	            if (navbarInnerContainer.f7NavbarInitialized && ((view && view.params.domCache) || (!view && $(navbarContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	                // Reinit Navbar
	                app.reinitNavbar(navbarContainer, navbarInnerContainer);
	        
	                // Plugin hook
	                app.pluginHook('navbarReinit', eventData);
	        
	                // Event
	                $(navbarInnerContainer).trigger('navbarReinit navbar:reinit', eventData);
	                return;
	            }
	            navbarInnerContainer.f7NavbarInitialized = true;
	            // Before Init
	            app.pluginHook('navbarBeforeInit', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarBeforeInit navbar:beforeinit', eventData);
	        
	            // Initialize Navbar
	            app.initNavbar(navbarContainer, navbarInnerContainer);
	        
	            // On init
	            app.pluginHook('navbarInit', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarInit navbar:init', eventData);
	        };
	        // Navbar Remove Callback
	        app.navbarRemoveCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	            if (!navbarContainer && navbarInnerContainer) navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	            var navbarData = {
	                container: navbarContainer,
	                innerContainer: navbarInnerContainer
	            };
	            var pageData;
	            if (pageContainer) {
	                pageData = pageContainer.f7PageData;
	            }
	        
	            var eventData = {
	                page: pageData,
	                navbar: navbarData
	            };
	            app.pluginHook('navbarBeforeRemove', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarBeforeRemove navbar:beforeremove', eventData);
	            navbarData = null;
	            pageData = null;
	        };
	        app.initNavbar = function (navbarContainer, navbarInnerContainer) {
	            // Init Subnavbar Searchbar
	            if (app.initSearchbar) app.initSearchbar(navbarInnerContainer);
	        };
	        app.reinitNavbar = function (navbarContainer, navbarInnerContainer) {
	            // Re init navbar methods
	        };
	        app.initNavbarWithCallback = function (navbarContainer) {
	            navbarContainer = $(navbarContainer);
	            var viewContainer = navbarContainer.parents('.' + app.params.viewClass);
	            var view;
	            if (viewContainer.length === 0) return;
	            if (navbarContainer.parents('.navbar-through').length === 0 && viewContainer.find('.navbar-through').length === 0) return;
	            view = viewContainer[0].f7View || undefined;
	        
	            navbarContainer.find('.navbar-inner').each(function () {
	                var navbarInnerContainer = this;
	                var pageContainer;
	                if ($(navbarInnerContainer).attr('data-page')) {
	                    // For dom cache
	                    pageContainer = viewContainer.find('.page[data-page="' + $(navbarInnerContainer).attr('data-page') + '"]')[0];
	                }
	                if (!pageContainer) {
	                    var pages = viewContainer.find('.page');
	                    if (pages.length === 1) {
	                        pageContainer = pages[0];
	                    }
	                    else {
	                        viewContainer.find('.page').each(function () {
	                            if (this.f7PageData && this.f7PageData.navbarInnerContainer === navbarInnerContainer) {
	                                pageContainer = this;
	                            }
	                        });
	                    }
	                }
	                app.navbarInitCallback(view, pageContainer, navbarContainer[0], navbarInnerContainer);
	            });
	        };
	        
	        // Size Navbars
	        app.sizeNavbars = function (viewContainer) {
	            if (app.params.material) return;
	            var navbarInner = viewContainer ? $(viewContainer).find('.navbar .navbar-inner:not(.cached)') : $('.navbar .navbar-inner:not(.cached)');
	            navbarInner.each(function () {
	                var n = $(this);
	                if (n.hasClass('cached')) return;
	                var left = app.rtl ? n.find('.right') : n.find('.left'),
	                    right = app.rtl ? n.find('.left') : n.find('.right'),
	                    center = n.find('.center'),
	                    subnavbar = n.find('.subnavbar'),
	                    noLeft = left.length === 0,
	                    noRight = right.length === 0,
	                    leftWidth = noLeft ? 0 : left.outerWidth(true),
	                    rightWidth = noRight ? 0 : right.outerWidth(true),
	                    centerWidth = center.outerWidth(true),
	                    navbarStyles = n.styles(),
	                    navbarWidth = n[0].offsetWidth - parseInt(navbarStyles.paddingLeft, 10) - parseInt(navbarStyles.paddingRight, 10),
	                    onLeft = n.hasClass('navbar-on-left'),
	                    currLeft, diff;
	        
	                if (noRight) {
	                    currLeft = navbarWidth - centerWidth;
	                }
	                if (noLeft) {
	                    currLeft = 0;
	                }
	                if (!noLeft && !noRight) {
	                    currLeft = (navbarWidth - rightWidth - centerWidth + leftWidth) / 2;
	                }
	                var requiredLeft = (navbarWidth - centerWidth) / 2;
	                if (navbarWidth - leftWidth - rightWidth > centerWidth) {
	                    if (requiredLeft < leftWidth) {
	                        requiredLeft = leftWidth;
	                    }
	                    if (requiredLeft + centerWidth > navbarWidth - rightWidth) {
	                        requiredLeft = navbarWidth - rightWidth - centerWidth;
	                    }
	                    diff = requiredLeft - currLeft;
	                }
	                else {
	                    diff = 0;
	                }
	                // RTL inverter
	                var inverter = app.rtl ? -1 : 1;
	        
	                if (center.hasClass('sliding')) {
	                    center[0].f7NavbarLeftOffset = -(currLeft + diff) * inverter;
	                    center[0].f7NavbarRightOffset = (navbarWidth - currLeft - diff - centerWidth) * inverter;
	                    if (onLeft) {
	                        if (app.params.animateNavBackIcon) {
	                            var activeNavbarBackLink = n.parent().find('.navbar-on-center').find('.left.sliding .back .icon ~ span');
	                            if (activeNavbarBackLink.length > 0) {
	                                center[0].f7NavbarLeftOffset += activeNavbarBackLink[0].offsetLeft;
	                            }
	                        }
	                        center.transform('translate3d(' + center[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                    }
	                }
	                if (!noLeft && left.hasClass('sliding')) {
	                    if (app.rtl) {
	                        left[0].f7NavbarLeftOffset = -(navbarWidth - left[0].offsetWidth) / 2 * inverter;
	                        left[0].f7NavbarRightOffset = leftWidth * inverter;
	                    }
	                    else {
	                        left[0].f7NavbarLeftOffset = -leftWidth;
	                        left[0].f7NavbarRightOffset = (navbarWidth - left[0].offsetWidth) / 2;
	                        if (app.params.animateNavBackIcon && left.find('.back .icon').length > 0) {
	                            left[0].f7NavbarRightOffset -= left.find('.back .icon')[0].offsetWidth;
	                        }
	                    }
	                    if (onLeft) left.transform('translate3d(' + left[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                }
	                if (!noRight && right.hasClass('sliding')) {
	                    if (app.rtl) {
	                        right[0].f7NavbarLeftOffset = -rightWidth * inverter;
	                        right[0].f7NavbarRightOffset = (navbarWidth - right[0].offsetWidth) / 2 * inverter;
	                    }
	                    else {
	                        right[0].f7NavbarLeftOffset = -(navbarWidth - right[0].offsetWidth) / 2;
	                        right[0].f7NavbarRightOffset = rightWidth;
	                    }
	                    if (onLeft) right.transform('translate3d(' + right[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                }
	                if (subnavbar.length && subnavbar.hasClass('sliding')) {
	                    subnavbar[0].f7NavbarLeftOffset = app.rtl ? subnavbar[0].offsetWidth : -subnavbar[0].offsetWidth;
	                    subnavbar[0].f7NavbarRightOffset = -subnavbar[0].f7NavbarLeftOffset;
	                }
	        
	                // Center left
	                var centerLeft = diff;
	                if (app.rtl && noLeft && noRight && center.length > 0) centerLeft = -centerLeft;
	                center.css({left: centerLeft + 'px'});
	                
	            });
	        };
	        
	        // Hide/Show Navbars/Toolbars
	        app.hideNavbar = function (navbarContainer, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            $(navbarContainer).addClass('navbar-hidden' + (!animated ? (' not-animated') : ''));
	            return true;
	        };
	        app.showNavbar = function (navbarContainer, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            var navbar = $(navbarContainer);
	            if (animated) {
	                navbar.removeClass('not-animated');
	                navbar.addClass('navbar-hiding').removeClass('navbar-hidden').transitionEnd(function () {
	                    navbar.removeClass('navbar-hiding');
	                });
	            }
	            else {
	                navbar.removeClass('navbar-hidden navbar-hiding not-animated');
	            }
	            return true;
	        };
	        app.hideToolbar = function (toolbarContainer, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            $(toolbarContainer).addClass('toolbar-hidden' + (!animated ? (' not-animated') : ''));
	            return true;
	        };
	        app.showToolbar = function (toolbarContainer, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            var toolbar = $(toolbarContainer);
	            if (animated) {
	                toolbar.removeClass('not-animated');
	                toolbar.addClass('toolbar-hiding').removeClass('toolbar-hidden').transitionEnd(function () {
	                    toolbar.removeClass('toolbar-hiding' + (!animated ? (' not-animated') : ''));
	                });
	            }
	            else {
	                toolbar.removeClass('toolbar-hidden toolbar-hiding not-animated');
	            }
	                
	        };
	        
	
	        /*======================================================
	        ************   Searchbar   ************
	        ======================================================*/
	        var Searchbar = function (container, params) {
	            var defaults = {
	                input: null,
	                clearButton: null,
	                cancelButton: null,
	                searchList: null,
	                searchIn: '.item-title',
	                searchBy: '',
	                found: null,
	                notFound: null,
	                overlay: null,
	                ignore: '.searchbar-ignore',
	                customSearch: false,
	                removeDiacritics: false,
	                hideDividers: true,
	                hideGroups: true,
	                /* Callbacks
	                onSearch
	                onEnable
	                onDisable
	                onClear
	                */
	        
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null && defaults.hasOwnProperty(def)) {
	                    params[def] = defaults[def];
	                }
	            }
	        
	            // Instance
	            var s = this;
	        
	            // Material
	            s.material = app.params.material;
	        
	            // Params
	            s.params = params;
	        
	            // Container
	            container = $(container);
	            s.container = container;
	        
	            // Active
	            s.active = false;
	        
	            // Input
	            s.input = s.params.input ? $(s.params.input) : s.container.find('input[type="search"]');
	            s.clearButton = s.params.clearButton ? $(s.params.clearButton) : s.container.find('.searchbar-clear');
	            s.cancelButton = s.params.cancelButton ? $(s.params.cancelButton) : s.container.find('.searchbar-cancel');
	        
	            // Search List
	            s.searchList = $(s.params.searchList);
	        
	            // Is Virtual List
	            s.isVirtualList = s.searchList.hasClass('virtual-list');
	        
	            // Is In Page
	            s.pageContainer = s.container.parents('.page').eq(0);
	        
	            // Overlay
	            if (!s.params.overlay) {
	                s.overlay = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-overlay') : $('.searchbar-overlay');
	            }
	            else {
	                s.overlay = $(s.params.overlay);
	            }
	            // Found and not found
	            if (!s.params.found) {
	                s.found = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-found') : $('.searchbar-found');
	            }
	            else {
	                s.found = $(s.params.found);
	            }
	            if (!s.params.notFound) {
	                s.notFound = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-not-found') : $('.searchbar-not-found');
	            }
	            else {
	                s.notFound = $(s.params.notFound);
	            }
	        
	            // Set Cancel button
	            var cancelMarginProp = app.rtl ? 'margin-left' : 'margin-right';
	            var cancelButtonHasMargin = false;
	            s.setCancelButtonMargin = function () {
	                s.cancelButton.transition(0).show();
	                s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	                var clientLeft = s.cancelButton[0].clientLeft;
	                s.cancelButton.transition('');
	                cancelButtonHasMargin = true;
	            };
	        
	            // Trigger
	            s.triggerEvent = function (eventName, callbackName, eventData) {
	                s.container.trigger(eventName, eventData);
	                if (s.searchList.length > 0) s.searchList.trigger(eventName, eventData);
	                if (callbackName && s.params[callbackName]) s.params[callbackName](s, eventData);
	            };
	        
	            // Enable/disalbe
	            s.enable = function (e) {
	                function _enable() {
	                    if ((s.searchList.length || s.params.customSearch) && !s.container.hasClass('searchbar-active') && !s.query) s.overlay.addClass('searchbar-overlay-active');
	                    s.container.addClass('searchbar-active');
	                    if (s.cancelButton.length > 0 && !s.material) {
	                        if (!cancelButtonHasMargin) {
	                            s.setCancelButtonMargin();
	                        }
	                        s.cancelButton.css(cancelMarginProp, '0px');
	                    }
	                    s.triggerEvent('enableSearch searchbar:enable', 'onEnable');
	                    s.active = true;
	                }
	                if (app.device.ios && !app.params.material && e && e.type === 'focus') {
	                    setTimeout(function () {
	                        _enable();
	                    }, 400);
	                }
	                else {
	                    _enable();
	                }
	            };
	        
	            s.disable = function () {
	                s.input.val('').trigger('change');
	                s.container.removeClass('searchbar-active searchbar-not-empty');
	                if (s.cancelButton.length > 0 && !s.material) s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	        
	                if (s.searchList.length || s.params.customSearch) s.overlay.removeClass('searchbar-overlay-active');
	        
	                s.active = false;
	                function _disable() {
	                    s.input.blur();
	                }
	                if (app.device.ios) {
	                    setTimeout(function () {
	                        _disable();
	                    }, 400);
	                }
	                else {
	                    _disable();
	                }
	                s.triggerEvent('disableSearch searchbar:disable', 'onDisable');
	            };
	        
	            // Clear
	            s.clear = function (e) {
	                if (!s.query && e && $(e.target).hasClass('searchbar-clear')) {
	                    s.disable();
	                    return;
	                }
	                var previousQuery = s.value;
	                s.input.val('').trigger('change').focus();
	                s.triggerEvent('clearSearch searchbar:clear', 'onClear', {previousQuery: previousQuery});
	            };
	        
	            // Search
	            s.handleInput = function () {
	                setTimeout(function () {
	                    var value = s.input.val().trim();
	                    if ((s.searchList.length > 0 || s.params.customSearch) && (s.params.searchIn || s.isVirtualList)) s.search(value, true);
	                }, 0);
	            };
	        
	            var previousQuery = '';
	            var virtualList;
	            s.search = function (query, internal) {
	                if (query.trim() === previousQuery) return;
	                previousQuery = query.trim();
	        
	                if (!internal) {
	                    if (!s.active) {
	                        s.enable();
	                    }
	                    s.input.val(query);
	                }
	                s.query = s.value = query;
	                // Add active/inactive classes on overlay
	                if (query.length === 0) {
	                    s.container.removeClass('searchbar-not-empty');
	                    if (s.searchList.length && s.container.hasClass('searchbar-active')) s.overlay.addClass('searchbar-overlay-active');
	                }
	                else {
	                    s.container.addClass('searchbar-not-empty');
	                    if (s.searchList.length && s.container.hasClass('searchbar-active')) s.overlay.removeClass('searchbar-overlay-active');
	                }
	        
	                if (s.params.customSearch) {
	                    s.triggerEvent('search searchbar:search', 'onSearch', {query: query});
	                    return;
	                }
	        
	                var foundItems = [], _vlQuery;
	                if (s.isVirtualList) {
	                    virtualList = s.searchList[0].f7VirtualList;
	                    if (query.trim() === '') {
	                        virtualList.resetFilter();
	                        s.notFound.hide();
	                        s.found.show();
	                        return;
	                    }
	                    _vlQuery = s.params.removeDiacritics ? $.removeDiacritics(query) : query;
	                    if (virtualList.params.searchAll) {
	                        foundItems = virtualList.params.searchAll(_vlQuery, virtualList.items) || [];
	                    }
	                    else if (virtualList.params.searchByItem) {
	                        for (var i = 0; i < virtualList.items.length; i++) {
	                            if(virtualList.params.searchByItem(_vlQuery, i, virtualList.params.items[i])) {
	                                foundItems.push(i);
	                            }
	                        }
	                    }
	                }
	                else {
	                    var values;
	                    if (s.params.removeDiacritics) values = $.removeDiacritics(query.trim().toLowerCase()).split(' ');
	                    else {
	                        values = query.trim().toLowerCase().split(' ');
	                    }
	                    s.searchList.find('li').removeClass('hidden-by-searchbar').each(function (index, el) {
	                        el = $(el);
	                        var compareWithText = [];
	                        el.find(s.params.searchIn).each(function () {
	                            var itemText = $(this).text().trim().toLowerCase();
	                            if (s.params.removeDiacritics) itemText = $.removeDiacritics(itemText);
	                            compareWithText.push(itemText);
	                        });
	                        compareWithText = compareWithText.join(' ');
	                        var wordsMatch = 0;
	                        for (var i = 0; i < values.length; i++) {
	                            if (compareWithText.indexOf(values[i]) >= 0) wordsMatch++;
	                        }
	                        if (wordsMatch !== values.length && !(s.params.ignore && el.is(s.params.ignore))) {
	                            el.addClass('hidden-by-searchbar');
	                        }
	                        else {
	                            foundItems.push(el[0]);
	                        }
	                    });
	        
	                    if (s.params.hideDividers) {
	                        s.searchList.find('.item-divider, .list-group-title').each(function () {
	                            var title = $(this);
	                            var nextElements = title.nextAll('li');
	                            var hide = true;
	                            for (var i = 0; i < nextElements.length; i++) {
	                                var nextEl = $(nextElements[i]);
	                                if (nextEl.hasClass('list-group-title') || nextEl.hasClass('item-divider')) break;
	                                if (!nextEl.hasClass('hidden-by-searchbar')) {
	                                    hide = false;
	                                }
	                            }
	                            var ignore = s.params.ignore && title.is(s.params.ignore);
	                            if (hide && !ignore) title.addClass('hidden-by-searchbar');
	                            else title.removeClass('hidden-by-searchbar');
	                        });
	                    }
	                    if (s.params.hideGroups) {
	                        s.searchList.find('.list-group').each(function () {
	                            var group = $(this);
	                            var ignore = s.params.ignore && group.is(s.params.ignore);
	                            var notHidden = group.find('li:not(.hidden-by-searchbar)');
	                            if (notHidden.length === 0 && !ignore) {
	                                group.addClass('hidden-by-searchbar');
	                            }
	                            else {
	                                group.removeClass('hidden-by-searchbar');
	                            }
	                        });
	                    }
	                }
	                s.triggerEvent('search searchbar:search', 'onSearch', {query: query, foundItems: foundItems});
	                if (foundItems.length === 0) {
	                    s.notFound.show();
	                    s.found.hide();
	                }
	                else {
	                    s.notFound.hide();
	                    s.found.show();
	                }
	                if (s.isVirtualList) {
	                    virtualList.filterItems(foundItems);
	                }
	            };
	        
	            // Events
	            function preventSubmit(e) {
	                e.preventDefault();
	            }
	        
	            s.attachEvents = function (destroy) {
	                var method = destroy ? 'off' : 'on';
	                s.container[method]('submit', preventSubmit);
	                if (!s.material) s.cancelButton[method]('click', s.disable);
	                s.overlay[method]('click', s.disable);
	                s.input[method]('focus', s.enable);
	                s.input[method]('change keydown keypress keyup', s.handleInput);
	                s.clearButton[method]('click', s.clear);
	        
	            };
	            s.detachEvents = function() {
	                s.attachEvents(true);
	            };
	        
	            // Init Destroy
	            s.init = function () {
	                s.attachEvents();
	            };
	            s.destroy = function () {
	                if (!s) return;
	                s.detachEvents();
	                s = null;
	            };
	        
	            // Init
	            s.init();
	        
	            s.container[0].f7Searchbar = s;
	            return s;
	        
	        };
	        app.searchbar = function (container, params) {
	            return new Searchbar(container, params);
	        };
	        app.initSearchbar = function (container) {
	            container = $(container);
	            var searchbar = container.hasClass('searchbar') ? container : container.find('.searchbar');
	            if (searchbar.length === 0) return;
	            if (!searchbar.hasClass('searchbar-init')) return;
	        
	            var sb = app.searchbar(searchbar, searchbar.dataset());
	        
	            function onBeforeRemove() {
	                if (sb) sb.destroy();
	            }
	            if (container.hasClass('page')) {
	                container.once('pageBeforeRemove', onBeforeRemove);
	            }
	            else if (container.hasClass('navbar-inner')) {
	                container.once('navbarBeforeRemove', onBeforeRemove);
	            }
	        };
	        
	
	        /*======================================================
	        ************   Messagebar   ************
	        ======================================================*/
	        var Messagebar = function (container, params) {
	            var defaults = {
	                textarea: null,
	                maxHeight: null,
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null) {
	                    params[def] = defaults[def];
	                }
	            }
	        
	            // Instance
	            var m = this;
	        
	            // Params
	            m.params = params;
	        
	            // Container
	            m.container = $(container);
	            if (m.container.length === 0) return;
	        
	            // Textarea
	            m.textarea = m.params.textarea ? $(m.params.textarea) : m.container.find('textarea');
	        
	            // Is In Page
	            m.pageContainer = m.container.parents('.page').eq(0);
	            m.pageContent = m.pageContainer.find('.page-content');
	        
	            // Initial Sizes
	            m.pageContentPadding = parseInt(m.pageContent.css('padding-bottom'));
	            m.initialBarHeight = m.container[0].offsetHeight;
	            m.initialAreaHeight = m.textarea[0].offsetHeight;
	        
	        
	            // Resize textarea
	            m.sizeTextarea = function () {
	                // Reset
	                m.textarea.css({'height': ''});
	        
	                var height = m.textarea[0].offsetHeight;
	                var diff = height - m.textarea[0].clientHeight;
	                var scrollHeight = m.textarea[0].scrollHeight;
	        
	                // Update
	                if (scrollHeight + diff > height) {
	                    var newAreaHeight = scrollHeight + diff;
	                    var newBarHeight = m.initialBarHeight + (newAreaHeight - m.initialAreaHeight);
	                    var maxBarHeight = m.params.maxHeight || m.container.parents('.view')[0].offsetHeight - 88;
	                    if (newBarHeight > maxBarHeight) {
	                        newBarHeight = parseInt(maxBarHeight, 10);
	                        newAreaHeight = newBarHeight - m.initialBarHeight + m.initialAreaHeight;
	                    }
	                    m.textarea.css('height', newAreaHeight + 'px');
	                    m.container.css('height', newBarHeight + 'px');
	                    var onBottom = (m.pageContent[0].scrollTop === m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	                    if (m.pageContent.length > 0) {
	                        m.pageContent.css('padding-bottom', newBarHeight + 'px');
	                        if (m.pageContent.find('.messages-new-first').length === 0 && onBottom) {
	                            m.pageContent.scrollTop(m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	                        }
	                    }
	                }
	                else {
	                    if (m.pageContent.length > 0) {
	                        m.container.css({'height': '', 'bottom': ''});
	                        m.pageContent.css({'padding-bottom': ''});
	                    }
	                }
	            };
	        
	            // Clear
	            m.clear = function () {
	                m.textarea.val('').trigger('change');
	            };
	            m.value = function (value) {
	                if (typeof value === 'undefined') return m.textarea.val();
	                else m.textarea.val(value).trigger('change');
	            };
	        
	            // Handle textarea
	            m.textareaTimeout = undefined;
	            m.handleTextarea = function (e) {
	                clearTimeout(m.textareaTimeout);
	                m.textareaTimeout = setTimeout(function () {
	                    m.sizeTextarea();
	                }, 0);
	            };
	        
	            //Events
	            function preventSubmit(e) {
	                e.preventDefault();
	            }
	        
	            m.attachEvents = function (destroy) {
	                var method = destroy ? 'off' : 'on';
	                m.container[method]('submit', preventSubmit);
	                m.textarea[method]('change keydown keypress keyup paste cut', m.handleTextarea);
	            };
	            m.detachEvents = function () {
	                m.attachEvents(true);
	            };
	        
	            // Init Destroy
	            m.init = function () {
	                m.attachEvents();
	            };
	            m.destroy = function () {
	                m.detachEvents();
	                m = null;
	            };
	        
	            // Init
	            m.init();
	        
	            m.container[0].f7Messagebar = m;
	            return m;
	        };
	        app.messagebar = function (container, params) {
	            return new Messagebar(container, params);
	        };
	        app.initPageMessagebar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var messagebar = pageContainer.hasClass('messagebar') ? pageContainer : pageContainer.find('.messagebar');
	            if (messagebar.length === 0) return;
	            if (!messagebar.hasClass('messagebar-init')) return;
	            var mb = app.messagebar(messagebar, messagebar.dataset());
	        
	            // Destroy on page remove
	            function pageBeforeRemove() {
	                mb.destroy();
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            if (pageContainer.hasClass('page')) {
	                pageContainer.on('page:beforeremove', pageBeforeRemove);
	            }
	        };
	        
	
	        /*======================================================
	        ************   XHR   ************
	        ======================================================*/
	        // XHR Caching
	        app.cache = [];
	        app.removeFromCache = function (url) {
	            var index = false;
	            for (var i = 0; i < app.cache.length; i++) {
	                if (app.cache[i].url === url) index = i;
	            }
	            if (index !== false) app.cache.splice(index, 1);
	        };
	        
	        // XHR
	        app.xhr = false;
	        app.get = function (url, view, ignoreCache, callback) {
	            // should we ignore get params or not
	            var _url = url;
	            if (app.params.cacheIgnoreGetParameters && url.indexOf('?') >= 0) {
	                _url = url.split('?')[0];
	            }
	            if (app.params.cache && !ignoreCache && url.indexOf('nocache') < 0 && app.params.cacheIgnore.indexOf(_url) < 0) {
	                // Check is the url cached
	                for (var i = 0; i < app.cache.length; i++) {
	                    if (app.cache[i].url === _url) {
	                        // Check expiration
	                        if ((new Date()).getTime() - app.cache[i].time < app.params.cacheDuration) {
	                            // Load from cache
	                            callback(app.cache[i].content);
	                            return false;
	                        }
	                    }
	                }
	            }
	        
	            app.xhr = $.ajax({
	                url: url,
	                method: 'GET',
	                beforeSend: app.params.onAjaxStart,
	                complete: function (xhr) {
	                    if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	                        if (app.params.cache) {
	                            app.removeFromCache(_url);
	                            app.cache.push({
	                                url: _url,
	                                time: (new Date()).getTime(),
	                                content: xhr.responseText
	                            });
	                        }
	                        callback(xhr.responseText, false);
	                    }
	                    else {
	                        callback(xhr.responseText, true);
	                    }
	                    if (app.params.onAjaxComplete) app.params.onAjaxComplete(xhr);
	                },
	                error: function (xhr) {
	                    callback(xhr.responseText, true);
	                    if (app.params.onAjaxError) app.params.onAjaxError(xhr);
	                }
	            });
	            if (view) view.xhr = app.xhr;
	        
	            return app.xhr;
	        };
	        
	
	        /*======================================================
	        ************   Pages   ************
	        ======================================================*/
	        // Page Callbacks API
	        app.pageCallbacks = {};
	        
	        app.onPage = function (callbackName, pageName, callback) {
	            if (pageName && pageName.split(' ').length > 1) {
	                var pageNames = pageName.split(' ');
	                var returnCallbacks = [];
	                for (var i = 0; i < pageNames.length; i++) {
	                    returnCallbacks.push(app.onPage(callbackName, pageNames[i], callback));
	                }
	                returnCallbacks.remove = function () {
	                    for (var i = 0; i < returnCallbacks.length; i++) {
	                        returnCallbacks[i].remove();
	                    }
	                };
	                returnCallbacks.trigger = function () {
	                    for (var i = 0; i < returnCallbacks.length; i++) {
	                        returnCallbacks[i].trigger();
	                    }
	                };
	                return returnCallbacks;
	            }
	            var callbacks = app.pageCallbacks[callbackName][pageName];
	            if (!callbacks) {
	                callbacks = app.pageCallbacks[callbackName][pageName] = [];
	            }
	            app.pageCallbacks[callbackName][pageName].push(callback);
	            return {
	                remove: function () {
	                    var removeIndex;
	                    for (var i = 0; i < callbacks.length; i++) {
	                        if (callbacks[i].toString() === callback.toString()) {
	                            removeIndex = i;
	                        }
	                    }
	                    if (typeof removeIndex !== 'undefined') callbacks.splice(removeIndex, 1);
	                },
	                trigger: callback
	            };
	        };
	        
	        //Create callbacks methods dynamically
	        function createPageCallback(callbackName) {
	            var capitalized = callbackName.replace(/^./, function (match) {
	                return match.toUpperCase();
	            });
	            app['onPage' + capitalized] = function (pageName, callback) {
	                return app.onPage(callbackName, pageName, callback);
	            };
	        }
	        
	        var pageCallbacksNames = ('beforeInit init reinit beforeAnimation afterAnimation back afterBack beforeRemove').split(' ');
	        for (var i = 0; i < pageCallbacksNames.length; i++) {
	            app.pageCallbacks[pageCallbacksNames[i]] = {};
	            createPageCallback(pageCallbacksNames[i]);
	        }
	        
	        app.triggerPageCallbacks = function (callbackName, pageName, pageData) {
	            var allPagesCallbacks = app.pageCallbacks[callbackName]['*'];
	            if (allPagesCallbacks) {
	                for (var j = 0; j < allPagesCallbacks.length; j++) {
	                    allPagesCallbacks[j](pageData);
	                }
	            }
	            var callbacks = app.pageCallbacks[callbackName][pageName];
	            if (!callbacks || callbacks.length === 0) return;
	            for (var i = 0; i < callbacks.length; i++) {
	                callbacks[i](pageData);
	            }
	        };
	        
	        // On Page Init Callback
	        app.pageInitCallback = function (view, params) {
	            var pageContainer = params.pageContainer;
	            if (!pageContainer) return;
	            if (pageContainer.f7PageInitialized && view && !view.params.domCache) return;
	        
	            var pageQuery = params.query;
	            if (!pageQuery) {
	                if (params.url && params.url.indexOf('?') > 0) {
	                    pageQuery = $.parseUrlQuery(params.url || '');
	                }
	                else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	                    pageQuery = pageContainer.f7PageData.query;
	                }
	                else {
	                    pageQuery = {};
	                }
	            }
	        
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                url: params.url,
	                query: pageQuery,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                from: params.position,
	                context: params.context,
	                navbarInnerContainer: params.navbarInnerContainer,
	                fromPage: params.fromPage
	            };
	            if (params.fromPage && !params.fromPage.navbarInnerContainer && params.oldNavbarInnerContainer) {
	                params.fromPage.navbarInnerContainer = params.oldNavbarInnerContainer;
	            }
	        
	            if (pageContainer.f7PageInitialized && ((view && view.params.domCache) || (!view && $(pageContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	                // Reinit Page
	                app.reinitPage(pageContainer);
	        
	                // Callbacks
	                app.pluginHook('pageReinit', pageData);
	                if (app.params.onPageReinit) app.params.onPageReinit(app, pageData);
	                app.triggerPageCallbacks('reinit', pageData.name, pageData);
	                $(pageData.container).trigger('pageReinit page:reinit', {page: pageData});
	                return;
	            }
	            pageContainer.f7PageInitialized = true;
	        
	            // Store pagedata in page
	            pageContainer.f7PageData = pageData;
	        
	            // Update View's activePage
	            if (view && !params.preloadOnly && !params.reloadPrevious) {
	                // Add data-page on view
	                $(view.container).attr('data-page', pageData.name);
	                // Update View active page data
	                view.activePage = pageData;
	            }
	        
	            // Before Init Callbacks
	            app.pluginHook('pageBeforeInit', pageData);
	            if (app.params.onPageBeforeInit) app.params.onPageBeforeInit(app, pageData);
	            app.triggerPageCallbacks('beforeInit', pageData.name, pageData);
	            $(pageData.container).trigger('pageBeforeInit page:beforeinit', {page: pageData});
	        
	            // Init page
	            app.initPage(pageContainer);
	        
	            // Init Callback
	            app.pluginHook('pageInit', pageData);
	            if (app.params.onPageInit) app.params.onPageInit(app, pageData);
	            app.triggerPageCallbacks('init', pageData.name, pageData);
	            $(pageData.container).trigger('pageInit page:init', {page: pageData});
	        };
	        app.pageRemoveCallback = function (view, pageContainer, position) {
	            var pageContext;
	            if (!pageContainer) return;
	            if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	                query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                from: position,
	                context: pageContext
	            };
	            // Before Init Callback
	            app.pluginHook('pageBeforeRemove', pageData);
	            if (app.params.onPageBeforeRemove) app.params.onPageBeforeRemove(app, pageData);
	            app.triggerPageCallbacks('beforeRemove', pageData.name, pageData);
	            $(pageData.container).trigger('pageBeforeRemove page:beforeremove', {page: pageData});
	            pageData = null;
	        };
	        app.pageBackCallback = function (callback, view, params) {
	            // Page Data
	            var pageContainer = params.pageContainer;
	            var pageContext;
	            if (!pageContainer) return;
	            if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	        
	            var pageData = {
	                container: pageContainer,
	                name: $(pageContainer).attr('data-page'),
	                url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	                query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	                view: view,
	                from: params.position,
	                context: pageContext,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                swipeBack: params.swipeBack
	            };
	        
	            if (callback === 'after') {
	                app.pluginHook('pageAfterBack', pageData);
	                if (app.params.onPageAfterBack) app.params.onPageAfterBack(app, pageData);
	                app.triggerPageCallbacks('afterBack', pageData.name, pageData);
	                $(pageContainer).trigger('pageAfterBack page:afterback', {page: pageData});
	        
	            }
	            if (callback === 'before') {
	                app.pluginHook('pageBack', pageData);
	                if (app.params.onPageBack) app.params.onPageBack(app, pageData);
	                app.triggerPageCallbacks('back', pageData.name, pageData);
	                $(pageData.container).trigger('pageBack page:back', {page: pageData});
	            }
	        };
	        app.pageAnimCallback = function (callback, view, params) {
	            var pageContainer = params.pageContainer;
	            var pageContext;
	            if (!pageContainer) return;
	            if (pageContainer.f7PageData) pageContext = pageContainer.f7PageData.context;
	        
	            var pageQuery = params.query;
	            if (!pageQuery) {
	                if (params.url && params.url.indexOf('?') > 0) {
	                    pageQuery = $.parseUrlQuery(params.url || '');
	                }
	                else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	                    pageQuery = pageContainer.f7PageData.query;
	                }
	                else {
	                    pageQuery = {};
	                }
	            }
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                url: params.url,
	                query: pageQuery,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                from: params.position,
	                context: pageContext,
	                swipeBack: params.swipeBack,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                fromPage: params.fromPage
	            };
	            var oldPage = params.oldPage,
	                newPage = params.newPage;
	        
	            // Update page date
	            pageContainer.f7PageData = pageData;
	        
	            if (callback === 'after') {
	                app.pluginHook('pageAfterAnimation', pageData);
	                if (app.params.onPageAfterAnimation) app.params.onPageAfterAnimation(app, pageData);
	                app.triggerPageCallbacks('afterAnimation', pageData.name, pageData);
	                $(pageData.container).trigger('pageAfterAnimation page:afteranimation', {page: pageData});
	        
	            }
	            if (callback === 'before') {
	                // Add data-page on view
	                $(view.container).attr('data-page', pageData.name);
	        
	                // Update View's activePage
	                if (view) view.activePage = pageData;
	        
	                // Hide/show navbar dynamically
	                if (newPage.hasClass('no-navbar') && !oldPage.hasClass('no-navbar')) {
	                    view.hideNavbar();
	                }
	                if (!newPage.hasClass('no-navbar') && (oldPage.hasClass('no-navbar') || oldPage.hasClass('no-navbar-by-scroll'))) {
	                    view.showNavbar();
	                }
	                // Hide/show navbar toolbar
	                if (newPage.hasClass('no-toolbar') && !oldPage.hasClass('no-toolbar')) {
	                    view.hideToolbar();
	                }
	                if (!newPage.hasClass('no-toolbar') && (oldPage.hasClass('no-toolbar') || oldPage.hasClass('no-toolbar-by-scroll'))) {
	                    view.showToolbar();
	                }
	                // Hide/show tabbar
	                var tabBar;
	                if (newPage.hasClass('no-tabbar') && !oldPage.hasClass('no-tabbar')) {
	                    tabBar = $(view.container).find('.tabbar');
	                    if (tabBar.length === 0) tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	                    app.hideToolbar(tabBar);
	                }
	                if (!newPage.hasClass('no-tabbar') && (oldPage.hasClass('no-tabbar') || oldPage.hasClass('no-tabbar-by-scroll'))) {
	                    tabBar = $(view.container).find('.tabbar');
	                    if (tabBar.length === 0) tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	                    app.showToolbar(tabBar);
	                }
	        
	                oldPage.removeClass('no-navbar-by-scroll no-toolbar-by-scroll');
	                // Callbacks
	                app.pluginHook('pageBeforeAnimation', pageData);
	                if (app.params.onPageBeforeAnimation) app.params.onPageBeforeAnimation(app, pageData);
	                app.triggerPageCallbacks('beforeAnimation', pageData.name, pageData);
	                $(pageData.container).trigger('pageBeforeAnimation page:beforeanimation', {page: pageData});
	            }
	        };
	        
	        // Init Page Events and Manipulations
	        app.initPage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length === 0) return;
	            // Size navbars on page load
	            if (app.sizeNavbars) app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	            // Init messages
	            if (app.initPageMessages) app.initPageMessages(pageContainer);
	            // Init forms storage
	            if (app.initFormsStorage) app.initFormsStorage(pageContainer);
	            // Init smart select
	            if (app.initSmartSelects) app.initSmartSelects(pageContainer);
	            // Init slider
	            if (app.initPageSwiper) app.initPageSwiper(pageContainer);
	            // Init pull to refres
	            if (app.initPullToRefresh) app.initPullToRefresh(pageContainer);
	            // Init infinite scroll
	            if (app.initPageInfiniteScroll) app.initPageInfiniteScroll(pageContainer);
	            // Init searchbar
	            if (app.initSearchbar) app.initSearchbar(pageContainer);
	            // Init message bar
	            if (app.initPageMessagebar) app.initPageMessagebar(pageContainer);
	            // Init scroll toolbars
	            if (app.initPageScrollToolbars) app.initPageScrollToolbars(pageContainer);
	            // Init lazy images
	            if (app.initImagesLazyLoad) app.initImagesLazyLoad(pageContainer);
	            // Init progress bars
	            if (app.initPageProgressbar) app.initPageProgressbar(pageContainer);
	            // Init resizeable textareas
	            if (app.initPageResizableTextarea) app.initPageResizableTextarea(pageContainer);
	            // Init Material Preloader
	            if (app.params.material && app.initPageMaterialPreloader) app.initPageMaterialPreloader(pageContainer);
	            // Init Material Inputs
	            if (app.params.material && app.initPageMaterialInputs) app.initPageMaterialInputs(pageContainer);
	            // Init Material Tabbar
	            if (app.params.material && app.initPageMaterialTabbar) app.initPageMaterialTabbar(pageContainer);
	        };
	        app.reinitPage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length === 0) return;
	            // Size navbars on page reinit
	            if (app.sizeNavbars) app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	            // Reinit slider
	            if (app.reinitPageSwiper) app.reinitPageSwiper(pageContainer);
	            // Reinit lazy load
	            if (app.reinitLazyLoad) app.reinitLazyLoad(pageContainer);
	        };
	        app.initPageWithCallback = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var viewContainer = pageContainer.parents('.' + app.params.viewClass);
	            if (viewContainer.length === 0) return;
	            var view = viewContainer[0].f7View || undefined;
	            var url = view && view.url ? view.url : undefined;
	            if (viewContainer && pageContainer.attr('data-page')) {
	                viewContainer.attr('data-page', pageContainer.attr('data-page'));
	            }
	            app.pageInitCallback(view, {pageContainer: pageContainer[0], url: url, position: 'center'});
	        };
	
	        /*======================================================
	        ************   Navigation / Router   ************
	        ======================================================*/
	        app.router = {
	            _remove: function (el) {
	                if (app.params.routerRemoveTimeout || app.params.routerRemoveWithTimeout) {
	                    setTimeout(function () {
	                        $(el).remove();
	                    }, 0);
	                }
	                else $(el).remove();
	            },
	            _modalsSelector: '.popup, .modal, .popover, .actions-modal, .picker-modal, .login-screen',
	            // Temporary DOM Element
	            temporaryDom: document.createElement('div'),
	        
	            // Find page or navbar in passed container which are related to View
	            findElement: function (selector, container, view, notCached) {
	                container = $(container);
	                if (notCached) selector = selector + ':not(.cached)';
	                var found = container.find(selector).filter(function (index, el) {
	                    return $(el).parents(app.router._modalsSelector).length === 0;
	                });
	                if (found.length > 1) {
	                    if (typeof view.selector === 'string') {
	                        // Search in related view
	                        found = container.find(view.selector + ' ' + selector);
	                    }
	                    if (found.length > 1) {
	                        // Search in main view
	                        found = container.find('.' + app.params.viewMainClass + ' ' + selector);
	                    }
	                }
	                if (found.length === 1) return found;
	                else {
	                    // Try to find non cached
	                    if (!notCached) found = app.router.findElement(selector, container, view, true);
	                    if (found && found.length === 1) return found;
	                    if (found && found.length > 1) return $(found[0]);
	                    else return undefined;
	                }
	            },
	        
	            // Set pages classes for animationEnd
	            animatePages: function (leftPage, rightPage, direction) {
	                // Loading new page
	                var removeClasses = 'page-on-center page-on-right page-on-left';
	                if (direction === 'to-left') {
	                    leftPage.removeClass(removeClasses).addClass('page-from-center-to-left');
	                    rightPage.removeClass(removeClasses).addClass('page-from-right-to-center');
	                }
	                // Go back
	                if (direction === 'to-right') {
	                    leftPage.removeClass(removeClasses).addClass('page-from-left-to-center');
	                    rightPage.removeClass(removeClasses).addClass('page-from-center-to-right');
	        
	                }
	            },
	        
	            // Prepare navbar before animarion
	            prepareNavbar: function (newNavbarInner, oldNavbarInner, newNavbarPosition) {
	                $(newNavbarInner).find('.sliding').each(function () {
	                    var sliding = $(this);
	                    var slidingOffset = newNavbarPosition === 'right' ? this.f7NavbarRightOffset : this.f7NavbarLeftOffset;
	        
	                    if (app.params.animateNavBackIcon) {
	                        if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                            sliding.find('.back .icon').transform('translate3d(' + (-slidingOffset) + 'px,0,0)');
	                        }
	                    }
	                    sliding.transform('translate3d(' + slidingOffset + 'px,0,0)');
	                });
	            },
	        
	            // Set navbars classes for animation
	            animateNavbars: function (leftNavbarInner, rightNavbarInner, direction) {
	                // Loading new page
	                var removeClasses = 'navbar-on-right navbar-on-center navbar-on-left';
	                if (direction === 'to-left') {
	                    rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-right-to-center');
	                    rightNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        sliding.transform('translate3d(0px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                            }
	                        }
	                    });
	        
	                    leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-left');
	                    leftNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        var rightText;
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('center') && rightNavbarInner.find('.sliding.left .back .icon').length > 0) {
	                                rightText = rightNavbarInner.find('.sliding.left .back span');
	                                if (rightText.length > 0) this.f7NavbarLeftOffset += rightText[0].offsetLeft;
	                            }
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarLeftOffset) + 'px,0,0)');
	                            }
	                        }
	                        sliding.transform('translate3d(' + (this.f7NavbarLeftOffset) + 'px,0,0)');
	                    });
	                }
	                // Go back
	                if (direction === 'to-right') {
	                    leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-left-to-center');
	                    leftNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        sliding.transform('translate3d(0px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                            }
	                        }
	                    });
	        
	                    rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-right');
	                    rightNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarRightOffset) + 'px,0,0)');
	                            }
	                        }
	                        sliding.transform('translate3d(' + (this.f7NavbarRightOffset) + 'px,0,0)');
	                    });
	                }
	            },
	        
	            preprocess: function(view, content, url, next) {
	                // Plugin hook
	                app.pluginHook('routerPreprocess', view, content, url, next);
	        
	                // Preprocess by plugin
	                content = app.pluginProcess('preprocess', content);
	        
	                if (view && view.params && view.params.preprocess) {
	                    content = view.params.preprocess(content, url, next);
	                    if (typeof content !== 'undefined') {
	                        next(content);
	                    }
	                }
	                else if (app.params.preprocess) {
	                    content = app.params.preprocess(content, url, next);
	                    if (typeof content !== 'undefined') {
	                        next(content);
	                    }
	                }
	                else {
	                    next(content);
	                }
	            },
	            preroute: function(view, options, isBack) {
	                if (isBack) options.isBack = true;
	                app.pluginHook('routerPreroute', view, options);
	                if ((app.params.preroute && app.params.preroute(view, options) === false) || (view && view.params.preroute && view.params.preroute(view, options) === false)) {
	                    return true;
	                }
	                else {
	                    return false;
	                }
	            },
	        
	            template7Render: function (view, options) {
	                var url = options.url,
	                    content = options.content, //initial content
	                    t7_rendered_content = options.content, // will be rendered using Template7
	                    context = options.context, // Context data for Template7
	                    contextName = options.contextName,
	                    template = options.template; // Template 7 compiled template
	        
	                var t7_ctx, t7_template;
	                if (typeof content === 'string') {
	                    if (url) {
	                        if (app.template7Cache[url] && !options.ignoreCache) t7_template = t7.cache[url];
	                        else {
	                            t7_template = t7.compile(content);
	                            t7.cache[url] = t7_template;
	                        }
	                    }
	                    else t7_template = t7.compile(content);
	                }
	                else if (template) {
	                    t7_template = template;
	                }
	        
	                if (context) {
	                    t7_ctx = context;
	                    if (context && url) {
	                        view.contextCache[url] = context;
	                    }
	                }
	                else {
	                    if (contextName) {
	                        if (contextName.indexOf('.') >= 0) {
	                            var _ctx_path = contextName.split('.');
	                            var _ctx = t7.data[_ctx_path[0]];
	                            for (var i = 1; i < _ctx_path.length; i++) {
	                                if (_ctx_path[i]) _ctx = _ctx[_ctx_path[i]];
	                            }
	                            t7_ctx = _ctx;
	                        }
	                        else t7_ctx = t7.data[contextName];
	                    }
	                    if (!t7_ctx && url) {
	                        t7_ctx = t7.data['url:' + url];
	                    }
	                    if (!t7_ctx && typeof content === 'string' && !template) {
	                        //try to find by page name in content
	                        var pageNameMatch = content.match(/(data-page=["'][^"^']*["'])/);
	                        if (pageNameMatch) {
	                            var page = pageNameMatch[0].split('data-page=')[1].replace(/['"]/g, '');
	                            if (page) t7_ctx = t7.data['page:' + page];
	                        }
	                    }
	                    if (!t7_ctx && template && t7.templates) {
	                        // Try to find matched template name in t7.templates
	                        for (var templateName in t7.templates) {
	                            if (t7.templates[templateName] === template) t7_ctx = t7.data[templateName];
	                        }
	                    }
	                    if (!t7_ctx && url && url in view.contextCache) {
	                        t7_ctx = view.contextCache[url];
	                    }
	                    if (!t7_ctx) {
	                        t7_ctx = {};
	                    }
	                }
	        
	                if (t7_template && t7_ctx) {
	                    if (typeof t7_ctx === 'function') t7_ctx = t7_ctx();
	                    if (url) {
	                        // Extend data with URL query
	                        var query = $.parseUrlQuery(url);
	                        t7_ctx.url_query = {};
	                        for (var key in query) {
	                            t7_ctx.url_query[key] = query[key];
	                        }
	                    }
	                    try {
	                        t7_rendered_content = t7_template(t7_ctx);
	                    }
	                    catch (e) {
	                        t7_rendered_content = '';
	                        if (window.console && window.console.error) {
	                            console.error(e);
	                        }
	                    }
	                }
	        
	                return {content: t7_rendered_content, context: t7_ctx};
	            }
	        };
	        
	        
	        app.router._load = function (view, options) {
	            // Plugin hook
	            app.pluginHook('routerLoad', view, options);
	        
	            var url = options.url,
	                content = options.content, //initial content
	                t7_rendered = {content: options.content},
	                template = options.template, // Template 7 compiled template
	                pageName = options.pageName,
	                viewContainer = $(view.container),
	                pagesContainer = $(view.pagesContainer),
	                animatePages = options.animatePages,
	                newPage, oldPage, pagesInView, i, oldNavbarInner, newNavbarInner, navbar, dynamicNavbar, reloadPosition,
	                isDynamicPage = typeof url === 'undefined' && content || template,
	                pushState = options.pushState,
	                pageElement = options.pageElement;
	        
	            if (typeof animatePages === 'undefined') animatePages = view.params.animatePages;
	        
	            // Render with Template7
	            if (app.params.template7Pages && typeof content === 'string' || template) {
	                t7_rendered = app.router.template7Render(view, options);
	                if (t7_rendered.content && !content) {
	                    content = t7_rendered.content;
	                }
	            }
	        
	            app.router.temporaryDom.innerHTML = '';
	        
	            // Parse DOM
	            if (!pageName && !pageElement) {
	                if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	                    app.router.temporaryDom.innerHTML = t7_rendered.content;
	                } else {
	                    if ('length' in content && content.length > 1) {
	                        for (var ci = 0; ci < content.length; ci++) {
	                            $(app.router.temporaryDom).append(content[ci]);
	                        }
	                    } else {
	                        $(app.router.temporaryDom).append(content);
	                    }
	                }
	            }
	        
	            // Reload position
	            reloadPosition = options.reload && (options.reloadPrevious ? 'left' : 'center');
	        
	            // Find new page
	            if (pageName) newPage = pagesContainer.find('.page[data-page="' + pageName + '"]');
	            else {
	                if (pageElement) newPage = $(pageElement);
	                else newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	            }
	            // If page not found exit
	            if (!newPage || newPage.length === 0 || (pageName && view.activePage && view.activePage.name === pageName)) {
	                view.allowPageChange = true;
	                return;
	            }
	        
	            newPage.addClass(options.reload ? 'page-on-' + reloadPosition : 'page-on-right');
	        
	            // Find old page (should be the last one) and remove older pages
	            pagesInView = pagesContainer.children('.page:not(.cached)');
	            if (pageElement) {
	                pagesInView = pagesInView.filter(function (index, page) {
	                    if (page !== pageElement) return page;
	                });
	            }
	        
	            if (options.reload && options.reloadPrevious && pagesInView.length === 1)  {
	                view.allowPageChange = true;
	                return;
	            }
	        
	            if (options.reload) {
	                oldPage = pagesInView.eq(pagesInView.length - 1);
	            }
	            else {
	                if (pagesInView.length > 1) {
	                    for (i = 0; i < pagesInView.length - 2; i++) {
	                        if (!view.params.domCache) {
	                            app.pageRemoveCallback(view, pagesInView[i], 'left');
	                            app.router._remove(pagesInView[i]);
	                        }
	                        else {
	                            $(pagesInView[i]).addClass('cached');
	                        }
	                    }
	                    if (!view.params.domCache) {
	                        app.pageRemoveCallback(view, pagesInView[i], 'left');
	                        app.router._remove(pagesInView[i]);
	                    }
	                    else {
	                        $(pagesInView[i]).addClass('cached');
	                    }
	                }
	                oldPage = pagesContainer.children('.page:not(.cached)');
	            }
	            if (pageElement && oldPage.length > 1) {
	                oldPage = oldPage.filter(function (index, page) {
	                    if (page !== pageElement) return page;
	                });
	            }
	            if(view.params.domCache || pageElement) newPage.removeClass('cached');
	        
	            // Dynamic navbar
	            if (view.params.dynamicNavbar) {
	                dynamicNavbar = true;
	                // Find navbar
	                if (pageName) {
	                    newNavbarInner = viewContainer.find('.navbar-inner[data-page="' + pageName + '"]');
	                }
	                else {
	                    newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	                }
	                if (!newNavbarInner || newNavbarInner.length === 0) {
	                    // Look in page
	                    newNavbarInner = newPage.find('.navbar-inner');
	                    if (!newNavbarInner || newNavbarInner.length === 0) {
	                        // Set false
	                        dynamicNavbar = false;
	                    }
	                    else {
	                        if (newNavbarInner.parent('.navbar').length > 0) {
	                            newNavbarInner.prependTo(newPage);
	                        }
	                    }
	                }
	                if (dynamicNavbar && newPage.find('.navbar').length > 0) {
	                    app.router._remove(newPage.find('.navbar').filter(function(index, el){
	                        return $(el).parents(app.router._modalsSelector).length === 0;
	                    }));
	                }
	                navbar = viewContainer.children('.navbar');
	                if (options.reload) {
	                    oldNavbarInner = navbar.find('.navbar-inner:not(.cached):last-child');
	                }
	                else {
	                    oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	        
	                    if (oldNavbarInner.length > 0) {
	                        for (i = 0; i < oldNavbarInner.length - 1; i++) {
	                            if (!view.params.domCache) {
	                                app.navbarRemoveCallback(view, pagesInView[i], navbar[0], oldNavbarInner[i]);
	                                app.router._remove(oldNavbarInner[i]);
	                            }
	                            else
	                                $(oldNavbarInner[i]).addClass('cached');
	                        }
	                        if (!newNavbarInner && oldNavbarInner.length === 1) {
	                            if (!view.params.domCache) {
	                                app.navbarRemoveCallback(view, pagesInView[0], navbar[0], oldNavbarInner[0]);
	                                app.router._remove(oldNavbarInner[0]);
	                            }
	                            else
	                                $(oldNavbarInner[0]).addClass('cached');
	                        }
	                        oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	                    }
	                }
	            }
	            if (dynamicNavbar) {
	                newNavbarInner.addClass(options.reload ? 'navbar-on-' + reloadPosition : 'navbar-on-right');
	                if(view.params.domCache || pageElement) newNavbarInner.removeClass('cached');
	                newPage[0].f7RelatedNavbar = newNavbarInner[0];
	                newNavbarInner[0].f7RelatedPage = newPage[0];
	            }
	        
	            // save content areas into view's cache
	            if (!url) {
	                var newPageName = pageName || newPage.attr('data-page');
	                if (isDynamicPage) url = '#' + app.params.dynamicPageUrl.replace(/{{name}}/g, newPageName).replace(/{{index}}/g, view.history.length - (options.reload ? 1 : 0));
	                else url = '#' + newPageName;
	                if (!view.params.domCache) {
	                    view.contentCache[url] = content;
	                }
	                if (view.params.domCache && pageName) {
	                    view.pagesCache[url] = pageName;
	                }
	            }
	            else if (url && pageElement) {
	                view.pageElementsCache[url] = {
	                    page: newPage,
	                    navbarInner: newNavbarInner
	                };
	            }
	        
	            // Push State
	            if (app.params.pushState && !options.reloadPrevious && view.main)  {
	                if (typeof pushState === 'undefined') pushState = true;
	                var pushStateRoot = app.params.pushStateRoot || '';
	                var method = options.reload ? 'replaceState' : 'pushState';
	                if (pushState) {
	                    if (!isDynamicPage && !pageName) {
	                        history[method]({url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                    else if (isDynamicPage && content) {
	                        history[method]({content: typeof content === 'string' ? content : '', url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                    else if (pageName) {
	                        history[method]({pageName: pageName, url: url, viewIndex: app.views.indexOf(view)}, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                }
	            }
	        
	            // Update View history
	            view.url = url;
	            if (options.reload) {
	                var lastUrl = view.history[view.history.length - (options.reloadPrevious ? 2 : 1)];
	                if (lastUrl &&
	                    lastUrl.indexOf('#') === 0 &&
	                    lastUrl in view.contentCache &&
	                    lastUrl !== url &&
	                    view.history.indexOf(lastUrl) === -1) {
	                    view.contentCache[lastUrl] = null;
	                    delete view.contentCache[lastUrl];
	                }
	                else if (lastUrl &&
	                    lastUrl in view.pageElementsCache &&
	                    lastUrl !== url &&
	                    (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	                    view.pageElementsCache[lastUrl] = null;
	                    delete view.pageElementsCache[lastUrl];
	                }
	                if (lastUrl &&
	                    lastUrl in view.contextCache &&
	                    lastUrl !== url &&
	                    (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	                    view.contextCache[lastUrl] = null;
	                    delete view.contextCache[lastUrl];
	                }
	                view.history[view.history.length - (options.reloadPrevious ? 2 : 1)] = url;
	            }
	            else {
	                view.history.push(url);
	            }
	        
	            // Unique history
	            var historyBecameUnique = false;
	            if (view.params.uniqueHistory) {
	                var _history = view.history;
	                var _url = url;
	                if (view.params.uniqueHistoryIgnoreGetParameters) {
	                    _history = [];
	                    _url = url.split('?')[0];
	                    for (i = 0; i < view.history.length; i++) {
	                        _history.push(view.history[i].split('?')[0]);
	                    }
	                }
	        
	                if (_history.indexOf(_url) !== _history.lastIndexOf(_url)) {
	                    view.history = view.history.slice(0, _history.indexOf(_url));
	                    view.history.push(url);
	                    historyBecameUnique = true;
	                }
	            }
	            // Dom manipulations
	            if (options.reloadPrevious) {
	                oldPage = oldPage.prev('.page');
	                newPage.insertBefore(oldPage);
	                if (dynamicNavbar) {
	                    oldNavbarInner = oldNavbarInner.prev('.navbar-inner');
	                    newNavbarInner.insertAfter(oldNavbarInner);
	                }
	            }
	            else {
	                pagesContainer.append(newPage[0]);
	                if (dynamicNavbar) navbar.append(newNavbarInner[0]);
	            }
	            // Remove Old Page And Navbar
	            if (options.reload) {
	                if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	                    oldPage.addClass('cached');
	                    if (dynamicNavbar) oldNavbarInner.addClass('cached');
	                }
	                else {
	                    app.pageRemoveCallback(view, oldPage[0], reloadPosition);
	                    if (dynamicNavbar) app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	                    app.router._remove(oldPage);
	                    if (dynamicNavbar) app.router._remove(oldNavbarInner);
	                }
	            }
	        
	            // Page Init Events
	            app.pageInitCallback(view, {
	                pageContainer: newPage[0],
	                url: url,
	                position: options.reload ? reloadPosition : 'right',
	                navbarInnerContainer: dynamicNavbar ? newNavbarInner && newNavbarInner[0] : undefined,
	                oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	                context: t7_rendered.context || options.context,
	                query: options.query,
	                fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	                reload: options.reload,
	                reloadPrevious: options.reloadPrevious
	            });
	        
	            // Navbar init event
	            if (dynamicNavbar) {
	                app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, options.reload ? reloadPosition : 'right');
	            }
	        
	            if (options.reload) {
	                view.allowPageChange = true;
	                if (historyBecameUnique) view.refreshPreviousPage();
	                return;
	            }
	        
	            if (dynamicNavbar && animatePages) {
	                app.router.prepareNavbar(newNavbarInner, oldNavbarInner, 'right');
	            }
	            // Force reLayout
	            var clientLeft = newPage[0].clientLeft;
	        
	            // Before Anim Callback
	            app.pageAnimCallback('before', view, {
	                pageContainer: newPage[0],
	                url: url,
	                position: 'right',
	                oldPage: oldPage,
	                newPage: newPage,
	                query: options.query,
	                fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	            });
	        
	            function afterAnimation() {
	                view.allowPageChange = true;
	                newPage.removeClass('page-from-right-to-center page-on-right page-on-left').addClass('page-on-center');
	                oldPage.removeClass('page-from-center-to-left page-on-center page-on-right').addClass('page-on-left');
	                if (dynamicNavbar) {
	                    newNavbarInner.removeClass('navbar-from-right-to-center navbar-on-left navbar-on-right').addClass('navbar-on-center');
	                    oldNavbarInner.removeClass('navbar-from-center-to-left navbar-on-center navbar-on-right').addClass('navbar-on-left');
	                }
	                app.pageAnimCallback('after', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'right',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	                if (app.params.pushState && view.main) app.pushStateClearQueue();
	                if (!(view.params.swipeBackPage || view.params.preloadPreviousPage)) {
	                    if (view.params.domCache) {
	                        oldPage.addClass('cached');
	                        if (dynamicNavbar) oldNavbarInner.addClass('cached');
	                    }
	                    else {
	                        if (!(url.indexOf('#') === 0 && newPage.attr('data-page').indexOf('smart-select-') === 0)) {
	                            app.pageRemoveCallback(view, oldPage[0], 'left');
	                            if (dynamicNavbar) app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	                            app.router._remove(oldPage);
	                            if (dynamicNavbar) app.router._remove(oldNavbarInner);
	                        }
	                    }
	                }
	                if (view.params.uniqueHistory && historyBecameUnique) {
	                    view.refreshPreviousPage();
	                }
	            }
	            if (animatePages) {
	                // Set pages before animation
	                if (app.params.material && app.params.materialPageLoadDelay) {
	                    setTimeout(function () {
	                        app.router.animatePages(oldPage, newPage, 'to-left', view);
	                    }, app.params.materialPageLoadDelay);
	                }
	                else {
	                    app.router.animatePages(oldPage, newPage, 'to-left', view);
	                }
	        
	                // Dynamic navbar animation
	                if (dynamicNavbar) {
	                    setTimeout(function() {
	                        app.router.animateNavbars(oldNavbarInner, newNavbarInner, 'to-left', view);
	                    }, 0);
	                }
	                newPage.animationEnd(function () {
	                    afterAnimation();
	                });
	            }
	            else {
	                if (dynamicNavbar) newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	                afterAnimation();
	            }
	        
	        };
	        
	        app.router.load = function (view, options) {
	            options = options || {};
	            if (app.router.preroute(view, options)) {
	                return false;
	            }
	            var url = options.url;
	            var content = options.content;
	            var pageName = options.pageName;
	            var pageElement = options.pageElement;
	            if (pageName) {
	                if (pageName.indexOf('?') > 0) {
	                    options.query = $.parseUrlQuery(pageName);
	                    options.pageName = pageName = pageName.split('?')[0];
	                }
	            }
	            var template = options.template;
	            if (view.params.reloadPages === true) options.reload = true;
	        
	            if (!view.allowPageChange) return false;
	            if (url && view.url === url && !options.reload && !view.params.allowDuplicateUrls) return false;
	            view.allowPageChange = false;
	            if (app.xhr && view.xhr && view.xhr === app.xhr) {
	                app.xhr.abort();
	                app.xhr = false;
	            }
	            function proceed(content) {
	                app.router.preprocess(view, content, url, function (content) {
	                    options.content = content;
	                    app.router._load(view, options);
	                });
	            }
	            if (content || pageName || pageElement) {
	                proceed(content);
	                return;
	            }
	            else if (template) {
	                app.router._load(view, options);
	                return;
	            }
	        
	            if (!options.url || options.url === '#') {
	                view.allowPageChange = true;
	                return;
	            }
	            app.get(options.url, view, options.ignoreCache, function (content, error) {
	                if (error) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                proceed(content);
	            });
	        };
	        
	        app.router._back = function (view, options) {
	            options = options || {};
	        
	            app.pluginHook('routerBack', view, options);
	        
	            var url = options.url,
	                content = options.content,
	                t7_rendered = {content: options.content}, // will be rendered using Template7
	                template = options.template, // Template 7 compiled template
	                animatePages = options.animatePages,
	                preloadOnly = options.preloadOnly,
	                pushState = options.pushState,
	                ignoreCache = options.ignoreCache,
	                force = options.force,
	                pageName = options.pageName,
	                pageElement = options.pageElement;
	        
	            var viewContainer = $(view.container),
	                pagesContainer = $(view.pagesContainer),
	                pagesInView = pagesContainer.children('.page:not(.cached)'),
	                oldPage, newPage, oldNavbarInner, newNavbarInner, navbar, navbarInners, dynamicNavbar, manipulateDom = true;
	        
	            if (typeof animatePages === 'undefined') animatePages = view.params.animatePages;
	        
	            // Render with Template7
	            if (app.params.template7Pages && typeof content === 'string' || template) {
	                t7_rendered = app.router.template7Render(view, options);
	                if (t7_rendered.content && !content) {
	                    content = t7_rendered.content;
	                }
	            }
	        
	            // Animation
	            function afterAnimation() {
	                app.pageBackCallback('after', view, {
	                    pageContainer: oldPage[0],
	                    url: url,
	                    position: 'center',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                });
	                app.pageAnimCallback('after', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	                app.router.afterBack(view, oldPage[0], newPage[0]);
	            }
	            function animateBack() {
	                // Page before animation callback
	                app.pageBackCallback('before', view, {
	                    pageContainer: oldPage[0],
	                    url: url,
	                    position: 'center',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                });
	                app.pageAnimCallback('before', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	        
	                if (animatePages) {
	                    // Set pages before animation
	                    app.router.animatePages(newPage, oldPage, 'to-right', view);
	        
	                    // Dynamic navbar animation
	                    if (dynamicNavbar) {
	                        setTimeout(function () {
	                            app.router.animateNavbars(newNavbarInner, oldNavbarInner, 'to-right', view);
	                        }, 0);
	                    }
	        
	                    newPage.animationEnd(function () {
	                        afterAnimation();
	                    });
	                }
	                else {
	                    if (dynamicNavbar) newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	                    afterAnimation();
	                }
	            }
	        
	            function parseNewPage() {
	                app.router.temporaryDom.innerHTML = '';
	                // Parse DOM
	                if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	                    app.router.temporaryDom.innerHTML = t7_rendered.content;
	                } else {
	                    if ('length' in content && content.length > 1) {
	                        for (var ci = 0; ci < content.length; ci++) {
	                            $(app.router.temporaryDom).append(content[ci]);
	                        }
	                    } else {
	                        $(app.router.temporaryDom).append(content);
	                    }
	                }
	                if (pageElement) newPage = $(pageElement);
	                else newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	        
	                if (view.params.dynamicNavbar) {
	                    // Find navbar
	                    newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	                }
	            }
	            function setPages() {
	                // If pages not found or there are still more than one, exit
	                if (!newPage || newPage.length === 0) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                if (view.params.dynamicNavbar && typeof dynamicNavbar === 'undefined') {
	                    if (!newNavbarInner || newNavbarInner.length === 0) {
	                        dynamicNavbar = false;
	                    }
	                    else {
	                        dynamicNavbar = true;
	                    }
	                }
	        
	                newPage.addClass('page-on-left').removeClass('cached');
	                if (dynamicNavbar) {
	                    navbar = viewContainer.children('.navbar');
	                    navbarInners = navbar.find('.navbar-inner:not(.cached)');
	                    newNavbarInner.addClass('navbar-on-left').removeClass('cached');
	                }
	                // Remove/hide previous page in force mode
	                if (force) {
	                    var pageToRemove, navbarToRemove;
	                    pageToRemove = $(pagesInView[pagesInView.length - 2]);
	        
	                    if (dynamicNavbar) navbarToRemove = $(pageToRemove[0] && pageToRemove[0].f7RelatedNavbar || navbarInners[navbarInners.length - 2]);
	                    if (view.params.domCache && view.initialPages.indexOf(pageToRemove[0]) >= 0) {
	                        if (pageToRemove.length && pageToRemove[0] !== newPage[0]) pageToRemove.addClass('cached');
	                        if (dynamicNavbar && navbarToRemove.length && navbarToRemove[0] !== newNavbarInner[0]) {
	                            navbarToRemove.addClass('cached');
	                        }
	                    }
	                    else {
	                        var removeNavbar = dynamicNavbar && navbarToRemove.length;
	                        if (pageToRemove.length) {
	                            app.pageRemoveCallback(view, pageToRemove[0], 'right');
	                            if (removeNavbar) {
	                                app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                            }
	                            app.router._remove(pageToRemove);
	                            if (removeNavbar) app.router._remove(navbarToRemove);
	                        }
	                        else if (removeNavbar) {
	                            app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                            app.router._remove(navbarToRemove);
	                        }
	                    }
	                    pagesInView = pagesContainer.children('.page:not(.cached)');
	                    if (dynamicNavbar) {
	                        navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	                    }
	                    if (view.history.indexOf(url) >= 0) {
	                        view.history = view.history.slice(0, view.history.indexOf(url) + 2);
	                    }
	                    else {
	                        if (view.history[[view.history.length - 2]]) {
	                            view.history[view.history.length - 2] = url;
	                        }
	                        else {
	                            view.history.unshift(url);
	                        }
	                    }
	                }
	        
	                oldPage = $(pagesInView[pagesInView.length - 1]);
	                if (view.params.domCache) {
	                    if (oldPage[0] === newPage[0]) {
	                        oldPage = pagesContainer.children('.page.page-on-center');
	                        if (oldPage.length === 0 && view.activePage) oldPage = $(view.activePage.container);
	                    }
	                }
	        
	                if (dynamicNavbar && !oldNavbarInner) {
	                    oldNavbarInner = $(navbarInners[navbarInners.length - 1]);
	                    if (view.params.domCache) {
	                        if (oldNavbarInner[0] === newNavbarInner[0]) {
	                            oldNavbarInner = navbar.children('.navbar-inner.navbar-on-center:not(.cached)');
	                        }
	                        if (oldNavbarInner.length === 0) {
	                            oldNavbarInner = navbar.children('.navbar-inner[data-page="'+oldPage.attr('data-page')+'"]');
	                        }
	                    }
	                    if (oldNavbarInner.length === 0 || newNavbarInner[0] === oldNavbarInner[0]) dynamicNavbar = false;
	                }
	        
	                if (dynamicNavbar) {
	                    if (manipulateDom) newNavbarInner.insertBefore(oldNavbarInner);
	                    newNavbarInner[0].f7RelatedPage = newPage[0];
	                    newPage[0].f7RelatedNavbar = newNavbarInner[0];
	                }
	                if (manipulateDom) newPage.insertBefore(oldPage);
	        
	                // Page Init Events
	                app.pageInitCallback(view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    navbarInnerContainer: dynamicNavbar ? newNavbarInner[0] : undefined,
	                    oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	                    context: t7_rendered.context,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	                    preloadOnly: preloadOnly
	                });
	                if (dynamicNavbar) {
	                    app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, 'right');
	                }
	        
	                if (dynamicNavbar && newNavbarInner.hasClass('navbar-on-left') && animatePages) {
	                    app.router.prepareNavbar(newNavbarInner,  oldNavbarInner, 'left');
	                }
	        
	                if (preloadOnly) {
	                    view.allowPageChange = true;
	                    return;
	                }
	        
	                // Update View's URL
	                view.url = url;
	        
	                // Force reLayout
	                var clientLeft = newPage[0].clientLeft;
	        
	                animateBack();
	        
	                // Push state
	                if (app.params.pushState && view.main)  {
	                    if (typeof pushState === 'undefined') pushState = true;
	                    if (!preloadOnly && history.state && pushState) {
	                        history.back();
	                    }
	                }
	                return;
	            }
	        
	            // Simple go back when we have pages on left
	            if (pagesInView.length > 1 && !force) {
	                // Exit if only preloadOnly
	                if (preloadOnly) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                // Update View's URL
	                view.url = view.history[view.history.length - 2];
	                url = view.url;
	        
	                // Define old and new pages
	                newPage = $(pagesInView[pagesInView.length - 2]);
	                oldPage = $(pagesInView[pagesInView.length - 1]);
	        
	                // Dynamic navbar
	                if (view.params.dynamicNavbar) {
	                    dynamicNavbar = true;
	                    // Find navbar
	                    navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	                    newNavbarInner = $(navbarInners[0]);
	                    oldNavbarInner = $(navbarInners[1]);
	                    if (newNavbarInner.length === 0 || oldNavbarInner.length === 0 || oldNavbarInner[0] === newNavbarInner[0]) {
	                        dynamicNavbar = false;
	                    }
	                }
	                manipulateDom = false;
	                setPages();
	                return;
	            }
	        
	            if (!force) {
	                // Go back when there is no pages on left
	                if (!preloadOnly) {
	                    view.url = view.history[view.history.length - 2];
	                    url = view.url;
	                }
	        
	                if (content) {
	                    parseNewPage();
	                    setPages();
	                    return;
	                }
	                else if (pageName) {
	                    // Get dom cached pages
	                    newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                        if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                            newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                        }
	                        if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                            newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else if (url && url in view.pageElementsCache) {
	                    newPage = view.pageElementsCache[url].page;
	                    newNavbarInner = view.pageElementsCache[url].navbarInner;
	                    setPages();
	                    return;
	                }
	                else {
	                    view.allowPageChange = true;
	                    return;
	                }
	            }
	            else {
	                if (url && url === view.url || pageName && view.activePage && view.activePage.name === pageName) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                // Go back with force url
	                if (content) {
	                    parseNewPage();
	                    setPages();
	                    return;
	                }
	                else if (pageName && view.params.domCache) {
	                    if (pageName) url = '#' + pageName;
	        
	                    newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	                    if (newPage[0].f7PageData && newPage[0].f7PageData.url) {
	                        url = newPage[0].f7PageData.url;
	                    }
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                        if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                            newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                        }
	                        if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                            newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else if (pageElement && url) {
	                    newPage = $(pageElement);
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = newPage.find('.navbar-inner').filter(function (index, el) {
	                            return $(el).parents(app.router._modalsSelector).length === 0;
	                        });
	                        if (newNavbarInner.length > 0) {
	                            newPage.prepend(newNavbarInner);
	                            app.router._remove(newPage.find('.navbar').filter(function (index, el) {
	                                return $(el).parents(app.router._modalsSelector).length === 0;
	                            }));
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else {
	                    view.allowPageChange = true;
	                    return;
	                }
	            }
	        
	        };
	        app.router.back = function (view, options) {
	            options = options || {};
	            if (app.router.preroute(view, options, true)) {
	                return false;
	            }
	            var url = options.url;
	            var content = options.content;
	            var pageName = options.pageName;
	            var pageElement = options.pageElement;
	            if (pageName) {
	                if (pageName.indexOf('?') > 0) {
	                    options.query = $.parseUrlQuery(pageName);
	                    options.pageName = pageName = pageName.split('?')[0];
	                }
	            }
	            var force = options.force;
	            if (!view.allowPageChange) return false;
	            view.allowPageChange = false;
	            if (app.xhr && view.xhr && view.xhr === app.xhr) {
	                app.xhr.abort();
	                app.xhr = false;
	            }
	            var pagesInView = $(view.pagesContainer).find('.page:not(.cached)');
	        
	            function proceed(content) {
	                app.router.preprocess(view, content, url, function (content) {
	                    options.content = content;
	                    app.router._back(view, options);
	                });
	            }
	            if (pagesInView.length > 1 && !force) {
	                // Simple go back to previos page in view
	                app.router._back(view, options);
	                return;
	            }
	            if (!force) {
	                url = view.history[view.history.length - 2] || options.url;
	                if (!options.url) options.url = url;
	                if (!url) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                if (url.indexOf('#') === 0 && view.contentCache[url]) {
	                    proceed(view.contentCache[url]);
	                    return;
	                }
	                else if (url.indexOf('#') === 0 && view.params.domCache) {
	                    if (!pageName) options.pageName = url.split('#')[1];
	                    proceed();
	                    return;
	                }
	                else if (url && url in view.pageElementsCache) {
	                    proceed();
	                }
	                else if (url.indexOf('#') !== 0) {
	                    // Load ajax page
	                    app.get(options.url, view, options.ignoreCache, function (content, error) {
	                        if (error) {
	                            view.allowPageChange = true;
	                            return;
	                        }
	                        proceed(content);
	                    });
	                    return;
	                }
	            }
	            else {
	                // Go back with force url
	                if (!url && content) {
	                    proceed(content);
	                    return;
	                }
	                else if (!url && pageName) {
	                    if (pageName) url = '#' + pageName;
	                    proceed();
	                    return;
	                }
	                else if (url && pageElement) {
	                    proceed();
	                    return;
	                }
	                else if (url) {
	                    app.get(options.url, view, options.ignoreCache, function (content, error) {
	                        if (error) {
	                            view.allowPageChange = true;
	                            return;
	                        }
	                        proceed(content);
	                    });
	                    return;
	                }
	            }
	            view.allowPageChange = true;
	            return;
	        };
	        
	        app.router.afterBack = function (view, oldPage, newPage) {
	            // Remove old page and set classes on new one
	            oldPage = $(oldPage);
	            newPage = $(newPage);
	        
	            if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	                oldPage.removeClass('page-from-center-to-right').addClass('cached');
	            }
	            else {
	                app.pageRemoveCallback(view, oldPage[0], 'right');
	                app.router._remove(oldPage);
	            }
	        
	            newPage.removeClass('page-from-left-to-center page-on-left').addClass('page-on-center');
	            view.allowPageChange = true;
	        
	            // Update View's History
	            var previousURL = view.history.pop();
	        
	            var newNavbar;
	        
	            // Updated dynamic navbar
	            if (view.params.dynamicNavbar) {
	                var inners = $(view.container).children('.navbar').find('.navbar-inner:not(.cached)');
	                var oldNavbar = $(oldPage[0].f7RelatedNavbar || inners[1]);
	                if (view.params.domCache && view.initialNavbars.indexOf(oldNavbar[0]) >= 0) {
	                    oldNavbar.removeClass('navbar-from-center-to-right').addClass('cached');
	                }
	                else {
	                    app.navbarRemoveCallback(view, oldPage[0], undefined, oldNavbar[0]);
	                    app.router._remove(oldNavbar);
	                }
	                newNavbar = $(inners[0]).removeClass('navbar-on-left navbar-from-left-to-center').addClass('navbar-on-center');
	            }
	        
	            // Remove pages in dom cache
	            if (view.params.domCache) {
	                $(view.container).find('.page.cached').each(function () {
	                    var page = $(this);
	                    var pageUrl = page[0].f7PageData && page[0].f7PageData.url;
	                    if (pageUrl && view.history.indexOf(pageUrl) < 0 && view.initialPages.indexOf(this) < 0) {
	                        app.pageRemoveCallback(view, page[0], 'right');
	                        if (page[0].f7RelatedNavbar && view.params.dynamicNavbar) app.navbarRemoveCallback(view, page[0], undefined, page[0].f7RelatedNavbar);
	                        app.router._remove(page);
	                        if (page[0].f7RelatedNavbar && view.params.dynamicNavbar) app.router._remove(page[0].f7RelatedNavbar);
	                    }
	                });
	            }
	        
	            // Check previous page is content based only and remove it from content cache
	            if (!view.params.domCache &&
	                previousURL &&
	                previousURL.indexOf('#') > -1 &&
	                (previousURL in view.contentCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.contentCache[previousURL] = null;
	                delete view.contentCache[previousURL];
	            }
	            if (previousURL &&
	                (previousURL in view.pageElementsCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.pageElementsCache[previousURL] = null;
	                delete view.pageElementsCache[previousURL];
	            }
	            // Check for context cache
	            if (previousURL &&
	                (previousURL in view.contextCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.contextCache[previousURL] = null;
	                delete view.contextCache[previousURL];
	            }
	        
	            if (app.params.pushState && view.main) app.pushStateClearQueue();
	        
	            // Preload previous page
	            if (view.params.preloadPreviousPage) {
	                if (view.params.domCache && view.history.length > 1) {
	                    var preloadUrl = view.history[view.history.length - 2];
	                    var previousPage;
	                    var previousNavbar;
	                    if (preloadUrl && view.pagesCache[preloadUrl]) {
	                        // Load by page name
	                        previousPage = $(view.container).find('.page[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                        if (previousPage.next('.page')[0] !== newPage[0]) previousPage.insertBefore(newPage);
	                        if (newNavbar) {
	                            previousNavbar = $(view.container).children('.navbar').find('.navbar-inner[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                            if(!previousNavbar || previousNavbar.length === 0) previousNavbar = newNavbar.prev('.navbar-inner.cached');
	                            if (previousNavbar.next('.navbar-inner')[0] !== newNavbar[0]) previousNavbar.insertBefore(newNavbar);
	                        }
	                    }
	                    else {
	                        // Just load previous page
	                        previousPage = newPage.prev('.page.cached');
	                        if (newNavbar) previousNavbar = newNavbar.prev('.navbar-inner.cached');
	                    }
	                    if (previousPage && previousPage.length > 0) previousPage.removeClass('cached page-on-right page-on-center').addClass('page-on-left');
	                    if (previousNavbar && previousNavbar.length > 0) previousNavbar.removeClass('cached navbar-on-right navbar-on-center').addClass('navbar-on-left');
	                }
	                else {
	                    app.router.back(view, {preloadOnly: true});
	                }
	            }
	        };
	        
	
	        /*======================================================
	        ************   Modals   ************
	        ======================================================*/
	        var _modalTemplateTempDiv = document.createElement('div');
	        app.modalStack = [];
	        app.modalStackClearQueue = function () {
	            if (app.modalStack.length) {
	                (app.modalStack.shift())();
	            }
	        };
	        app.modal = function (params) {
	            params = params || {};
	            var modalHTML = '';
	            if (app.params.modalTemplate) {
	                if (!app._compiledTemplates.modal) app._compiledTemplates.modal = t7.compile(app.params.modalTemplate);
	                modalHTML = app._compiledTemplates.modal(params);
	            }
	            else {
	                var buttonsHTML = '';
	                if (params.buttons && params.buttons.length > 0) {
	                    for (var i = 0; i < params.buttons.length; i++) {
	                        buttonsHTML += '<span class="modal-button' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
	                    }
	                }
	                var titleHTML = params.title ? '<div class="modal-title">' + params.title + '</div>' : '';
	                var textHTML = params.text ? '<div class="modal-text">' + params.text + '</div>' : '';
	                var afterTextHTML = params.afterText ? params.afterText : '';
	                var noButtons = !params.buttons || params.buttons.length === 0 ? 'modal-no-buttons' : '';
	                var verticalButtons = params.verticalButtons ? 'modal-buttons-vertical': '';
	                var modalButtonsHTML = params.buttons && params.buttons.length > 0 ? '<div class="modal-buttons modal-buttons-' + params.buttons.length + ' ' + verticalButtons + '">' + buttonsHTML + '</div>' : '';
	                modalHTML = '<div class="modal ' + noButtons + ' ' + (params.cssClass || '') + '"><div class="modal-inner">' + (titleHTML + textHTML + afterTextHTML) + '</div>' + modalButtonsHTML + '</div>';
	            }
	        
	            _modalTemplateTempDiv.innerHTML = modalHTML;
	        
	            var modal = $(_modalTemplateTempDiv).children();
	        
	            app.root.append(modal[0]);
	        
	            // Add events on buttons
	            modal.find('.modal-button').each(function (index, el) {
	                $(el).on('click', function (e) {
	                    if (params.buttons[index].close !== false) app.closeModal(modal);
	                    if (params.buttons[index].onClick) params.buttons[index].onClick(modal, e);
	                    if (params.onClick) params.onClick(modal, index);
	                });
	            });
	            app.openModal(modal);
	            return modal[0];
	        };
	        app.alert = function (text, title, callbackOk) {
	            if (typeof title === 'function') {
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                buttons: [ {text: app.params.modalButtonOk, bold: true, onClick: callbackOk} ]
	            });
	        };
	        app.confirm = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                buttons: [
	                    {text: app.params.modalButtonCancel, onClick: callbackCancel},
	                    {text: app.params.modalButtonOk, bold: true, onClick: callbackOk}
	                ]
	            });
	        };
	        app.prompt = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field"><input type="text" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    if (index === 0 && callbackCancel) callbackCancel($(modal).find('.modal-text-input').val());
	                    if (index === 1 && callbackOk) callbackOk($(modal).find('.modal-text-input').val());
	                }
	            });
	        };
	        app.modalLogin = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field modal-input-double"><input type="text" name="modal-username" placeholder="' + app.params.modalUsernamePlaceholder + '" class="modal-text-input"></div><div class="input-field modal-input-double"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    var username = $(modal).find('.modal-text-input[name="modal-username"]').val();
	                    var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                    if (index === 0 && callbackCancel) callbackCancel(username, password);
	                    if (index === 1 && callbackOk) callbackOk(username, password);
	                }
	            });
	        };
	        app.modalPassword = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                    if (index === 0 && callbackCancel) callbackCancel(password);
	                    if (index === 1 && callbackOk) callbackOk(password);
	                }
	            });
	        };
	        app.showPreloader = function (title) {
	            return app.modal({
	                title: title || app.params.modalPreloaderTitle,
	                text: '<div class="preloader">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</div>',
	                cssClass: 'modal-preloader'
	            });
	        };
	        app.hidePreloader = function () {
	            app.closeModal('.modal.modal-in');
	        };
	        app.showIndicator = function () {
	            if ($('.preloader-indicator-overlay').length > 0) return;
	            app.root.append('<div class="preloader-indicator-overlay"></div><div class="preloader-indicator-modal"><span class="preloader preloader-white">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</span></div>');
	        };
	        app.hideIndicator = function () {
	            $('.preloader-indicator-overlay, .preloader-indicator-modal').remove();
	        };
	        // Action Sheet
	        app.actions = function (target, params, animated) {
	            var toPopover = false, modal, groupSelector, buttonSelector;
	            if (arguments.length === 1 || arguments.length === 2 && typeof arguments[1] === 'boolean') {
	                // Actions
	                params = arguments[0];
	                animated = arguments[1];
	            }
	            else {
	                // Popover
	                if (app.device.ios) {
	                    if (app.device.ipad) toPopover = true;
	                }
	                else {
	                    if (app.width >= 768) toPopover = true;
	                }
	            }
	            if (typeof animated === 'undefined') animated = true;
	        
	            params = params || [];
	        
	            if (params.length > 0 && !Array.isArray(params[0])) {
	                params = [params];
	            }
	            var modalHTML;
	            if (toPopover) {
	                var actionsToPopoverTemplate = app.params.modalActionsToPopoverTemplate ||
	                    '<div class="popover actions-popover">' +
	                      '<div class="popover-inner">' +
	                        '{{#each this}}' +
	                        '<div class="list-block">' +
	                          '<ul>' +
	                            '{{#each this}}' +
	                            '{{#if label}}' +
	                            '<li class="actions-popover-label {{#if color}}color-{{color}}{{/if}} {{#if bold}}actions-popover-bold{{/if}}">{{text}}</li>' +
	                            '{{else}}' +
	                            '<li><a href="#" class="item-link list-button {{#if color}}color-{{color}}{{/if}} {{#if bg}}bg-{{bg}}{{/if}} {{#if bold}}actions-popover-bold{{/if}} {{#if disabled}}disabled{{/if}}">{{text}}</a></li>' +
	                            '{{/if}}' +
	                            '{{/each}}' +
	                          '</ul>' +
	                        '</div>' +
	                        '{{/each}}' +
	                      '</div>' +
	                    '</div>';
	                if (!app._compiledTemplates.actionsToPopover) {
	                    app._compiledTemplates.actionsToPopover = t7.compile(actionsToPopoverTemplate);
	                }
	                var popoverHTML = app._compiledTemplates.actionsToPopover(params);
	                modal = $(app.popover(popoverHTML, target, true, animated));
	                groupSelector = '.list-block ul';
	                buttonSelector = '.list-button';
	            }
	            else {
	                if (app.params.modalActionsTemplate) {
	                    if (!app._compiledTemplates.actions) app._compiledTemplates.actions = t7.compile(app.params.modalActionsTemplate);
	                    modalHTML = app._compiledTemplates.actions(params);
	                }
	                else {
	                    var buttonsHTML = '';
	                    for (var i = 0; i < params.length; i++) {
	                        for (var j = 0; j < params[i].length; j++) {
	                            if (j === 0) buttonsHTML += '<div class="actions-modal-group">';
	                            var button = params[i][j];
	                            var buttonClass = button.label ? 'actions-modal-label' : 'actions-modal-button';
	                            if (button.bold) buttonClass += ' actions-modal-button-bold';
	                            if (button.color) buttonClass += ' color-' + button.color;
	                            if (button.bg) buttonClass += ' bg-' + button.bg;
	                            if (button.disabled) buttonClass += ' disabled';
	                            buttonsHTML += '<div class="' + buttonClass + '">' + button.text + '</div>';
	                            if (j === params[i].length - 1) buttonsHTML += '</div>';
	                        }
	                    }
	                    modalHTML = '<div class="actions-modal">' + buttonsHTML + '</div>';
	                }
	                _modalTemplateTempDiv.innerHTML = modalHTML;
	                modal = $(_modalTemplateTempDiv).children();
	                app.root.append(modal[0]);
	                groupSelector = '.actions-modal-group';
	                buttonSelector = '.actions-modal-button';
	            }
	        
	            var groups = modal.find(groupSelector);
	            groups.each(function (index, el) {
	                var groupIndex = index;
	                $(el).children().each(function (index, el) {
	                    var buttonIndex = index;
	                    var buttonParams = params[groupIndex][buttonIndex];
	                    var clickTarget;
	                    if (!toPopover && $(el).is(buttonSelector)) clickTarget = $(el);
	                    if (toPopover && $(el).find(buttonSelector).length > 0) clickTarget = $(el).find(buttonSelector);
	        
	                    if (clickTarget) {
	                        clickTarget.on('click', function (e) {
	                            if (buttonParams.close !== false) app.closeModal(modal);
	                            if (buttonParams.onClick) buttonParams.onClick(modal, e);
	                        });
	                    }
	                });
	            });
	            if (!toPopover) app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.popover = function (modal, target, removeOnClose, animated) {
	            if (typeof removeOnClose === 'undefined') removeOnClose = true;
	            if (typeof animated === 'undefined') animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                var _modal = document.createElement('div');
	                _modal.innerHTML = modal.trim();
	                if (_modal.childNodes.length > 0) {
	                    modal = _modal.childNodes[0];
	                    if (removeOnClose) modal.classList.add('remove-on-close');
	                    app.root.append(modal);
	                }
	                else return false; //nothing found
	            }
	            modal = $(modal);
	            target = $(target);
	            if (modal.length === 0 || target.length === 0) return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose) modal.addClass('remove-on-close');
	                app.root.append(modal[0]);
	            }
	            if (modal.find('.popover-angle').length === 0 && !app.params.material) {
	                modal.append('<div class="popover-angle"></div>');
	            }
	            modal.show();
	        
	            var material = app.params.material;
	        
	            function sizePopover() {
	                modal.css({left: '', top: ''});
	                var modalWidth =  modal.width();
	                var modalHeight =  modal.height(); // 13 - height of angle
	                var modalAngle, modalAngleSize = 0, modalAngleLeft, modalAngleTop;
	                if (!material) {
	                    modalAngle = modal.find('.popover-angle');
	                    modalAngleSize = modalAngle.width() / 2;
	                    modalAngle.removeClass('on-left on-right on-top on-bottom').css({left: '', top: ''});
	                }
	                else {
	                    modal.removeClass('popover-on-left popover-on-right popover-on-top popover-on-bottom').css({left: '', top: ''});
	                }
	        
	                var targetWidth = target.outerWidth();
	                var targetHeight = target.outerHeight();
	                var targetOffset = target.offset();
	                var targetOffsetLeft = targetOffset.left - app.left;
	                var targetOffsetTop = targetOffset.top - app.top;
	                var targetParentPage = target.parents('.page');
	                if (targetParentPage.length > 0) {
	                    targetOffsetTop = targetOffsetTop - targetParentPage[0].scrollTop;
	                }
	        
	                var modalTop = 0;
	                var modalLeft = 0;
	                var diff = 0;
	                // Top Position
	                var modalPosition = material ? 'bottom' : 'top';
	                if (material) {
	                    if (modalHeight < app.height - targetOffsetTop - targetHeight) {
	                        // On bottom
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop;
	                    }
	                    else if (modalHeight < targetOffsetTop) {
	                        // On top
	                        modalTop = targetOffsetTop - modalHeight + targetHeight;
	                        modalPosition = 'top';
	                    }
	                    else {
	                        // On middle
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop;
	                    }
	        
	                    if (modalTop <= 0) {
	                        modalTop = 8;
	                    }
	                    else if (modalTop + modalHeight >= app.height) {
	                        modalTop = app.height - modalHeight - 8;
	                    }
	        
	                    // Horizontal Position
	                    modalLeft = targetOffsetLeft;
	                    if (modalLeft + modalWidth >= app.width - 8) {
	                        modalLeft = targetOffsetLeft + targetWidth - modalWidth - 8;
	                    }
	                    if (modalLeft < 8) {
	                        modalLeft = 8;
	                    }
	                    if (modalPosition === 'top') {
	                        modal.addClass('popover-on-top');
	                    }
	                    if (modalPosition === 'bottom') {
	                        modal.addClass('popover-on-bottom');
	                    }
	                    if (target.hasClass('floating-button-to-popover') && !modal.hasClass('modal-in')) {
	                        modal.addClass('popover-floating-button');
	                        var diffX = (modalLeft + modalWidth / 2) - (targetOffsetLeft + targetWidth / 2),
	                            diffY = (modalTop + modalHeight / 2) - (targetOffsetTop + targetHeight / 2);
	                        target
	                            .addClass('floating-button-to-popover-in')
	                            .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0)')
	                            .transitionEnd(function (e) {
	                                if (!target.hasClass('floating-button-to-popover-in')) return;
	                                target
	                                    .addClass('floating-button-to-popover-scale')
	                                    .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0) scale(' + (modalWidth/targetWidth) + ', ' + (modalHeight/targetHeight) + ')');
	                            });
	        
	                        modal.once('popover:close', function () {
	                            target
	                                .removeClass('floating-button-to-popover-in floating-button-to-popover-scale')
	                                .addClass('floating-button-to-popover-out')
	                                .transform('')
	                                .transitionEnd(function (e) {
	                                    target.removeClass('floating-button-to-popover-out');
	                                });
	                        });
	                        modal.once('popover:closed', function () {
	                            modal.removeClass('popover-floating-button');
	                        });
	                    }
	                    else if (target.hasClass('floating-button-to-popover') && modal.hasClass('modal-in')) {
	                        modalLeft = targetOffsetLeft;
	                        modalTop = targetOffsetTop;
	                    }
	        
	                }
	                else {
	                    if ((modalHeight + modalAngleSize) < targetOffsetTop) {
	                        // On top
	                        modalTop = targetOffsetTop - modalHeight - modalAngleSize;
	                    }
	                    else if ((modalHeight + modalAngleSize) < app.height - targetOffsetTop - targetHeight) {
	                        // On bottom
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop + targetHeight + modalAngleSize;
	                    }
	                    else {
	                        // On middle
	                        modalPosition = 'middle';
	                        modalTop = targetHeight / 2 + targetOffsetTop - modalHeight / 2;
	                        diff = modalTop;
	                        if (modalTop <= 0) {
	                            modalTop = 5;
	                        }
	                        else if (modalTop + modalHeight >= app.height) {
	                            modalTop = app.height - modalHeight - 5;
	                        }
	                        diff = diff - modalTop;
	                    }
	        
	                    // Horizontal Position
	                    if (modalPosition === 'top' || modalPosition === 'bottom') {
	                        modalLeft = targetWidth / 2 + targetOffsetLeft - modalWidth / 2;
	                        diff = modalLeft;
	                        if (modalLeft < 5) modalLeft = 5;
	                        if (modalLeft + modalWidth > app.width) modalLeft = app.width - modalWidth - 5;
	                        if (modalPosition === 'top') {
	                            modalAngle.addClass('on-bottom');
	                        }
	                        if (modalPosition === 'bottom') {
	                            modalAngle.addClass('on-top');
	                        }
	                        diff = diff - modalLeft;
	                        modalAngleLeft = (modalWidth / 2 - modalAngleSize + diff);
	                        modalAngleLeft = Math.max(Math.min(modalAngleLeft, modalWidth - modalAngleSize * 2 - 13), 13);
	                        modalAngle.css({left: modalAngleLeft + 'px'});
	        
	                    }
	                    else if (modalPosition === 'middle') {
	                        modalLeft = targetOffsetLeft - modalWidth - modalAngleSize;
	                        modalAngle.addClass('on-right');
	                        if (modalLeft < 5 || (modalLeft + modalWidth > app.width)) {
	                            if (modalLeft < 5) modalLeft = targetOffsetLeft + targetWidth + modalAngleSize;
	                            if (modalLeft + modalWidth > app.width) modalLeft = app.width - modalWidth - 5;
	                            modalAngle.removeClass('on-right').addClass('on-left');
	                        }
	                        modalAngleTop = (modalHeight / 2 - modalAngleSize + diff);
	                        modalAngleTop = Math.max(Math.min(modalAngleTop, modalHeight - modalAngleSize * 2 - 13), 13);
	                        modalAngle.css({top: modalAngleTop + 'px'});
	                    }
	                }
	        
	        
	                // Apply Styles
	                modal.css({top: modalTop + 'px', left: modalLeft + 'px'});
	            }
	        
	            sizePopover();
	        
	            app.onResize(sizePopover);
	        
	            modal.on('popover:close', function () {
	                app.offResize(sizePopover);
	            });
	        
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.popup = function (modal, removeOnClose, animated) {
	            if (typeof removeOnClose === 'undefined') removeOnClose = true;
	            if (typeof animated === 'undefined') animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                var _modal = document.createElement('div');
	                _modal.innerHTML = modal.trim();
	                if (_modal.childNodes.length > 0) {
	                    modal = _modal.childNodes[0];
	                    if (removeOnClose) modal.classList.add('remove-on-close');
	                    app.root.append(modal);
	                }
	                else return false; //nothing found
	            }
	            modal = $(modal);
	            if (modal.length === 0) return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose) modal.addClass('remove-on-close');
	                app.root.append(modal[0]);
	            }
	            modal.show();
	        
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.pickerModal = function (modal, removeOnClose, animated) {
	            if (typeof removeOnClose === 'undefined') removeOnClose = true;
	            if (typeof animated === 'undefined') animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                modal = $(modal);
	                if (modal.length > 0) {
	                    if (removeOnClose) modal.addClass('remove-on-close');
	                    app.root.append(modal[0]);
	                }
	                else return false; //nothing found
	            }
	            modal = $(modal);
	            if (modal.length === 0) return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose) modal.addClass('remove-on-close');
	                app.root.append(modal[0]);
	            }
	            if ($('.picker-modal.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	                app.closeModal('.picker-modal.modal-in:not(.modal-out)');
	            }
	            modal.show();
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.loginScreen = function (modal, animated) {
	            if (!modal) modal = '.login-screen';
	            if (typeof animated === 'undefined') animated = true;
	            modal = $(modal);
	            if (modal.length === 0) return false;
	            if ($('.login-screen.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	                app.closeModal('.login-screen.modal-in:not(.modal-out)');
	            }
	            modal.show();
	        
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.openModal = function (modal, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            modal = $(modal);
	            modal[animated ? 'removeClass' : 'addClass']('not-animated');
	        
	            var isModal = modal.hasClass('modal');
	            var isPopover = modal.hasClass('popover');
	            var isPopup = modal.hasClass('popup');
	            var isLoginScreen = modal.hasClass('login-screen');
	            var isPickerModal = modal.hasClass('picker-modal');
	            var isActions = modal.hasClass('actions-modal');
	        
	            // Modal Event Prefix
	            var modalType = 'modal';
	            if (isPopover) modalType = 'popover';
	            if (isPopup) modalType = 'popup';
	            if (isLoginScreen) modalType = 'loginscreen';
	            if (isPickerModal) modalType = 'picker';
	            if (isActions) modalType = 'actions';
	        
	            if ($('.modal.modal-in:not(.modal-out)').length && app.params.modalStack && isModal) {
	                app.modalStack.push(function () {
	                    app.openModal(modal);
	                });
	                return;
	            }
	        
	            // do nothing if this modal already shown
	            if (true === modal.data('f7-modal-shown')) {
	                return;
	            }
	            modal.data('f7-modal-shown', true);
	        
	            // Move modal
	            var modalParent = modal.parent();
	            if (app.params.modalsMoveToRoot && !modalParent.is(app.root)) {
	                app.root.append(modal);
	                modal.once(modalType + ':closed', function() {
	                   modalParent.append(modal);
	                });
	            }
	        
	            modal.once(modalType + ':close', function() {
	               modal.removeData('f7-modal-shown');
	            });
	        
	            if (isModal) {
	                modal.show();
	                modal.css({
	                    marginTop: - Math.round(modal.outerHeight() / 2) + 'px'
	                });
	            }
	        
	            var overlay;
	            if (!isLoginScreen && !isPickerModal) {
	                if ($('.modal-overlay').length === 0 && !isPopup) {
	                    app.root.append('<div class="modal-overlay"></div>');
	                }
	                if ($('.popup-overlay').length === 0 && isPopup) {
	                    app.root.append('<div class="popup-overlay"></div>');
	                }
	                overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
	            }
	            if (app.params.material && isPickerModal) {
	                if (modal.hasClass('picker-calendar')) {
	                    if ($('.picker-modal-overlay').length === 0 && !isPopup) {
	                        app.root.append('<div class="picker-modal-overlay"></div>');
	                    }
	                    overlay = $('.picker-modal-overlay');
	                }
	            }
	            if (overlay) {
	                overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	            }
	        
	            //Make sure that styles are applied, trigger relayout;
	            var clientLeft = modal[0].clientLeft;
	        
	            // Trugger open event
	            modal.trigger('open ' + modalType + ':open');
	        
	            // Picker modal body class
	            if (isPickerModal) {
	                $('body').addClass('with-picker-modal');
	            }
	        
	            // Init Pages and Navbars in modal
	            if (modal.find('.' + app.params.viewClass).length > 0) {
	                modal.find('.page').each(function () {
	                    app.initPageWithCallback(this);
	                });
	                modal.find('.navbar').each(function () {
	                    app.initNavbarWithCallback(this);
	                });
	            }
	        
	            // Classes for transition in
	            if (!isLoginScreen && !isPickerModal) overlay.addClass('modal-overlay-visible');
	            if (app.params.material && isPickerModal && overlay) overlay.addClass('modal-overlay-visible');
	            if (animated) {
	                modal.removeClass('modal-out').addClass('modal-in').transitionEnd(function (e) {
	                    if (modal.hasClass('modal-out')) modal.trigger('closed ' + modalType + ':closed');
	                    else modal.trigger('opened ' + modalType + ':opened');
	                });
	            }
	            else {
	                modal.removeClass('modal-out').addClass('modal-in');
	                modal.trigger('opened ' + modalType + ':opened');
	            }
	            return true;
	        };
	        app.closeModal = function (modal, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            modal = $(modal || '.modal-in');
	            if (typeof modal !== 'undefined' && modal.length === 0) {
	                return;
	            }
	            modal[animated ? 'removeClass' : 'addClass']('not-animated');
	            var isModal = modal.hasClass('modal');
	            var isPopover = modal.hasClass('popover');
	            var isPopup = modal.hasClass('popup');
	            var isLoginScreen = modal.hasClass('login-screen');
	            var isPickerModal = modal.hasClass('picker-modal');
	            var isActions = modal.hasClass('actions-modal');
	        
	            // Modal Event Prefix
	            var modalType = 'modal';
	            if (isPopover) modalType = 'popover';
	            if (isPopup) modalType = 'popup';
	            if (isLoginScreen) modalType = 'loginscreen';
	            if (isPickerModal) modalType = 'picker';
	            if (isActions) modalType = 'actions';
	        
	            var removeOnClose = modal.hasClass('remove-on-close');
	        
	            // For Actions
	            var keepOnClose = modal.hasClass('keep-on-close');
	        
	            var overlay;
	        
	            if (isPopup) overlay = $('.popup-overlay');
	            else {
	                if (isPickerModal && app.params.material) overlay = $('.picker-modal-overlay');
	                else if (!isPickerModal) overlay = $('.modal-overlay');
	            }
	        
	            if (isPopup){
	                if (modal.length === $('.popup.modal-in').length) {
	                    overlay.removeClass('modal-overlay-visible');
	                }
	            }
	            else if (overlay && overlay.length > 0) {
	                overlay.removeClass('modal-overlay-visible');
	            }
	            if (overlay) overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	        
	            modal.trigger('close ' + modalType + ':close');
	        
	            // Picker modal body class
	            if (isPickerModal) {
	                $('body').removeClass('with-picker-modal');
	                $('body').addClass('picker-modal-closing');
	            }
	        
	            if (!(isPopover && !app.params.material)) {
	                if (animated) {
	                    modal.removeClass('modal-in').addClass('modal-out').transitionEnd(function (e) {
	                        if (modal.hasClass('modal-out')) modal.trigger('closed ' + modalType + ':closed');
	                        else {
	                            modal.trigger('opened ' + modalType + ':opened');
	                            if (isPopover) return;
	                        }
	        
	                        if (isPickerModal) {
	                            $('body').removeClass('picker-modal-closing');
	                        }
	                        if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                            modal.removeClass('modal-out').hide();
	                            if (removeOnClose && modal.length > 0) {
	                                modal.remove();
	                            }
	                        }
	                        else if (!keepOnClose) {
	                            modal.remove();
	                        }
	                    });
	                }
	                else {
	                    modal.trigger('closed ' + modalType + ':closed');
	                    modal.removeClass('modal-in modal-out');
	                    if (isPickerModal) {
	                        $('body').removeClass('picker-modal-closing');
	                    }
	                    if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                        modal.hide();
	                        if (removeOnClose && modal.length > 0) {
	                            modal.remove();
	                        }
	                    }
	                    else if (!keepOnClose) {
	                        modal.remove();
	                    }
	                }
	                if (isModal && app.params.modalStack) {
	                    app.modalStackClearQueue();
	                }
	            }
	            else {
	                modal.removeClass('modal-in modal-out not-animated').trigger('closed ' + modalType + ':closed').hide();
	                if (removeOnClose) {
	                    modal.remove();
	                }
	            }
	            return true;
	        };
	        
	
	        /*===============================================================================
	        ************   Progress Bar   ************
	        ===============================================================================*/
	        app.setProgressbar = function (container, progress, speed) {
	            container = $(container || app.root);
	            if (container.length === 0) return;
	            if (progress) progress = Math.min(Math.max(progress, 0), 100);
	            var progressbar;
	            if (container.hasClass('progressbar')) progressbar = container;
	            else {
	                progressbar = container.children('.progressbar');
	            }
	            if (progressbar.length === 0 || progressbar.hasClass('progressbar-infinite')) return;
	            var clientLeft = progressbar[0].clientLeft;
	            progressbar.children('span').transform('translate3d(' + (-100 + progress) + '%,0,0)');
	            if (typeof speed !== 'undefined') {
	                progressbar.children('span').transition(speed);
	            }
	            else {
	                progressbar.children('span').transition('');
	            }
	            return progressbar[0];
	        };
	        app.showProgressbar = function (container, progress, color) {
	            if (typeof container === 'number') {
	                container = app.root;
	                progress = arguments[0];
	                color = arguments[1];
	            }
	            if (progress && typeof progress === 'string' && parseFloat(progress) !== progress * 1) {
	                color = progress;
	                progress = undefined;
	            }
	            container = $(container || app.root);
	            if (container.length === 0) return;
	            var progressbar;
	            if (container.hasClass('progressbar')) progressbar = container;
	            else {
	                progressbar = container.children('.progressbar:not(.progressbar-out), .progressbar-infinite:not(.progressbar-out)');
	                if (progressbar.length === 0) {
	                    // Create one
	                    if (typeof progress !== 'undefined') {
	                        // Determined
	                        progressbar = $('<span class="progressbar progressbar-in' + (color ? ' color-' + color : '') + '"><span></span></span>');
	                    }
	                    else {
	                        // Infinite
	                        progressbar = $('<span class="progressbar-infinite progressbar-in' + (color ? ' color-' + color : '') + '"></span>');
	                    }
	                    container.append(progressbar);
	                }
	            }
	            if (progress) app.setProgressbar(container, progress);
	            return progressbar[0];
	        };
	        app.hideProgressbar = function (container) {
	            container = $(container || app.root);
	            if (container.length === 0) return;
	            var progressbar;
	            if (container.hasClass('progressbar')) progressbar = container;
	            else {
	                progressbar = container.children('.progressbar, .progressbar-infinite');
	            }
	            if (progressbar.length === 0 || !progressbar.hasClass('progressbar-in') || progressbar.hasClass('progressbar-out')) return;
	            progressbar.removeClass('progressbar-in').addClass('progressbar-out').animationEnd(function () {
	                progressbar.remove();
	                progressbar = null;
	            });
	            return;
	        };
	        app.initPageProgressbar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            pageContainer.find('.progressbar').each(function () {
	                var p = $(this);
	                if (p.children('span').length === 0) p.append('<span></span>');
	                if (p.attr('data-progress')) app.setProgressbar(p, p.attr('data-progress'));
	            });
	        };
	
	        /*======================================================
	        ************   Panels   ************
	        ======================================================*/
	        app.allowPanelOpen = true;
	        app.openPanel = function (panelPosition, animated) {
	            if (typeof animated === 'undefined') animated = true;
	            if (!app.allowPanelOpen) return false;
	            var panel = $('.panel-' + panelPosition);
	            if (panel.length === 0 || panel.hasClass('active') || panel.hasClass('panel-visible-by-breakpoint')) return false;
	            app.closePanel(); // Close if some panel is opened
	            app.allowPanelOpen = false;
	            var effect = panel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	            panel[animated ? 'removeClass' : 'addClass']('not-animated');
	            panel.css({display: 'block'}).addClass('active');
	            panel.trigger('open panel:open');
	        
	            var panelOverlay = $('.panel-overlay');
	            panelOverlay[animated ? 'removeClass' : 'addClass']('not-animated');
	            panelOverlay.show();
	        
	            if (panel.find('.' + app.params.viewClass).length > 0) {
	                if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	            }
	        
	            // Trigger reLayout
	            var clientLeft = panel[0].clientLeft;
	        
	            // Transition End;
	            var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : panel;
	        
	            function panelTransitionEnd() {
	                transitionEndTarget.transitionEnd(function (e) {
	                    if ($(e.target).is(transitionEndTarget)) {
	                        if (panel.hasClass('active')) {
	                            panel.trigger('opened panel:opened');
	                        }
	                        else {
	                            panel.trigger('closed panel:closed');
	                        }
	                        panelOverlay.css({display: ''});
	                        app.allowPanelOpen = true;
	                    }
	                    else panelTransitionEnd();
	                });
	            }
	            if (animated) {
	                panelTransitionEnd();
	            }
	            else {
	                panel.trigger('opened panel:opened');
	                panelOverlay.css({display: ''});
	                app.allowPanelOpen = true;
	            }
	        
	            $('body').addClass('with-panel-' + panelPosition + '-' + effect);
	            return true;
	        };
	        app.closePanel = function (animated) {
	            if (typeof animated === 'undefined') animated = true;
	            var activePanel = $('.panel.active');
	            if (activePanel.length === 0 || activePanel.hasClass('panel-visible-by-breakpoint')) return false;
	            var effect = activePanel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	            var panelPosition = activePanel.hasClass('panel-left') ? 'left' : 'right';
	            activePanel[animated ? 'removeClass' : 'addClass']('not-animated');
	            activePanel.removeClass('active');
	        
	            var panelOverlay = $('.panel-overlay');
	            panelOverlay.removeClass('not-animated');
	        
	            var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : activePanel;
	            activePanel.trigger('close panel:close');
	            app.allowPanelOpen = false;
	            if (animated) {
	                transitionEndTarget.transitionEnd(function () {
	                    if (activePanel.hasClass('active')) return;
	                    activePanel.css({display: ''});
	                    activePanel.trigger('closed panel:closed');
	                    $('body').removeClass('panel-closing');
	                    app.allowPanelOpen = true;
	                });
	                $('body').addClass('panel-closing').removeClass('with-panel-' + panelPosition + '-' + effect);
	            }
	            else {
	                activePanel.css({display: ''});
	                activePanel.trigger('closed panel:closed');
	                activePanel.removeClass('not-animated');
	                $('body').removeClass('with-panel-' + panelPosition + '-' + effect);
	                app.allowPanelOpen = true;
	            }
	        };
	        /*======================================================
	        ************   Panels breakpoints   ************
	        ======================================================*/
	        app.initPanelsBreakpoints = function () {
	            var panelLeft = $('.panel-left');
	            var panelRight = $('.panel-right');
	            var views = app.root.children('.views');
	            var wasVisible;
	            function setPanels() {
	                // Left Panel
	                if (app.params.panelLeftBreakpoint && panelLeft.length > 0) {
	                    wasVisible = panelLeft.hasClass('panel-visible-by-breakpoint');
	                    if (app.width >= app.params.panelLeftBreakpoint) {
	                        if (!wasVisible) {
	                            $('body').removeClass('with-panel-left-reveal with-panel-left-cover');
	                            panelLeft.css('display', '').addClass('panel-visible-by-breakpoint').removeClass('active');
	                            panelLeft.trigger('open panel:open opened panel:opened');
	                            views.css({
	                                'margin-left': panelLeft.width() + 'px'
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                    else {
	                        if (wasVisible) {
	                            panelLeft.css('display', '').removeClass('panel-visible-by-breakpoint active');
	                            panelLeft.trigger('close panel:close closed panel:closed');
	                            views.css({
	                                'margin-left': ''
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                }
	                // Right Panel
	                if (app.params.panelRightBreakpoint && panelRight.length > 0) {
	                    wasVisible = panelRight.hasClass('panel-visible-by-breakpoint');
	                    if (app.width >= app.params.panelRightBreakpoint) {
	                        if (!wasVisible) {
	                            $('body').removeClass('with-panel-right-reveal with-panel-right-cover');
	                            panelRight.css('display', '').addClass('panel-visible-by-breakpoint').removeClass('active');
	                            panelRight.trigger('open panel:open opened panel:opened');
	                            views.css({
	                                'margin-right': panelRight.width() + 'px'
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                    else {
	                        if (wasVisible) {
	                            panelRight.css('display', '').removeClass('panel-visible-by-breakpoint active');
	                            panelRight.trigger('close panel:close closed panel:closed');
	                            views.css({
	                                'margin-right': ''
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                }
	            }
	            app.onResize(setPanels);
	            setPanels();
	        };
	        /*======================================================
	        ************   Swipe panels   ************
	        ======================================================*/
	        app.initSwipePanels = function () {
	            var panel, side;
	            if (app.params.swipePanel) {
	                panel = $('.panel.panel-' + app.params.swipePanel);
	                side = app.params.swipePanel;
	                if (panel.length === 0 && side !== 'both') return;
	            }
	            else {
	                if (app.params.swipePanelOnlyClose) {
	                    if ($('.panel').length === 0) return;
	                }
	                else return;
	            }
	        
	            var panelOverlay = $('.panel-overlay');
	            var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, translate, overlayOpacity, opened, panelWidth, effect, direction;
	            var views = $('.' + app.params.viewsClass);
	        
	            function handleTouchStart(e) {
	                if (!app.allowPanelOpen || (!app.params.swipePanel && !app.params.swipePanelOnlyClose) || isTouched) return;
	                if ($('.modal-in, .photo-browser-in').length > 0) return;
	                if (!(app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose)) {
	                    if ($('.panel.active').length > 0 && !panel.hasClass('active')) return;
	                }
	                if (e.target && e.target.nodeName.toLowerCase() === 'input' && e.target.type === 'range') return;
	                if ($(e.target).closest('.tabs-swipeable-wrap').length > 0) return;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                if (app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose) {
	                    if ($('.panel.active').length > 0) {
	                        side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                    }
	                    else {
	                        if (app.params.swipePanelOnlyClose) return;
	                        side = app.params.swipePanel;
	                    }
	                    if (!side) return;
	                }
	                panel = $('.panel.panel-' + side);
	                opened = panel.hasClass('active');
	                if (app.params.swipePanelActiveArea && !opened) {
	                    if (side === 'left') {
	                        if (touchesStart.x > app.params.swipePanelActiveArea) return;
	                    }
	                    if (side === 'right') {
	                        if (touchesStart.x < app.width - app.params.swipePanelActiveArea) return;
	                    }
	                }
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	        
	                touchStartTime = (new Date()).getTime();
	                direction = undefined;
	            }
	            function handleTouchMove(e) {
	                if (!isTouched) return;
	                if (e.f7PreventPanelSwipe) return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	                if (!direction) {
	                    if (pageX > touchesStart.x) {
	                        direction = 'to-right';
	                    }
	                    else {
	                        direction = 'to-left';
	                    }
	        
	                    if(side === 'both'){
	                        if ($('.panel.active').length > 0) {
	                            side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                        }
	                        else {
	                            side = direction === 'to-right' ? 'left' : 'right';
	                        }
	                        if (app.params.swipePanelActiveArea > 0) {
	                            if (side === 'left' && touchesStart.x > app.params.swipePanelActiveArea) {
	                                isTouched = false;
	                                return;
	                            }
	                            if (side === 'right' && touchesStart.x < app.width - app.params.swipePanelActiveArea) {
	                                isTouched = false;
	                                return;
	                            }
	                        }
	                        panel = $('.panel.panel-' + side);
	                    }
	                    if (panel.hasClass('panel-visible-by-breakpoint')) {
	                        isTouched = false;
	                        return;
	                    }
	        
	                    if (
	                        side === 'left' &&
	                        (
	                            direction === 'to-left' && !panel.hasClass('active')
	                        ) ||
	                        side === 'right' &&
	                        (
	                            direction === 'to-right' && !panel.hasClass('active')
	                        )
	                    )
	                    {
	                        isTouched = false;
	                        return;
	                    }
	                }
	        
	                if (app.params.swipePanelNoFollow) {
	                    var timeDiff = (new Date()).getTime() - touchStartTime;
	                    if (timeDiff < 300) {
	                        if (direction === 'to-left') {
	                            if (side === 'right') app.openPanel(side);
	                            if (side === 'left' && panel.hasClass('active')) app.closePanel();
	                        }
	                        if (direction === 'to-right') {
	                            if (side === 'left') app.openPanel(side);
	                            if (side === 'right' && panel.hasClass('active')) app.closePanel();
	                        }
	                    }
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	        
	                if (!isMoved) {
	                    effect = panel.hasClass('panel-cover') ? 'cover' : 'reveal';
	                    if (!opened) {
	                        panel.show();
	                        panelOverlay.show();
	                    }
	                    panelWidth = panel[0].offsetWidth;
	                    panel.transition(0);
	                    if (panel.find('.' + app.params.viewClass).length > 0) {
	                        if (app.sizeNavbars) app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	                    }
	                }
	        
	                isMoved = true;
	        
	                e.preventDefault();
	                var threshold = opened ? 0 : -app.params.swipePanelThreshold;
	                if (side === 'right') threshold = -threshold;
	        
	                touchesDiff = pageX - touchesStart.x + threshold;
	        
	                if (side === 'right') {
	                    translate = touchesDiff  - (opened ? panelWidth : 0);
	                    if (translate > 0) translate = 0;
	                    if (translate < -panelWidth) {
	                        translate = -panelWidth;
	                    }
	                }
	                else {
	                    translate = touchesDiff  + (opened ? panelWidth : 0);
	                    if (translate < 0) translate = 0;
	                    if (translate > panelWidth) {
	                        translate = panelWidth;
	                    }
	                }
	                if (effect === 'reveal') {
	                    views.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	                    panelOverlay.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	        
	                    panel.trigger('panel:swipe', {progress: Math.abs(translate / panelWidth)});
	                    app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	                }
	                else {
	                    panel.transform('translate3d(' + (translate - panelWidth) + 'px,0,0)').transition(0);
	        
	                    panelOverlay.transition(0);
	                    overlayOpacity = Math.abs(translate/panelWidth);
	                    panelOverlay.css({opacity: overlayOpacity});
	        
	                    panel.trigger('panel:swipe', {progress: Math.abs(translate / panelWidth)});
	                    app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	                }
	            }
	            function handleTouchEnd(e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                isTouched = false;
	                isMoved = false;
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var action;
	                var edge = (translate === 0 || Math.abs(translate) === panelWidth);
	        
	                if (!opened) {
	                    if (translate === 0) {
	                        action = 'reset';
	                    }
	                    else if (
	                        timeDiff < 300 && Math.abs(translate) > 0 ||
	                        timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2)
	                    ) {
	                        action = 'swap';
	                    }
	                    else {
	                        action = 'reset';
	                    }
	                }
	                else {
	                    if (translate === -panelWidth) {
	                        action = 'reset';
	                    }
	                    else if (
	                        timeDiff < 300 && Math.abs(translate) >= 0 ||
	                        timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2)
	                    ) {
	                        if (side === 'left' && translate === panelWidth) action = 'reset';
	                        else action = 'swap';
	                    }
	                    else {
	                        action = 'reset';
	                    }
	                }
	                if (action === 'swap') {
	                    app.allowPanelOpen = true;
	                    if (opened) {
	                        app.closePanel();
	                        if (edge) {
	                            panel.css({display: ''});
	                            $('body').removeClass('panel-closing');
	                        }
	                    }
	                    else {
	                        app.openPanel(side);
	                    }
	                    if (edge) app.allowPanelOpen = true;
	                }
	                if (action === 'reset') {
	                    if (opened) {
	                        app.allowPanelOpen = true;
	                        app.openPanel(side);
	                    }
	                    else {
	                        app.closePanel();
	                        if (edge) {
	                            app.allowPanelOpen = true;
	                            panel.css({display: ''});
	                        }
	                        else {
	                            var target = effect === 'reveal' ? views : panel;
	                            panel.trigger('close panel:close');
	                            $('body').addClass('panel-closing');
	                            target.transitionEnd(function () {
	                                panel.trigger('close panel:closed');
	                                panel.css({display: ''});
	                                $('body').removeClass('panel-closing');
	                                app.allowPanelOpen = true;
	                            });
	                        }
	                    }
	                }
	                if (effect === 'reveal') {
	                    views.transition('');
	                    views.transform('');
	                }
	                panel.transition('').transform('');
	                panelOverlay.css({display: ''}).transform('').transition('').css('opacity', '');
	            }
	            var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	            var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	            $(document).on(app.touchEvents.start, handleTouchStart, passiveListener);
	            $(document).on(app.touchEvents.move, handleTouchMove, activeListener);
	            $(document).on(app.touchEvents.end, handleTouchEnd, passiveListener);
	        };
	        
	
	        /*======================================================
	        ************   Image Lazy Loading   ************
	        ************   Based on solution by Marc Godard, https://github.com/MarcGodard   ************
	        ======================================================*/
	        app.initImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	        
	            // Lazy images
	            var lazyLoadImages;
	            if (pageContainer.hasClass('lazy')) {
	                lazyLoadImages = pageContainer;
	                pageContainer = lazyLoadImages.parents('.page');
	            }
	            else {
	                lazyLoadImages = pageContainer.find('.lazy');
	            }
	            if (lazyLoadImages.length === 0) return;
	        
	            // Scrollable page content
	            var pageContent;
	            if (pageContainer.hasClass('page-content'))  {
	                pageContent = pageContainer;
	                pageContainer = pageContainer.parents('.page');
	            }
	            else  {
	                pageContent = pageContainer.find('.page-content');
	            }
	            if (pageContent.length === 0) return;
	        
	            // Placeholder
	            var placeholderSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	            if (typeof app.params.imagesLazyLoadPlaceholder === 'string') {
	                placeholderSrc = app.params.imagesLazyLoadPlaceholder;
	            }
	            if (app.params.imagesLazyLoadPlaceholder !== false) lazyLoadImages.each(function(){
	                if ($(this).attr('data-src')) $(this).attr('src', placeholderSrc);
	            });
	        
	            // load image
	            var imagesSequence = [];
	            var imageIsLoading = false;
	            function loadImage(el) {
	                el = $(el);
	        
	                var bg = el.attr('data-background');
	                var src = bg ? bg : el.attr('data-src');
	                if (!src) return;
	        
	                function onLoad() {
	                    el.removeClass('lazy').addClass('lazy-loaded');
	                    if (bg) {
	                        el.css('background-image', 'url(' + src + ')');
	                    }
	                    else {
	                        el.attr('src', src);
	                    }
	        
	                    if (app.params.imagesLazyLoadSequential) {
	                        imageIsLoading = false;
	                        if (imagesSequence.length > 0) {
	                            loadImage(imagesSequence.shift());
	                        }
	                    }
	                }
	        
	                function onError() {
	                    el.removeClass('lazy').addClass('lazy-loaded');
	                    if (bg) {
	                        el.css('background-image', 'url(' + placeholderSrc + ')');
	                    }
	                    else {
	                        el.attr('src', placeholderSrc);
	                    }
	        
	                    if (app.params.imagesLazyLoadSequential) {
	                        imageIsLoading = false;
	                        if (imagesSequence.length > 0) {
	                            loadImage(imagesSequence.shift());
	                        }
	                    }
	                }
	        
	                if (app.params.imagesLazyLoadSequential) {
	                    if (imageIsLoading) {
	                        if (imagesSequence.indexOf(el[0]) < 0) imagesSequence.push(el[0]);
	                        return;
	                    }
	                }
	        
	                // Loading flag
	                imageIsLoading = true;
	        
	                var image = new Image();
	                image.onload = onLoad;
	                image.onerror = onError;
	                image.src =src;
	            }
	            function lazyHandler() {
	                lazyLoadImages = pageContainer.find('.lazy');
	                lazyLoadImages.each(function(index, el) {
	                    el = $(el);
	                    if (el.parents('.tab:not(.active)').length > 0) {
	                        return;
	                    }
	                    if (isElementInViewport(el[0])) {
	                        loadImage(el);
	                    }
	                });
	            }
	        
	            function isElementInViewport (el) {
	                var rect = el.getBoundingClientRect();
	                var threshold = app.params.imagesLazyLoadThreshold || 0;
	                return (
	                    rect.top >= (0 - threshold) &&
	                    rect.left >= (0 - threshold) &&
	                    rect.top <= (app.height + threshold) &&
	                    rect.left <= (app.width + threshold)
	                );
	            }
	        
	            function attachEvents(destroy) {
	                var method = destroy ? 'off' : 'on';
	                lazyLoadImages[method]('lazy', lazyHandler);
	                lazyLoadImages.parents('.tab')[method]('show', lazyHandler);
	                pageContainer[method]('lazy', lazyHandler);
	                pageContent[method]('lazy', lazyHandler);
	                pageContent[method]('scroll', lazyHandler);
	                app[method === 'on' ? 'onResize' : 'offResize'](lazyHandler);
	            }
	            function detachEvents() {
	                attachEvents(true);
	            }
	        
	            // Store detach function
	            pageContainer[0].f7DestroyImagesLazyLoad = detachEvents;
	        
	            // Attach events
	            attachEvents();
	        
	            // Destroy on page remove
	            if (pageContainer.hasClass('page')) {
	                pageContainer.once('page:beforeremove', detachEvents);
	            }
	        
	            // Run loader on page load/init
	            lazyHandler();
	        
	            // Run after page animation
	            pageContainer.once('page:afteranimation', lazyHandler);
	        };
	        app.destroyImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0 && pageContainer[0].f7DestroyImagesLazyLoad) {
	                pageContainer[0].f7DestroyImagesLazyLoad();
	            }
	        };
	        app.reinitImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0) {
	                pageContainer.trigger('lazy');
	            }
	        };
	        
	
	        /*======================================================
	        ************   Material Preloader   ************
	        ======================================================*/
	        app.initPageMaterialPreloader = function (pageContainer) {
	            $(pageContainer).find('.preloader').each(function () {
	                if ($(this).children().length === 0) {
	                    $(this).html(app.params.materialPreloaderHtml);
	                }
	            });
	        };
	
	        /*======================================================
	        ************   Messages   ************
	        ======================================================*/
	        var Messages = function (container, params) {
	            var defaults = {
	                autoLayout: true,
	                newMessagesFirst: false,
	                scrollMessages: true,
	                scrollMessagesOnlyOnEdge: false,
	                messageTemplate:
	                    '{{#if day}}' +
	                    '<div class="messages-date">{{day}} {{#if time}}, <span>{{time}}</span>{{/if}}</div>' +
	                    '{{/if}}' +
	                    '<div class="message message-{{type}} {{#if hasImage}}message-pic{{/if}} {{#if avatar}}message-with-avatar{{/if}} {{#if position}}message-appear-from-{{position}}{{/if}}">' +
	                        '{{#if name}}<div class="message-name">{{name}}</div>{{/if}}' +
	                        '<div class="message-text">{{text}}{{#if date}}<div class="message-date">{{date}}</div>{{/if}}</div>' +
	                        '{{#if avatar}}<div class="message-avatar" style="background-image:url({{avatar}})"></div>{{/if}}' +
	                        '{{#if label}}<div class="message-label">{{label}}</div>{{/if}}' +
	                    '</div>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null) {
	                    params[def] = defaults[def];
	                }
	            }
	        
	            // Instance
	            var m = this;
	        
	            // Params
	            m.params = params;
	        
	            // Container
	            m.container = $(container);
	            if (m.container.length === 0) return;
	        
	            // Autolayout
	            if (m.params.autoLayout) m.container.addClass('messages-auto-layout');
	        
	            // New messages first
	            if (m.params.newMessagesFirst) m.container.addClass('messages-new-first');
	        
	            // Is In Page
	            m.pageContainer = m.container.parents('.page').eq(0);
	            m.pageContent = m.pageContainer.find('.page-content');
	        
	            // Compiled template
	            m.template = Template7.compile(m.params.messageTemplate);
	        
	            // Auto Layout
	            m.layout = function () {
	                if (!m.container.hasClass('messages-auto-layout')) m.container.addClass('messages-auto-layout');
	                m.container.find('.message').each(function () {
	                    var message = $(this);
	                    if (message.find('.message-text img').length > 0) {
	                        var childNodes = message.find('.message-text')[0].childNodes;
	                        var onlyPic = true;
	                        for (var i = 0 ; i < childNodes.length; i++) {
	                            if (childNodes[i].nodeType === 1 && childNodes[i].nodeName.toLowerCase() !== 'img') onlyPic = false;
	                            if (childNodes[i].nodeType === 3 && childNodes[i].textContent.trim() !== '') onlyPic = false;
	                        }
	                        if (onlyPic) message.addClass('message-pic');
	                        else message.removeClass('message-pic');
	                    }
	                    if (message.find('.message-avatar').length > 0) message.addClass('message-with-avatar');
	                });
	                m.container.find('.message').each(function () {
	                    var message = $(this);
	                    var isSent = message.hasClass('message-sent');
	                    var next = message.next('.message-' + (isSent ? 'sent' : 'received'));
	                    var prev = message.prev('.message-' + (isSent ? 'sent' : 'received'));
	                    if (next.length === 0) {
	                        message.addClass('message-last message-with-tail');
	                    }
	                    else message.removeClass('message-last message-with-tail');
	        
	                    if (prev.length === 0) {
	                        message.addClass('message-first');
	                    }
	                    else message.removeClass('message-first');
	        
	                    if (prev.length > 0 && prev.find('.message-name').length > 0 && message.find('.message-name').length > 0) {
	                        if (prev.find('.message-name').text() !== message.find('.message-name').text()) {
	                            prev.addClass('message-last message-with-tail');
	                            message.addClass('message-first');
	                        }
	                    }
	                });
	            };
	        
	            // Add Message
	            m.appendMessage = function (props, animate) {
	                return m.addMessage(props, 'append', animate);
	            };
	            m.prependMessage = function (props, animate) {
	                return m.addMessage(props, 'prepend', animate);
	            };
	            m.addMessage = function (props, method, animate) {
	                return m.addMessages([props], method, animate);
	            };
	            m.addMessages = function (newMessages, method, animate) {
	                if (typeof animate === 'undefined') {
	                    animate = true;
	                }
	                if (typeof method === 'undefined') {
	                    method = m.params.newMessagesFirst ? 'prepend' : 'append';
	                }
	                var newMessagesHTML = '', i;
	                for (i = 0; i < newMessages.length; i++) {
	                    var props = newMessages[i] || {};
	                    props.type = props.type || 'sent';
	                    if (!props.text) continue;
	                    props.hasImage = props.text.indexOf('<img') >= 0;
	                    if (props.onlyImage === false) props.hasImage = false;
	                    if (animate) props.position = method === 'append' ? 'bottom' : 'top';
	        
	                    newMessagesHTML += m.template(props);
	                }
	                var scrollHeightBefore = m.pageContent[0].scrollHeight,
	                    heightBefore = m.pageContent[0].offsetHeight,
	                    scrollBefore = m.pageContent[0].scrollTop;
	                m.container[method](newMessagesHTML);
	                if (m.params.autoLayout) m.layout();
	                if (method === 'prepend') {
	                    m.pageContent[0].scrollTop = scrollBefore + (m.pageContent[0].scrollHeight - scrollHeightBefore);
	                }
	                if (m.params.scrollMessages && (method === 'append' && !m.params.newMessagesFirst) || (method === 'prepend' && m.params.newMessagesFirst)) {
	                    if (m.params.scrollMessagesOnlyOnEdge) {
	                        var onEdge = false;
	                        if (m.params.newMessagesFirst) {
	                            if (scrollBefore === 0) onEdge = true;
	                        }
	                        else {
	                            if (scrollBefore - (scrollHeightBefore - heightBefore) >= -10) onEdge = true;
	                        }
	                        if (onEdge) m.scrollMessages(animate ? undefined : 0);
	                    }
	                    else m.scrollMessages(animate ? undefined : 0);
	                }
	                var messages = m.container.find('.message');
	                if (newMessages.length === 1) {
	                    return method === 'append' ? messages[messages.length - 1] : messages[0];
	                }
	                else {
	                    var messagesToReturn = [];
	                    if (method === 'append') {
	                        for (i = messages.length - newMessages.length; i < messages.length; i++) {
	                            messagesToReturn.push(messages[i]);
	                        }
	                    }
	                    else {
	                        for (i = 0; i < newMessages.length; i++) {
	                            messagesToReturn.push(messages[i]);
	                        }
	                    }
	                    return messagesToReturn;
	                }
	        
	            };
	            m.removeMessage = function (message) {
	                message = $(message);
	                if (message.length === 0) {
	                    return false;
	                }
	                else {
	                    message.remove();
	                    if (m.params.autoLayout) m.layout();
	                    return true;
	                }
	            };
	            m.removeMessages = function (messages) {
	                m.removeMessage(messages);
	            };
	            m.clean = function () {
	                m.container.html('');
	            };
	        
	            // Scroll
	            m.scrollMessages = function (duration, scrollTop) {
	                if (typeof duration === 'undefined') duration = 400;
	                var currentScroll = m.pageContent[0].scrollTop;
	                var newScroll;
	                if (typeof scrollTop !== 'undefined') newScroll = scrollTop;
	                else {
	                    newScroll = m.params.newMessagesFirst ? 0 : m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight;
	                    if (newScroll === currentScroll) return;
	                }
	                m.pageContent.scrollTop(newScroll, duration);
	            };
	        
	            // Init Destroy
	            m.init = function () {
	                if (m.params.messages) {
	                    m.addMessages(m.params.messages, undefined, false);
	                }
	                else {
	                    if (m.params.autoLayout) m.layout();
	                    m.scrollMessages(0);
	                }
	        
	            };
	            m.destroy = function () {
	                m = null;
	            };
	        
	            // Init
	            m.init();
	        
	            m.container[0].f7Messages = m;
	            return m;
	        };
	        app.messages = function (container, params) {
	            return new Messages (container, params);
	        };
	        app.initPageMessages = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var messages = pageContainer.find('.messages');
	            if (messages.length === 0) return;
	            if (!messages.hasClass('messages-init')) {
	                return;
	            }
	            var m = app.messages(messages, messages.dataset());
	        
	            // Destroy on page remove
	            function pageBeforeRemove() {
	                m.destroy();
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            if (pageContainer.hasClass('page')) {
	                pageContainer.on('page:beforeremove', pageBeforeRemove);
	            }
	        };
	        
	
	        /*===============================================================================
	        ************   Swipeout Actions (Swipe to delete)   ************
	        ===============================================================================*/
	        app.swipeoutOpenedEl = undefined;
	        app.allowSwipeout = true;
	        app.initSwipeout = function (swipeoutEl) {
	            var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, swipeOutEl, swipeOutContent, actionsRight, actionsLeft, actionsLeftWidth, actionsRightWidth, translate, opened, openedActions, buttonsLeft, buttonsRight, direction, overswipeLeftButton, overswipeRightButton, overswipeLeft, overswipeRight, noFoldLeft, noFoldRight;
	        
	            var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	        
	            $(document).on(app.touchEvents.start, function (e) {
	                if (app.swipeoutOpenedEl) {
	                    var target = $(e.target);
	                    if (!(
	                        app.swipeoutOpenedEl.is(target[0]) ||
	                        target.parents('.swipeout').is(app.swipeoutOpenedEl) ||
	                        target.hasClass('modal-in') ||
	                        target.hasClass('modal-overlay') ||
	                        target.hasClass('actions-modal') || 
	                        target.parents('.actions-modal.modal-in, .modal.modal-in').length > 0
	                        )) {
	                        app.swipeoutClose(app.swipeoutOpenedEl);
	                    }
	                }
	            }, activeListener);
	        
	            function handleTouchStart(e) {
	                if (!app.allowSwipeout) return;
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	            }
	            function handleTouchMove(e) {
	                if (!isTouched) return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	        
	                if (!isMoved) {
	                    if ($('.list-block.sortable-opened').length > 0) return;
	                    /*jshint validthis:true */
	                    swipeOutEl = $(this);
	                    swipeOutContent = swipeOutEl.find('.swipeout-content');
	                    actionsRight = swipeOutEl.find('.swipeout-actions-right');
	                    actionsLeft = swipeOutEl.find('.swipeout-actions-left');
	                    actionsLeftWidth = actionsRightWidth = buttonsLeft = buttonsRight = overswipeRightButton = overswipeLeftButton = null;
	                    noFoldLeft = actionsLeft.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	                    noFoldRight = actionsRight.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	                    if (actionsLeft.length > 0) {
	                        actionsLeftWidth = actionsLeft.outerWidth();
	                        buttonsLeft = actionsLeft.children('a');
	                        overswipeLeftButton = actionsLeft.find('.swipeout-overswipe');
	                    }
	                    if (actionsRight.length > 0) {
	                        actionsRightWidth = actionsRight.outerWidth();
	                        buttonsRight = actionsRight.children('a');
	                        overswipeRightButton = actionsRight.find('.swipeout-overswipe');
	                    }
	                    opened = swipeOutEl.hasClass('swipeout-opened');
	                    if (opened) {
	                        openedActions = swipeOutEl.find('.swipeout-actions-left.swipeout-actions-opened').length > 0 ? 'left' : 'right';
	                    }
	                    swipeOutEl.removeClass('transitioning');
	                    if (!app.params.swipeoutNoFollow) {
	                        swipeOutEl.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	                        swipeOutEl.removeClass('swipeout-opened');
	                    }
	                }
	                isMoved = true;
	                e.preventDefault();
	                
	                touchesDiff = pageX - touchesStart.x;
	                translate = touchesDiff;
	        
	                if (opened) {
	                    if (openedActions === 'right') translate = translate - actionsRightWidth;
	                    else translate = translate + actionsLeftWidth;
	                }
	        
	                if (translate > 0 && actionsLeft.length === 0 || translate < 0 && actionsRight.length === 0) {
	                    if (!opened) {
	                        isTouched = isMoved = false;
	                        swipeOutContent.transform('');
	                        if (buttonsRight && buttonsRight.length > 0) {
	                            buttonsRight.transform('');
	                        }
	                        if (buttonsLeft && buttonsLeft.length > 0) {
	                            buttonsLeft.transform('');
	                        }
	                        return;
	                    }
	                    translate = 0;
	                }
	        
	                if (translate < 0) direction = 'to-left';
	                else if (translate > 0) direction = 'to-right';
	                else {
	                    if (!direction) direction = 'to-left';
	                }
	                
	                var i, buttonOffset, progress;
	                
	                e.f7PreventPanelSwipe = true;
	                if (app.params.swipeoutNoFollow) {
	                    if (opened) {
	                        if (openedActions === 'right' && touchesDiff > 0) {
	                            app.swipeoutClose(swipeOutEl);
	                        }
	                        if (openedActions === 'left' && touchesDiff < 0) {
	                            app.swipeoutClose(swipeOutEl);
	                        }
	                    }
	                    else {
	                        if (touchesDiff < 0 && actionsRight.length > 0) {
	                            app.swipeoutOpen(swipeOutEl, 'right');
	                        }
	                        if (touchesDiff > 0 && actionsLeft.length > 0) {
	                            app.swipeoutOpen(swipeOutEl, 'left');
	                        }
	                    }
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                overswipeLeft = false;
	                overswipeRight = false;
	                var $button;
	                if (actionsRight.length > 0) {
	                    // Show right actions
	                    progress = translate / actionsRightWidth;
	                    if (translate < -actionsRightWidth) {
	                        translate = -actionsRightWidth - Math.pow(-translate - actionsRightWidth, 0.8);
	                        if (overswipeRightButton.length > 0) {
	                            overswipeRight = true;
	                        }
	                    }
	                    for (i = 0; i < buttonsRight.length; i++) {
	                        if (typeof buttonsRight[i]._buttonOffset === 'undefined') {
	                            buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                        }
	                        buttonOffset = buttonsRight[i]._buttonOffset;
	                        $button = $(buttonsRight[i]);
	                        if (overswipeRightButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                            $button.css({left: (overswipeRight ? -buttonOffset : 0) + 'px'});
	                            if (overswipeRight) {
	                                $button.addClass('swipeout-overswipe-active');
	                            }
	                            else {
	                                $button.removeClass('swipeout-overswipe-active');   
	                            }
	                        }
	                        $button.transform('translate3d(' + (translate - buttonOffset * (1 + Math.max(progress, -1))) + 'px,0,0)');
	                    }
	                }
	                if (actionsLeft.length > 0) {
	                    // Show left actions
	                    progress = translate / actionsLeftWidth;
	                    if (translate > actionsLeftWidth) {
	                        translate = actionsLeftWidth + Math.pow(translate - actionsLeftWidth, 0.8);
	                        if (overswipeLeftButton.length > 0) {
	                            overswipeLeft = true;
	                        }
	                    }
	                    for (i = 0; i < buttonsLeft.length; i++) {
	                        if (typeof buttonsLeft[i]._buttonOffset === 'undefined') {
	                            buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                        }
	                        buttonOffset = buttonsLeft[i]._buttonOffset;
	                        $button = $(buttonsLeft[i]);
	                        if (overswipeLeftButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                            $button.css({left: (overswipeLeft ? buttonOffset : 0) + 'px'});
	                            if (overswipeLeft) {
	                                $button.addClass('swipeout-overswipe-active');
	                            }
	                            else {
	                                $button.removeClass('swipeout-overswipe-active');   
	                            }
	                        }
	                        if (buttonsLeft.length > 1) {
	                            $button.css('z-index', buttonsLeft.length - i); 
	                        }
	                        $button.transform('translate3d(' + (translate + buttonOffset * (1 - Math.min(progress, 1))) + 'px,0,0)');
	                    }
	                }
	                swipeOutContent.transform('translate3d(' + translate + 'px,0,0)');
	            }
	            function handleTouchEnd(e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	        
	                isTouched = false;
	                isMoved = false;
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var action, actionsWidth, actions, buttons, i;
	        
	                actions = direction === 'to-left' ? actionsRight : actionsLeft;
	                actionsWidth = direction === 'to-left' ? actionsRightWidth : actionsLeftWidth;
	        
	                if (
	                    timeDiff < 300 && (touchesDiff < -10 && direction === 'to-left' || touchesDiff > 10 && direction === 'to-right') ||
	                    timeDiff >= 300 && Math.abs(translate) > actionsWidth / 2
	                ) {
	                    action = 'open';
	                }
	                else {
	                    action = 'close';
	                }
	                if (timeDiff < 300) {
	                    if (Math.abs(translate) === 0) action = 'close';
	                    if (Math.abs(translate) === actionsWidth) action = 'open';
	                }
	                
	                if (action === 'open') {
	                    app.swipeoutOpenedEl = swipeOutEl;
	                    swipeOutEl.trigger('open swipeout:open');
	                    swipeOutEl.addClass('swipeout-opened transitioning');
	                    var newTranslate = direction === 'to-left' ? -actionsWidth : actionsWidth;
	                    swipeOutContent.transform('translate3d(' + newTranslate + 'px,0,0)');
	                    actions.addClass('swipeout-actions-opened');
	                    buttons = direction === 'to-left' ? buttonsRight : buttonsLeft;
	                    if (buttons) {
	                        for (i = 0; i < buttons.length; i++) {
	                            $(buttons[i]).transform('translate3d(' + newTranslate + 'px,0,0)');
	                        }
	                    }
	                    if (overswipeRight) {
	                        actionsRight.find('.swipeout-overswipe')[0].click();
	                    }
	                    if (overswipeLeft) {
	                        actionsLeft.find('.swipeout-overswipe')[0].click();
	                    }
	                }
	                else {
	                    swipeOutEl.trigger('close swipeout:close');
	                    app.swipeoutOpenedEl = undefined;
	                    swipeOutEl.addClass('transitioning').removeClass('swipeout-opened');
	                    swipeOutContent.transform('');
	                    actions.removeClass('swipeout-actions-opened');
	                }
	                
	                var buttonOffset;
	                if (buttonsLeft && buttonsLeft.length > 0 && buttonsLeft !== buttons) {
	                    for (i = 0; i < buttonsLeft.length; i++) {
	                        buttonOffset = buttonsLeft[i]._buttonOffset;
	                        if (typeof buttonOffset === 'undefined') {
	                            buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                        }
	                        $(buttonsLeft[i]).transform('translate3d(' + (buttonOffset) + 'px,0,0)');
	                    }
	                }
	                if (buttonsRight && buttonsRight.length > 0 && buttonsRight !== buttons) {
	                    for (i = 0; i < buttonsRight.length; i++) {
	                        buttonOffset = buttonsRight[i]._buttonOffset;
	                        if (typeof buttonOffset === 'undefined') {
	                            buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                        }
	                        $(buttonsRight[i]).transform('translate3d(' + (-buttonOffset) + 'px,0,0)');
	                    }
	                }
	                swipeOutContent.transitionEnd(function (e) {
	                    if (opened && action === 'open' || closed && action === 'close') return;
	                    swipeOutEl.trigger(action === 'open' ? 'opened' : 'closed');
	                    if (opened && action === 'close') {
	                        if (actionsRight.length > 0) {
	                            buttonsRight.transform('');
	                        }
	                        if (actionsLeft.length > 0) {
	                            buttonsLeft.transform('');
	                        }
	                    }
	                });
	            }
	            if (swipeoutEl) {
	                $(swipeoutEl).on(app.touchEvents.start, handleTouchStart, activeListener);
	                $(swipeoutEl).on(app.touchEvents.move, handleTouchMove, activeListener);
	                $(swipeoutEl).on(app.touchEvents.end, handleTouchEnd, activeListener);
	            }
	            else {
	                $(document).on(app.touchEvents.start, '.list-block li.swipeout', handleTouchStart, activeListener);
	                $(document).on(app.touchEvents.move, '.list-block li.swipeout', handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, '.list-block li.swipeout', handleTouchEnd, activeListener);
	            }
	                
	        };
	        app.swipeoutOpen = function (el, dir, callback) {
	            el = $(el);
	            if (arguments.length === 2) {
	                if (typeof arguments[1] === 'function') {
	                    callback = dir;
	                }
	            }
	        
	            if (el.length === 0) return;
	            if (el.length > 1) el = $(el[0]);
	            if (!el.hasClass('swipeout') || el.hasClass('swipeout-opened')) return;
	            if (!dir) {
	                if (el.find('.swipeout-actions-right').length > 0) dir = 'right';
	                else dir = 'left';
	            }
	            var swipeOutActions = el.find('.swipeout-actions-' + dir);
	            if (swipeOutActions.length === 0) return;
	            el.trigger('open swipeout:open').addClass('swipeout-opened').removeClass('transitioning');
	            swipeOutActions.addClass('swipeout-actions-opened');
	            var buttons = swipeOutActions.children('a');
	            var swipeOutActionsWidth = swipeOutActions.outerWidth();
	            var translate = dir === 'right' ? -swipeOutActionsWidth : swipeOutActionsWidth;
	            var i;
	            if (buttons.length > 1) {
	                for (i = 0; i < buttons.length; i++) {
	                    if (dir === 'right') {
	                        $(buttons[i]).transform('translate3d(' + (- buttons[i].offsetLeft) + 'px,0,0)');
	                    }
	                    else {
	                        $(buttons[i]).css('z-index', buttons.length - i).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	                    }
	                }
	                var clientLeft = buttons[1].clientLeft;
	            }
	            el.addClass('transitioning');
	            for (i = 0; i < buttons.length; i++) {
	                $(buttons[i]).transform('translate3d(' + (translate) + 'px,0,0)');
	            }
	            el.find('.swipeout-content').transform('translate3d(' + translate + 'px,0,0)').transitionEnd(function () {
	                el.trigger('opened swipeout:opened');
	                if (callback) callback.call(el[0]);
	            });
	            app.swipeoutOpenedEl = el;
	        };
	        app.swipeoutClose = function (el, callback) {
	            el = $(el);
	            if (el.length === 0) return;
	            if (!el.hasClass('swipeout-opened')) return;
	            var dir = el.find('.swipeout-actions-opened').hasClass('swipeout-actions-right') ? 'right' : 'left';
	            var swipeOutActions = el.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	            var buttons = swipeOutActions.children('a');
	            var swipeOutActionsWidth = swipeOutActions.outerWidth();
	            app.allowSwipeout = false;
	            el.trigger('close swipeout:close');
	            el.removeClass('swipeout-opened').addClass('transitioning');
	        
	            var closeTO;
	            function onSwipeoutClose() {
	                app.allowSwipeout = true;
	                if (el.hasClass('swipeout-opened')) return;
	                el.removeClass('transitioning');
	                buttons.transform('');
	                el.trigger('closed swipeout:closed');
	                if (callback) callback.call(el[0]);
	                if (closeTO) clearTimeout(closeTO);
	            }
	            el.find('.swipeout-content').transform('').transitionEnd(onSwipeoutClose);
	            closeTO = setTimeout(onSwipeoutClose, 500);
	            
	            for (var i = 0; i < buttons.length; i++) {
	                if (dir === 'right') {
	                    $(buttons[i]).transform('translate3d(' + (-buttons[i].offsetLeft) + 'px,0,0)');
	                }
	                else {
	                    $(buttons[i]).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	                }
	                $(buttons[i]).css({left:0 + 'px'}).removeClass('swipeout-overswipe-active');
	            }
	            if (app.swipeoutOpenedEl && app.swipeoutOpenedEl[0] === el[0]) app.swipeoutOpenedEl = undefined;
	        };
	        app.swipeoutDelete = function (el, callback) {
	            el = $(el);
	            if (el.length === 0) return;
	            if (el.length > 1) el = $(el[0]);
	            app.swipeoutOpenedEl = undefined;
	            el.trigger('delete swipeout:delete');
	            el.css({height: el.outerHeight() + 'px'});
	            var clientLeft = el[0].clientLeft;
	            el.css({height: 0 + 'px'}).addClass('deleting transitioning').transitionEnd(function () {
	                el.trigger('deleted swipeout:deleted');
	                if (callback) callback.call(el[0]);
	                if (el.parents('.virtual-list').length > 0) {
	                    var virtualList = el.parents('.virtual-list')[0].f7VirtualList;
	                    var virtualIndex = el[0].f7VirtualListIndex;
	                    if (virtualList && typeof virtualIndex !== 'undefined') virtualList.deleteItem(virtualIndex);
	                }
	                else {
	                    if (app.params.swipeoutRemoveWithTimeout) {
	                        setTimeout(function () {
	                            el.remove();
	                        }, 0);
	                    }
	                    else el.remove();
	                }
	            });
	            var translate = '-100%';
	            el.find('.swipeout-content').transform('translate3d(' + translate + ',0,0)');
	        };
	        
	
	        /*===============================================================================
	        ************   Sortable   ************
	        ===============================================================================*/
	        app.sortableToggle = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	            sortableContainer.toggleClass('sortable-opened');
	            if (sortableContainer.hasClass('sortable-opened')) {
	                sortableContainer.trigger('open sortable:open');
	            }
	            else {
	                sortableContainer.trigger('close sortable:close');
	            }
	            return sortableContainer;
	        };
	        app.sortableOpen = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	            sortableContainer.addClass('sortable-opened');
	            sortableContainer.trigger('open sortable:open');
	            return sortableContainer;
	        };
	        app.sortableClose = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0) sortableContainer = $('.list-block.sortable');
	            sortableContainer.removeClass('sortable-opened');
	            sortableContainer.trigger('close sortable:close');
	            return sortableContainer;
	        };
	        app.initSortable = function () {
	            var isTouched, isMoved, touchStartY, touchesDiff, sortingEl, sortingElHeight, sortingItems, minTop, maxTop, insertAfter, insertBefore, sortableContainer, startIndex;
	            
	            function handleTouchStart(e) {
	                isMoved = false;
	                isTouched = true;
	                touchStartY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                /*jshint validthis:true */
	                sortingEl = $(this).parent();
	                startIndex = sortingEl.index();
	                sortingItems = sortingEl.parent().children('li');
	                sortableContainer = sortingEl.parents('.sortable');
	                e.preventDefault();
	                app.allowPanelOpen = app.allowSwipeout = false;
	            }
	            function handleTouchMove(e) {
	                if (!isTouched || !sortingEl) return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (!isMoved) {
	                    sortingEl.addClass('sorting');
	                    sortableContainer.addClass('sortable-sorting');
	                    minTop = sortingEl[0].offsetTop;
	                    maxTop = sortingEl.parent().height() - sortingEl[0].offsetTop - sortingEl.height();
	                    sortingElHeight = sortingEl[0].offsetHeight;
	                }
	                isMoved = true;
	        
	                e.preventDefault();
	                e.f7PreventPanelSwipe = true;
	                touchesDiff = pageY - touchStartY;
	                var translate = touchesDiff;
	                if (translate < -minTop) translate = -minTop;
	                if (translate > maxTop) translate = maxTop;
	                sortingEl.transform('translate3d(0,' + translate + 'px,0)');
	        
	                insertBefore = insertAfter = undefined;
	        
	                sortingItems.each(function () {
	                    var currentEl = $(this);
	                    if (currentEl[0] === sortingEl[0]) return;
	                    var currentElOffset = currentEl[0].offsetTop;
	                    var currentElHeight = currentEl.height();
	                    var sortingElOffset = sortingEl[0].offsetTop + translate;
	        
	                    if ((sortingElOffset >= currentElOffset - currentElHeight / 2) && sortingEl.index() < currentEl.index()) {
	                        currentEl.transform('translate3d(0, '+(-sortingElHeight)+'px,0)');
	                        insertAfter = currentEl;
	                        insertBefore = undefined;
	                    }
	                    else if ((sortingElOffset <= currentElOffset + currentElHeight / 2) && sortingEl.index() > currentEl.index()) {
	                        currentEl.transform('translate3d(0, '+(sortingElHeight)+'px,0)');
	                        insertAfter = undefined;
	                        if (!insertBefore) insertBefore = currentEl;
	                    }
	                    else {
	                        $(this).transform('translate3d(0, 0%,0)');
	                    }
	                });
	            }
	            function handleTouchEnd(e) {
	                app.allowPanelOpen = app.allowSwipeout = true;
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                e.preventDefault();
	                sortingItems.transform('');
	                sortingEl.removeClass('sorting');
	                sortableContainer.removeClass('sortable-sorting');
	                var virtualList, oldIndex, newIndex;
	                if (insertAfter) {
	                    sortingEl.insertAfter(insertAfter);
	                    sortingEl.trigger('sort sortable:sort', {startIndex: startIndex, newIndex: sortingEl.index()});
	                }
	                if (insertBefore) {
	                    sortingEl.insertBefore(insertBefore);
	                    sortingEl.trigger('sort sortable:sort', {startIndex: startIndex, newIndex: sortingEl.index()});
	                }
	                if ((insertAfter || insertBefore) && sortableContainer.hasClass('virtual-list')) {
	                    virtualList = sortableContainer[0].f7VirtualList;
	                    oldIndex = sortingEl[0].f7VirtualListIndex;
	                    newIndex = insertBefore ? insertBefore[0].f7VirtualListIndex : insertAfter[0].f7VirtualListIndex;
	                    if (virtualList) virtualList.moveItem(oldIndex, newIndex);
	                }
	                insertAfter = insertBefore = undefined;
	                isTouched = false;
	                isMoved = false;
	            }
	            var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	            $(document).on(app.touchEvents.start, '.list-block.sortable .sortable-handler', handleTouchStart, activeListener);
	            if (app.support.touch) {
	                $(document).on(app.touchEvents.move, '.list-block.sortable .sortable-handler', handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, '.list-block.sortable .sortable-handler', handleTouchEnd, activeListener);
	            }
	            else {
	                $(document).on(app.touchEvents.move, handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, handleTouchEnd, activeListener);
	            }
	        };
	        
	
	        /*===============================================================================
	        ************   Smart Select   ************
	        ===============================================================================*/
	        app.initSmartSelects = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var selects;
	            if (pageContainer.is('.smart-select')) {
	                selects = pageContainer;
	            }
	            else {
	                selects = pageContainer.find('.smart-select');
	            }
	            if (selects.length === 0) return;
	        
	            selects.each(function () {
	                var smartSelect = $(this);
	        
	                var $select = smartSelect.find('select');
	                if ($select.length === 0) return;
	        
	                var select = $select[0];
	                if (select.length === 0) return;
	        
	                var valueText = [];
	                var displayAs;
	                for (var i = 0; i < select.length; i++) {
	                    if (select[i].selected) {
	                        displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                        if (displayAs && typeof displayAs !== 'undefined') {
	        					valueText.push(displayAs);
	        				} else {
	        					valueText.push(select[i].textContent.trim());
	        				}
	        			}
	                }
	        
	                var itemAfter = smartSelect.find('.item-after');
	                if (itemAfter.length === 0) {
	                    smartSelect.find('.item-inner').append('<div class="item-after">' + valueText.join(', ') + '</div>');
	                }
	                else {
	                    var selectedText = itemAfter.text();
	                    if (itemAfter.hasClass('smart-select-value')) {
	                        for (i = 0; i < select.length; i++) {
	                            select[i].selected = select[i].textContent.trim() === selectedText.trim();
	                        }
	                    } else {
	                        itemAfter.text(valueText.join(', '));
	                    }
	                }
	        
	                $select.on('change', function () {
	                    var valueText = [];
	                    for (var i = 0; i < select.length; i++) {
	                        if (select[i].selected) {
	                            var displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                        	if (displayAs && typeof displayAs !== 'undefined') {
	        						valueText.push(displayAs);
	        					} else {
	        						valueText.push(select[i].textContent.trim());
	        					}
	        				}
	                    }
	                    smartSelect.find('.item-after').text(valueText.join(', '));
	                });
	        
	            });
	        
	        };
	        app.smartSelectAddOption = function (select, option, index) {
	            select = $(select);
	            var smartSelect = select.parents('.smart-select');
	            if (typeof index === 'undefined') {
	                select.append(option);
	            }
	            else {
	                $(option).insertBefore(select.find('option').eq(index));
	            }
	            app.initSmartSelects(smartSelect);
	            var selectName = smartSelect.find('select').attr('name');
	            var opened = $('.page.smart-select-page[data-select-name="' + selectName + '"]').length > 0;
	            if (opened) {
	                app.smartSelectOpen(smartSelect, true);
	            }
	        };
	        app.smartSelectOpen = function (smartSelect, reLayout) {
	            smartSelect = $(smartSelect);
	            if (smartSelect.length === 0) return;
	        
	            // Find related view
	            var view = smartSelect.parents('.' + app.params.viewClass);
	            if (view.length === 0) return;
	            view = view[0].f7View;
	        
	            // Parameters
	            var openIn = smartSelect.attr('data-open-in') || app.params.smartSelectOpenIn;
	            if (openIn === 'popup') {
	                if ($('.popup.smart-select-popup').length > 0) return;
	            }
	            else if (openIn === 'picker') {
	                if ($('.picker-modal.modal-in').length > 0 && !reLayout){
	                    if (smartSelect[0].f7SmartSelectPicker !== $('.picker-modal.modal-in:not(.modal-out)')[0]) app.closeModal($('.picker-modal.modal-in:not(.modal-out)'));
	                    else return;
	                }
	            }
	            else {
	                if (!view) return;
	            }
	        
	            var smartSelectData = smartSelect.dataset();
	            var pageTitle = smartSelectData.pageTitle || smartSelect.find('.item-title').text();
	            var backText = smartSelectData.backText || app.params.smartSelectBackText;
	            var closeText;
	            if (openIn === 'picker') {
	                closeText = smartSelectData.pickerCloseText || smartSelectData.backText || app.params.smartSelectPickerCloseText ;
	            }
	            else {
	                closeText = smartSelectData.popupCloseText || smartSelectData.backText || app.params.smartSelectPopupCloseText ;
	            }
	            var backOnSelect = smartSelectData.backOnSelect !== undefined ? smartSelectData.backOnSelect : app.params.smartSelectBackOnSelect;
	            var formTheme = smartSelectData.formTheme || app.params.smartSelectFormTheme;
	            var navbarTheme = smartSelectData.navbarTheme || app.params.smartSelectNavbarTheme;
	            var toolbarTheme = smartSelectData.toolbarTheme || app.params.smartSelectToolbarTheme;
	            var virtualList = smartSelectData.virtualList;
	            var virtualListHeight = smartSelectData.virtualListHeight;
	            var material = app.params.material;
	            var pickerHeight = smartSelectData.pickerHeight || app.params.smartSelectPickerHeight;
	        
	            // Collect all options/values
	            var select = smartSelect.find('select')[0];
	            var $select = $(select);
	            var $selectData = $select.dataset();
	            if (select.disabled || smartSelect.hasClass('disabled') || $select.hasClass('disabled')) {
	                return;
	            }
	            var values = [];
	            var id = (new Date()).getTime();
	            var inputType = select.multiple ? 'checkbox' : 'radio';
	            var inputName = inputType + '-' + id;
	            var maxLength = $select.attr('maxlength');
	            var selectName = select.name;
	            var option, optionHasMedia, optionImage, optionIcon, optionGroup, optionGroupLabel, optionPreviousGroup, optionIsLabel, previousGroup, optionColor, optionClassName, optionData;
	            for (var i = 0; i < select.length; i++) {
	                option = $(select[i]);
	                optionData = option.dataset();
	                optionImage = optionData.optionImage || $selectData.optionImage || smartSelectData.optionImage;
	                optionIcon = optionData.optionIcon || $selectData.optionIcon || smartSelectData.optionIcon;
	                optionHasMedia = optionImage || optionIcon || inputType === 'checkbox';
	                if (material) optionHasMedia = optionImage || optionIcon;
	                optionColor = optionData.optionColor;
	                optionClassName = optionData.optionClass;
	                if (option[0].disabled) optionClassName += ' disabled';
	                optionGroup = option.parent('optgroup')[0];
	                optionGroupLabel = optionGroup && optionGroup.label;
	                optionIsLabel = false;
	                if (optionGroup) {
	                    if (optionGroup !== previousGroup) {
	                        optionIsLabel = true;
	                        previousGroup = optionGroup;
	                        values.push({
	                            groupLabel: optionGroupLabel,
	                            isLabel: optionIsLabel
	                        });
	                    }
	                }
	                values.push({
	                    value: option[0].value,
	                    text: option[0].textContent.trim(),
	                    selected: option[0].selected,
	                    group: optionGroup,
	                    groupLabel: optionGroupLabel,
	                    image: optionImage,
	                    icon: optionIcon,
	                    color: optionColor,
	                    className: optionClassName,
	                    disabled: option[0].disabled,
	                    inputType: inputType,
	                    id: id,
	                    hasMedia: optionHasMedia,
	                    checkbox: inputType === 'checkbox',
	                    inputName: inputName,
	                    material: app.params.material
	                });
	            }
	        
	        
	            // Item template/HTML
	            if (!app._compiledTemplates.smartSelectItem) {
	                app._compiledTemplates.smartSelectItem = t7.compile(app.params.smartSelectItemTemplate ||
	                    '{{#if isLabel}}' +
	                    '<li class="item-divider">{{groupLabel}}</li>' +
	                    '{{else}}' +
	                    '<li{{#if className}} class="{{className}}"{{/if}}>' +
	                        '<label class="label-{{inputType}} item-content">' +
	                            '<input type="{{inputType}}" name="{{inputName}}" value="{{value}}" {{#if selected}}checked{{/if}}>' +
	                            '{{#if material}}' +
	                                '{{#if hasMedia}}' +
	                                '<div class="item-media">' +
	                                    '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                                    '{{#if image}}<img src="{{image}}">{{/if}}' +
	                                '</div>' +
	                                '<div class="item-inner">' +
	                                    '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                                '</div>' +
	                                '<div class="item-after">' +
	                                    '<i class="icon icon-form-{{inputType}}"></i>' +
	                                '</div>' +
	                                '{{else}}' +
	                                '<div class="item-media">' +
	                                    '<i class="icon icon-form-{{inputType}}"></i>' +
	                                '</div>' +
	                                '<div class="item-inner">' +
	                                    '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                                '</div>' +
	                                '{{/if}}' +
	                            '{{else}}' +
	                                '{{#if hasMedia}}' +
	                                '<div class="item-media">' +
	                                    '{{#if checkbox}}<i class="icon icon-form-checkbox"></i>{{/if}}' +
	                                    '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                                    '{{#if image}}<img src="{{image}}">{{/if}}' +
	                                '</div>' +
	                                '{{/if}}' +
	                                '<div class="item-inner">' +
	                                    '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                                '</div>' +
	                            '{{/if}}' +
	                        '</label>' +
	                    '</li>' +
	                    '{{/if}}'
	                );
	            }
	            var smartSelectItemTemplate = app._compiledTemplates.smartSelectItem;
	        
	            var inputsHTML = '';
	            if (!virtualList) {
	                for (var j = 0; j < values.length; j++) {
	                    inputsHTML += smartSelectItemTemplate(values[j]);
	                }
	            }
	        
	            // Toolbar / Navbar
	            var toolbarHTML = '', navbarHTML;
	            var noNavbar = '', noToolbar = '', noTabbar = '', navbarLayout;
	        
	            if (openIn === 'picker') {
	                if (!app._compiledTemplates.smartSelectToolbar) {
	                    app._compiledTemplates.smartSelectToolbar = t7.compile(app.params.smartSelectToolbarTemplate ||
	                        '<div class="toolbar {{#if toolbarTheme}}theme-{{toolbarTheme}}{{/if}}">' +
	                          '<div class="toolbar-inner">' +
	                            '<div class="left"></div>' +
	                            '<div class="right"><a href="#" class="link close-picker"><span>{{closeText}}</span></a></div>' +
	                        '</div>' +
	                      '</div>'
	                    );
	                }
	        
	                toolbarHTML = app._compiledTemplates.smartSelectToolbar({
	                    pageTitle: pageTitle,
	                    closeText: closeText,
	                    openIn: openIn,
	                    toolbarTheme: toolbarTheme,
	                    inPicker: openIn === 'picker'
	                });
	            }
	            else {
	                // Navbar HTML
	                if (!app._compiledTemplates.smartSelectNavbar) {
	                    app._compiledTemplates.smartSelectNavbar = t7.compile(app.params.smartSelectNavbarTemplate ||
	                        '<div class="navbar {{#if navbarTheme}}theme-{{navbarTheme}}{{/if}}">' +
	                            '<div class="navbar-inner">' +
	                                '{{leftTemplate}}' +
	                                '<div class="center sliding">{{pageTitle}}</div>' +
	                            '</div>' +
	                        '</div>'
	                    );
	                }
	                navbarHTML = app._compiledTemplates.smartSelectNavbar({
	                    pageTitle: pageTitle,
	                    backText: backText,
	                    closeText: closeText,
	                    openIn: openIn,
	                    navbarTheme: navbarTheme,
	                    inPopup: openIn === 'popup',
	                    inPage: openIn === 'page',
	                    leftTemplate: openIn === 'popup' ?
	                        (app.params.smartSelectPopupCloseTemplate || (material ? '<div class="left"><a href="#" class="link close-popup icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left"><a href="#" class="link close-popup"><i class="icon icon-back"></i><span>{{closeText}}</span></a></div>')).replace(/{{closeText}}/g, closeText) :
	                        (app.params.smartSelectBackTemplate || (material ? '<div class="left"><a href="#" class="back link icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left sliding"><a href="#" class="back link"><i class="icon icon-back"></i><span>{{backText}}</span></a></div>')).replace(/{{backText}}/g, backText)
	                });
	                // Determine navbar layout type - static/fixed/through
	                if (openIn === 'page') {
	                    navbarLayout = 'static';
	                    if (smartSelect.parents('.navbar-through').length > 0) navbarLayout = 'through';
	                    if (smartSelect.parents('.navbar-fixed').length > 0) navbarLayout = 'fixed';
	                    noToolbar = smartSelect.parents('.page').hasClass('no-toolbar') ? 'no-toolbar' : '';
	                    noNavbar  = smartSelect.parents('.page').hasClass('no-navbar')  ? 'no-navbar'  : 'navbar-' + navbarLayout;
	                    noTabbar = smartSelect.parents('.page').hasClass('no-tabbar') ? 'no-tabbar' : '';
	                }
	                else {
	                    navbarLayout = 'fixed';
	                }
	            }
	        
	        
	            // Page Layout
	            var pageName = 'smart-select-' + inputName;
	        
	            var useSearchbar = typeof smartSelect.data('searchbar') === 'undefined' ? app.params.smartSelectSearchbar : (smartSelect.data('searchbar') === 'true' ? true : false);
	            var searchbarPlaceholder, searchbarCancel;
	        
	            if (useSearchbar) {
	                searchbarPlaceholder = smartSelect.data('searchbar-placeholder') || 'Search';
	                searchbarCancel = smartSelect.data('searchbar-cancel') || 'Cancel';
	            }
	        
	            var searchbarHTML =   '<form class="searchbar searchbar-init" data-search-list=".smart-select-list-' + id + '" data-search-in=".item-title">' +
	                                    '<div class="searchbar-input">' +
	                                        '<input type="search" placeholder="' + searchbarPlaceholder + '">' +
	                                        '<a href="#" class="searchbar-clear"></a>' +
	                                    '</div>' +
	                                    (material ? '' : '<a href="#" class="searchbar-cancel">' + searchbarCancel + '</a>') +
	                                  '</form>' +
	                                  '<div class="searchbar-overlay"></div>';
	        
	            var pageHTML =
	                (openIn !== 'picker' && navbarLayout === 'through' ? navbarHTML : '') +
	                '<div class="pages">' +
	                '  <div data-page="' + pageName + '" data-select-name="' + selectName + '" class="page smart-select-page ' + noNavbar + ' ' + noToolbar + ' ' + noTabbar + '">' +
	                     (openIn !== 'picker' && navbarLayout === 'fixed' ? navbarHTML : '') +
	                     (useSearchbar ? searchbarHTML : '') +
	                '    <div class="page-content">' +
	                       (openIn !== 'picker' && navbarLayout === 'static' ? navbarHTML : '') +
	                '      <div class="list-block ' + (virtualList ? 'virtual-list' : '') + ' smart-select-list-' + id + ' ' + (formTheme ? 'theme-' + formTheme : '') + '">' +
	                '        <ul>' +
	                            (virtualList ? '' : inputsHTML) +
	                '        </ul>' +
	                '      </div>' +
	                '    </div>' +
	                '  </div>' +
	                '</div>';
	        
	            // Define popup and picker
	            var popup, picker;
	        
	            // Scroll SS Picker To Input
	            function scrollToInput() {
	                var pageContent = smartSelect.parents('.page-content');
	                if (pageContent.length === 0) return;
	                var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                    paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                    pageHeight = pageContent[0].offsetHeight - paddingTop - picker.height(),
	                    pageScrollHeight = pageContent[0].scrollHeight - paddingTop - picker.height(),
	                    newPaddingBottom;
	                var inputTop = smartSelect.offset().top - paddingTop + smartSelect[0].offsetHeight;
	                if (inputTop > pageHeight) {
	                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                    if (scrollTop + pageHeight > pageScrollHeight) {
	                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                        if (pageHeight === pageScrollHeight) {
	                            newPaddingBottom = picker.height();
	                        }
	                        pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                    }
	                    pageContent.scrollTop(scrollTop, 300);
	                }
	            }
	            // Close SS Picker on HTML Click
	            function closeOnHTMLClick(e) {
	                var close = true;
	                if (e.target === smartSelect[0] || $(e.target).parents(smartSelect[0]).length > 0) {
	                    close = false;
	                }
	                if ($(e.target).parents('.picker-modal').length > 0) {
	                    close = false;
	                }
	                if (close) {
	                    app.closeModal('.smart-select-picker.modal-in');
	                }
	            }
	        
	            // Check max length
	            function checkMaxLength(container) {
	                if (select.selectedOptions.length >= maxLength) {
	                    container.find('input[type="checkbox"]').each(function () {
	                        if (!this.checked) {
	                            $(this).parents('li').addClass('disabled');
	                        }
	                        else {
	                            $(this).parents('li').removeClass('disabled');
	                        }
	                    });
	                }
	                else {
	                    container.find('.disabled').removeClass('disabled');
	                }
	            }
	            // Event Listeners on new page
	            function handleInputs(container) {
	                container = $(container);
	                if (virtualList) {
	                    var virtualListInstance = app.virtualList(container.find('.virtual-list'), {
	                        items: values,
	                        template: smartSelectItemTemplate,
	                        height: virtualListHeight || undefined,
	                        searchByItem: function (query, index, item) {
	                            if (item.text && item.text.toLowerCase().indexOf(query.trim().toLowerCase()) >=0 ) return true;
	                            return false;
	                        }
	                    });
	                    container.once(openIn === 'popup' || openIn === 'picker' ? 'closed': 'pageBeforeRemove', function () {
	                        if (virtualListInstance && virtualListInstance.destroy) virtualListInstance.destroy();
	                    });
	                }
	                if (maxLength) {
	                    checkMaxLength(container);
	                }
	                if (backOnSelect) {
	                    container.find('input[type="radio"][name="' + inputName + '"]:checked').parents('label').once('click', function () {
	                        if (openIn === 'popup') app.closeModal(popup);
	                        else if (openIn === 'picker') app.closeModal(picker);
	                        else view.router.back();
	                    });
	                }
	                container.on('change', 'input[name="' + inputName + '"]', function () {
	        			var option, text;
	                    var input = this;
	                    var value = input.value;
	                    var optionText = [];
	                    var displayAs;
	                    if (input.type === 'checkbox') {
	                        var values = [];
	                        for (var i = 0; i < select.options.length; i++) {
	                            option = select.options[i];
	                            if (option.value === value) {
	                                option.selected = input.checked;
	                            }
	                            if (option.selected) {
	                                displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                                text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                                optionText.push(text.trim());
	                            }
	                        }
	                        if (maxLength) {
	                            checkMaxLength(container);
	                        }
	                    }
	                    else {
	                        option = smartSelect.find('option[value="' + value + '"]')[0];
	                        displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                        text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                        optionText = [text];
	                        select.value = value;
	                    }
	        
	                    $select.trigger('change');
	                    smartSelect.find('.item-after').text(optionText.join(', '));
	                    if (backOnSelect && inputType === 'radio') {
	                        if (openIn === 'popup') app.closeModal(popup);
	                        else if (openIn === 'picker') app.closeModal(picker);
	                        else view.router.back();
	                    }
	                });
	            }
	            function pageInit(e) {
	                var page = e.detail.page;
	                if (page.name === pageName) {
	                    handleInputs(page.container);
	                }
	            }
	            if (openIn === 'popup') {
	                if (reLayout) {
	                    popup = $('.popup.smart-select-popup .view');
	                    popup.html(pageHTML);
	                }
	                else {
	                    popup = app.popup(
	                        '<div class="popup smart-select-popup smart-select-popup-' + inputName + '">' +
	                            '<div class="view navbar-fixed">' +
	                                pageHTML +
	                            '</div>' +
	                        '</div>'
	                        );
	                    popup = $(popup);
	                }
	                app.initPage(popup.find('.page'));
	                handleInputs(popup);
	            }
	            else if (openIn === 'picker') {
	                if (reLayout) {
	                    picker = $('.picker-modal.smart-select-picker .view');
	                    picker.html(pageHTML);
	                }
	                else {
	                    picker = app.pickerModal(
	                        '<div class="picker-modal smart-select-picker smart-select-picker-' + inputName + '"' + (pickerHeight ? ' style="height:' + pickerHeight + '"' : '') + '>' +
	                            toolbarHTML +
	                            '<div class="picker-modal-inner">' +
	                                '<div class="view">' +
	                                    pageHTML +
	                                '</div>' +
	                            '</div>' +
	                        '</div>'
	                        );
	                    picker = $(picker);
	        
	                    // Scroll To Input
	                    scrollToInput();
	        
	                    // Close On Click
	                    $('html').on('click', closeOnHTMLClick);
	        
	                    // On Close
	                    picker.once('picker:close', function () {
	                        // Reset linked picker
	                        smartSelect[0].f7SmartSelectPicker = undefined;
	        
	                        // Detach html click
	                        $('html').off('click', closeOnHTMLClick);
	        
	                        // Restore page padding bottom
	                        smartSelect.parents('.page-content').css({paddingBottom: ''});
	                    });
	        
	                    // Link Picker
	                    smartSelect[0].f7SmartSelectPicker = picker[0];
	                }
	        
	                // Init Page
	                app.initPage(picker.find('.page'));
	        
	                // Attach events
	                handleInputs(picker);
	            }
	            else {
	                $(document).once('page:init', '.smart-select-page', pageInit);
	                view.router.load({
	                    content: pageHTML,
	                    reload: reLayout ? true : undefined
	                });
	            }
	        };
	        
	
	        /*===============================================================================
	        ************   Virtual List   ************
	        ===============================================================================*/
	        var VirtualList = function (listBlock, params) {
	            var defaults = {
	                cols: 1,
	                height: app.params.material ? 48 : 44,
	                cache: true,
	                dynamicHeightBufferSize: 1,
	                showFilteredItemsOnly: false,
	                template:
	                    '<li>' +
	                        '<div class="item-content">' +
	                            '<div class="item-inner">' +
	                                '<div class="item-title">{{this}}</div>' +
	                            '</div>' +
	                        '</div>' +
	                    '</li>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	        
	            // Preparation
	            var vl = this;
	            vl.listBlock = $(listBlock);
	            vl.params = params;
	            vl.items = vl.params.items;
	            if (vl.params.showFilteredItemsOnly) {
	                vl.filteredItems = [];
	            }
	            if (vl.params.template && !vl.params.renderItem) {
	                if (typeof vl.params.template === 'string') vl.template = t7.compile(vl.params.template);
	                else if (typeof vl.params.template === 'function') vl.template = vl.params.template;
	            }
	            vl.pageContent = vl.listBlock.parents('.page-content');
	        
	            // Bad scroll
	            var updatableScroll;
	            if (typeof vl.params.updatableScroll !== 'undefined') {
	                updatableScroll = vl.params.updatableScroll;
	            }
	            else {
	                updatableScroll = true;
	                if (app.device.ios && app.device.osVersion.split('.')[0] < 8) {
	                    updatableScroll = false;
	                }
	                vl.params.updatableScroll = updatableScroll;
	            }
	        
	            // Append <ul>
	            vl.ul = vl.params.ul ? $(vl.params.ul) : vl.listBlock.children('ul');
	            if (vl.ul.length === 0) {
	                vl.listBlock.append('<ul></ul>');
	                vl.ul = vl.listBlock.children('ul');
	            }
	        
	            // DOM cached items
	            vl.domCache = {};
	            vl.displayDomCache = {};
	        
	            // Temporary DOM Element
	            vl.tempDomElement = document.createElement('ul');
	        
	            // Last repain position
	            vl.lastRepaintY = null;
	        
	            // Fragment
	            vl.fragment = document.createDocumentFragment();
	        
	            // Filter
	            vl.filterItems = function (indexes, resetScrollTop) {
	                vl.filteredItems = [];
	                var firstIndex = indexes[0];
	                var lastIndex = indexes[indexes.length - 1];
	                for (var i = 0; i < indexes.length; i++) {
	                    vl.filteredItems.push(vl.items[indexes[i]]);
	                }
	                if (typeof resetScrollTop === 'undefined') resetScrollTop = true;
	                if (resetScrollTop) {
	                    vl.pageContent[0].scrollTop = 0;
	                }
	                vl.update();
	            };
	            vl.resetFilter = function () {
	                if (vl.params.showFilteredItemsOnly) {
	                    vl.filteredItems = [];
	                }
	                else {
	                    vl.filteredItems = null;
	                    delete vl.filteredItems;
	                }
	                vl.update();
	            };
	        
	            var pageHeight, rowsPerScreen, rowsBefore, rowsAfter, rowsToRender, maxBufferHeight = 0, listHeight;
	            var dynamicHeight = typeof vl.params.height === 'function';
	        
	            // Set list size
	            vl.setListSize = function () {
	                var items = vl.filteredItems || vl.items;
	                pageHeight = vl.pageContent[0].offsetHeight;
	                if (dynamicHeight) {
	                    listHeight = 0;
	                    vl.heights = [];
	                    for (var i = 0; i < items.length; i++) {
	                        var itemHeight = vl.params.height(items[i]);
	                        listHeight += itemHeight;
	                        vl.heights.push(itemHeight);
	                    }
	                }
	                else {
	                    listHeight = Math.ceil(items.length /  vl.params.cols) * vl.params.height;
	                    rowsPerScreen = Math.ceil(pageHeight / vl.params.height);
	                    rowsBefore = vl.params.rowsBefore || rowsPerScreen * 2;
	                    rowsAfter = vl.params.rowsAfter || rowsPerScreen;
	                    rowsToRender = (rowsPerScreen + rowsBefore + rowsAfter);
	                    maxBufferHeight = rowsBefore / 2 * vl.params.height;
	                }
	        
	                if (updatableScroll) {
	                    vl.ul.css({height: listHeight + 'px'});
	                }
	            };
	        
	            // Render items
	            vl.render = function (force, forceScrollTop) {
	                if (force) vl.lastRepaintY = null;
	        
	                var scrollTop = -(vl.listBlock[0].getBoundingClientRect().top - vl.pageContent[0].getBoundingClientRect().top);
	        
	                if (typeof forceScrollTop !== 'undefined') scrollTop = forceScrollTop;
	        
	                if (vl.lastRepaintY === null || Math.abs(scrollTop - vl.lastRepaintY) > maxBufferHeight || (!updatableScroll && (vl.pageContent[0].scrollTop + pageHeight >= vl.pageContent[0].scrollHeight))) {
	                    vl.lastRepaintY = scrollTop;
	                }
	                else {
	                    return;
	                }
	        
	                var items = vl.filteredItems || vl.items,
	                    fromIndex, toIndex, heightBeforeFirstItem = 0, heightBeforeLastItem = 0;
	                if (dynamicHeight) {
	                    var itemTop = 0, j, itemHeight;
	                    maxBufferHeight = pageHeight;
	        
	                    for (j = 0; j < vl.heights.length; j++) {
	                        itemHeight = vl.heights[j];
	                        if (typeof fromIndex === 'undefined') {
	                            if (itemTop + itemHeight >= scrollTop - pageHeight * 2 * vl.params.dynamicHeightBufferSize) fromIndex = j;
	                            else heightBeforeFirstItem += itemHeight;
	                        }
	        
	                        if (typeof toIndex === 'undefined') {
	                            if (itemTop + itemHeight >= scrollTop + pageHeight * 2 * vl.params.dynamicHeightBufferSize || j === vl.heights.length - 1) toIndex = j + 1;
	                            heightBeforeLastItem += itemHeight;
	                        }
	                        itemTop += itemHeight;
	                    }
	                    toIndex = Math.min(toIndex, items.length);
	                }
	                else {
	                    fromIndex = (parseInt(scrollTop / vl.params.height) - rowsBefore) * vl.params.cols;
	                    if (fromIndex < 0) {
	                        fromIndex = 0;
	                    }
	                    toIndex = Math.min(fromIndex + rowsToRender * vl.params.cols, items.length);
	                }
	        
	                var topPosition;
	                vl.reachEnd = false;
	                for (var i = fromIndex; i < toIndex; i++) {
	                    var item, index;
	                    // Define real item index
	                    index = vl.items.indexOf(items[i]);
	        
	                    if (i === fromIndex) vl.currentFromIndex = index;
	                    if (i === toIndex - 1) vl.currentToIndex = index;
	                    if (vl.filteredItems) {
	                        if (vl.items[index] === vl.filteredItems[vl.filteredItems.length - 1]) vl.reachEnd = true;
	                    }
	                    else {
	                        if (index === vl.items.length - 1) vl.reachEnd = true;
	                    }
	        
	                    // Find items
	                    if (vl.domCache[index]) {
	                        item = vl.domCache[index];
	                    }
	                    else {
	                        if (vl.template && !vl.params.renderItem) {
	                            vl.tempDomElement.innerHTML = vl.template(items[i], {index: index}).trim();
	                        }
	                        else if (vl.params.renderItem) {
	                            vl.tempDomElement.innerHTML = vl.params.renderItem(index, items[i]).trim();
	                        }
	                        else {
	                            vl.tempDomElement.innerHTML = items[i].toString().trim();
	                        }
	                        item = vl.tempDomElement.childNodes[0];
	                        if (vl.params.cache) vl.domCache[index] = item;
	                    }
	                    item.f7VirtualListIndex = index;
	        
	                    // Set item top position
	                    if (i === fromIndex) {
	                        if (dynamicHeight) {
	                            topPosition = heightBeforeFirstItem;
	                        }
	                        else {
	                            topPosition = (i * vl.params.height / vl.params.cols);
	                        }
	                    }
	                    item.style.top = topPosition + 'px';
	        
	                    // Before item insert
	                    if (vl.params.onItemBeforeInsert) vl.params.onItemBeforeInsert(vl, item);
	        
	                    // Append item to fragment
	                    vl.fragment.appendChild(item);
	        
	        
	                }
	        
	                // Update list height with not updatable scroll
	                if (!updatableScroll) {
	                    if (dynamicHeight) {
	                        vl.ul[0].style.height = heightBeforeLastItem + 'px';
	                    }
	                    else {
	                        vl.ul[0].style.height = i * vl.params.height / vl.params.cols + 'px';
	                    }
	                }
	        
	                // Update list html
	                if (vl.params.onBeforeClear) vl.params.onBeforeClear(vl, vl.fragment);
	                vl.ul[0].innerHTML = '';
	        
	                if (vl.params.onItemsBeforeInsert) vl.params.onItemsBeforeInsert(vl, vl.fragment);
	                if (items && items.length === 0) {
	                    vl.reachEnd = true;
	                    if (vl.params.emptyTemplate) vl.ul[0].innerHTML = vl.params.emptyTemplate;
	                }
	                else {
	                    vl.ul[0].appendChild(vl.fragment);
	                }
	        
	                if (vl.params.onItemsAfterInsert) vl.params.onItemsAfterInsert(vl, vl.fragment);
	        
	                if (typeof forceScrollTop !== 'undefined' && force) {
	                    vl.pageContent.scrollTop(forceScrollTop, 0);
	                }
	            };
	        
	            vl.scrollToItem = function (index) {
	                if (index > vl.items.length) return false;
	        
	                var itemTop = 0, listTop;
	                if (dynamicHeight) {
	                    for (var i = 0; i < index; i++) {
	                        itemTop += vl.heights[i];
	                    }
	                }
	                else {
	                    itemTop = index * vl.params.height;
	                }
	                listTop = vl.listBlock[0].offsetTop;
	                vl.render(true, listTop + itemTop - parseInt(vl.pageContent.css('padding-top'), 10));
	                return true;
	            };
	        
	            // Handle scroll event
	            vl.handleScroll = function (e) {
	                vl.render();
	            };
	            // Handle resize event
	            vl._isVisible = function (el) {
	                return !!( el.offsetWidth || el.offsetHeight || el.getClientRects().length );
	            };
	            vl.handleResize = function (e) {
	                if (vl._isVisible(vl.listBlock[0])) {
	                    vl.setListSize();
	                    vl.render(true);
	                }
	            };
	        
	            vl.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                vl.pageContent[action]('scroll', vl.handleScroll);
	                vl.listBlock.parents('.tab').eq(0)[action]('tab:show', vl.handleResize);
	                vl.listBlock.parents('.panel').eq(0)[action]('panel:open', vl.handleResize);
	                vl.listBlock.parents('.popup').eq(0)[action]('popup:open', vl.handleResize);
	                app[action === 'on' ? 'onResize' : 'offResize'](vl.handleResize);
	            };
	        
	            // Init Virtual List
	            vl.init = function () {
	                vl.attachEvents();
	                vl.setListSize();
	                vl.render();
	            };
	        
	            // Append
	            vl.appendItems = function (items) {
	                for (var i = 0; i < items.length; i++) {
	                    vl.items.push(items[i]);
	                }
	                vl.update();
	            };
	            vl.appendItem = function (item) {
	                vl.appendItems([item]);
	            };
	            // Replace
	            vl.replaceAllItems = function (items) {
	                vl.items = items;
	                delete vl.filteredItems;
	                vl.domCache = {};
	                vl.update();
	            };
	            vl.replaceItem = function (index, item) {
	                vl.items[index] = item;
	                if (vl.params.cache) delete vl.domCache[index];
	                vl.update();
	            };
	            // Prepend
	            vl.prependItems = function (items) {
	                for (var i = items.length - 1; i >= 0; i--) {
	                    vl.items.unshift(items[i]);
	                }
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        newCache[parseInt(cached, 10) + items.length] = vl.domCache[cached];
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            vl.prependItem = function (item) {
	                vl.prependItems([item]);
	            };
	        
	            // Move
	            vl.moveItem = function (oldIndex, newIndex) {
	                if (oldIndex === newIndex) return;
	                // remove item from array
	                var item = vl.items.splice(oldIndex, 1)[0];
	                if (newIndex >= vl.items.length) {
	                    // Add item to the end
	                    vl.items.push(item);
	                    newIndex = vl.items.length - 1;
	                }
	                else {
	                    // Add item to new index
	                    vl.items.splice(newIndex, 0, item);
	                }
	                // Update cache
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        var cachedIndex = parseInt(cached, 10);
	                        var leftIndex = oldIndex < newIndex ? oldIndex : newIndex;
	                        var rightIndex = oldIndex < newIndex ? newIndex : oldIndex;
	                        var indexShift = oldIndex < newIndex ? -1 : 1;
	                        if (cachedIndex < leftIndex || cachedIndex > rightIndex) newCache[cachedIndex] = vl.domCache[cachedIndex];
	                        if (cachedIndex === leftIndex) newCache[rightIndex] = vl.domCache[cachedIndex];
	                        if (cachedIndex > leftIndex && cachedIndex <= rightIndex) newCache[cachedIndex + indexShift] = vl.domCache[cachedIndex];
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            // Insert before
	            vl.insertItemBefore = function (index, item) {
	                if (index === 0) {
	                    vl.prependItem(item);
	                    return;
	                }
	                if (index >= vl.items.length) {
	                    vl.appendItem(item);
	                    return;
	                }
	                vl.items.splice(index, 0, item);
	                // Update cache
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        var cachedIndex = parseInt(cached, 10);
	                        if (cachedIndex >= index) {
	                            newCache[cachedIndex + 1] = vl.domCache[cachedIndex];
	                        }
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            // Delete
	            vl.deleteItems = function (indexes) {
	                var prevIndex, indexShift = 0;
	                for (var i = 0; i < indexes.length; i++) {
	                    var index = indexes[i];
	                    if (typeof prevIndex !== 'undefined') {
	                        if (index > prevIndex) {
	                            indexShift = -i;
	                        }
	                    }
	                    index = index + indexShift;
	                    prevIndex = indexes[i];
	                    // Delete item
	                    var deletedItem = vl.items.splice(index, 1)[0];
	        
	                    // Delete from filtered
	                    if (vl.filteredItems && vl.filteredItems.indexOf(deletedItem) >= 0) {
	                        vl.filteredItems.splice(vl.filteredItems.indexOf(deletedItem), 1);
	                    }
	                    // Update cache
	                    if (vl.params.cache) {
	                        var newCache = {};
	                        for (var cached in vl.domCache) {
	                            var cachedIndex = parseInt(cached, 10);
	                            if (cachedIndex === index) {
	                                delete vl.domCache[index];
	                            }
	                            else if (parseInt(cached, 10) > index) {
	                                newCache[cachedIndex - 1] = vl.domCache[cached];
	                            }
	                            else {
	                                newCache[cachedIndex] = vl.domCache[cached];
	                            }
	                        }
	                        vl.domCache = newCache;
	                    }
	                }
	                vl.update();
	            };
	            vl.deleteAllItems = function () {
	                vl.items = [];
	                delete vl.filteredItems;
	                if (vl.params.cache) vl.domCache = {};
	                vl.update();
	            };
	            vl.deleteItem = function (index) {
	                vl.deleteItems([index]);
	            };
	        
	            // Clear cache
	            vl.clearCache = function () {
	                vl.domCache = {};
	            };
	        
	            // Update Virtual List
	            vl.update = function () {
	                vl.setListSize();
	                vl.render(true);
	            };
	        
	            // Destroy
	            vl.destroy = function () {
	                vl.attachEvents(true);
	                delete vl.items;
	                delete vl.domCache;
	            };
	        
	            // Init Virtual List
	            vl.init();
	        
	            // Store vl in container
	            vl.listBlock[0].f7VirtualList = vl;
	            return vl;
	        };
	        
	        // App Method
	        app.virtualList = function (listBlock, params) {
	            return new VirtualList(listBlock, params);
	        };
	        
	        app.reinitVirtualList = function (pageContainer) {
	            var page = $(pageContainer);
	            var vlists = page.find('.virtual-list');
	            if (vlists.length === 0) return;
	            for (var i = 0; i < vlists.length; i++) {
	                var vlistInstance = vlists[i].f7VirtualList;
	                if (vlistInstance) {
	                    vlistInstance.update();
	                }
	            }
	        };
	        
	
	        /*======================================================
	        ************   Pull To Refresh   ************
	        ======================================================*/
	        app.initPullToRefresh = function (pageContainer) {
	            var eventsTarget = $(pageContainer);
	            if (!eventsTarget.hasClass('pull-to-refresh-content')) {
	                eventsTarget = eventsTarget.find('.pull-to-refresh-content');
	            }
	            if (!eventsTarget || eventsTarget.length === 0) return;
	        
	            var touchId, isTouched, isMoved, touchesStart = {}, isScrolling, touchesDiff, touchStartTime, container, refresh = false, useTranslate = false, startTranslate = 0, translate, scrollTop, wasScrolled, layer, triggerDistance, dynamicTriggerDistance, pullStarted;
	            var page = eventsTarget.hasClass('page') ? eventsTarget : eventsTarget.parents('.page');
	            var hasNavbar = false;
	            if (page.find('.navbar').length > 0 || page.parents('.navbar-fixed, .navbar-through').length > 0 || page.hasClass('navbar-fixed') || page.hasClass('navbar-through')) hasNavbar = true;
	            if (page.hasClass('no-navbar')) hasNavbar = false;
	            if (!hasNavbar) eventsTarget.addClass('pull-to-refresh-no-navbar');
	        
	            container = eventsTarget;
	        
	            // Define trigger distance
	            if (container.attr('data-ptr-distance')) {
	                dynamicTriggerDistance = true;
	            }
	            else {
	                triggerDistance = 44;
	            }
	        
	            function handleTouchStart(e) {
	                if (isTouched) {
	                    if (app.device.os === 'android') {
	                        if ('targetTouches' in e && e.targetTouches.length > 1) return;
	                    }
	                    else return;
	                }
	        
	                /*jshint validthis:true */
	                container = $(this);
	                if (container.hasClass('refreshing')) {
	                    return;
	                }
	        
	                isMoved = false;
	                pullStarted = false;
	                isTouched = true;
	                isScrolling = undefined;
	                wasScrolled = undefined;
	                if (e.type === 'touchstart') touchId = e.targetTouches[0].identifier;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	        
	            }
	        
	            function handleTouchMove(e) {
	                if (!isTouched) return;
	                var pageX, pageY, touch;
	                if (e.type === 'touchmove') {
	                    if (touchId && e.touches) {
	                        for (var i = 0; i < e.touches.length; i++) {
	                            if (e.touches[i].identifier === touchId) {
	                                touch = e.touches[i];
	                            }
	                        }
	                    }
	                    if (!touch) touch = e.targetTouches[0];
	                    pageX = touch.pageX;
	                    pageY = touch.pageY;
	                }
	                else {
	                    pageX = e.pageX;
	                    pageY = e.pageY;
	                }
	                if (!pageX || !pageY) return;
	        
	        
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (!isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	        
	                scrollTop = container[0].scrollTop;
	                if (typeof wasScrolled === 'undefined' && scrollTop !== 0) wasScrolled = true;
	        
	                if (!isMoved) {
	                    /*jshint validthis:true */
	                    container.removeClass('transitioning');
	                    if (scrollTop > container[0].offsetHeight) {
	                        isTouched = false;
	                        return;
	                    }
	                    if (dynamicTriggerDistance) {
	                        triggerDistance = container.attr('data-ptr-distance');
	                        if (triggerDistance.indexOf('%') >= 0) triggerDistance = container[0].offsetHeight * parseInt(triggerDistance, 10) / 100;
	                    }
	                    startTranslate = container.hasClass('refreshing') ? triggerDistance : 0;
	                    if (container[0].scrollHeight === container[0].offsetHeight || app.device.os !== 'ios') {
	                        useTranslate = true;
	                    }
	                    else {
	                        useTranslate = false;
	                    }
	                }
	                isMoved = true;
	                touchesDiff = pageY - touchesStart.y;
	        
	                if (touchesDiff > 0 && scrollTop <= 0 || scrollTop < 0) {
	                    // iOS 8 fix
	                    if (app.device.os === 'ios' && parseInt(app.device.osVersion.split('.')[0], 10) > 7 && scrollTop === 0 && !wasScrolled) useTranslate = true;
	        
	                    if (useTranslate) {
	                        e.preventDefault();
	                        translate = (Math.pow(touchesDiff, 0.85) + startTranslate);
	                        container.transform('translate3d(0,' + translate + 'px,0)');
	                    }
	                    if ((useTranslate && Math.pow(touchesDiff, 0.85) > triggerDistance) || (!useTranslate && touchesDiff >= triggerDistance * 2)) {
	                        refresh = true;
	                        container.addClass('pull-up').removeClass('pull-down');
	                    }
	                    else {
	                        refresh = false;
	                        container.removeClass('pull-up').addClass('pull-down');
	                    }
	                    if (!pullStarted) {
	                        container.trigger('pullstart ptr:pullstart');
	                        pullStarted = true;
	                    }
	                    container.trigger('pullmove ptr:pullmove', {
	                        event: e,
	                        scrollTop: scrollTop,
	                        translate: translate,
	                        touchesDiff: touchesDiff
	                    });
	                }
	                else {
	                    pullStarted = false;
	                    container.removeClass('pull-up pull-down');
	                    refresh = false;
	                    return;
	                }
	            }
	            function handleTouchEnd(e) {
	                if (e.type === 'touchend' && e.changedTouches && e.changedTouches.length > 0 && touchId) {
	                    if (e.changedTouches[0].identifier !== touchId) return;
	                }
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                if (translate) {
	                    container.addClass('transitioning');
	                    translate = 0;
	                }
	                container.transform('');
	                if (refresh) {
	                    container.addClass('refreshing');
	                    container.trigger('refresh ptr:refresh', {
	                        done: function () {
	                            app.pullToRefreshDone(container);
	                        }
	                    });
	                }
	                else {
	                    container.removeClass('pull-down');
	                }
	                isTouched = false;
	                isMoved = false;
	                if (pullStarted) container.trigger('pullend ptr:pullend');
	            }
	        
	            // Attach Events
	            var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	            var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	            eventsTarget.on(app.touchEvents.start, handleTouchStart, passiveListener);
	            eventsTarget.on(app.touchEvents.move, handleTouchMove, activeListener);
	            eventsTarget.on(app.touchEvents.end, handleTouchEnd, passiveListener);
	        
	            // Detach Events on page remove
	            if (page.length === 0) return;
	            function destroyPullToRefresh() {
	                eventsTarget.off(app.touchEvents.start, handleTouchStart, passiveListener);
	                eventsTarget.off(app.touchEvents.move, handleTouchMove, activeListener);
	                eventsTarget.off(app.touchEvents.end, handleTouchEnd, passiveListener);
	            }
	            eventsTarget[0].f7DestroyPullToRefresh = destroyPullToRefresh;
	            function detachEvents() {
	                destroyPullToRefresh();
	                page.off('page:beforeremove', detachEvents);
	            }
	            page.on('page:beforeremove', detachEvents);
	        
	        };
	        
	        app.pullToRefreshDone = function (container) {
	            container = $(container);
	            if (container.length === 0) container = $('.pull-to-refresh-content.refreshing');
	            container.removeClass('refreshing').addClass('transitioning');
	            container.transitionEnd(function () {
	                container.removeClass('transitioning pull-up pull-down');
	                container.trigger('refreshdone ptr:done');
	            });
	        };
	        app.pullToRefreshTrigger = function (container) {
	            container = $(container);
	            if (container.length === 0) container = $('.pull-to-refresh-content');
	            if (container.hasClass('refreshing')) return;
	            container.addClass('transitioning refreshing');
	            container.trigger('refresh ptr:refresh', {
	                done: function () {
	                    app.pullToRefreshDone(container);
	                }
	            });
	        };
	        
	        app.destroyPullToRefresh = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
	            if (pullToRefreshContent.length === 0) return;
	            if (pullToRefreshContent[0].f7DestroyPullToRefresh) pullToRefreshContent[0].f7DestroyPullToRefresh();
	        };
	        
	
	        /* ===============================================================================
	        ************   Infinite Scroll   ************
	        =============================================================================== */
	        function handleInfiniteScroll() {
	            /*jshint validthis:true */
	            var inf = $(this);
	            var scrollTop = inf[0].scrollTop;
	            var scrollHeight = inf[0].scrollHeight;
	            var height = inf[0].offsetHeight;
	            var distance = inf[0].getAttribute('data-distance');
	            var virtualListContainer = inf.find('.virtual-list');
	            var virtualList;
	            var onTop = inf.hasClass('infinite-scroll-top');
	            if (!distance) distance = 50;
	            if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	                distance = parseInt(distance, 10) / 100 * height;
	            }
	            if (distance > height) distance = height;
	            if (onTop) {
	                if (scrollTop < distance) {
	                    inf.trigger('infinite');
	                }
	            }
	            else {
	                if (scrollTop + height >= scrollHeight - distance) {
	                    if (virtualListContainer.length > 0) {
	                        virtualList = virtualListContainer.eq(-1)[0].f7VirtualList;
	                        if (virtualList && !virtualList.reachEnd && !virtualList.params.updatableScroll) {
	                            return;
	                        }
	                    }
	                    inf.trigger('infinite');
	                }
	            }
	        
	        }
	        app.attachInfiniteScroll = function (infiniteContent) {
	            $(infiniteContent).on('scroll', handleInfiniteScroll);
	        };
	        app.detachInfiniteScroll = function (infiniteContent) {
	            $(infiniteContent).off('scroll', handleInfiniteScroll);
	        };
	        
	        app.initPageInfiniteScroll = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var infiniteContent = pageContainer.find('.infinite-scroll');
	            if (infiniteContent.length === 0) return;
	            app.attachInfiniteScroll(infiniteContent);
	            function detachEvents() {
	                app.detachInfiniteScroll(infiniteContent);
	                pageContainer.off('page:beforeremove', detachEvents);
	            }
	            pageContainer.on('page:beforeremove', detachEvents);
	        };
	
	        /*=============================================================
	        ************   Hide/show Toolbar/Navbar on scroll   ************
	        =============================================================*/
	        app.initPageScrollToolbars = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var scrollContent = pageContainer.find('.page-content');
	            if (scrollContent.length === 0) return;
	            var hideNavbar = (app.params.hideNavbarOnPageScroll || scrollContent.hasClass('hide-navbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-navbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	            var hideToolbar = (app.params.hideToolbarOnPageScroll || scrollContent.hasClass('hide-toolbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-toolbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	            var hideTabbar = (app.params.hideTabbarOnPageScroll || scrollContent.hasClass('hide-tabbar-on-scroll')) && !(scrollContent.hasClass('keep-tabbar-on-scroll'));
	        
	            if (!(hideNavbar || hideToolbar || hideTabbar)) return;
	        
	            var viewContainer = scrollContent.parents('.' + app.params.viewClass);
	            if (viewContainer.length === 0) return;
	        
	            var navbar = viewContainer.find('.navbar'),
	                toolbar = viewContainer.find('.toolbar'),
	                tabbar;
	            if (hideTabbar) {
	                tabbar = viewContainer.find('.tabbar');
	                if (tabbar.length === 0) tabbar = viewContainer.parents('.' + app.params.viewsClass).find('.tabbar');
	            }
	        
	            var hasNavbar = navbar.length > 0,
	                hasToolbar = toolbar.length > 0,
	                hasTabbar = tabbar && tabbar.length > 0;
	        
	            var previousScroll, currentScroll;
	                previousScroll = currentScroll = scrollContent[0].scrollTop;
	        
	            var scrollHeight, offsetHeight, reachEnd, action, navbarHidden, toolbarHidden, tabbarHidden;
	        
	            var toolbarHeight = (hasToolbar && hideToolbar) ? toolbar[0].offsetHeight : 0;
	            var tabbarHeight = (hasTabbar && hideTabbar) ? tabbar[0].offsetHeight : 0;
	            var bottomBarHeight = tabbarHeight || toolbarHeight;
	        
	            function handleScroll(e) {
	                if (pageContainer.hasClass('page-on-left')) return;
	                currentScroll = scrollContent[0].scrollTop;
	                scrollHeight = scrollContent[0].scrollHeight;
	                offsetHeight = scrollContent[0].offsetHeight;
	                reachEnd =  currentScroll + offsetHeight >= scrollHeight - bottomBarHeight;
	                navbarHidden = navbar.hasClass('navbar-hidden');
	                toolbarHidden = toolbar.hasClass('toolbar-hidden');
	                tabbarHidden = tabbar && tabbar.hasClass('toolbar-hidden');
	        
	                if (reachEnd) {
	                    if (app.params.showBarsOnPageScrollEnd) {
	                        action = 'show';
	                    }
	                }
	                else if (previousScroll > currentScroll) {
	                    if (app.params.showBarsOnPageScrollTop || currentScroll <= 44) {
	                        action = 'show';
	                    }
	                    else {
	                        action = 'hide';
	                    }
	                }
	                else {
	                    if (currentScroll > 44) {
	                        action = 'hide';
	                    }
	                    else {
	                        action = 'show';
	                    }
	                }
	        
	                if (action === 'show') {
	                    if (hasNavbar && hideNavbar && navbarHidden) {
	                        app.showNavbar(navbar);
	                        pageContainer.removeClass('no-navbar-by-scroll');
	                        navbarHidden = false;
	                    }
	                    if (hasToolbar && hideToolbar && toolbarHidden) {
	                        app.showToolbar(toolbar);
	                        pageContainer.removeClass('no-toolbar-by-scroll');
	                        toolbarHidden = false;
	                    }
	                    if (hasTabbar && hideTabbar && tabbarHidden) {
	                        app.showToolbar(tabbar);
	                        pageContainer.removeClass('no-tabbar-by-scroll');
	                        tabbarHidden = false;
	                    }
	                }
	                else {
	                    if (hasNavbar && hideNavbar && !navbarHidden) {
	                        app.hideNavbar(navbar);
	                        pageContainer.addClass('no-navbar-by-scroll');
	                        navbarHidden = true;
	                    }
	                    if (hasToolbar && hideToolbar && !toolbarHidden) {
	                        app.hideToolbar(toolbar);
	                        pageContainer.addClass('no-toolbar-by-scroll');
	                        toolbarHidden = true;
	                    }
	                    if (hasTabbar && hideTabbar && !tabbarHidden) {
	                        app.hideToolbar(tabbar);
	                        pageContainer.addClass('no-tabbar-by-scroll');
	                        tabbarHidden = true;
	                    }
	                }
	        
	                previousScroll = currentScroll;
	            }
	            scrollContent.on('scroll', handleScroll);
	            scrollContent[0].f7ScrollToolbarsHandler = handleScroll;
	        };
	        app.destroyScrollToolbars = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var scrollContent = pageContainer.find('.page-content');
	            if (scrollContent.length === 0) return;
	            var handler = scrollContent[0].f7ScrollToolbarsHandler;
	            if (!handler) return;
	            scrollContent.off('scroll', scrollContent[0].f7ScrollToolbarsHandler);
	        };
	        
	
	        /*======================================================
	        ************   Material Tabbar   ************
	        ======================================================*/
	        app.materialTabbarSetHighlight = function (tabbar, activeLink) {
	            $(tabbar).each(function () {
	                var tabbar = $(this);
	                activeLink = activeLink || tabbar.find('.tab-link.active');
	        
	                if (activeLink && activeLink.length > 0) {
	                    var tabLinkWidth, highlightTranslate;
	                    if (tabbar.hasClass('tabbar-scrollable')) {
	                        tabLinkWidth = activeLink[0].offsetWidth + 'px';
	                        highlightTranslate = activeLink[0].offsetLeft + 'px';
	                    }
	                    else {
	                        tabLinkWidth = 1 / tabbar.find('.tab-link').length * 100 + '%';
	                        highlightTranslate = (app.rtl ? - activeLink.index(): activeLink.index()) * 100 + '%';
	                    }
	        
	                    tabbar.find('.tab-link-highlight')
	                        .css({width: tabLinkWidth})
	                        .transform('translate3d(' + highlightTranslate + ',0,0)');
	                }
	            });
	        };
	        app.initPageMaterialTabbar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var tabbar = pageContainer.find('.tabbar');
	            if (tabbar.length === 0 && pageContainer.hasClass('tabbar')) tabbar = pageContainer;
	        
	            function tabbarSetHighlight() {
	                app.materialTabbarSetHighlight(tabbar);
	            }
	            if (tabbar.length > 0) {
	                if (tabbar.find('.tab-link-highlight').length === 0) {
	                    tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	                }
	        
	                tabbarSetHighlight();
	                app.onResize(tabbarSetHighlight);
	                pageContainer.once('page:beforeremove', function () {
	                    app.offResize(tabbarSetHighlight);
	                });
	            }
	        };
	        app.initMaterialTabbar = function (tabbar) {
	            return app.initPageMaterialTabbar(tabbar);
	        };
	        
	
	        /* ===============================================================================
	        ************   Tabs   ************
	        =============================================================================== */
	        app.showTab = function (tab, tabLink, animated, force) {
	            var newTab = $(tab);
	            if (arguments.length === 2 && typeof arguments[1] === 'boolean') {
	                tab = arguments[0];
	                animated = arguments[1];
	            }
	            if (arguments.length === 3 && typeof arguments[1] === 'boolean' && typeof arguments[2] === 'boolean') {
	                tab = arguments[0];
	                animated = arguments[1];
	                force = arguments[2];
	            }
	            if (typeof animated === 'undefined') animated = true;
	            if (newTab.length === 0) return false;
	            if (newTab.hasClass('active')) {
	                if (force) newTab.trigger('show tab:show');
	                return false;
	            }
	            var tabs = newTab.parent('.tabs');
	            if (tabs.length === 0) return false;
	        
	            // Return swipeouts in hidden tabs
	            app.allowSwipeout = true;
	        
	            // Animated tabs
	            var isAnimatedTabs = tabs.parent().hasClass('tabs-animated-wrap');
	            if (isAnimatedTabs) {
	                tabs.parent()[animated ? 'removeClass' : 'addClass']('not-animated');
	                var tabTranslate = (app.rtl ? newTab.index() : -newTab.index()) * 100;
	                tabs.transform('translate3d(' + tabTranslate + '%,0,0)');
	            }
	        
	            // Swipeable tabs
	            var isSwipeableTabs = tabs.parent().hasClass('tabs-swipeable-wrap'), swiper;
	            if (isSwipeableTabs) {
	                swiper = tabs.parent()[0].swiper;
	                if (swiper.activeIndex !== newTab.index()) swiper.slideTo(newTab.index(), animated ? undefined : 0, false);
	            }
	        
	            // Remove active class from old tabs
	            var oldTab = tabs.children('.tab.active').removeClass('active').trigger('hide tab:hide');
	            // Add active class to new tab
	            newTab.addClass('active');
	            // Trigger 'show' event on new tab
	            newTab.trigger('show tab:show');
	        
	            // Update navbars in new tab
	            if (!isAnimatedTabs && !isSwipeableTabs && newTab.find('.navbar').length > 0) {
	                // Find tab's view
	                var viewContainer;
	                if (newTab.hasClass(app.params.viewClass)) viewContainer = newTab[0];
	                else viewContainer = newTab.parents('.' + app.params.viewClass)[0];
	                app.sizeNavbars(viewContainer);
	            }
	        
	            // Find related link for new tab
	            if (tabLink) tabLink = $(tabLink);
	            else {
	                // Search by id
	                if (typeof tab === 'string') tabLink = $('.tab-link[href="' + tab + '"]');
	                else tabLink = $('.tab-link[href="#' + newTab.attr('id') + '"]');
	                // Search by data-tab
	                if (!tabLink || tabLink && tabLink.length === 0) {
	                    $('[data-tab]').each(function () {
	                        if (newTab.is($(this).attr('data-tab'))) tabLink = $(this);
	                    });
	                }
	            }
	            if (tabLink.length === 0) return;
	        
	            // Find related link for old tab
	            var oldTabLink;
	            if (oldTab && oldTab.length > 0) {
	                // Search by id
	                var oldTabId = oldTab.attr('id');
	                if (oldTabId) oldTabLink = $('.tab-link[href="#' + oldTabId + '"]');
	                // Search by data-tab
	                if (!oldTabLink || oldTabLink && oldTabLink.length === 0) {
	                    $('[data-tab]').each(function () {
	                        if (oldTab.is($(this).attr('data-tab'))) oldTabLink = $(this);
	                    });
	                }
	            }
	        
	            // Update links' classes
	            if (tabLink && tabLink.length > 0) {
	                tabLink.addClass('active');
	                // Material Highlight
	                if (app.params.material) {
	                    var tabbar = tabLink.parents('.tabbar');
	                    if (tabbar.length > 0) {
	                        if (tabbar.find('.tab-link-highlight').length === 0) {
	                            tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	                        }
	                        app.materialTabbarSetHighlight(tabbar, tabLink);
	                    }
	                }
	            }
	            if (oldTabLink && oldTabLink.length > 0) oldTabLink.removeClass('active');
	        
	            return true;
	        };
	
	        /*===============================================================================
	        ************   Accordion   ************
	        ===============================================================================*/
	        app.accordionToggle = function (item) {
	            item = $(item);
	            if (item.length === 0) return;
	            if (item.hasClass('accordion-item-expanded')) app.accordionClose(item);
	            else app.accordionOpen(item);
	        };
	        app.accordionOpen = function (item) {
	            item = $(item);
	            var list = item.parents('.accordion-list').eq(0);
	            var content = item.children('.accordion-item-content');
	            if (content.length === 0) content = item.find('.accordion-item-content');
	            var expandedItem = list.length > 0 && item.parent().children('.accordion-item-expanded');
	            if (expandedItem.length > 0) {
	                app.accordionClose(expandedItem);
	            }
	            content.css('height', content[0].scrollHeight + 'px').transitionEnd(function () {
	                if (item.hasClass('accordion-item-expanded')) {
	                    content.transition(0);
	                    content.css('height', 'auto');
	                    var clientLeft = content[0].clientLeft;
	                    content.transition('');
	                    item.trigger('opened accordion:opened');
	                }
	                else {
	                    content.css('height', '');
	                    item.trigger('closed accordion:closed');
	                }
	            });
	            item.trigger('open accordion:open');
	            item.addClass('accordion-item-expanded');
	        };
	        app.accordionClose = function (item) {
	            item = $(item);
	            var content = item.children('.accordion-item-content');
	            if (content.length === 0) content = item.find('.accordion-item-content');
	            item.removeClass('accordion-item-expanded');
	            content.transition(0);
	            content.css('height', content[0].scrollHeight + 'px');
	            // Relayout
	            var clientLeft = content[0].clientLeft;
	            // Close
	            content.transition('');
	            content.css('height', '').transitionEnd(function () {
	                if (item.hasClass('accordion-item-expanded')) {
	                    content.transition(0);
	                    content.css('height', 'auto');
	                    var clientLeft = content[0].clientLeft;
	                    content.transition('');
	                    item.trigger('opened accordion:opened');
	                }
	                else {
	                    content.css('height', '');
	                    item.trigger('closed accordion:closed');
	                }
	            });
	            item.trigger('close accordion:close');
	        };
	
	        /*===============================================================================
	        ************   Fast Clicks   ************
	        ************   Inspired by https://github.com/ftlabs/fastclick   ************
	        ===============================================================================*/
	        app.initFastClicks = function () {
	            if (app.params.activeState) {
	                $('html').addClass('watch-active-state');
	            }
	            if (app.device.ios && app.device.webView) {
	                // Strange hack required for iOS 8 webview to work on inputs
	                window.addEventListener('touchstart', function () {});
	            }
	        
	            var touchStartX, touchStartY, touchStartTime, targetElement, trackClick, activeSelection, scrollParent, lastClickTime, isMoved, tapHoldFired, tapHoldTimeout;
	            var activableElement, activeTimeout, needsFastClick, needsFastClickTimeOut;
	            var rippleWave, rippleTarget, rippleTransform, rippleTimeout;
	            function findActivableElement(el) {
	                var target = $(el);
	                var parents = target.parents(app.params.activeStateElements);
	                var activable;
	                if (target.is(app.params.activeStateElements)) {
	                    activable = target;
	                }
	                if (parents.length > 0) {
	                    activable = activable ? activable.add(parents) : parents;
	                }
	                return activable ? activable : target;
	            }
	            function isInsideScrollableView(el) {
	                var pageContent = el.parents('.page-content, .panel');
	        
	                if (pageContent.length === 0) {
	                    return false;
	                }
	        
	                // This event handler covers the "tap to stop scrolling".
	                if (pageContent.prop('scrollHandlerSet') !== 'yes') {
	                    pageContent.on('scroll', function() {
	                      clearTimeout(activeTimeout);
	                      clearTimeout(rippleTimeout);
	                    });
	                    pageContent.prop('scrollHandlerSet', 'yes');
	                }
	        
	                return true;
	            }
	            function addActive() {
	                if (!activableElement) return;
	                activableElement.addClass('active-state');
	            }
	            function removeActive(el) {
	                if (!activableElement) return;
	                activableElement.removeClass('active-state');
	                activableElement = null;
	            }
	            function isFormElement(el) {
	                var nodes = ('input select textarea label').split(' ');
	                if (el.nodeName && nodes.indexOf(el.nodeName.toLowerCase()) >= 0) return true;
	                return false;
	            }
	            function androidNeedsBlur(el) {
	                var noBlur = ('button input textarea select').split(' ');
	                if (document.activeElement && el !== document.activeElement && document.activeElement !== document.body) {
	                    if (noBlur.indexOf(el.nodeName.toLowerCase()) >= 0) {
	                        return false;
	                    }
	                    else {
	                        return true;
	                    }
	                }
	                else {
	                    return false;
	                }
	            }
	            function targetNeedsFastClick(el) {
	                var $el = $(el);
	                if (el.nodeName.toLowerCase() === 'input' && (el.type === 'file' || el.type === 'range')) return false;
	                if (el.nodeName.toLowerCase() === 'select' && app.device.android) return false;
	                if ($el.hasClass('no-fastclick') || $el.parents('.no-fastclick').length > 0) return false;
	                if (app.params.fastClicksExclude && $el.is(app.params.fastClicksExclude)) return false;
	                return true;
	            }
	            function targetNeedsFocus(el) {
	                if (document.activeElement === el) {
	                    return false;
	                }
	                var tag = el.nodeName.toLowerCase();
	                var skipInputs = ('button checkbox file image radio submit').split(' ');
	                if (el.disabled || el.readOnly) return false;
	                if (tag === 'textarea') return true;
	                if (tag === 'select') {
	                    if (app.device.android) return false;
	                    else return true;
	                }
	                if (tag === 'input' && skipInputs.indexOf(el.type) < 0) return true;
	            }
	            function targetNeedsPrevent(el) {
	                el = $(el);
	                var prevent = true;
	                if (el.is('label') || el.parents('label').length > 0) {
	                    if (app.device.android) {
	                        prevent = false;
	                    }
	                    else if (app.device.ios && el.is('input')) {
	                        prevent = true;
	                    }
	                    else prevent = false;
	                }
	                return prevent;
	            }
	        
	            // Mouse Handlers
	            function handleMouseDown (e) {
	                findActivableElement(e.target).addClass('active-state');
	                if ('which' in e && e.which === 3) {
	                    setTimeout(function () {
	                        $('.active-state').removeClass('active-state');
	                    }, 0);
	                }
	                if (app.params.material && app.params.materialRipple) {
	                    touchStartX = e.pageX;
	                    touchStartY = e.pageY;
	                    rippleTouchStart(e.target, e.pageX, e.pageY);
	                }
	            }
	            function handleMouseMove (e) {
	                $('.active-state').removeClass('active-state');
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchMove();
	                }
	            }
	            function handleMouseUp (e) {
	                $('.active-state').removeClass('active-state');
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	            }
	        
	            // Material Touch Ripple Effect
	            function findRippleElement(el) {
	                var needsRipple = app.params.materialRippleElements;
	                var $el = $(el);
	                if ($el.is(needsRipple)) {
	                    if ($el.hasClass('no-ripple')) {
	                        return false;
	                    }
	                    return $el;
	                }
	                else if ($el.parents(needsRipple).length > 0) {
	                    var rippleParent = $el.parents(needsRipple).eq(0);
	                    if (rippleParent.hasClass('no-ripple')) {
	                        return false;
	                    }
	                    return rippleParent;
	                }
	                else return false;
	            }
	            function createRipple(x, y, el) {
	                if (!el) return;
	                var box = el[0].getBoundingClientRect();
	                var center = {
	                    x: x - box.left,
	                    y: y - box.top
	                },
	                    height = box.height,
	                    width = box.width;
	                var diameter = Math.max(Math.pow((Math.pow(height, 2) + Math.pow(width, 2)), 0.5), 48);
	        
	                rippleWave = $(
	                    '<div class="ripple-wave" style="width: ' + diameter + 'px; height: '+diameter+'px; margin-top:-'+diameter/2+'px; margin-left:-'+diameter/2+'px; left:'+center.x+'px; top:'+center.y+'px;"></div>'
	                );
	                el.prepend(rippleWave);
	                var clientLeft = rippleWave[0].clientLeft;
	                rippleTransform = 'translate3d('+(-center.x + width/2)+'px, '+(-center.y + height/2)+'px, 0) scale(1)';
	                rippleWave.transform(rippleTransform);
	            }
	        
	            function removeRipple() {
	                if (!rippleWave) return;
	                var toRemove = rippleWave;
	        
	                var removeTimeout = setTimeout(function () {
	                    toRemove.remove();
	                }, 400);
	        
	                rippleWave
	                    .addClass('ripple-wave-fill')
	                    .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'))
	                    .transitionEnd(function () {
	                        clearTimeout(removeTimeout);
	        
	                        var rippleWave = $(this)
	                            .addClass('ripple-wave-out')
	                            .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'));
	        
	                        removeTimeout = setTimeout(function () {
	                            rippleWave.remove();
	                        }, 700);
	        
	                        setTimeout(function () {
	                            rippleWave.transitionEnd(function(){
	                                clearTimeout(removeTimeout);
	                                $(this).remove();
	                            });
	                        }, 0);
	                    });
	        
	                rippleWave = rippleTarget = undefined;
	            }
	        
	            function rippleTouchStart (el, x, y) {
	                rippleTarget = findRippleElement(el);
	                if (!rippleTarget || rippleTarget.length === 0) {
	                    rippleTarget = undefined;
	                    return;
	                }
	                if (!isInsideScrollableView(rippleTarget)) {
	                    createRipple(touchStartX, touchStartY, rippleTarget);
	                }
	                else {
	                    rippleTimeout = setTimeout(function () {
	                        createRipple(touchStartX, touchStartY, rippleTarget);
	                    }, 80);
	                }
	            }
	            function rippleTouchMove() {
	                clearTimeout(rippleTimeout);
	                removeRipple();
	            }
	            function rippleTouchEnd() {
	                if (rippleWave) {
	                    removeRipple();
	                }
	                else if (rippleTarget && !isMoved) {
	                    clearTimeout(rippleTimeout);
	                    createRipple(touchStartX, touchStartY, rippleTarget);
	                    setTimeout(removeRipple, 0);
	                }
	                else {
	                    removeRipple();
	                }
	            }
	        
	            // Send Click
	            function sendClick(e) {
	                var touch = e.changedTouches[0];
	                var evt = document.createEvent('MouseEvents');
	                var eventType = 'click';
	                if (app.device.android && targetElement.nodeName.toLowerCase() === 'select') {
	                    eventType = 'mousedown';
	                }
	                evt.initMouseEvent(eventType, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	                evt.forwardedTouchEvent = true;
	                targetElement.dispatchEvent(evt);
	            }
	        
	            // Touch Handlers
	            function handleTouchStart(e) {
	                isMoved = false;
	                tapHoldFired = false;
	                if (e.targetTouches.length > 1) {
	                    if (activableElement) removeActive();
	                    return true;
	                }
	                if (e.touches.length > 1 && activableElement) {
	                    removeActive();
	                }
	                if (app.params.tapHold) {
	                    if (tapHoldTimeout) clearTimeout(tapHoldTimeout);
	                    tapHoldTimeout = setTimeout(function () {
	                        if (e && e.touches && e.touches.length > 1) return;
	                        tapHoldFired = true;
	                        e.preventDefault();
	                        $(e.target).trigger('taphold');
	                    }, app.params.tapHoldDelay);
	                }
	                if (needsFastClickTimeOut) clearTimeout(needsFastClickTimeOut);
	                needsFastClick = targetNeedsFastClick(e.target);
	        
	                if (!needsFastClick) {
	                    trackClick = false;
	                    return true;
	                }
	                if (app.device.ios || (app.device.android && 'getSelection' in window)) {
	                    var selection = window.getSelection();
	                    if (selection.rangeCount && selection.focusNode !== document.body && (!selection.isCollapsed || document.activeElement === selection.focusNode)) {
	                        activeSelection = true;
	                        return true;
	                    }
	                    else {
	                        activeSelection = false;
	                    }
	                }
	                if (app.device.android)  {
	                    if (androidNeedsBlur(e.target)) {
	                        document.activeElement.blur();
	                    }
	                }
	        
	                trackClick = true;
	                targetElement = e.target;
	                touchStartTime = (new Date()).getTime();
	                touchStartX = e.targetTouches[0].pageX;
	                touchStartY = e.targetTouches[0].pageY;
	        
	                // Detect scroll parent
	                if (app.device.ios) {
	                    scrollParent = undefined;
	                    $(targetElement).parents().each(function () {
	                        var parent = this;
	                        if (parent.scrollHeight > parent.offsetHeight && !scrollParent) {
	                            scrollParent = parent;
	                            scrollParent.f7ScrollTop = scrollParent.scrollTop;
	                        }
	                    });
	                }
	                if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	                    e.preventDefault();
	                }
	        
	                if (app.params.activeState) {
	                    activableElement = findActivableElement(targetElement);
	                    // If it's inside a scrollable view, we don't trigger active-state yet,
	                    // because it can be a scroll instead. Based on the link:
	                    // http://labnote.beedesk.com/click-scroll-and-pseudo-active-on-mobile-webk
	                    if (!isInsideScrollableView(activableElement)) {
	                        addActive();
	                    } else {
	                        activeTimeout = setTimeout(addActive, 80);
	                    }
	                }
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchStart(targetElement, touchStartX, touchStartY);
	                }
	            }
	            function handleTouchMove(e) {
	                if (!trackClick) return;
	                var _isMoved = false;
	                var distance = app.params.fastClicksDistanceThreshold;
	                if (distance) {
	                    var pageX = e.targetTouches[0].pageX;
	                    var pageY = e.targetTouches[0].pageY;
	                    if (Math.abs(pageX - touchStartX) > distance ||  Math.abs(pageY - touchStartY) > distance) {
	                        _isMoved = true;
	                    }
	                }
	                else {
	                    _isMoved = true;
	                }
	                if (_isMoved) {
	                    trackClick = false;
	                    targetElement = null;
	                    isMoved = true;
	                    if (app.params.tapHold) {
	                        clearTimeout(tapHoldTimeout);
	                    }
	        			if (app.params.activeState) {
	        				clearTimeout(activeTimeout);
	        				removeActive();
	        			}
	                    if (app.params.material && app.params.materialRipple) {
	                        rippleTouchMove();
	                    }
	                }
	            }
	            function handleTouchEnd(e) {
	                clearTimeout(activeTimeout);
	                clearTimeout(tapHoldTimeout);
	        
	                if (!trackClick) {
	                    if (!activeSelection && needsFastClick) {
	                        if (!(app.device.android && !e.cancelable)) {
	                            e.preventDefault();
	                        }
	                    }
	                    return true;
	                }
	        
	                if (document.activeElement === e.target) {
	                    if (app.params.activeState) removeActive();
	                    if (app.params.material && app.params.materialRipple) {
	                        rippleTouchEnd();
	                    }
	                    return true;
	                }
	        
	                if (!activeSelection) {
	                    e.preventDefault();
	                }
	        
	                if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	                    setTimeout(removeActive, 0);
	                    return true;
	                }
	        
	                lastClickTime = e.timeStamp;
	        
	                trackClick = false;
	        
	                if (app.device.ios && scrollParent) {
	                    if (scrollParent.scrollTop !== scrollParent.f7ScrollTop) {
	                        return false;
	                    }
	                }
	        
	                // Add active-state here because, in a very fast tap, the timeout didn't
	                // have the chance to execute. Removing active-state in a timeout gives
	                // the chance to the animation execute.
	                if (app.params.activeState) {
	                    addActive();
	                    setTimeout(removeActive, 0);
	                }
	                // Remove Ripple
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	        
	                // Trigger focus when required
	                if (targetNeedsFocus(targetElement)) {
	                    if (app.device.ios && app.device.webView) {
	                        if ((event.timeStamp - touchStartTime) > 159) {
	                            targetElement = null;
	                            return false;
	                        }
	                        targetElement.focus();
	                        return false;
	                    }
	                    else {
	                        targetElement.focus();
	                    }
	                }
	        
	                // Blur active elements
	                if (document.activeElement && targetElement !== document.activeElement && document.activeElement !== document.body && targetElement.nodeName.toLowerCase() !== 'label') {
	                    document.activeElement.blur();
	                }
	        
	                // Send click
	                e.preventDefault();
	                sendClick(e);
	                return false;
	            }
	            function handleTouchCancel(e) {
	                trackClick = false;
	                targetElement = null;
	        
	                // Remove Active State
	                clearTimeout(activeTimeout);
	                clearTimeout(tapHoldTimeout);
	                if (app.params.activeState) {
	                    removeActive();
	                }
	        
	                // Remove Ripple
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	            }
	        
	            function handleClick(e) {
	                var allowClick = false;
	        
	                if (trackClick) {
	                    targetElement = null;
	                    trackClick = false;
	                    return true;
	                }
	                if (e.target.type === 'submit' && e.detail === 0 || e.target.type === 'file') {
	                    return true;
	                }
	                if (!targetElement) {
	                    if (!isFormElement(e.target)) {
	                        allowClick =  true;
	                    }
	                }
	                if (!needsFastClick) {
	                    allowClick = true;
	                }
	                if (document.activeElement === targetElement) {
	                    allowClick =  true;
	                }
	                if (e.forwardedTouchEvent) {
	                    allowClick =  true;
	                }
	                if (!e.cancelable) {
	                    allowClick =  true;
	                }
	                if (app.params.tapHold && app.params.tapHoldPreventClicks && tapHoldFired) {
	                    allowClick = false;
	                }
	                if (!allowClick) {
	                    e.stopImmediatePropagation();
	                    e.stopPropagation();
	                    if (targetElement) {
	                        if (targetNeedsPrevent(targetElement) || isMoved) {
	                            e.preventDefault();
	                        }
	                    }
	                    else {
	                        e.preventDefault();
	                    }
	                    targetElement = null;
	                }
	                needsFastClickTimeOut = setTimeout(function () {
	                    needsFastClick = false;
	                }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	        
	                if (app.params.tapHold) {
	                    tapHoldTimeout = setTimeout(function () {
	                        tapHoldFired = false;
	                    }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	                }
	        
	                return allowClick;
	            }
	            if (app.support.touch) {
	                document.addEventListener('click', handleClick, true);
	        
	                document.addEventListener('touchstart', handleTouchStart);
	                document.addEventListener('touchmove', handleTouchMove);
	                document.addEventListener('touchend', handleTouchEnd);
	                document.addEventListener('touchcancel', handleTouchCancel);
	            }
	            else {
	                if (app.params.activeState) {
	                    document.addEventListener('mousedown', handleMouseDown);
	                    document.addEventListener('mousemove', handleMouseMove);
	                    document.addEventListener('mouseup', handleMouseUp);
	                }
	            }
	            if (app.params.material && app.params.materialRipple) {
	                document.addEventListener('contextmenu', function (e) {
	                    if (activableElement) removeActive();
	                    rippleTouchEnd();
	                });
	            }
	        
	        };
	        
	
	        /*===============================================================================
	        ************   Handle clicks and make them fast (on tap);   ************
	        ===============================================================================*/
	        app.initClickEvents = function () {
	            function handleScrollTop(e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var target = $(e.target);
	                var isLink = clicked[0].nodeName.toLowerCase() === 'a' ||
	                             clicked.parents('a').length > 0 ||
	                             target[0].nodeName.toLowerCase() === 'a' ||
	                             target.parents('a').length > 0;
	        
	                if (isLink) return;
	                var pageContent, page;
	                if (app.params.scrollTopOnNavbarClick && clicked.is('.navbar .center')) {
	                    // Find active page
	                    var navbar = clicked.parents('.navbar');
	        
	                    // Static Layout
	                    pageContent = navbar.parents('.page-content');
	        
	                    if (pageContent.length === 0) {
	                        // Fixed Layout
	                        if (navbar.parents('.page').length > 0) {
	                            pageContent = navbar.parents('.page').find('.page-content');
	                        }
	                        // Through Layout
	                        if (pageContent.length === 0) {
	                            if (navbar.nextAll('.pages').length > 0) {
	                                pageContent = navbar.nextAll('.pages').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                            }
	                        }
	                    }
	                }
	                if (app.params.scrollTopOnStatusbarClick && clicked.is('.statusbar-overlay')) {
	                    if ($('.popup.modal-in').length > 0) {
	                        // Check for opened popup
	                        pageContent = $('.popup.modal-in').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else if ($('.panel.active').length > 0) {
	                        // Check for opened panel
	                        pageContent = $('.panel.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else if ($('.views > .view.active').length > 0) {
	                        // View in tab bar app layout
	                        pageContent = $('.views > .view.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else {
	                        // Usual case
	                        pageContent = $('.views').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                }
	        
	                if (pageContent && pageContent.length > 0) {
	                    // Check for tab
	                    if (pageContent.hasClass('tab')) {
	                        pageContent = pageContent.parent('.tabs').children('.page-content.active');
	                    }
	                    if (pageContent.length > 0) pageContent.scrollTop(0, 300);
	                }
	            }
	            function handleClicks(e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var url = clicked.attr('href');
	                var isLink = clicked[0].nodeName.toLowerCase() === 'a';
	        
	                // Check if link is external
	                if (isLink) {
	                    if (clicked.is(app.params.externalLinks) || (url && url.indexOf('javascript:') >= 0)) {
	                        if(url && clicked.attr('target') === '_system') {
	                            e.preventDefault();
	                            window.open(url, '_system');
	                        }
	                        return;
	                    }
	                }
	        
	                // Collect Clicked data- attributes
	                var clickedData = clicked.dataset();
	        
	                // Smart Select
	                if (clicked.hasClass('smart-select')) {
	                    if (app.smartSelectOpen) app.smartSelectOpen(clicked);
	                }
	        
	                // Open Panel
	                if (clicked.hasClass('open-panel')) {
	                    if ($('.panel').length === 1) {
	                        if ($('.panel').hasClass('panel-left')) app.openPanel('left');
	                        else app.openPanel('right');
	                    }
	                    else {
	                        if (clickedData.panel === 'right') app.openPanel('right');
	                        else app.openPanel('left');
	                    }
	                }
	                
	                // Close Panel
	                if (clicked.hasClass('close-panel')) {
	                    app.closePanel();
	                }
	        
	                // Panel Overlay
	                if (clicked.hasClass('panel-overlay')) {
	                    $('.panel.active').trigger('panel:overlay-click');
	                    if (app.params.panelsCloseByOutside) app.closePanel();
	                }
	        
	                // Popover
	                if (clicked.hasClass('open-popover')) {
	                    var popover;
	                    if (clickedData.popover) {
	                        popover = clickedData.popover;
	                    }
	                    else popover = '.popover';
	                    app.popover(popover, clicked);
	                }
	                if (clicked.hasClass('close-popover')) {
	                    app.closeModal('.popover.modal-in');
	                }
	                // Popup
	                var popup;
	                if (clicked.hasClass('open-popup')) {
	                    if (clickedData.popup) {
	                        popup = clickedData.popup;
	                    }
	                    else popup = '.popup';
	                    app.popup(popup);
	                }
	                if (clicked.hasClass('close-popup')) {
	                    if (clickedData.popup) {
	                        popup = clickedData.popup;
	                    }
	                    else popup = '.popup.modal-in';
	                    app.closeModal(popup);
	                }
	                // Login Screen
	                var loginScreen;
	                if (clicked.hasClass('open-login-screen')) {
	                    if (clickedData.loginScreen) {
	                        loginScreen = clickedData.loginScreen;
	                    }
	                    else loginScreen = '.login-screen';
	                    app.loginScreen(loginScreen);
	                }
	                if (clicked.hasClass('close-login-screen')) {
	                    app.closeModal('.login-screen.modal-in');
	                }
	                // Close Modal
	                if (clicked.hasClass('modal-overlay')) {
	                    if ($('.modal.modal-in').length > 0 && app.params.modalCloseByOutside)
	                        app.closeModal('.modal.modal-in');
	                    if ($('.actions-modal.modal-in').length > 0 && app.params.actionsCloseByOutside)
	                        app.closeModal('.actions-modal.modal-in');
	        
	                    if ($('.popover.modal-in').length > 0) app.closeModal('.popover.modal-in');
	                }
	                if (clicked.hasClass('popup-overlay')) {
	                    if ($('.popup.modal-in').length > 0 && app.params.popupCloseByOutside)
	                        app.closeModal('.popup.modal-in');
	                }
	                if (clicked.hasClass('picker-modal-overlay')) {
	                    if ($('.picker-modal.modal-in').length > 0)
	                        app.closeModal('.picker-modal.modal-in');
	                }
	        
	                // Picker
	                if (clicked.hasClass('close-picker')) {
	                    var pickerToClose = $('.picker-modal.modal-in');
	                    if (pickerToClose.length > 0) {
	                        app.closeModal(pickerToClose);
	                    }
	                    else {
	                        pickerToClose = $('.popover.modal-in .picker-modal');
	                        if (pickerToClose.length > 0) {
	                            app.closeModal(pickerToClose.parents('.popover'));
	                        }
	                    }
	                }
	                if (clicked.hasClass('open-picker')) {
	                    var pickerToOpen;
	                    if (clickedData.picker) {
	                        pickerToOpen = clickedData.picker;
	                    }
	                    else pickerToOpen = '.picker-modal';
	                    app.pickerModal(pickerToOpen, clicked);
	                }
	        
	                // Tabs
	                var isTabLink;
	                if (clicked.hasClass('tab-link')) {
	                    isTabLink = true;
	                    app.showTab(clickedData.tab || clicked.attr('href'), clicked);
	                }
	                // Swipeout Close
	                if (clicked.hasClass('swipeout-close')) {
	                    app.swipeoutClose(clicked.parents('.swipeout-opened'));
	                }
	                // Swipeout Delete
	                if (clicked.hasClass('swipeout-delete')) {
	                    if (clickedData.confirm) {
	                        var text = clickedData.confirm;
	                        var title = clickedData.confirmTitle;
	                        if (title) {
	                            app.confirm(text, title, function () {
	                                app.swipeoutDelete(clicked.parents('.swipeout'));
	                            }, function () {
	                                if (clickedData.closeOnCancel) app.swipeoutClose(clicked.parents('.swipeout'));
	                            });
	                        }
	                        else {
	                            app.confirm(text, function () {
	                                app.swipeoutDelete(clicked.parents('.swipeout'));
	                            }, function () {
	                                if (clickedData.closeOnCancel) app.swipeoutClose(clicked.parents('.swipeout'));
	                            });
	                        }
	                    }
	                    else {
	                        app.swipeoutDelete(clicked.parents('.swipeout'));
	                    }
	        
	                }
	                // Sortable
	                if (clicked.hasClass('toggle-sortable')) {
	                    app.sortableToggle(clickedData.sortable);
	                }
	                if (clicked.hasClass('open-sortable')) {
	                    app.sortableOpen(clickedData.sortable);
	                }
	                if (clicked.hasClass('close-sortable')) {
	                    app.sortableClose(clickedData.sortable);
	                }
	                // Accordion
	                if (clicked.hasClass('accordion-item-toggle') || (clicked.hasClass('item-link') && clicked.parent().hasClass('accordion-item'))) {
	                    var accordionItem = clicked.parent('.accordion-item');
	                    if (accordionItem.length === 0) accordionItem = clicked.parents('.accordion-item');
	                    if (accordionItem.length === 0) accordionItem = clicked.parents('li');
	                    app.accordionToggle(accordionItem);
	                }
	        
	                // Speed Dial
	                if (clicked.hasClass('floating-button') && clicked.parent().hasClass('speed-dial')) {
	                    clicked.parent().toggleClass('speed-dial-opened');
	                }
	                if (clicked.hasClass('close-speed-dial')) {
	                    $('.speed-dial-opened').removeClass('speed-dial-opened');
	                }
	        
	                // Load Page
	                if (app.params.ajaxLinks && !clicked.is(app.params.ajaxLinks) || !isLink || !app.params.router) {
	                    return;
	                }
	                if (isLink) {
	                    e.preventDefault();
	                }
	        
	                var validUrl = url && url.length > 0 && url !== '#' && !isTabLink;
	                var template = clickedData.template;
	                if (validUrl || clicked.hasClass('back') || template) {
	                    var view;
	                    if (clickedData.view) {
	                        view = $(clickedData.view)[0].f7View;
	                    }
	                    else {
	                        view = clicked.parents('.' + app.params.viewClass)[0] && clicked.parents('.' + app.params.viewClass)[0].f7View;
	                        if (view && view.params.linksView) {
	                            if (typeof view.params.linksView === 'string') view = $(view.params.linksView)[0].f7View;
	                            else if (view.params.linksView instanceof View) view = view.params.linksView;
	                        }
	                    }
	                    if (!view) {
	                        if (app.mainView) view = app.mainView;
	                    }
	                    if (!view) return;
	        
	                    var pageName;
	                    if (!template) {
	                        if (url && url.indexOf('#') === 0 && url !== '#')  {
	                            if (view.params.domCache) {
	                                pageName = url.split('#')[1];
	                            }
	                            else return;
	                        }
	                        if (url === '#' && !clicked.hasClass('back')) return;
	                    }
	                    else {
	                        url = undefined;
	                    }
	        
	                    var animatePages;
	                    if (typeof clickedData.animatePages !== 'undefined') {
	                        animatePages = clickedData.animatePages;
	                    }
	                    else {
	                        if (clicked.hasClass('with-animation')) animatePages = true;
	                        if (clicked.hasClass('no-animation')) animatePages = false;
	                    }
	        
	                    var options = {
	                        animatePages: animatePages,
	                        ignoreCache: clickedData.ignoreCache,
	                        force: clickedData.force,
	                        reload: clickedData.reload,
	                        reloadPrevious: clickedData.reloadPrevious,
	                        pageName: pageName,
	                        pushState: clickedData.pushState,
	                        url: url
	                    };
	        
	                    if (app.params.template7Pages) {
	                        options.contextName = clickedData.contextName;
	                        var context = clickedData.context;
	                        if (context) {
	                            options.context = JSON.parse(context);
	                        }
	                    }
	                    if (template && template in t7.templates) {
	                        options.template = t7.templates[template];
	                    }
	        
	                    if (clicked.hasClass('back')) view.router.back(options);
	                    else view.router.load(options);
	                }
	            }
	            $(document).on('click', 'a, .open-panel, .close-panel, .panel-overlay, .modal-overlay, .popup-overlay, .swipeout-delete, .swipeout-close, .close-popup, .open-popup, .open-popover, .open-login-screen, .close-login-screen .smart-select, .toggle-sortable, .open-sortable, .close-sortable, .accordion-item-toggle, .close-picker, .picker-modal-overlay', handleClicks);
	            if (app.params.scrollTopOnNavbarClick || app.params.scrollTopOnStatusbarClick) {
	                $(document).on('click', '.statusbar-overlay, .navbar .center', handleScrollTop);
	            }
	        
	            // Prevent scrolling on overlays
	            function preventScrolling(e) {
	                e.preventDefault();
	            }
	            if (app.support.touch && !app.device.android) {
	                var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	                $(document).on((app.params.fastClicks ? 'touchstart' : 'touchmove'), '.panel-overlay, .modal-overlay, .preloader-indicator-overlay, .popup-overlay, .searchbar-overlay', preventScrolling, activeListener);
	            }
	        };
	        
	
	        /*======================================================
	        ************   App Resize Actions   ************
	        ======================================================*/
	        // Prevent iPad horizontal body scrolling when soft keyboard is opened
	        function _fixIpadBodyScrolLeft() {
	            if (app.device.ipad) {
	                document.body.scrollLeft = 0;
	                setTimeout(function () {
	                    document.body.scrollLeft = 0;
	                }, 0);
	            }
	        }
	        var appResizeCallbacks = [];
	        app.getSize = function () {
	            var offset = app.root.offset();
	            app.width = app.root[0].offsetWidth;
	            app.height = app.root[0].offsetHeight;
	            app.left = offset.left;
	            app.top = offset.top;
	        };
	        app.onResize = function (callback) {
	            appResizeCallbacks.push(callback);
	        };
	        app.offResize = function (callback) {
	            for (var i = 0; i < appResizeCallbacks.length; i++) {
	                if (appResizeCallbacks[i] === callback) {
	                    appResizeCallbacks.splice(i, 1);
	                }
	            }
	        };
	        app.resize = function () {
	            _fixIpadBodyScrolLeft();
	            app.getSize();
	            if (app.sizeNavbars) app.sizeNavbars();
	            for (var i = 0; i < appResizeCallbacks.length; i++) {
	                appResizeCallbacks[i]();
	            }
	        };
	        app.orientationchange = function () {
	            if (app.device && app.device.minimalUi) {
	                if (window.orientation === 90 || window.orientation === -90) document.body.scrollTop = 0;
	            }
	            _fixIpadBodyScrolLeft();
	        };
	        app.initResize = function () {
	            $(window).on('resize', app.resize);
	            $(window).on('orientationchange', app.orientationchange);
	            app.getSize();
	        };
	        
	
	        /*===============================================================================
	        ************   Store and parse forms data   ************
	        ===============================================================================*/
	        app.formsData = {};
	        app.formStoreData = function (formId, formJSON) {
	            // Store form data in app.formsData
	            app.formsData[formId] = formJSON;
	        
	            // Store form data in local storage also
	            app.ls['f7form-' + formId] = JSON.stringify(formJSON);
	        };
	        app.formDeleteData = function (formId) {
	            // Delete form data from app.formsData
	            if (app.formsData[formId]) {
	                app.formsData[formId] = '';
	                delete app.formsData[formId];
	            }
	        
	            // Delete form data from local storage also
	            if (app.ls['f7form-' + formId]) {
	                app.ls['f7form-' + formId] = '';
	                app.ls.removeItem('f7form-' + formId);
	            }
	        };
	        app.formGetData = function (formId) {
	            // First of all check in local storage
	            if (app.ls['f7form-' + formId]) {
	                return JSON.parse(app.ls['f7form-' + formId]);
	            }
	            // Try to get it from formsData obj
	            else if (app.formsData[formId]) return app.formsData[formId];
	        };
	        app.formToData = function (form) {
	            form = $(form);
	            if (form.length !== 1) return false;
	        
	            // Form data
	            var formData = {};
	        
	            // Skip input types
	            var skipTypes = ['submit', 'image', 'button', 'file'];
	            var skipNames = [];
	            form.find('input, select, textarea').each(function () {
	                var input = $(this);
	                var name = input.attr('name');
	                var type = input.attr('type');
	                var tag = this.nodeName.toLowerCase();
	                if (skipTypes.indexOf(type) >= 0) return;
	                if (skipNames.indexOf(name) >= 0 || !name) return;
	                if (tag === 'select' && input.prop('multiple')) {
	                    skipNames.push(name);
	                    formData[name] = [];
	                    form.find('select[name="' + name + '"] option').each(function () {
	                        if (this.selected) formData[name].push(this.value);
	                    });
	                }
	                else {
	                    switch (type) {
	                        case 'checkbox' :
	                            skipNames.push(name);
	                            formData[name] = [];
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (this.checked) formData[name].push(this.value);
	                            });
	                            break;
	                        case 'radio' :
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (this.checked) formData[name] = this.value;
	                            });
	                            break;
	                        default :
	                            formData[name] = input.val();
	                            break;
	                    }
	                }
	            });
	            form.trigger('formToJSON formToData form:todata', {formData: formData});
	        
	            return formData;
	        };
	        app.formToJSON = app.formToData;
	        app.formFromData = function (form, formData) {
	            form = $(form);
	            if (form.length !== 1) return false;
	        
	            // Skip input types
	            var skipTypes = ['submit', 'image', 'button', 'file'];
	            var skipNames = [];
	        
	            form.find('input, select, textarea').each(function () {
	                var input = $(this);
	                var name = input.attr('name');
	                var type = input.attr('type');
	                var tag = this.nodeName.toLowerCase();
	                if (typeof formData[name] === 'undefined' || formData[name] === null) return;
	                if (skipTypes.indexOf(type) >= 0) return;
	                if (skipNames.indexOf(name) >= 0 || !name) return;
	                if (tag === 'select' && input.prop('multiple')) {
	                    skipNames.push(name);
	                    form.find('select[name="' + name + '"] option').each(function () {
	                        if (formData[name].indexOf(this.value) >= 0) this.selected = true;
	                        else this.selected = false;
	                    });
	                }
	                else {
	                    switch (type) {
	                        case 'checkbox' :
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (formData[name].indexOf(this.value) >= 0) this.checked = true;
	                                else this.checked = false;
	                            });
	                            break;
	                        case 'radio' :
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (formData[name] === this.value) this.checked = true;
	                                else this.checked = false;
	                            });
	                            break;
	                        default :
	                            input.val(formData[name]);
	                            break;
	                    }
	                }
	                if (tag === 'select' || tag === 'input' || tag === 'textarea') {
	                    input.trigger('change');
	                }
	            });
	            form.trigger('formFromJSON formFromData form:fromdata', {formData: formData});
	        };
	        app.formFromJSON = app.formFromData;
	        
	        app.initFormsStorage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var forms = pageContainer.find('form.store-data');
	            if (forms.length === 0) return;
	        
	            // Parse forms data and fill form if there is such data
	            forms.each(function () {
	                var id = this.getAttribute('id');
	                if (!id) return;
	                var formData = app.formGetData(id);
	                if (formData) app.formFromData(this, formData);
	            });
	            // Update forms data on inputs change
	            function storeForm() {
	                /*jshint validthis:true */
	                var form = $(this);
	                var formId = form[0].id;
	                if (!formId) return;
	                var formJSON = app.formToData(form);
	                if (!formJSON) return;
	                app.formStoreData(formId, formJSON);
	                form.trigger('store form:storedata', {data: formJSON});
	            }
	            forms.on('change submit', storeForm);
	        
	            // Detach Listeners
	            function pageBeforeRemove() {
	                forms.off('change submit', storeForm);
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            pageContainer.on('page:beforeremove', pageBeforeRemove);
	        };
	
	        /*===============================================================================
	        ************   Ajax submit for forms   ************
	        ===============================================================================*/
	        // Ajax submit on forms
	        $(document).on('submit change', 'form.ajax-submit, form.ajax-submit-onchange', function (e) {
	            var form = $(this);
	            if (e.type === 'change' && !form.hasClass('ajax-submit-onchange')) return;
	            if (e.type === 'submit') e.preventDefault();
	        
	            var method = (form.attr('method') || 'GET').toUpperCase();
	            var contentType = form.prop('enctype') || form.attr('enctype');
	        
	            var url = form.attr('action');
	            if (!url) return;
	        
	            var data;
	            if (method === 'POST') data = new FormData(form[0]);
	            else data = $.serializeObject(app.formToJSON(form[0]));
	        
	            var xhr = $.ajax({
	                method: method,
	                url: url,
	                contentType: contentType,
	                data: data,
	                beforeSend: function (xhr) {
	                    form.trigger('beforeSubmit form:beforesend', {data:data, xhr: xhr});
	                },
	                error: function (xhr) {
	                    form.trigger('submitError form:error', {data:data, xhr: xhr});
	                },
	                success: function (data) {
	                    form.trigger('submitted form:success', {data: data, xhr: xhr});
	                }
	            });
	        });
	        
	        
	
	        /*===============================================================================
	        ************   Resizable textarea   ************
	        ===============================================================================*/
	        app.resizeTextarea = function (textarea) {
	            textarea = $(textarea);
	            if (!textarea.hasClass('resizable')) {
	                return;
	            }
	            textarea.css({'height': ''});
	            var height = textarea[0].offsetHeight;
	            var diff = height - textarea[0].clientHeight;
	            var scrollHeight = textarea[0].scrollHeight;
	        
	            if (scrollHeight + diff > height) {
	                var newAreaHeight = scrollHeight + diff;
	                textarea.css('height', newAreaHeight + 'px');
	            }
	        };
	        app.resizableTextarea = function (textarea) {
	            textarea = $(textarea);
	            if (textarea.length === 0) return;
	            var textareaTimeout;
	            function handleTextarea() {
	                clearTimeout(textareaTimeout);
	                textareaTimeout = setTimeout(function () {
	                    app.resizeTextarea(textarea);
	                }, 0);
	            }
	            textarea[0].f7DestroyResizableTextarea = function () {
	                textarea.off('change keydown keypress keyup paste cut', handleTextarea);
	            };
	            return textarea.on('change keydown keypress keyup paste cut', handleTextarea);
	        };
	        app.destroyResizableTextarea = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0 && pageContainer.is('textarea') && pageContainer[0].f7DestroyResizableTextarea) {
	                pageContainer[0].f7DestroyResizableTextarea();
	            }
	            else if (pageContainer.length > 0) {
	                pageContainer.find('textarea.resiable').each(function () {
	                    var textarea = this;
	                    if (textarea.f7DestroyResizableTextarea) {
	                        textarea.f7DestroyResizableTextarea ();
	                    }
	                });
	            }
	        };
	        app.initPageResizableTextarea = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var textareas = pageContainer.find('textarea.resizable');
	            textareas.each(function () {
	                app.resizableTextarea(this);
	            });
	        };
	
	        /*======================================================
	        ************   Material Text Inputs   ************
	        ======================================================*/
	        app.initPageMaterialInputs = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var textareas = pageContainer.find('textarea.resizable');
	            pageContainer.find('.item-input').each(function () {
	                var itemInput = $(this);
	                var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	                itemInput.find('input, select, textarea').each(function () {
	                    var input = $(this);
	                    if (notInputs.indexOf(input.attr('type')) < 0) {
	                        itemInput.addClass('item-input-field');
	                        if (input.val().trim() !== '') {
	                            input.parents('.item-input, .input-field').add(input.parents('.item-inner')).addClass('not-empty-state');
	                        }
	                    }
	                });
	                if (itemInput.parents('.input-item, .inputs-list').length > 0) return;
	                itemInput.parents('.list-block').eq(0).addClass('inputs-list');
	            });
	        };
	        /*======================================================
	        ************   Material Focus Inputs   ************
	        ======================================================*/
	        app.initMaterialWatchInputs = function () {
	            var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	            function addFocusState(e) {
	                /*jshint validthis:true*/
	                var i = $(this);
	                var type = i.attr('type');
	                if (notInputs.indexOf(type) >= 0) return;
	                var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	                els.addClass('focus-state');
	            }
	            function removeFocusState(e) {
	                /*jshint validthis:true*/
	                var i = $(this), value = i.val();
	                var type = i.attr('type');
	                if (notInputs.indexOf(type) >= 0) return;
	                var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	                els.removeClass('focus-state');
	                if (value && value.trim() !== '') {
	                    els.addClass('not-empty-state');
	                }
	                else {
	                    els.removeClass('not-empty-state');
	                }
	            }
	            function watchChangeState(e) {
	                /*jshint validthis:true*/
	                var input = $(this),
	                    value = input.val();
	                var type = input.attr('type');
	                if (notInputs.indexOf(type) >= 0) return;
	                var els = input.add(input.parents('.item-input, .input-field')).add(input.parents('.item-inner').eq(0));
	                if (els.length === 0) return;
	                if (value && (typeof value === 'string' && value.trim() !== '') || (Array.isArray(value) && value.length > 0)) {
	                    els.addClass('not-empty-state');
	                }
	                else {
	                    els.removeClass('not-empty-state');
	                }
	            }
	            $(document).on('change', 'input, textarea, select', watchChangeState, true);
	            $(document).on('focus', 'input, textarea, select', addFocusState, true);
	            $(document).on('blur', 'input, textarea, select', removeFocusState, true);
	        };
	        
	
	        /*======================================================
	        ************   Handle Browser's History   ************
	        ======================================================*/
	        app.pushStateQueue = [];
	        app.pushStateClearQueue = function () {
	            if (app.pushStateQueue.length === 0) return;
	            var queue = app.pushStateQueue.pop();
	            var animatePages;
	            if (app.params.pushStateNoAnimation === true) animatePages = false;
	            if (queue.action === 'back') {
	                app.router.back(queue.view, {animatePages: animatePages});
	            }
	            if (queue.action === 'loadPage') {
	                app.router.load(queue.view, {url: queue.stateUrl, animatePages: animatePages, pushState: false});
	            }
	            if (queue.action === 'loadContent') {
	                app.router.load(queue.view, {content: queue.stateContent, animatePages: animatePages, pushState: false});
	            }
	            if (queue.action === 'loadPageName') {
	                app.router.load(queue.view, {pageName: queue.statePageName, url: queue.stateUrl, animatePages: animatePages, pushState: false});
	            }
	        };
	        
	        app.initPushState = function () {
	            var blockPopstate = true;
	            $(window).on('load', function () {
	                setTimeout(function () {
	                    blockPopstate = false;
	                }, 0);
	            });
	        
	            if (document.readyState && document.readyState === 'complete') {
	                blockPopstate = false;
	            }
	        
	            function handlePopState(e) {
	                if (blockPopstate) return;
	                var mainView = app.mainView;
	                if (!mainView) return;
	                var state = e.state;
	                if (!state) {
	                    state = {
	                        viewIndex: app.views.indexOf(mainView),
	                        url : mainView.history[0]
	                    };
	                }
	                if (state.viewIndex < 0) return;
	                var view = app.views[state.viewIndex];
	                var stateUrl = state && state.url || undefined;
	                var stateContent = state && state.content || undefined;
	                var statePageName = state && state.pageName || undefined;
	                var animatePages;
	        
	                if (app.params.pushStateNoAnimation === true) animatePages = false;
	        
	                if (stateUrl !== view.url) {
	                    if (view.history.indexOf(stateUrl) >= 0) {
	                        // Go Back
	                        if (view.allowPageChange) {
	                            app.router.back(view, {url:undefined, animatePages: animatePages, pushState: false, preloadOnly:false});
	                        }
	                        else {
	                            app.pushStateQueue.push({
	                                action: 'back',
	                                view: view
	                            });
	                        }
	                    }
	                    else if (stateContent) {
	                        // Load Page
	                        if (view.allowPageChange) {
	                            app.router.load(view, {content:stateContent, animatePages: animatePages, pushState: false});
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadContent',
	                                stateContent: stateContent,
	                                view: view
	                            });
	                        }
	        
	                    }
	                    else if (statePageName) {
	                        // Load Page by page name with Dom Cache
	                        if (view.allowPageChange) {
	                            app.router.load(view, {pageName:statePageName, url: stateUrl, animatePages: animatePages, pushState: false});
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadPageName',
	                                statePageName: statePageName,
	                                view: view
	                            });
	                        }
	                    }
	                    else  {
	                        // Load Page
	                        if (view.allowPageChange) {
	                            app.router.load(view, {url:stateUrl, animatePages: animatePages, pushState: false});
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadPage',
	                                stateUrl: stateUrl,
	                                view: view
	                            });
	                        }
	                    }
	                }
	            }
	            $(window).on('popstate', handlePopState);
	        };
	        
	
	        /*===========================
	        Framework7 Swiper Additions
	        ===========================*/
	        app.swiper = function (container, params) {
	            return new Swiper(container, params);
	        };
	        app.initPageSwiper = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var swipers = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	            if (swipers.length === 0) return;
	            function destroySwiperOnRemove(slider) {
	                function destroySwiper() {
	                    slider.destroy();
	                    pageContainer.off('page:beforeremove', destroySwiper);
	                }
	                pageContainer.on('page:beforeremove', destroySwiper);
	            }
	            swipers.each(function () {
	                var swiper = $(this), initialSlide;
	                var params;
	                if (swiper.hasClass('tabs-swipeable-wrap')) {
	                    swiper.addClass('swiper-container').children('.tabs').addClass('swiper-wrapper').children('.tab').addClass('swiper-slide');
	                    initialSlide = swiper.children('.tabs').children('.tab.active').index();
	                }
	                if (swiper.data('swiper')) {
	                    params = JSON.parse(swiper.data('swiper'));
	                }
	                else {
	                    params = swiper.dataset();
	                }
	                if (typeof params.initialSlide === 'undefined' && typeof initialSlide !== 'undefined') {
	                    params.initialSlide = initialSlide;
	                }
	                if (swiper.hasClass('tabs-swipeable-wrap')) {
	                    params.onSlideChangeStart = function (s) {
	                        app.showTab(s.slides.eq(s.activeIndex));
	                    };
	                }
	                var _slider = app.swiper(swiper[0], params);
	                destroySwiperOnRemove(_slider);
	            });
	        };
	        app.reinitPageSwiper = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var sliders = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	            if (sliders.length === 0) return;
	            for (var i = 0; i < sliders.length; i++) {
	                var sliderInstance = sliders[0].swiper;
	                if (sliderInstance) {
	                    sliderInstance.update(true);
	                }
	            }
	        };
	        
	
	        /*======================================================
	        ************   Photo Browser   ************
	        ======================================================*/
	        var PhotoBrowser = function (params) {
	            var pb = this, i;
	        
	            var defaults = {
	                photos : [],
	                initialSlide: 0,
	                spaceBetween: 20,
	                speed: 300,
	                zoom: true,
	                zoomMax: 3,
	                zoomMin: 1,
	                exposition: true,
	                expositionHideCaptions: false,
	                type: 'standalone',
	                navbar: true,
	                toolbar: true,
	                theme: 'light',
	                swipeToClose: true,
	                backLinkText: 'Close',
	                ofText: 'of',
	                loop: false,
	                lazyLoading: false,
	                lazyLoadingInPrevNext: false,
	                lazyLoadingOnTransitionStart: false,
	                material: app.params.material,
	                materialPreloaderSvg: app.params.materialPreloaderSvg,
	                materialPreloaderHtml: app.params.materialPreloaderHtml,
	                /*
	                Callbacks:
	                onLazyImageLoad(pb, slide, img)
	                onLazyImageReady(pb, slide, img)
	                onOpen(pb)
	                onClose(pb)
	                onTransitionStart(swiper)
	                onTransitionEnd(swiper)
	                onSlideChangeStart(swiper)
	                onSlideChangeEnd(swiper)
	                onTap(swiper, e)
	                onClick(swiper, e)
	                onDoubleTap(swiper, e)
	                onSwipeToClose(pb)
	                */
	            };
	        
	            params = params || {};
	            if (!params.backLinkText && app.params.material) defaults.backLinkText = '';
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            if (params.maxZoom) {
	                params.zoomMax = params.maxZoom;
	            }
	            if (params.minZoom) {
	                params.zoomMin = params.minZoom;
	            }
	        
	            pb.params = params;
	            pb.params.iconsColorClass = pb.params.iconsColor ? 'color-' + pb.params.iconsColor : (pb.params.theme === 'dark' ? 'color-white' : '');
	            pb.params.preloaderColorClass = pb.params.theme === 'dark' ? 'preloader-white' : '';
	        
	            // Templates
	            var photoTemplate = pb.params.photoTemplate ||
	                '<div class="photo-browser-slide swiper-slide">' +
	                    '<span class="swiper-zoom-container">' +
	                        '<img src="{{js "this.url || this"}}">' +
	                    '</span>' +
	                '</div>';
	            var photoLazyTemplate = pb.params.lazyPhotoTemplate ||
	                '<div class="photo-browser-slide photo-browser-slide-lazy swiper-slide">' +
	                    '<div class="preloader {{@root.preloaderColorClass}}">{{#if @root.material}}{{@root.materialPreloaderHtml}}{{/if}}</div>' +
	                    '<span class="swiper-zoom-container">' +
	                        '<img data-src="{{js "this.url || this"}}" class="swiper-lazy">' +
	                    '</span>' +
	                '</div>';
	            var objectTemplate = pb.params.objectTemplate ||
	                '<div class="photo-browser-slide photo-browser-object-slide swiper-slide">{{js "this.html || this"}}</div>';
	            var captionTemplate = pb.params.captionTemplate ||
	                '<div class="photo-browser-caption" data-caption-index="{{@index}}">' +
	                    '{{caption}}' +
	                '</div>';
	            var navbarTemplate = pb.params.navbarTemplate ||
	                '<div class="navbar">' +
	                    '<div class="navbar-inner">' +
	                        '<div class="left sliding">' +
	                            '<a href="#" class="link ' + (params.type === 'popup' ? 'close-popup' : 'photo-browser-close-link')+ ' {{#unless backLinkText}}icon-only{{/unless}} {{js "this.type === \'page\' ? \'back\' : \'\'"}}">' +
	                                '<i class="icon icon-back {{iconsColorClass}}"></i>' +
	                                '{{#if backLinkText}}<span>{{backLinkText}}</span>{{/if}}' +
	                            '</a>' +
	                        '</div>' +
	                        '<div class="center sliding">' +
	                            '<span class="photo-browser-current"></span> ' +
	                            '<span class="photo-browser-of">{{ofText}}</span> ' +
	                            '<span class="photo-browser-total"></span>' +
	                        '</div>' +
	                        '<div class="right"></div>' +
	                    '</div>' +
	                '</div>';
	            var toolbarTemplate = pb.params.toolbarTemplate ||
	                '<div class="toolbar tabbar">' +
	                    '<div class="toolbar-inner">' +
	                        '<a href="#" class="link photo-browser-prev">' +
	                            '<i class="icon icon-prev {{iconsColorClass}}"></i>' +
	                        '</a>' +
	                        '<a href="#" class="link photo-browser-next">' +
	                            '<i class="icon icon-next {{iconsColorClass}}"></i>' +
	                        '</a>' +
	                    '</div>' +
	                '</div>';
	        
	            var htmlTemplate = t7.compile('<div class="photo-browser photo-browser-{{theme}}">' +
	                    '<div class="view navbar-fixed toolbar-fixed">' +
	                        '{{#unless material}}{{#if navbar}}' +
	                        navbarTemplate +
	                        '{{/if}}{{/unless}}' +
	                        '<div class="page no-toolbar {{#unless navbar}}no-navbar{{/unless}} toolbar-fixed navbar-fixed" data-page="photo-browser-slides">' +
	                            '{{#if material}}{{#if navbar}}' +
	                            navbarTemplate +
	                            '{{/if}}{{/if}}' +
	                            '{{#if toolbar}}' +
	                            toolbarTemplate +
	                            '{{/if}}' +
	                            '<div class="photo-browser-captions photo-browser-captions-{{js "this.captionsTheme || this.theme"}}">' +
	                                '{{#each photos}}{{#if caption}}' +
	                                captionTemplate +
	                                '{{/if}}{{/each}}' +
	                            '</div>' +
	                            '<div class="photo-browser-swiper-container swiper-container">' +
	                                '<div class="photo-browser-swiper-wrapper swiper-wrapper">' +
	                                    '{{#each photos}}' +
	                                    '{{#js_compare "this.html || ((typeof this === \'string\' || this instanceof String) && (this.indexOf(\'<\') >= 0 || this.indexOf(\'>\') >= 0))"}}' +
	                                        objectTemplate +
	                                    '{{else}}' +
	                                        '{{#if @root.lazyLoading}}' +
	                                        photoLazyTemplate +
	                                        '{{else}}' +
	                                        photoTemplate +
	                                        '{{/if}}' +
	                                    '{{/js_compare}}' +
	                                    '{{/each}}' +
	                                '</div>' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>' +
	                '</div>')(pb.params);
	        
	            pb.activeIndex = pb.params.initialSlide;
	            pb.openIndex = pb.activeIndex;
	            pb.opened = false;
	        
	            pb.open = function (index) {
	                if (typeof index === 'undefined') index = pb.activeIndex;
	                index = parseInt(index, 10);
	                if (pb.opened && pb.swiper) {
	                    pb.swiper.slideTo(index);
	                    return;
	                }
	                pb.opened = true;
	                pb.openIndex = index;
	                if (pb.params.type === 'standalone') {
	                    app.root.append(htmlTemplate);
	                }
	                if (pb.params.type === 'popup') {
	                    pb.popup = app.popup('<div class="popup photo-browser-popup">' + htmlTemplate + '</div>');
	                    $(pb.popup).on('popup:closed', pb.onPopupClose);
	                }
	                if (pb.params.type === 'page') {
	                    $(document).once('page:beforeinit', pb.onPageBeforeInit);
	                    $(document).once('page:beforeremove', pb.onPageBeforeRemove);
	                    if (!pb.params.view) pb.params.view = app.mainView;
	                    pb.params.view.loadContent(htmlTemplate);
	                    return;
	                }
	                pb.layout(pb.openIndex);
	                if (pb.params.onOpen) {
	                    pb.params.onOpen(pb);
	                }
	        
	            };
	            pb.close = function () {
	                pb.opened = false;
	                if (!pb.swiperContainer || pb.swiperContainer.length === 0) {
	                    return;
	                }
	                if (pb.params.onClose) {
	                    pb.params.onClose(pb);
	                }
	                // Detach events
	                pb.attachEvents(true);
	                // Delete from DOM
	                if (pb.params.type === 'standalone') {
	                    pb.container.removeClass('photo-browser-in').addClass('photo-browser-out').animationEnd(function () {
	                        pb.container.remove();
	                    });
	                }
	                // Destroy slider
	                pb.swiper.destroy();
	                // Delete references
	                pb.swiper = pb.swiperContainer = pb.swiperWrapper = pb.slides = undefined; //gestureSlide = gestureImg = gestureImgWrap = undefined;
	            };
	        
	            pb.onPopupClose = function (e) {
	                pb.close();
	                $(pb.popup).off('page:beforeinit', pb.onPopupClose);
	            };
	            pb.onPageBeforeInit = function (e) {
	                if (e.detail.page.name === 'photo-browser-slides') {
	                    pb.layout(pb.openIndex);
	                    if (pb.params.onOpen) {
	                        pb.params.onOpen(pb);
	                    }
	                }
	            };
	            pb.onPageBeforeRemove = function (e) {
	                if (e.detail.page.name === 'photo-browser-slides') {
	                    pb.close();
	                }
	            };
	        
	            pb.onSliderTransitionStart = function (swiper) {
	                pb.activeIndex = swiper.activeIndex;
	        
	                var current = swiper.activeIndex + 1;
	                var total = swiper.slides.length;
	                if (pb.params.loop) {
	                    total = total - 2;
	                    current = current - swiper.loopedSlides;
	                    if (current < 1) current = total + current;
	                    if (current > total) current = current - total;
	                }
	                pb.container.find('.photo-browser-current').text(current);
	                pb.container.find('.photo-browser-total').text(total);
	        
	                $('.photo-browser-prev, .photo-browser-next').removeClass('photo-browser-link-inactive');
	        
	                if (swiper.isBeginning && !pb.params.loop) {
	                    $('.photo-browser-prev').addClass('photo-browser-link-inactive');
	                }
	                if (swiper.isEnd && !pb.params.loop) {
	                    $('.photo-browser-next').addClass('photo-browser-link-inactive');
	                }
	        
	                // Update captions
	                if (pb.captions.length > 0) {
	                    pb.captionsContainer.find('.photo-browser-caption-active').removeClass('photo-browser-caption-active');
	                    var captionIndex = pb.params.loop ? swiper.slides.eq(swiper.activeIndex).attr('data-swiper-slide-index') : pb.activeIndex;
	                    pb.captionsContainer.find('[data-caption-index="' + captionIndex + '"]').addClass('photo-browser-caption-active');
	                }
	        
	        
	                // Stop Video
	                var previousSlideVideo = swiper.slides.eq(swiper.previousIndex).find('video');
	                if (previousSlideVideo.length > 0) {
	                    if ('pause' in previousSlideVideo[0]) previousSlideVideo[0].pause();
	                }
	                // Callback
	                if (pb.params.onTransitionStart) pb.params.onTransitionStart(swiper);
	            };
	            pb.onSliderTransitionEnd = function (swiper) {
	                if (pb.params.onTransitionEnd) pb.params.onTransitionEnd(swiper);
	            };
	        
	            pb.layout = function (index) {
	                if (pb.params.type === 'page') {
	                    pb.container = $('.photo-browser-swiper-container').parents('.view');
	                }
	                else {
	                    pb.container = $('.photo-browser');
	                }
	                if (pb.params.type === 'standalone') {
	                    pb.container.addClass('photo-browser-in');
	                    app.sizeNavbars(pb.container);
	                }
	                pb.swiperContainer = pb.container.find('.photo-browser-swiper-container');
	                pb.swiperWrapper = pb.container.find('.photo-browser-swiper-wrapper');
	                pb.slides = pb.container.find('.photo-browser-slide');
	                pb.captionsContainer = pb.container.find('.photo-browser-captions');
	                pb.captions = pb.container.find('.photo-browser-caption');
	        
	                var sliderSettings = {
	                    nextButton: pb.params.nextButton || '.photo-browser-next',
	                    prevButton: pb.params.prevButton || '.photo-browser-prev',
	                    indexButton: pb.params.indexButton,
	                    initialSlide: index,
	                    spaceBetween: pb.params.spaceBetween,
	                    speed: pb.params.speed,
	                    loop: pb.params.loop,
	                    lazyLoading: pb.params.lazyLoading,
	                    lazyLoadingInPrevNext: pb.params.lazyLoadingInPrevNext,
	                    lazyLoadingOnTransitionStart: pb.params.lazyLoadingOnTransitionStart,
	                    preloadImages: pb.params.lazyLoading ? false : true,
	                    zoom: pb.params.zoom,
	                    zoomMax: pb.params.zoomMax,
	                    zoomMin: pb.params.zoomMin,
	                    onTap: function (swiper, e) {
	                        if (pb.params.onTap) pb.params.onTap(swiper, e);
	                    },
	                    onClick: function (swiper, e) {
	                        if (pb.params.exposition) pb.toggleExposition();
	                        if (pb.params.onClick) pb.params.onClick(swiper, e);
	                    },
	                    onDoubleTap: function (swiper, e) {
	                        // pb.toggleZoom(e);
	                        if (pb.params.onDoubleTap) pb.params.onDoubleTap(swiper, e);
	                    },
	                    onTransitionStart: function (swiper) {
	                        pb.onSliderTransitionStart(swiper);
	                    },
	                    onTransitionEnd: function (swiper) {
	                        pb.onSliderTransitionEnd(swiper);
	                    },
	                    onSlideChangeStart: pb.params.onSlideChangeStart,
	                    onSlideChangeEnd: pb.params.onSlideChangeEnd,
	                    onLazyImageLoad: function (swiper, slide, img) {
	                        if (pb.params.onLazyImageLoad) pb.params.onLazyImageLoad(pb, slide, img);
	                    },
	                    onLazyImageReady: function (swiper, slide, img) {
	                        $(slide).removeClass('photo-browser-slide-lazy');
	                        if (pb.params.onLazyImageReady) pb.params.onLazyImageReady(pb, slide, img);
	                    }
	                };
	        
	                if (pb.params.swipeToClose && pb.params.type !== 'page') {
	                    sliderSettings.onTouchStart = pb.swipeCloseTouchStart;
	                    sliderSettings.onTouchMoveOpposite = pb.swipeCloseTouchMove;
	                    sliderSettings.onTouchEnd = pb.swipeCloseTouchEnd;
	                }
	        
	                pb.swiper = app.swiper(pb.swiperContainer, sliderSettings);
	                if (index === 0) {
	                    pb.onSliderTransitionStart(pb.swiper);
	                }
	                pb.attachEvents();
	            };
	            pb.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                pb.container.find('.photo-browser-close-link')[action]('click', pb.close);
	            };
	        
	        
	            // Expose
	            pb.exposed = false;
	            pb.toggleExposition = function () {
	                if (pb.container) pb.container.toggleClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions) pb.captionsContainer.toggleClass('photo-browser-captions-exposed');
	                pb.exposed = !pb.exposed;
	            };
	            pb.enableExposition = function () {
	                if (pb.container) pb.container.addClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions) pb.captionsContainer.addClass('photo-browser-captions-exposed');
	                pb.exposed = true;
	            };
	            pb.disableExposition = function () {
	                if (pb.container) pb.container.removeClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions) pb.captionsContainer.removeClass('photo-browser-captions-exposed');
	                pb.exposed = false;
	            };
	        
	            // Swipe Up To Close
	            var swipeToCloseIsTouched = false;
	            var allowSwipeToClose = true;
	            var swipeToCloseDiff, swipeToCloseStart, swipeToCloseCurrent, swipeToCloseStarted = false, swipeToCloseActiveSlide, swipeToCloseTimeStart;
	            pb.swipeCloseTouchStart = function (swiper, e) {
	                if (!allowSwipeToClose) return;
	                swipeToCloseIsTouched = true;
	            };
	            pb.swipeCloseTouchMove = function (swiper, e) {
	                if (!swipeToCloseIsTouched) return;
	                if (!swipeToCloseStarted) {
	                    swipeToCloseStarted = true;
	                    swipeToCloseStart = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    swipeToCloseActiveSlide = pb.swiper.slides.eq(pb.swiper.activeIndex);
	                    swipeToCloseTimeStart = (new Date()).getTime();
	                }
	                e.preventDefault();
	                swipeToCloseCurrent = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                swipeToCloseDiff = swipeToCloseStart - swipeToCloseCurrent;
	                var opacity = 1 - Math.abs(swipeToCloseDiff) / 300;
	                swipeToCloseActiveSlide.transform('translate3d(0,' + (-swipeToCloseDiff) + 'px,0)');
	                pb.swiper.container.css('opacity', opacity).transition(0);
	            };
	            pb.swipeCloseTouchEnd = function (swiper, e) {
	                swipeToCloseIsTouched = false;
	                if (!swipeToCloseStarted) {
	                    swipeToCloseStarted = false;
	                    return;
	                }
	                swipeToCloseStarted = false;
	                allowSwipeToClose = false;
	                var diff = Math.abs(swipeToCloseDiff);
	                var timeDiff = (new Date()).getTime() - swipeToCloseTimeStart;
	                if ((timeDiff < 300 && diff > 20) || (timeDiff >= 300 && diff > 100)) {
	                    setTimeout(function () {
	                        if (pb.params.type === 'standalone') {
	                            pb.close();
	                        }
	                        if (pb.params.type === 'popup') {
	                            app.closeModal(pb.popup);
	                        }
	                        if (pb.params.onSwipeToClose) {
	                            pb.params.onSwipeToClose(pb);
	                        }
	                        allowSwipeToClose = true;
	                    }, 0);
	                    return;
	                }
	                if (diff !== 0) {
	                    swipeToCloseActiveSlide.addClass('transitioning').transitionEnd(function () {
	                        allowSwipeToClose = true;
	                        swipeToCloseActiveSlide.removeClass('transitioning');
	                    });
	                }
	                else {
	                    allowSwipeToClose = true;
	                }
	                pb.swiper.container.css('opacity', '').transition('');
	                swipeToCloseActiveSlide.transform('');
	            };
	        
	            return pb;
	        };
	        
	        app.photoBrowser = function (params) {
	            return new PhotoBrowser(params);
	        };
	        
	
	        /*===============================================================================
	        ************   Autocomplete   ************
	        ===============================================================================*/
	        var Autocomplete = function (params) {
	            var a = this;
	        
	            // Params
	            var defaults = {
	                // Standalone Options
	                /*
	                opener: undefined,
	                */
	                popupCloseText: 'Close',
	                backText: 'Back',
	                searchbarPlaceholderText: 'Search...',
	                searchbarCancelText: 'Cancel',
	                openWithAnimation: true,
	                // When opened in page should the searchbar be focused by default
	                autoFocus: true,
	                openIn: 'page',
	                backOnSelect: false,
	                notFoundText: 'Nothing found',
	                requestSourceOnOpen: false,
	                /*
	                pageTitle: undefined,
	                */
	        
	                // Handle Data
	                /*
	                source: undefined,
	                limit: undefined,
	                */
	                valueProperty: 'id',
	                textProperty: 'text',
	        
	                // Dropdown Options
	                highlightMatches: true,
	        
	                /*
	                dropdownPlaceholderText: 'Type anything...',
	                */
	                updateInputValueOnSelect: true,
	                expandInput: false,
	        
	                // Preloader
	                preloaderColor: false,
	                preloader: false,
	        
	                // Templates
	                /*
	                itemTemplate: undefined,
	                navbarTemplate: undefined,
	                dropdownTemplate: undefined
	                dropdownItemTemplate: undefined,
	                dropdownPlaceholderTemplate: undefined
	                */
	        
	                // Color themes
	                /*
	                navbarTheme: undefined,
	                formTheme: undefined,
	                */
	        
	                // Callbacks
	                /*
	                onChange: function (a, value) - for not dropdown
	                onOpen: function (a)
	                onClose: function (a)
	                */
	            };
	        
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            a.params = params;
	        
	            // Opener Link & View
	            if (a.params.opener) {
	                a.opener = $(a.params.opener);
	            }
	            var view = a.params.view;
	            if (!a.params.view && a.opener && a.opener.length) {
	                // Find related view
	                view = a.opener.parents('.' + app.params.viewClass);
	                if (view.length === 0) return;
	                view = view[0].f7View;
	            }
	        
	            // Input
	            if (a.params.input) {
	                a.input = $(a.params.input);
	                if (a.input.length === 0 && a.params.openIn === 'dropdown') return;
	            }
	        
	            // Array with selected items
	            a.value = a.params.value || [];
	        
	            // ID & Inputs
	            a.id = (new Date()).getTime();
	            a.inputType = a.params.multiple ? 'checkbox' : 'radio';
	            a.inputName = a.inputType + '-' + a.id;
	        
	            // Is Material
	            var material = app.params.material;
	        
	            // Back On Select
	            var backOnSelect = a.params.backOnSelect;
	        
	            if (a.params.openIn !== 'dropdown') {
	                // Item Template
	                a.itemTemplate = t7.compile(a.params.itemTemplate ||
	                    '<li>' +
	                        '<label class="label-{{inputType}} item-content">' +
	                            '<input type="{{inputType}}" name="{{inputName}}" value="{{value}}" {{#if selected}}checked{{/if}}>' +
	                            '{{#if material}}' +
	                                '<div class="item-media">' +
	                                    '<i class="icon icon-form-{{inputType}}"></i>' +
	                                '</div>' +
	                                '<div class="item-inner">' +
	                                    '<div class="item-title">{{text}}</div>' +
	                                '</div>' +
	                            '{{else}}' +
	                                '{{#if checkbox}}' +
	                                '<div class="item-media">' +
	                                    '<i class="icon icon-form-checkbox"></i>' +
	                                '</div>' +
	                                '{{/if}}' +
	                                '<div class="item-inner">' +
	                                    '<div class="item-title">{{text}}</div>' +
	                                '</div>' +
	                            '{{/if}}' +
	                        '</label>' +
	                    '</li>'
	                );
	                // Page Layout
	                var pageTitle = a.params.pageTitle || '';
	                if (!pageTitle && a.opener && a.opener.length) {
	                    pageTitle = a.opener.find('.item-title').text();
	                }
	                var pageName = 'autocomplete-' + a.inputName;
	        
	                var navbarTheme = a.params.navbarTheme,
	                    formTheme = a.params.formTheme;
	        
	                // Navbar HTML
	                var navbarHTML;
	                var noNavbar = '', noToolbar = '', navbarLayout;
	        
	                a.navbarTemplate = t7.compile(a.params.navbarTemplate ||
	                    '<div class="navbar no-shadow {{#if navbarTheme}}theme-{{navbarTheme}}{{/if}}">' +
	                        '<div class="navbar-inner">' +
	                            '<div class="left sliding">' +
	                                '{{#if material}}' +
	                                '<a href="#" class="link {{#if inPopup}}close-popup{{else}}back{{/if}} icon-only" {{#unless animated}}data-animate-pages="false"{{/unless}}><i class="icon icon-back"></i></a>' +
	                                '{{else}}' +
	                                '<a href="#" class="link {{#if inPopup}}close-popup{{else}}back{{/if}}" {{#unless animated}}data-animate-pages="false"{{/unless}}>' +
	                                    '<i class="icon icon-back"></i>' +
	                                    '{{#if inPopup}}' +
	                                    '<span>{{popupCloseText}}</span>' +
	                                    '{{else}}' +
	                                    '<span>{{backText}}</span>' +
	                                    '{{/if}}' +
	                                '</a>' +
	                                '{{/if}}' +
	                            '</div>' +
	                            '<div class="center sliding">{{pageTitle}}</div>' +
	                            '{{#if preloader}}' +
	                            '<div class="right">' +
	                                '<div class="autocomplete-preloader preloader {{#if preloaderColor}}preloader-{{preloaderColor}}{{/if}}"></div>' +
	                            '</div>' +
	                            '{{/if}}' +
	                        '</div>' +
	                    '</div>'
	                );
	                navbarHTML = a.navbarTemplate({
	                    pageTitle: pageTitle,
	                    backText: a.params.backText,
	                    popupCloseText: a.params.popupCloseText,
	                    openIn: a.params.openIn,
	                    navbarTheme: navbarTheme,
	                    inPopup: a.params.openIn === 'popup',
	                    inPage: a.params.openIn === 'page',
	                    material: material,
	                    preloader: a.params.preloader,
	                    preloaderColor: a.params.preloaderColor,
	                    animated: a.params.openWithAnimation
	                });
	        
	                // Determine navbar layout type - static/fixed/through
	                if (a.params.openIn === 'page') {
	                    navbarLayout = 'static';
	                    if (a.opener) {
	                        if (a.opener.parents('.navbar-through').length > 0) navbarLayout = 'through';
	                        if (a.opener.parents('.navbar-fixed').length > 0) navbarLayout = 'fixed';
	                        noToolbar = a.opener.parents('.page').hasClass('no-toolbar') ? 'no-toolbar' : '';
	                        noNavbar  = a.opener.parents('.page').hasClass('no-navbar')  ? 'no-navbar'  : 'navbar-' + navbarLayout;
	                    }
	                    else if (view.container) {
	                        if ($(view.container).hasClass('navbar-through') || $(view.container).find('.navbar-through').length > 0) navbarLayout = 'through';
	                        if ($(view.container).hasClass('navbar-fixed') || $(view.container).find('.navbar-fixed').length > 0) navbarLayout = 'fixed';
	                        noToolbar = $(view.activePage.container).hasClass('no-toolbar') ? 'no-toolbar' : '';
	                        noNavbar  = $(view.activePage.container).hasClass('no-navbar')  ? 'no-navbar'  : 'navbar-' + navbarLayout;
	                    }
	                }
	                else {
	                    navbarLayout = 'fixed';
	                }
	                var searchbarHTML =
	                    '<form class="searchbar">' +
	                        '<div class="searchbar-input">' +
	                            '<input type="search" placeholder="' + a.params.searchbarPlaceholderText + '">' +
	                            '<a href="#" class="searchbar-clear"></a>' +
	                        '</div>' +
	                        (material ? '' : '<a href="#" class="searchbar-cancel">' + a.params.searchbarCancelText + '</a>') +
	                    '</form>' +
	                    '<div class="searchbar-overlay"></div>';
	                var pageHTML =
	                    (navbarLayout === 'through' ? navbarHTML : '') +
	                    '<div class="pages">' +
	                        '<div data-page="' + pageName + '" class="page autocomplete-page ' + noNavbar + ' ' + noToolbar + '">' +
	                            (navbarLayout === 'fixed' ? navbarHTML : '') +
	                            searchbarHTML +
	                            '<div class="page-content">' +
	                                (navbarLayout === 'static' ? navbarHTML : '') +
	                                '<div class="list-block autocomplete-found autocomplete-list-' + a.id + ' ' + (formTheme ? 'theme-' + formTheme : '') + '">' +
	                                    '<ul></ul>' +
	                                '</div>' +
	                                '<div class="list-block autocomplete-not-found">' +
	                                    '<ul><li class="item-content"><div class="item-inner"><div class="item-title">' + a.params.notFoundText + '</div></div></li></ul>' +
	                                '</div>' +
	                                '<div class="list-block autocomplete-values">' +
	                                    '<ul></ul>' +
	                                '</div>' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>';
	            }
	            else {
	                a.dropdownItemTemplate = t7.compile(a.params.dropdownItemTemplate ||
	                    '<li>' +
	                        '<label class="{{#unless placeholder}}label-radio{{/unless}} item-content" data-value="{{value}}">' +
	                            '<div class="item-inner">' +
	                                '<div class="item-title">{{text}}</div>' +
	                            '</div>' +
	                        '</label>' +
	                    '</li>'
	                );
	                a.dropdownPlaceholderTemplate = t7.compile(a.params.dropdownPlaceholderTemplate ||
	                    '<li class="autocomplete-dropdown-placeholder">' +
	                        '<div class="item-content">' +
	                            '<div class="item-inner">' +
	                                '<div class="item-title">{{text}}</div>' +
	                            '</div>' +
	                        '</label>' +
	                    '</li>'
	                );
	                a.dropdownTemplate = t7.compile(a.params.dropdownTemplate ||
	                    '<div class="autocomplete-dropdown">' +
	                        '<div class="autocomplete-dropdown-inner">' +
	                            '<div class="list-block">' +
	                                '<ul></ul>' +
	                            '</div>' +
	                        '</div>' +
	                        '{{#if preloader}}' +
	                        '<div class="autocomplete-preloader preloader {{#if preloaderColor}}preloader-{{preloaderColor}}{{/if}}">{{#if material}}{{materialPreloaderHtml}}{{/if}}</div>' +
	                        '{{/if}}' +
	                    '</div>'
	                );
	            }
	        
	            // Define popup
	            a.popup = undefined;
	        
	            // Define Dropdown
	            a.dropdown = undefined;
	        
	            // Handle Input Value Change
	            function handleInputValue (e) {
	                var query = a.input.val();
	                if (a.params.source) {
	                    a.params.source(a, query, function (items) {
	                        var itemsHTML = '';
	                        var limit = a.params.limit ? Math.min(a.params.limit, items.length) : items.length;
	                        a.items = items;
	                        var i, j, regExp;
	                        if (a.params.highlightMatches) {
	                            query = query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	                            regExp = new RegExp('('+query+')', 'i');
	                        }
	        
	                        for (i = 0; i < limit; i++) {
	                            var itemValue = typeof items[i] === 'object' ? items[i][a.params.valueProperty] : items[i];
	                            var itemText = typeof items[i] !== 'object' ? items[i] : items[i][a.params.textProperty];
	                            itemsHTML += a.dropdownItemTemplate({
	                                value: itemValue,
	                                text: a.params.highlightMatches ? itemText.replace(regExp, '<b>$1</b>') : itemText
	                            });
	                        }
	                        if (itemsHTML === '' && query === '' && a.params.dropdownPlaceholderText) {
	                            itemsHTML += a.dropdownPlaceholderTemplate({
	                                text: a.params.dropdownPlaceholderText,
	                            });
	                        }
	                        a.dropdown.find('ul').html(itemsHTML);
	                    });
	                }
	            }
	            // Handle Drop Down Click
	            function handleDropdownClick (e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var clickedItem;
	                for (var i = 0; i < a.items.length; i++) {
	                    var itemValue = typeof a.items[i] === 'object' ? a.items[i][a.params.valueProperty] : a.items[i];
	                    var value = clicked.attr('data-value');
	                    if (itemValue === value || itemValue * 1 === value * 1) {
	                        clickedItem = a.items[i];
	                    }
	                }
	                if (a.params.updateInputValueOnSelect) {
	                    a.input.val(typeof clickedItem === 'object' ? clickedItem[a.params.textProperty] : clickedItem);
	                    a.input.trigger('input change');
	                }
	        
	                if (a.params.onChange) {
	                    a.params.onChange(a, clickedItem);
	                }
	        
	                a.close();
	            }
	        
	            // Handle HTML Click to close Dropdown
	            function closeOnHTMLClick (e) {
	                var target = $(e.target);
	                if (!(target.is(a.input[0]) || a.dropdown && target.parents(a.dropdown[0]).length > 0)) {
	                    a.close();
	                }
	            }
	        
	            a.positionDropDown = function () {
	                var listBlock = a.input.parents('.list-block'),
	                    pageContent = a.input.parents('.page-content'),
	                    paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                    paddingBottom = parseInt(pageContent.css('padding-top'), 10),
	                    // inputOffset = a.input.offset(),
	                    listBlockOffsetLeft = listBlock.length > 0 ? listBlock.offset().left - listBlock.parent().offset().left : 0,
	                    inputOffsetLeft = a.input.offset().left - (listBlock.length > 0 ? listBlock.offset().left : 0),
	                    inputOffsetTop = a.input.offset().top - (pageContent.offset().top - pageContent[0].scrollTop),
	                    maxHeight = pageContent[0].scrollHeight - paddingBottom - (inputOffsetTop + pageContent[0].scrollTop) - a.input[0].offsetHeight;
	        
	                a.dropdown.css({
	                    left: (listBlock.length > 0 ? listBlockOffsetLeft : inputOffsetLeft) + 'px',
	                    top: inputOffsetTop + pageContent[0].scrollTop + a.input[0].offsetHeight + 'px',
	                    width: (listBlock.length > 0 ? listBlock[0].offsetWidth : a.input[0].offsetWidth) + 'px'
	                });
	                a.dropdown.children('.autocomplete-dropdown-inner').css({
	                    maxHeight: maxHeight + 'px',
	                    paddingLeft: listBlock.length > 0 && !a.params.expandInput ? inputOffsetLeft - (material ? 16 : 15) + 'px' : ''
	                });
	            };
	        
	            a.pageInit = function (e) {
	                var page = e.detail.page;
	                a.page = $(page.container);
	                a.pageData = page;
	                if (page.name !== pageName) {
	                    return;
	                }
	                var container = $(page.container);
	        
	                // Source
	                function onSource(query) {
	                    if (!a.params.source) return;
	                    var i, j, k;
	        
	                    a.params.source(a, query, function(items) {
	                        var itemsHTML = '';
	                        var limit = a.params.limit ? Math.min(a.params.limit, items.length) : items.length;
	                        a.items = items;
	                        for (i = 0; i < limit; i++) {
	                            var selected = false;
	                            var itemValue = typeof items[i] === 'object' ? items[i][a.params.valueProperty] : items[i];
	                            for (j = 0; j < a.value.length; j++) {
	                                var aValue = typeof a.value[j] === 'object' ? a.value[j][a.params.valueProperty] : a.value[j];
	                                if (aValue === itemValue || aValue * 1 === itemValue * 1) selected = true;
	                            }
	                            itemsHTML += a.itemTemplate({
	                                value: itemValue,
	                                text: typeof items[i] !== 'object' ? items[i] : items[i][a.params.textProperty],
	                                inputType: a.inputType,
	                                id: a.id,
	                                inputName: a.inputName,
	                                selected: selected,
	                                checkbox: a.inputType === 'checkbox',
	                                material: material
	                            });
	                        }
	                        container.find('.autocomplete-found ul').html(itemsHTML);
	                        if (items.length === 0) {
	                            if (query.length !== 0) {
	                                container.find('.autocomplete-not-found').show();
	                                container.find('.autocomplete-found, .autocomplete-values').hide();
	                            }
	                            else {
	                                container.find('.autocomplete-values').show();
	                                container.find('.autocomplete-found, .autocomplete-not-found').hide();
	                            }
	                        }
	                        else {
	                            container.find('.autocomplete-found').show();
	                            container.find('.autocomplete-not-found, .autocomplete-values').hide();
	                        }
	                    });
	                }
	        
	                // Init Search Bar
	                var searchbar = app.searchbar(container.find('.searchbar'), {
	                    customSearch: true,
	                    onSearch: function (searchbar, data) {
	                        if (data.query.length === 0 && searchbar.active) {
	                            searchbar.overlay.addClass('searchbar-overlay-active');
	                        }
	                        else {
	                            searchbar.overlay.removeClass('searchbar-overlay-active');
	                        }
	        
	                        onSource(data.query);
	                    }
	                });
	        
	                // Save searchbar instance
	                a.searchbar = searchbar;
	        
	                // Update values
	                function updateValues() {
	                    var valuesHTML = '';
	                    var i;
	                    for (i = 0; i < a.value.length; i++) {
	        
	                        valuesHTML += a.itemTemplate({
	                            value: typeof a.value[i] === 'object' ? a.value[i][a.params.valueProperty] : a.value[i],
	                            text: typeof a.value[i] === 'object' ? a.value[i][a.params.textProperty]: a.value[i],
	                            inputType: a.inputType,
	                            id: a.id,
	                            inputName: a.inputName + '-checked',
	                            checkbox: a.inputType === 'checkbox',
	                            material: material,
	                            selected: true
	                        });
	                    }
	                    container.find('.autocomplete-values ul').html(valuesHTML);
	                }
	        
	                // Handle Inputs
	                if (!a.params.multiple && a.params.backOnSelect) {
	                    container.once('click', '.list-block label', function () {
	                        if (a.params.openIn === 'popup') app.closeModal(a.popup);
	                        else view.router.back({animatePages: a.params.openWithAnimation});
	                    });
	                }
	                container.on('change', 'input[type="radio"], input[type="checkbox"]', function () {
	                    var i;
	                    var input = this;
	                    var value = input.value;
	                    var text = $(input).parents('li').find('.item-title').text();
	                    var isValues = $(input).parents('.autocomplete-values').length > 0;
	                    var item, itemValue, aValue;
	                    if (isValues) {
	                        if (a.inputType === 'checkbox' && !input.checked) {
	                            for (i = 0; i < a.value.length; i++) {
	                                aValue = typeof a.value[i] === 'string' ? a.value[i] : a.value[i][a.params.valueProperty];
	                                if (aValue === value || aValue * 1 === value * 1) {
	                                    a.value.splice(i, 1);
	                                }
	                            }
	                            updateValues();
	                            if (a.params.onChange) a.params.onChange(a, a.value);
	                        }
	                        return;
	                    }
	        
	                    // Find Related Item
	                    for (i = 0; i < a.items.length; i++) {
	                        itemValue = typeof a.items[i] === 'string' ? a.items[i] : a.items[i][a.params.valueProperty];
	                        if (itemValue === value || itemValue * 1 === value * 1) item = a.items[i];
	                    }
	                    // Update Selected Value
	                    if (a.inputType === 'radio') {
	                        a.value = [item];
	                    }
	                    else {
	                        if (input.checked) {
	                            a.value.push(item);
	                        }
	                        else {
	                            for (i = 0; i < a.value.length; i++) {
	                                aValue = typeof a.value[i] === 'string' ? a.value[i] : a.value[i][a.params.valueProperty];
	                                if (aValue === value || aValue * 1 === value * 1) {
	                                    a.value.splice(i, 1);
	                                }
	                            }
	                        }
	                    }
	        
	                    // Update Values Block
	                    updateValues();
	        
	                    // On Select Callback
	                    if ((a.inputType === 'radio' && input.checked || a.inputType === 'checkbox') && a.params.onChange ) {
	                        a.params.onChange(a, a.value);
	                    }
	                });
	        
	                // Update Values On Page Init
	                updateValues();
	        
	                // Source on load
	                if (a.params.requestSourceOnOpen) onSource('');
	        
	                // On Open Callback
	                if (a.params.onOpen) a.params.onOpen(a);
	            };
	        
	            // Show Hide Preloader
	            a.showPreloader = function () {
	                if (a.params.openIn === 'dropdown') {
	                    if (a.dropdown) a.dropdown.find('.autocomplete-preloader').addClass('autocomplete-preloader-visible');
	                }
	                else $('.autocomplete-preloader').addClass('autocomplete-preloader-visible');
	            };
	        
	            a.hidePreloader = function () {
	                if (a.params.openIn === 'dropdown') {
	                    if (a.dropdown) a.dropdown.find('.autocomplete-preloader').removeClass('autocomplete-preloader-visible');
	                }
	                else $('.autocomplete-preloader').removeClass('autocomplete-preloader-visible');
	            };
	        
	            // Autofocus
	            a.autoFocus = function (e) {
	                var self = this;
	                setTimeout(function () {
	                    $(self).find('input[type=search]').focus();
	                }, 0);
	            };
	        
	            // Open Autocomplete Page/Popup
	            a.open = function () {
	                if (a.opened) return;
	                a.opened = true;
	                if (a.params.openIn === 'dropdown') {
	                    if (!a.dropdown) {
	                        a.dropdown = $(a.dropdownTemplate({
	                            preloader: a.params.preloader,
	                            preloaderColor: a.params.preloaderColor,
	                            material: material,
	                            materialPreloaderHtml: app.params.materialPreloaderHtml
	                        }));
	                        a.dropdown.on('click', 'label', handleDropdownClick);
	        
	                    }
	                    var listBlock = a.input.parents('.list-block');
	                    if (listBlock.length && a.input.parents('.item-content').length > 0 && a.params.expandInput) {
	                        a.input.parents('.item-content').addClass('item-content-dropdown-expand');
	                    }
	                    a.positionDropDown();
	                    a.input.parents('.page-content').append(a.dropdown);
	                    a.dropdown.addClass('autocomplete-dropdown-in');
	                    a.input.trigger('input');
	                    app.onResize(a.positionDropDown);
	                    if (a.params.onOpen) a.params.onOpen(a);
	                }
	                else {
	                    $(document).once('page:init', '.autocomplete-page', a.pageInit);
	                    if (a.params.openIn === 'popup') {
	                        a.popup = app.popup(
	                            '<div class="popup autocomplete-popup autocomplete-popup-' + a.inputName + '">' +
	                                '<div class="view navbar-fixed">' +
	                                    pageHTML +
	                                '</div>' +
	                            '</div>',
	                            true,
	                            a.params.openWithAnimation
	                        );
	                        a.popup = $(a.popup);
	                        if (a.params.autoFocus) {
	                            if (a.params.openWithAnimation) a.popup.once('popup:opened', a.autoFocus);
	                            else a.autoFocus.bind(a.popup)();
	                        }
	                        a.popup.once('popup:closed', function () {
	                            a.popup = undefined;
	                            a.opened = false;
	                            if (a.params.onClose) a.params.onClose(a);
	                        });
	                    }
	                    else {
	                        if (a.params.autoFocus) {
	                            $(document).once(a.params.openWithAnimation ? 'page:afteranimation' : 'page:init', '.autocomplete-page', a.autoFocus);
	                        }
	                        view.router.load({
	                            content: pageHTML,
	                            animatePages: a.params.openWithAnimation
	                        });
	                        $(document).once('page:back', '.autocomplete-page', function () {
	                            a.opened = false;
	                            if (a.params.onClose) a.params.onClose(a);
	                        });
	                    }
	                }
	            };
	            a.close = function (e) {
	                if (!a.opened) return;
	                if (a.params.openIn === 'dropdown') {
	                    if (e && e.type === 'blur' && a.dropdown.find('label.active-state').length > 0) return;
	                    a.dropdown.removeClass('autocomplete-dropdown-in').remove();
	                    a.input.parents('.item-content-dropdown-expand').removeClass('item-content-dropdown-expand');
	                    a.opened = false;
	                    app.offResize(a.positionDropDown);
	                    if (a.params.onClose) a.params.onClose(a);
	                }
	                if (a.params.openIn === 'popup') {
	                    if (a.popup) app.closeModal(a.popup);
	                }
	            };
	        
	            // Init Events
	            a.initEvents = function (detach) {
	                var method = detach ? 'off' : 'on';
	                if (a.params.openIn !== 'dropdown' && a.opener) {
	                    a.opener[method]('click', a.open);
	                }
	                if (a.params.openIn === 'dropdown' && a.input) {
	                    a.input[method]('focus', a.open);
	                    a.input[method]('input', handleInputValue);
	                    if (app.device.android) {
	                        $('html')[method]('click', closeOnHTMLClick);
	                    }
	                    else {
	                        a.input[method]('blur', a.close);
	                    }
	                }
	                if (detach && a.dropdown) {
	                    a.dropdown = null;
	                }
	            };
	        
	            // Init/Destroy Methods
	            a.init = function () {
	                a.initEvents();
	            };
	            a.destroy = function () {
	                a.initEvents(true);
	                a = null;
	            };
	        
	            // Init
	            a.init();
	        
	            return a;
	        };
	        app.autocomplete = function (params) {
	            return new Autocomplete(params);
	        };
	        
	
	        /*======================================================
	        ************   Picker   ************
	        ======================================================*/
	        var Picker = function (params) {
	            var p = this;
	            var defaults = {
	                updateValuesOnMomentum: false,
	                updateValuesOnTouchmove: true,
	                rotateEffect: false,
	                momentumRatio: 7,
	                freeMode: false,
	                // Common settings
	                closeByOutsideClick: true,
	                scrollToInput: true,
	                inputReadOnly: true,
	                convertToPopover: true,
	                onlyInPopover: false,
	                toolbar: true,
	                toolbarCloseText: 'Done',
	                toolbarTemplate:
	                    '<div class="toolbar">' +
	                        '<div class="toolbar-inner">' +
	                            '<div class="left"></div>' +
	                            '<div class="right">' +
	                                '<a href="#" class="link close-picker">{{closeText}}</a>' +
	                            '</div>' +
	                        '</div>' +
	                    '</div>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            p.params = params;
	            p.cols = [];
	            p.initialized = false;
	        
	            // Inline flag
	            p.inline = p.params.container ? true : false;
	        
	            // 3D Transforms origin bug, only on safari
	            var originBug = app.device.ios || (navigator.userAgent.toLowerCase().indexOf('safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0) && !app.device.android;
	        
	            // Should be converted to popover
	            function isPopover() {
	                var toPopover = false;
	                if (!p.params.convertToPopover && !p.params.onlyInPopover) return toPopover;
	                if (!p.inline && p.params.input) {
	                    if (p.params.onlyInPopover) toPopover = true;
	                    else {
	                        if (app.device.ios) {
	                            toPopover = app.device.ipad ? true : false;
	                        }
	                        else {
	                            if (app.width >= 768) toPopover = true;
	                        }
	                    }
	                }
	                return toPopover;
	            }
	            function inPopover() {
	                if (p.opened && p.container && p.container.length > 0 && p.container.parents('.popover').length > 0) return true;
	                else return false;
	            }
	        
	            // Value
	            p.setValue = function (arrValues, transition) {
	                var valueIndex = 0;
	                if (p.cols.length === 0) {
	                    p.value = arrValues;
	                    p.updateValue(arrValues);
	                    return;
	                }
	                for (var i = 0; i < p.cols.length; i++) {
	                    if (p.cols[i] && !p.cols[i].divider) {
	                        p.cols[i].setValue(arrValues[valueIndex], transition);
	                        valueIndex++;
	                    }
	                }
	            };
	            p.updateValue = function (forceValues) {
	                var newValue = forceValues || [];
	                var newDisplayValue = [], i, column;
	                if (p.cols.length === 0) {
	                    for (i = 0; i < p.params.cols.length; i++) {
	                        column = p.params.cols[i];
	                        if (column.displayValues !== undefined && column.values !== undefined && column.values.indexOf(newValue[i]) !== undefined) {
	                            newDisplayValue.push(column.displayValues[column.values.indexOf(newValue[i])]);
	                        }
	                        else {
	                            newDisplayValue.push(newValue[i]);
	                        }
	                    }
	                }
	                else {
	                    for (i = 0; i < p.cols.length; i++) {
	                        if (!p.cols[i].divider) {
	                            newValue.push(p.cols[i].value);
	                            newDisplayValue.push(p.cols[i].displayValue);
	                        }
	                    }
	                }
	        
	                if (newValue.indexOf(undefined) >= 0) {
	                    return;
	                }
	                p.value = newValue;
	                p.displayValue = newDisplayValue;
	                if (p.params.onChange) {
	                    p.params.onChange(p, p.value, p.displayValue);
	                }
	                if (p.input && p.input.length > 0) {
	                    $(p.input).val(p.params.formatValue ? p.params.formatValue(p, p.value, p.displayValue) : p.value.join(' '));
	                    $(p.input).trigger('change');
	                }
	            };
	        
	            // Columns Handlers
	            p.initPickerCol = function (colElement, updateItems) {
	                var colContainer = $(colElement);
	                var colIndex = colContainer.index();
	                var col = p.cols[colIndex];
	                if (col.divider) return;
	                col.container = colContainer;
	                col.wrapper = col.container.find('.picker-items-col-wrapper');
	                col.items = col.wrapper.find('.picker-item');
	        
	                var i, j;
	                var wrapperHeight, itemHeight, itemsHeight, minTranslate, maxTranslate;
	                col.replaceValues = function (values, displayValues) {
	                    col.destroyEvents();
	                    col.values = values;
	                    col.displayValues = displayValues;
	                    var newItemsHTML = p.columnHTML(col, true);
	                    col.wrapper.html(newItemsHTML);
	                    col.items = col.wrapper.find('.picker-item');
	                    col.calcSize();
	                    col.setValue(col.values[0], 0, true);
	                    col.initEvents();
	                };
	                var resizeTimeout;
	                col.calcSize = function () {
	                    if (p.params.rotateEffect) {
	                        col.container.removeClass('picker-items-col-absolute');
	                        if (!col.width) col.container.css({width:''});
	                    }
	                    var colWidth, colHeight;
	                    colWidth = 0;
	                    colHeight = col.container[0].offsetHeight;
	                    wrapperHeight = col.wrapper[0].offsetHeight;
	                    itemHeight = col.items[0].offsetHeight;
	                    itemsHeight = itemHeight * col.items.length;
	                    minTranslate = colHeight / 2 - itemsHeight + itemHeight / 2;
	                    maxTranslate = colHeight / 2 - itemHeight / 2;
	                    if (col.width) {
	                        colWidth = col.width;
	                        if (parseInt(colWidth, 10) === colWidth) colWidth = colWidth + 'px';
	                        col.container.css({width: colWidth});
	                    }
	                    if (p.params.rotateEffect) {
	                        if (!col.width) {
	                            col.items.each(function () {
	                                var item = $(this).children('span');
	                                colWidth = Math.max(colWidth, item[0].offsetWidth);
	                            });
	                            col.container.css({width: (colWidth + 2) + 'px'});
	                        }
	                        col.container.addClass('picker-items-col-absolute');
	                    }
	                };
	                col.calcSize();
	        
	                col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)').transition(0);
	        
	        
	                var activeIndex = 0;
	                var animationFrameId;
	        
	                // Set Value Function
	                col.setValue = function (newValue, transition, valueCallbacks) {
	                    if (typeof transition === 'undefined') transition = '';
	                    var newActiveIndex = col.wrapper.find('.picker-item[data-picker-value="' + newValue + '"]').index();
	                    if(typeof newActiveIndex === 'undefined' || newActiveIndex === -1) {
	                        return;
	                    }
	                    var newTranslate = -newActiveIndex * itemHeight + maxTranslate;
	                    // Update wrapper
	                    col.wrapper.transition(transition);
	                    col.wrapper.transform('translate3d(0,' + (newTranslate) + 'px,0)');
	        
	                    // Watch items
	                    if (p.params.updateValuesOnMomentum && col.activeIndex && col.activeIndex !== newActiveIndex ) {
	                        $.cancelAnimationFrame(animationFrameId);
	                        col.wrapper.transitionEnd(function(){
	                            $.cancelAnimationFrame(animationFrameId);
	                        });
	                        updateDuringScroll();
	                    }
	        
	                    // Update items
	                    col.updateItems(newActiveIndex, newTranslate, transition, valueCallbacks);
	                };
	        
	                col.updateItems = function (activeIndex, translate, transition, valueCallbacks) {
	                    if (typeof translate === 'undefined') {
	                        translate = $.getTranslate(col.wrapper[0], 'y');
	                    }
	                    if(typeof activeIndex === 'undefined') activeIndex = -Math.round((translate - maxTranslate)/itemHeight);
	                    if (activeIndex < 0) activeIndex = 0;
	                    if (activeIndex >= col.items.length) activeIndex = col.items.length - 1;
	                    var previousActiveIndex = col.activeIndex;
	                    col.activeIndex = activeIndex;
	                    col.wrapper.find('.picker-selected').removeClass('picker-selected');
	        
	                    col.items.transition(transition);
	        
	                    var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
	        
	                    // Set 3D rotate effect
	                    if (p.params.rotateEffect) {
	                        var percentage = (translate - (Math.floor((translate - maxTranslate)/itemHeight) * itemHeight + maxTranslate)) / itemHeight;
	        
	                        col.items.each(function () {
	                            var item = $(this);
	                            var itemOffsetTop = item.index() * itemHeight;
	                            var translateOffset = maxTranslate - translate;
	                            var itemOffset = itemOffsetTop - translateOffset;
	                            var percentage = itemOffset / itemHeight;
	        
	                            var itemsFit = Math.ceil(col.height / itemHeight / 2) + 1;
	        
	                            var angle = (-18*percentage);
	                            if (angle > 180) angle = 180;
	                            if (angle < -180) angle = -180;
	                            // Far class
	                            if (Math.abs(percentage) > itemsFit) item.addClass('picker-item-far');
	                            else item.removeClass('picker-item-far');
	                            // Set transform
	                            item.transform('translate3d(0, ' + (-translate + maxTranslate) + 'px, ' + (originBug ? -110 : 0) + 'px) rotateX(' + angle + 'deg)');
	                        });
	                    }
	        
	                    if (valueCallbacks || typeof valueCallbacks === 'undefined') {
	                        // Update values
	                        col.value = selectedItem.attr('data-picker-value');
	                        col.displayValue = col.displayValues ? col.displayValues[activeIndex] : col.value;
	                        // On change callback
	                        if (previousActiveIndex !== activeIndex) {
	                            if (col.onChange) {
	                                col.onChange(p, col.value, col.displayValue);
	                            }
	                            p.updateValue();
	                        }
	                    }
	                };
	        
	                function updateDuringScroll() {
	                    animationFrameId = $.requestAnimationFrame(function () {
	                        col.updateItems(undefined, undefined, 0);
	                        updateDuringScroll();
	                    });
	                }
	        
	                // Update items on init
	                if (updateItems) col.updateItems(0, maxTranslate, 0);
	        
	                var allowItemClick = true;
	                var isTouched, isMoved, touchStartY, touchCurrentY, touchStartTime, touchEndTime, startTranslate, returnTo, currentTranslate, prevTranslate, velocityTranslate, velocityTime;
	                function handleTouchStart (e) {
	                    if (isMoved || isTouched) return;
	                    e.preventDefault();
	                    isTouched = true;
	                    touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = (new Date()).getTime();
	        
	                    allowItemClick = true;
	                    startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                }
	                function handleTouchMove (e) {
	                    if (!isTouched) return;
	                    e.preventDefault();
	                    allowItemClick = false;
	                    touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    if (!isMoved) {
	                        // First move
	                        $.cancelAnimationFrame(animationFrameId);
	                        isMoved = true;
	                        startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                        col.wrapper.transition(0);
	                    }
	        
	                    var diff = touchCurrentY - touchStartY;
	                    currentTranslate = startTranslate + diff;
	                    returnTo = undefined;
	        
	                    // Normalize translate
	                    if (currentTranslate < minTranslate) {
	                        currentTranslate = minTranslate - Math.pow(minTranslate - currentTranslate, 0.8);
	                        returnTo = 'min';
	                    }
	                    if (currentTranslate > maxTranslate) {
	                        currentTranslate = maxTranslate + Math.pow(currentTranslate - maxTranslate, 0.8);
	                        returnTo = 'max';
	                    }
	                    // Transform wrapper
	                    col.wrapper.transform('translate3d(0,' + currentTranslate + 'px,0)');
	        
	                    // Update items
	                    col.updateItems(undefined, currentTranslate, 0, p.params.updateValuesOnTouchmove);
	        
	                    // Calc velocity
	                    velocityTranslate = currentTranslate - prevTranslate || currentTranslate;
	                    velocityTime = (new Date()).getTime();
	                    prevTranslate = currentTranslate;
	                }
	                function handleTouchEnd (e) {
	                    if (!isTouched || !isMoved) {
	                        isTouched = isMoved = false;
	                        return;
	                    }
	                    isTouched = isMoved = false;
	                    col.wrapper.transition('');
	                    if (returnTo) {
	                        if (returnTo === 'min') {
	                            col.wrapper.transform('translate3d(0,' + minTranslate + 'px,0)');
	                        }
	                        else col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)');
	                    }
	                    touchEndTime = new Date().getTime();
	                    var velocity, newTranslate;
	                    if (touchEndTime - touchStartTime > 300) {
	                        newTranslate = currentTranslate;
	                    }
	                    else {
	                        velocity = Math.abs(velocityTranslate / (touchEndTime - velocityTime));
	                        newTranslate = currentTranslate + velocityTranslate * p.params.momentumRatio;
	                    }
	        
	                    newTranslate = Math.max(Math.min(newTranslate, maxTranslate), minTranslate);
	        
	                    // Active Index
	                    var activeIndex = -Math.floor((newTranslate - maxTranslate)/itemHeight);
	        
	                    // Normalize translate
	                    if (!p.params.freeMode) newTranslate = -activeIndex * itemHeight + maxTranslate;
	        
	                    // Transform wrapper
	                    col.wrapper.transform('translate3d(0,' + (parseInt(newTranslate,10)) + 'px,0)');
	        
	                    // Update items
	                    col.updateItems(activeIndex, newTranslate, '', true);
	        
	                    // Watch items
	                    if (p.params.updateValuesOnMomentum) {
	                        updateDuringScroll();
	                        col.wrapper.transitionEnd(function(){
	                            $.cancelAnimationFrame(animationFrameId);
	                        });
	                    }
	        
	                    // Allow click
	                    setTimeout(function () {
	                        allowItemClick = true;
	                    }, 100);
	                }
	        
	                function handleClick(e) {
	                    if (!allowItemClick) return;
	                    $.cancelAnimationFrame(animationFrameId);
	                    /*jshint validthis:true */
	                    var value = $(this).attr('data-picker-value');
	                    col.setValue(value);
	                }
	        
	                col.initEvents = function (detach) {
	                    var method = detach ? 'off' : 'on';
	                    var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	                    col.container[method](app.touchEvents.start, handleTouchStart, activeListener);
	                    col.container[method](app.touchEvents.move, handleTouchMove, activeListener);
	                    col.container[method](app.touchEvents.end, handleTouchEnd, activeListener);
	                    col.items[method]('click', handleClick);
	                };
	                col.destroyEvents = function () {
	                    col.initEvents(true);
	                };
	        
	                col.container[0].f7DestroyPickerCol = function () {
	                    col.destroyEvents();
	                };
	        
	                col.initEvents();
	        
	            };
	            p.destroyPickerCol = function (colContainer) {
	                colContainer = $(colContainer);
	                if ('f7DestroyPickerCol' in colContainer[0]) colContainer[0].f7DestroyPickerCol();
	            };
	            // Resize cols
	            function resizeCols() {
	                if (!p.opened) return;
	                for (var i = 0; i < p.cols.length; i++) {
	                    if (!p.cols[i].divider) {
	                        p.cols[i].calcSize();
	                        p.cols[i].setValue(p.cols[i].value, 0, false);
	                    }
	                }
	            }
	            app.onResize(resizeCols);
	        
	            // HTML Layout
	            p.columnHTML = function (col, onlyItems) {
	                var columnItemsHTML = '';
	                var columnHTML = '';
	                if (col.divider) {
	                    columnHTML += '<div class="picker-items-col picker-items-col-divider ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '">' + col.content + '</div>';
	                }
	                else {
	                    for (var j = 0; j < col.values.length; j++) {
	                        columnItemsHTML += '<div class="picker-item" data-picker-value="' + col.values[j] + '"><span>' + (col.displayValues ? col.displayValues[j] : col.values[j]) + '</span></div>';
	                    }
	                    columnHTML += '<div class="picker-items-col ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '"><div class="picker-items-col-wrapper">' + columnItemsHTML + '</div></div>';
	                }
	                return onlyItems ? columnItemsHTML : columnHTML;
	            };
	            p.layout = function () {
	                var pickerHTML = '';
	                var pickerClass = '';
	                var i;
	                p.cols = [];
	                var colsHTML = '';
	                for (i = 0; i < p.params.cols.length; i++) {
	                    var col = p.params.cols[i];
	                    colsHTML += p.columnHTML(p.params.cols[i]);
	                    p.cols.push(col);
	                }
	                pickerClass = 'picker-modal picker-columns ' + (p.params.cssClass || '') + (p.params.rotateEffect ? ' picker-3d' : '');
	                pickerHTML =
	                    '<div class="' + (pickerClass) + '">' +
	                        (p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '') +
	                        '<div class="picker-modal-inner picker-items">' +
	                            colsHTML +
	                            '<div class="picker-center-highlight"></div>' +
	                        '</div>' +
	                    '</div>';
	        
	                p.pickerHTML = pickerHTML;
	            };
	        
	            // Input Events
	            function openOnInput(e) {
	                e.preventDefault();
	                if (p.opened) return;
	                p.open();
	                if (p.params.scrollToInput && !isPopover()) {
	                    var pageContent = p.input.parents('.page-content');
	                    if (pageContent.length === 0) return;
	        
	                    var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                        paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                        pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
	                        pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
	                        newPaddingBottom;
	                    var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                    if (inputTop > pageHeight) {
	                        var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                        if (scrollTop + pageHeight > pageScrollHeight) {
	                            newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                            if (pageHeight === pageScrollHeight) {
	                                newPaddingBottom = p.container.height();
	                            }
	                            pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                        }
	                        pageContent.scrollTop(scrollTop, 300);
	                    }
	                }
	            }
	            function closeOnHTMLClick(e) {
	                if (inPopover()) return;
	                if (p.input && p.input.length > 0) {
	                    if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
	                }
	                else {
	                    if ($(e.target).parents('.picker-modal').length === 0) p.close();
	                }
	            }
	        
	            if (p.params.input) {
	                p.input = $(p.params.input);
	                if (p.input.length > 0) {
	                    if (p.params.inputReadOnly) p.input.prop('readOnly', true);
	                    if (!p.inline) {
	                        p.input.on('click', openOnInput);
	                    }
	                    if (p.params.inputReadOnly) {
	                        p.input.on('focus mousedown', function (e) {
	                            e.preventDefault();
	                        });
	                    }
	                }
	        
	            }
	        
	            if (!p.inline && p.params.closeByOutsideClick) $('html').on('click', closeOnHTMLClick);
	        
	            // Open
	            function onPickerClose() {
	                p.opened = false;
	                if (p.input && p.input.length > 0) {
	                    p.input.parents('.page-content').css({'padding-bottom': ''});
	                    if (app.params.material) p.input.trigger('blur');
	                }
	                if (p.params.onClose) p.params.onClose(p);
	        
	                // Destroy events
	                p.container.find('.picker-items-col').each(function () {
	                    p.destroyPickerCol(this);
	                });
	            }
	        
	            p.opened = false;
	            p.open = function () {
	                var toPopover = isPopover();
	        
	                if (!p.opened) {
	        
	                    // Layout
	                    p.layout();
	        
	                    // Append
	                    if (toPopover) {
	                        p.pickerHTML = '<div class="popover popover-picker-columns"><div class="popover-inner">' + p.pickerHTML + '</div></div>';
	                        p.popover = app.popover(p.pickerHTML, p.params.input, true);
	                        p.container = $(p.popover).find('.picker-modal');
	                        $(p.popover).on('popover:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    else if (p.inline) {
	                        p.container = $(p.pickerHTML);
	                        p.container.addClass('picker-modal-inline');
	                        $(p.params.container).append(p.container);
	                    }
	                    else {
	                        p.container = $(app.pickerModal(p.pickerHTML));
	                        $(p.container)
	                        .on('picker:close', function () {
	                            onPickerClose();
	                        });
	                    }
	        
	                    // Store picker instance
	                    p.container[0].f7Picker = p;
	        
	                    // Init Events
	                    p.container.find('.picker-items-col').each(function () {
	                        var updateItems = true;
	                        if ((!p.initialized && p.params.value) || (p.initialized && p.value)) updateItems = false;
	                        p.initPickerCol(this, updateItems);
	                    });
	        
	                    // Set value
	                    if (!p.initialized) {
	                        if (p.value) p.setValue(p.value, 0);
	                        else if (p.params.value) {
	                            p.setValue(p.params.value, 0);
	                        }
	                    }
	                    else {
	                        if (p.value) p.setValue(p.value, 0);
	                    }
	        
	                    // Material Focus
	                    if (p.input && p.input.length > 0 && app.params.material) {
	                        p.input.trigger('focus');
	                    }
	                }
	        
	                // Set flag
	                p.opened = true;
	                p.initialized = true;
	        
	                if (p.params.onOpen) p.params.onOpen(p);
	            };
	        
	            // Close
	            p.close = function () {
	                if (!p.opened || p.inline) return;
	                if (inPopover()) {
	                    app.closeModal(p.popover);
	                    return;
	                }
	                else {
	                    app.closeModal(p.container);
	                    return;
	                }
	            };
	        
	            // Destroy
	            p.destroy = function () {
	                p.close();
	                if (p.params.input && p.input.length > 0) {
	                    p.input.off('click focus', openOnInput);
	                }
	                $('html').off('click', closeOnHTMLClick);
	                app.offResize(resizeCols);
	            };
	        
	            if (p.inline) {
	                p.open();
	            }
	            else {
	                if (!p.initialized && p.params.value) p.setValue(p.params.value);
	            }
	        
	            return p;
	        };
	        app.picker = function (params) {
	            return new Picker(params);
	        };
	        
	
	        /*======================================================
	        ************   Calendar   ************
	        ======================================================*/
	        var Calendar = function (params) {
	            var p = this;
	            var defaults = {
	                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August' , 'September' , 'October', 'November', 'December'],
	                monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	                firstDay: 1, // First day of the week, Monday
	                weekendDays: [0, 6], // Sunday and Saturday
	                multiple: false,
	                rangePicker: false,
	                dateFormat: 'yyyy-mm-dd',
	                direction: 'horizontal', // or 'vertical'
	                minDate: null,
	                maxDate: null,
	                disabled: null, // dates range of disabled days
	                events: null, // dates range of days with events
	                rangesClasses: null, //array with custom classes date ranges
	                touchMove: true,
	                animate: true,
	                closeOnSelect: false,
	                monthPicker: true,
	                monthPickerTemplate:
	                    '<div class="picker-calendar-month-picker">' +
	                        '<a href="#" class="link icon-only picker-calendar-prev-month"><i class="icon icon-prev"></i></a>' +
	                        '<span class="current-month-value"></span>' +
	                        '<a href="#" class="link icon-only picker-calendar-next-month"><i class="icon icon-next"></i></a>' +
	                    '</div>',
	                yearPicker: true,
	                yearPickerTemplate:
	                    '<div class="picker-calendar-year-picker">' +
	                        '<a href="#" class="link icon-only picker-calendar-prev-year"><i class="icon icon-prev"></i></a>' +
	                        '<span class="current-year-value"></span>' +
	                        '<a href="#" class="link icon-only picker-calendar-next-year"><i class="icon icon-next"></i></a>' +
	                    '</div>',
	                weekHeader: true,
	                // Common settings
	                closeByOutsideClick: true,
	                scrollToInput: true,
	                inputReadOnly: true,
	                convertToPopover: true,
	                onlyInPopover: false,
	                toolbar: true,
	                toolbarCloseText: 'Done',
	                headerPlaceholder: 'Select date',
	                header: app.params.material,
	                footer: app.params.material,
	                toolbarTemplate:
	                    '<div class="toolbar">' +
	                        '<div class="toolbar-inner">' +
	                            '{{monthPicker}}' +
	                            '{{yearPicker}}' +
	                        '</div>' +
	                    '</div>',
	                headerTemplate:
	                    '<div class="picker-header">' +
	                        '<div class="picker-calendar-selected-date">{{placeholder}}</div>' +
	                    '</div>',
	                footerTemplate:
	                    '<div class="picker-footer">' +
	                        '<a href="#" class="button close-picker">{{closeText}}</a>' +
	                    '</div>',
	        
	                /* Callbacks
	                onMonthAdd
	                onChange
	                onOpen
	                onClose
	                onDayClick
	                onMonthYearChangeStart
	                onMonthYearChangeEnd
	                */
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            p.params = params;
	            p.initialized = false;
	        
	            // Inline flag
	            p.inline = p.params.container ? true : false;
	        
	            // Is horizontal
	            p.isH = p.params.direction === 'horizontal';
	        
	            // RTL inverter
	            var inverter = p.isH ? (app.rtl ? -1 : 1) : 1;
	        
	            // Animating flag
	            p.animating = false;
	        
	            // Should be converted to popover
	            function isPopover() {
	                var toPopover = false;
	                if (!p.params.convertToPopover && !p.params.onlyInPopover) return toPopover;
	                if (!p.inline && p.params.input) {
	                    if (p.params.onlyInPopover) toPopover = true;
	                    else {
	                        if (app.device.ios) {
	                            toPopover = app.device.ipad ? true : false;
	                        }
	                        else {
	                            if (app.width >= 768) toPopover = true;
	                        }
	                    }
	                }
	                return toPopover;
	            }
	            function inPopover() {
	                if (p.opened && p.container && p.container.length > 0 && p.container.parents('.popover').length > 0) return true;
	                else return false;
	            }
	        
	            // Format date
	            function formatDate(date) {
	                date = new Date(date);
	                var year = date.getFullYear();
	                var month = date.getMonth();
	                var month1 = month + 1;
	                var day = date.getDate();
	                var weekDay = date.getDay();
	        
	                return p.params.dateFormat
	                    .replace(/yyyy/g, year)
	                    .replace(/yy/g, (year + '').substring(2))
	                    .replace(/mm/g, month1 < 10 ? '0' + month1 : month1)
	                    .replace(/m(\W+)/g, month1 + '$1')
	                    .replace(/MM/g, p.params.monthNames[month])
	                    .replace(/M(\W+)/g, p.params.monthNamesShort[month] + '$1')
	                    .replace(/dd/g, day < 10 ? '0' + day : day)
	                    .replace(/d(\W+)/g, day + '$1')
	                    .replace(/DD/g, p.params.dayNames[weekDay])
	                    .replace(/D(\W+)/g, p.params.dayNamesShort[weekDay] + '$1');
	            }
	        
	        
	            // Value
	            p.addValue = function (value) {
	                if (p.params.multiple) {
	                    if (!p.value) p.value = [];
	                    var inValuesIndex;
	                    for (var i = 0; i < p.value.length; i++) {
	                        if (new Date(value).getTime() === new Date(p.value[i]).getTime()) {
	                            inValuesIndex = i;
	                        }
	                    }
	                    if (typeof inValuesIndex === 'undefined') {
	                        p.value.push(value);
	                    }
	                    else {
	                        p.value.splice(inValuesIndex, 1);
	                    }
	                    p.updateValue();
	                }
	                else if (p.params.rangePicker) {
	                    if (!p.value) p.value = [];
	                    if (p.value.length === 2 || p.value.length === 0) {
	                        p.value = [];
	                    }
	                    if (p.value[0] !== value) p.value.push(value);
	                    else p.value = [];
	                    p.value.sort(function (a,b) {
	                        return a - b;
	                    });
	                    p.updateValue();
	                }
	                else {
	                    p.value = [value];
	                    p.updateValue();
	                }
	            };
	            p.setValue = function (arrValues) {
	                p.value = arrValues;
	                p.updateValue();
	            };
	            p.updateValue = function (onlyHeader) {
	                var i, inputValue;
	                if (p.container && p.container.length > 0) {
	                    p.wrapper.find('.picker-calendar-day-selected').removeClass('picker-calendar-day-selected');
	                    var valueDate;
	                    if (p.params.rangePicker && p.value.length === 2) {
	                        for (i = p.value[0]; i <= p.value[1]; i += 24*60*60*1000) {
	                            valueDate = new Date(i);
	                            p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
	                        }
	                    }
	                    else {
	                        for (i = 0; i < p.value.length; i++) {
	                            valueDate = new Date(p.value[i]);
	                            p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
	                        }
	                    }
	                }
	        
	                if (p.params.onChange) {
	                    p.params.onChange(p, p.value);
	                }
	                if ((p.input && p.input.length > 0) || (app.params.material && p.params.header)) {
	                    if (p.params.formatValue) inputValue = p.params.formatValue(p, p.value);
	                    else {
	                        inputValue = [];
	                        for (i = 0; i < p.value.length; i++) {
	                            inputValue.push(formatDate(p.value[i]));
	                        }
	                        inputValue = inputValue.join(p.params.rangePicker ? ' - ' : ', ');
	                    }
	                    if (app.params.material && p.params.header && p.container && p.container.length > 0) {
	                        p.container.find('.picker-calendar-selected-date').text(inputValue);
	                    }
	                    if (p.input && p.input.length > 0 && !onlyHeader) {
	                        $(p.input).val(inputValue);
	                        $(p.input).trigger('change');
	                    }
	        
	                }
	            };
	        
	            // Columns Handlers
	            p.initCalendarEvents = function () {
	                var col;
	                var allowItemClick = true;
	                var isTouched, isMoved, touchStartX, touchStartY, touchCurrentX, touchCurrentY, touchStartTime, touchEndTime, startTranslate, currentTranslate, wrapperWidth, wrapperHeight, percentage, touchesDiff, isScrolling;
	                function handleTouchStart (e) {
	                    if (isMoved || isTouched) return;
	                    // e.preventDefault();
	                    isTouched = true;
	                    touchStartX = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                    touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = (new Date()).getTime();
	                    percentage = 0;
	                    allowItemClick = true;
	                    isScrolling = undefined;
	                    startTranslate = currentTranslate = p.monthsTranslate;
	                }
	                function handleTouchMove (e) {
	                    if (!isTouched) return;
	        
	                    touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    if (typeof isScrolling === 'undefined') {
	                        isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
	                    }
	                    if (p.isH && isScrolling) {
	                        isTouched = false;
	                        return;
	                    }
	                    e.preventDefault();
	                    if (p.animating) {
	                        isTouched = false;
	                        return;
	                    }
	                    allowItemClick = false;
	                    if (!isMoved) {
	                        // First move
	                        isMoved = true;
	                        wrapperWidth = p.wrapper[0].offsetWidth;
	                        wrapperHeight = p.wrapper[0].offsetHeight;
	                        p.wrapper.transition(0);
	                    }
	        
	                    touchesDiff = p.isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
	                    percentage = touchesDiff/(p.isH ? wrapperWidth : wrapperHeight);
	                    currentTranslate = (p.monthsTranslate * inverter + percentage) * 100;
	        
	                    // Transform wrapper
	                    p.wrapper.transform('translate3d(' + (p.isH ? currentTranslate : 0) + '%, ' + (p.isH ? 0 : currentTranslate) + '%, 0)');
	        
	                }
	                function handleTouchEnd (e) {
	                    if (!isTouched || !isMoved) {
	                        isTouched = isMoved = false;
	                        return;
	                    }
	                    isTouched = isMoved = false;
	        
	                    touchEndTime = new Date().getTime();
	                    if (touchEndTime - touchStartTime < 300) {
	                        if (Math.abs(touchesDiff) < 10) {
	                            p.resetMonth();
	                        }
	                        else if (touchesDiff >= 10) {
	                            if (app.rtl) p.nextMonth();
	                            else p.prevMonth();
	                        }
	                        else {
	                            if (app.rtl) p.prevMonth();
	                            else p.nextMonth();
	                        }
	                    }
	                    else {
	                        if (percentage <= -0.5) {
	                            if (app.rtl) p.prevMonth();
	                            else p.nextMonth();
	                        }
	                        else if (percentage >= 0.5) {
	                            if (app.rtl) p.nextMonth();
	                            else p.prevMonth();
	                        }
	                        else {
	                            p.resetMonth();
	                        }
	                    }
	        
	                    // Allow click
	                    setTimeout(function () {
	                        allowItemClick = true;
	                    }, 100);
	                }
	        
	                function handleDayClick(e) {
	                    if (!allowItemClick) return;
	                    var day = $(e.target).parents('.picker-calendar-day');
	                    if (day.length === 0 && $(e.target).hasClass('picker-calendar-day')) {
	                        day = $(e.target);
	                    }
	                    if (day.length === 0) return;
	                    if (day.hasClass('picker-calendar-day-disabled')) return;
	                    if (!p.params.rangePicker) {
	                        if (day.hasClass('picker-calendar-day-next')) p.nextMonth();
	                        if (day.hasClass('picker-calendar-day-prev')) p.prevMonth();
	                    }
	                    var dateYear = day.attr('data-year');
	                    var dateMonth = day.attr('data-month');
	                    var dateDay = day.attr('data-day');
	                    if (p.params.onDayClick) {
	                        p.params.onDayClick(p, day[0], dateYear, dateMonth, dateDay);
	                    }
	                    if (!day.hasClass('picker-calendar-day-selected') || p.params.multiple || p.params.rangePicker) {
	                        p.addValue(Date.UTC(dateYear, dateMonth, dateDay,0,0,0));
	                    }
	                    if (p.params.closeOnSelect) {
	                        if (p.params.rangePicker && p.value.length === 2 || !p.params.rangePicker) p.close();
	                    }
	                }
	        
	                p.container.find('.picker-calendar-prev-month').on('click', p.prevMonth);
	                p.container.find('.picker-calendar-next-month').on('click', p.nextMonth);
	                p.container.find('.picker-calendar-prev-year').on('click', p.prevYear);
	                p.container.find('.picker-calendar-next-year').on('click', p.nextYear);
	                p.wrapper.on('click', handleDayClick);
	                var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? {passive: true, capture: false} : false;
	                var activeListener = app.support.passiveListener ? {passive: false, capture: false} : false;
	                if (p.params.touchMove) {
	                    p.wrapper.on(app.touchEvents.start, handleTouchStart, passiveListener);
	                    p.wrapper.on(app.touchEvents.move, handleTouchMove, activeListener);
	                    p.wrapper.on(app.touchEvents.end, handleTouchEnd, passiveListener);
	                }
	        
	                p.container[0].f7DestroyCalendarEvents = function () {
	                    p.container.find('.picker-calendar-prev-month').off('click', p.prevMonth);
	                    p.container.find('.picker-calendar-next-month').off('click', p.nextMonth);
	                    p.container.find('.picker-calendar-prev-year').off('click', p.prevYear);
	                    p.container.find('.picker-calendar-next-year').off('click', p.nextYear);
	                    p.wrapper.off('click', handleDayClick);
	                    if (p.params.touchMove) {
	                        p.wrapper.off(app.touchEvents.start, handleTouchStart, passiveListener);
	                        p.wrapper.off(app.touchEvents.move, handleTouchMove, activeListener);
	                        p.wrapper.off(app.touchEvents.end, handleTouchEnd, passiveListener);
	                    }
	                };
	        
	        
	            };
	            p.destroyCalendarEvents = function (colContainer) {
	                if ('f7DestroyCalendarEvents' in p.container[0]) p.container[0].f7DestroyCalendarEvents();
	            };
	        
	            // Scan Dates Range
	            p.dateInRange = function (dayDate, range) {
	                var match = false;
	                var i;
	                if (!range) return false;
	                if (Array.isArray(range)) {
	                    for (i = 0; i < range.length; i ++) {
	                        if (range[i].from || range[i].to) {
	                            if (range[i].from && range[i].to) {
	                                if ((dayDate <= new Date(range[i].to).getTime()) && (dayDate >= new Date(range[i].from).getTime())) {
	                                    match = true;
	                                }
	                            }
	                            else if (range[i].from) {
	                                if (dayDate >= new Date(range[i].from).getTime()) {
	                                    match = true;
	                                }
	                            }
	                            else if (range[i].to) {
	                                if (dayDate <= new Date(range[i].to).getTime()) {
	                                    match = true;
	                                }
	                            }
	                        } else if (dayDate === new Date(range[i]).getTime()) {
	                            match = true;
	                        }
	                    }
	                }
	                else if (range.from || range.to) {
	                    if (range.from && range.to) {
	                        if ((dayDate <= new Date(range.to).getTime()) && (dayDate >= new Date(range.from).getTime())) {
	                            match = true;
	                        }
	                    }
	                    else if (range.from) {
	                        if (dayDate >= new Date(range.from).getTime()) {
	                            match = true;
	                        }
	                    }
	                    else if (range.to) {
	                        if (dayDate <= new Date(range.to).getTime()) {
	                            match = true;
	                        }
	                    }
	                }
	                else if (typeof range === 'function') {
	                    match = range(new Date(dayDate));
	                }
	                return match;
	            };
	            // Calendar Methods
	            p.daysInMonth = function (date) {
	                var d = new Date(date);
	                return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
	            };
	            p.monthHTML = function (date, offset) {
	                date = new Date(date);
	                var year = date.getFullYear(),
	                    month = date.getMonth(),
	                    day = date.getDate();
	                if (offset === 'next') {
	                    if (month === 11) date = new Date(year + 1, 0);
	                    else date = new Date(year, month + 1, 1);
	                }
	                if (offset === 'prev') {
	                    if (month === 0) date = new Date(year - 1, 11);
	                    else date = new Date(year, month - 1, 1);
	                }
	                if (offset === 'next' || offset === 'prev') {
	                    month = date.getMonth();
	                    year = date.getFullYear();
	                }
	                var daysInPrevMonth = p.daysInMonth(new Date(date.getFullYear(), date.getMonth()).getTime() - 10 * 24 * 60 * 60 * 1000),
	                    daysInMonth = p.daysInMonth(date),
	                    firstDayOfMonthIndex = new Date(date.getFullYear(), date.getMonth()).getDay();
	                if (firstDayOfMonthIndex === 0) firstDayOfMonthIndex = 7;
	        
	                var dayDate, currentValues = [], i, j, k,
	                    rows = 6, cols = 7,
	                    monthHTML = '',
	                    dayIndex = 0 + (p.params.firstDay - 1),
	                    today = new Date().setHours(0,0,0,0),
	                    minDate = p.params.minDate ? new Date(p.params.minDate).getTime() : null,
	                    maxDate = p.params.maxDate ? new Date(p.params.maxDate).getTime() : null,
	                    disabled,
	                    hasEvent;
	        
	                if (p.value && p.value.length) {
	                    for (i = 0; i < p.value.length; i++) {
	                        currentValues.push(new Date(p.value[i]).setHours(0,0,0,0));
	                    }
	                }
	        
	                for (i = 1; i <= rows; i++) {
	                    var rowHTML = '';
	                    var row = i;
	                    for (j = 1; j <= cols; j++) {
	                        var col = j;
	                        dayIndex ++;
	                        var dayNumber = dayIndex - firstDayOfMonthIndex;
	                        var weekDayIndex = (col - 1 + p.params.firstDay > 6) ? (col - 1 - 7 + p.params.firstDay) : (col - 1 + p.params.firstDay);
	                        var addClass = '';
	                        if (dayNumber < 0) {
	                            dayNumber = daysInPrevMonth + dayNumber + 1;
	                            addClass += ' picker-calendar-day-prev';
	                            dayDate = new Date(month - 1 < 0 ? year - 1 : year, month - 1 < 0 ? 11 : month - 1, dayNumber).getTime();
	                        }
	                        else {
	                            dayNumber = dayNumber + 1;
	                            if (dayNumber > daysInMonth) {
	                                dayNumber = dayNumber - daysInMonth;
	                                addClass += ' picker-calendar-day-next';
	                                dayDate = new Date(month + 1 > 11 ? year + 1 : year, month + 1 > 11 ? 0 : month + 1, dayNumber).getTime();
	                            }
	                            else {
	                                dayDate = new Date(year, month, dayNumber).getTime();
	                            }
	                        }
	                        // Today
	                        if (dayDate === today) addClass += ' picker-calendar-day-today';
	                        // Selected
	                        if (p.params.rangePicker && currentValues.length === 2) {
	                            if (dayDate >= currentValues[0] && dayDate <= currentValues[1]) addClass += ' picker-calendar-day-selected';
	                        }
	                        else {
	                            if (currentValues.indexOf(dayDate) >= 0) addClass += ' picker-calendar-day-selected';
	                        }
	                        // Weekend
	                        if (p.params.weekendDays.indexOf(weekDayIndex) >= 0) {
	                            addClass += ' picker-calendar-day-weekend';
	                        }
	                        // Has Events
	                        hasEvent = false;
	                        if (p.params.events) {
	                            if (p.dateInRange(dayDate, p.params.events)) {
	                                hasEvent = true;
	                            }
	                        }
	                        if (hasEvent) {
	                            addClass += ' picker-calendar-day-has-events';
	                        }
	                        // Custom Ranges
	                        if (p.params.rangesClasses) {
	                            for (k = 0; k < p.params.rangesClasses.length; k++) {
	                                if (p.dateInRange(dayDate, p.params.rangesClasses[k].range)) {
	                                    addClass += ' ' + p.params.rangesClasses[k].cssClass;
	                                }
	                            }
	                        }
	                        // Disabled
	                        disabled = false;
	                        if ((minDate && dayDate < minDate) || (maxDate && dayDate > maxDate)) {
	                            disabled = true;
	                        }
	                        if (p.params.disabled) {
	                            if (p.dateInRange(dayDate, p.params.disabled)) {
	                                disabled = true;
	                            }
	                        }
	                        if (disabled) {
	                            addClass += ' picker-calendar-day-disabled';
	                        }
	        
	        
	                        dayDate = new Date(dayDate);
	                        var dayYear = dayDate.getFullYear();
	                        var dayMonth = dayDate.getMonth();
	                        rowHTML += '<div data-year="' + dayYear + '" data-month="' + dayMonth + '" data-day="' + dayNumber + '" class="picker-calendar-day' + (addClass) + '" data-date="' + (dayYear + '-' + dayMonth + '-' + dayNumber) + '"><span>'+dayNumber+'</span></div>';
	                    }
	                    monthHTML += '<div class="picker-calendar-row">' + rowHTML + '</div>';
	                }
	                monthHTML = '<div class="picker-calendar-month" data-year="' + year + '" data-month="' + month + '">' + monthHTML + '</div>';
	                return monthHTML;
	            };
	            p.animating = false;
	            p.updateCurrentMonthYear = function (dir) {
	                if (typeof dir === 'undefined') {
	                    p.currentMonth = parseInt(p.months.eq(1).attr('data-month'), 10);
	                    p.currentYear = parseInt(p.months.eq(1).attr('data-year'), 10);
	                }
	                else {
	                    p.currentMonth = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-month'), 10);
	                    p.currentYear = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-year'), 10);
	                }
	                p.container.find('.current-month-value').text(p.params.monthNames[p.currentMonth]);
	                p.container.find('.current-year-value').text(p.currentYear);
	        
	            };
	            p.onMonthChangeStart = function (dir) {
	                p.updateCurrentMonthYear(dir);
	                p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	                var currentIndex = dir === 'next' ? p.months.length - 1 : 0;
	        
	                p.months.eq(currentIndex).addClass('picker-calendar-month-current');
	                p.months.eq(dir === 'next' ? currentIndex - 1 : currentIndex + 1).addClass(dir === 'next' ? 'picker-calendar-month-prev' : 'picker-calendar-month-next');
	        
	                if (p.params.onMonthYearChangeStart) {
	                    p.params.onMonthYearChangeStart(p, p.currentYear, p.currentMonth);
	                }
	            };
	            p.onMonthChangeEnd = function (dir, rebuildBoth) {
	                p.animating = false;
	                var nextMonthHTML, prevMonthHTML, newMonthHTML;
	                p.wrapper.find('.picker-calendar-month:not(.picker-calendar-month-prev):not(.picker-calendar-month-current):not(.picker-calendar-month-next)').remove();
	        
	                if (typeof dir === 'undefined') {
	                    dir = 'next';
	                    rebuildBoth = true;
	                }
	                if (!rebuildBoth) {
	                    newMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), dir);
	                }
	                else {
	                    p.wrapper.find('.picker-calendar-month-next, .picker-calendar-month-prev').remove();
	                    prevMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'prev');
	                    nextMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'next');
	                }
	                if (dir === 'next' || rebuildBoth) {
	                    p.wrapper.append(newMonthHTML || nextMonthHTML);
	                }
	                if (dir === 'prev' || rebuildBoth) {
	                    p.wrapper.prepend(newMonthHTML || prevMonthHTML);
	                }
	                p.months = p.wrapper.find('.picker-calendar-month');
	                p.setMonthsTranslate(p.monthsTranslate);
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	                }
	                if (p.params.onMonthYearChangeEnd) {
	                    p.params.onMonthYearChangeEnd(p, p.currentYear, p.currentMonth);
	                }
	            };
	            p.setMonthsTranslate = function (translate) {
	                translate = translate || p.monthsTranslate || 0;
	                if (typeof p.monthsTranslate === 'undefined') p.monthsTranslate = translate;
	                p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	                var prevMonthTranslate = -(translate + 1) * 100 * inverter;
	                var currentMonthTranslate = -translate * 100 * inverter;
	                var nextMonthTranslate = -(translate - 1) * 100 * inverter;
	                p.months.eq(0).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                p.months.eq(1).transform('translate3d(' + (p.isH ? currentMonthTranslate : 0) + '%, ' + (p.isH ? 0 : currentMonthTranslate) + '%, 0)').addClass('picker-calendar-month-current');
	                p.months.eq(2).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	            };
	            p.nextMonth = function (transition) {
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate) transition = 0;
	                }
	                var nextMonth = parseInt(p.months.eq(p.months.length - 1).attr('data-month'), 10);
	                var nextYear = parseInt(p.months.eq(p.months.length - 1).attr('data-year'), 10);
	                var nextDate = new Date(nextYear, nextMonth);
	                var nextDateTime = nextDate.getTime();
	                var transitionEndCallback = p.animating ? false : true;
	                if (p.params.maxDate) {
	                    if (nextDateTime > new Date(p.params.maxDate).getTime()) {
	                        return p.resetMonth();
	                    }
	                }
	                p.monthsTranslate --;
	                if (nextMonth === p.currentMonth) {
	                    var nextMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                    var nextMonthHTML = $(p.monthHTML(nextDateTime, 'next')).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	                    p.wrapper.append(nextMonthHTML[0]);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    if (p.params.onMonthAdd) {
	                        p.params.onMonthAdd(p, p.months.eq(p.months.length - 1)[0]);
	                    }
	                }
	                p.animating = true;
	                p.onMonthChangeStart('next');
	                var translate = (p.monthsTranslate * 100) * inverter;
	        
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	                if (transitionEndCallback) {
	                    p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd('next');
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd('next');
	                }
	            };
	            p.prevMonth = function (transition) {
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate) transition = 0;
	                }
	                var prevMonth = parseInt(p.months.eq(0).attr('data-month'), 10);
	                var prevYear = parseInt(p.months.eq(0).attr('data-year'), 10);
	                var prevDate = new Date(prevYear, prevMonth + 1, -1);
	                var prevDateTime = prevDate.getTime();
	                var transitionEndCallback = p.animating ? false : true;
	                if (p.params.minDate) {
	                    if (prevDateTime < new Date(p.params.minDate).getTime()) {
	                        return p.resetMonth();
	                    }
	                }
	                p.monthsTranslate ++;
	                if (prevMonth === p.currentMonth) {
	                    var prevMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                    var prevMonthHTML = $(p.monthHTML(prevDateTime, 'prev')).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                    p.wrapper.prepend(prevMonthHTML[0]);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    if (p.params.onMonthAdd) {
	                        p.params.onMonthAdd(p, p.months.eq(0)[0]);
	                    }
	                }
	                p.animating = true;
	                p.onMonthChangeStart('prev');
	                var translate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	                if (transitionEndCallback) {
	                    p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd('prev');
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd('prev');
	                }
	            };
	            p.resetMonth = function (transition) {
	                if (typeof transition === 'undefined') transition = '';
	                var translate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	            };
	            p.setYearMonth = function (year, month, transition) {
	                if (typeof year === 'undefined') year = p.currentYear;
	                if (typeof month === 'undefined') month = p.currentMonth;
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate) transition = 0;
	                }
	                var targetDate;
	                if (year < p.currentYear) {
	                    targetDate = new Date(year, month + 1, -1).getTime();
	                }
	                else {
	                    targetDate = new Date(year, month).getTime();
	                }
	                if (p.params.maxDate && targetDate > new Date(p.params.maxDate).getTime()) {
	                    return false;
	                }
	                if (p.params.minDate && targetDate < new Date(p.params.minDate).getTime()) {
	                    return false;
	                }
	                var currentDate = new Date(p.currentYear, p.currentMonth).getTime();
	                var dir = targetDate > currentDate ? 'next' : 'prev';
	                var newMonthHTML = p.monthHTML(new Date(year, month));
	                p.monthsTranslate = p.monthsTranslate || 0;
	                var prevTranslate = p.monthsTranslate;
	                var monthTranslate, wrapperTranslate;
	                var transitionEndCallback = p.animating ? false : true;
	                if (targetDate > currentDate) {
	                    // To next
	                    p.monthsTranslate --;
	                    if (!p.animating) p.months.eq(p.months.length - 1).remove();
	                    p.wrapper.append(newMonthHTML);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    monthTranslate = -(prevTranslate - 1) * 100 * inverter;
	                    p.months.eq(p.months.length - 1).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	                }
	                else {
	                    // To prev
	                    p.monthsTranslate ++;
	                    if (!p.animating) p.months.eq(0).remove();
	                    p.wrapper.prepend(newMonthHTML);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    monthTranslate = -(prevTranslate + 1) * 100 * inverter;
	                    p.months.eq(0).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                }
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	                }
	                p.animating = true;
	                p.onMonthChangeStart(dir);
	                wrapperTranslate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? wrapperTranslate : 0) + '%, ' + (p.isH ? 0 : wrapperTranslate) + '%, 0)');
	                if (transitionEndCallback) {
	                   p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd(dir, true);
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd(dir);
	                }
	            };
	            p.nextYear = function () {
	                p.setYearMonth(p.currentYear + 1);
	            };
	            p.prevYear = function () {
	                p.setYearMonth(p.currentYear - 1);
	            };
	        
	        
	            // HTML Layout
	            p.layout = function () {
	                var pickerHTML = '';
	                var pickerClass = '';
	                var i;
	        
	                var layoutDate = p.value && p.value.length ? p.value[0] : new Date().setHours(0,0,0,0);
	                var prevMonthHTML = p.monthHTML(layoutDate, 'prev');
	                var currentMonthHTML = p.monthHTML(layoutDate);
	                var nextMonthHTML = p.monthHTML(layoutDate, 'next');
	                var monthsHTML = '<div class="picker-calendar-months"><div class="picker-calendar-months-wrapper">' + (prevMonthHTML + currentMonthHTML + nextMonthHTML) + '</div></div>';
	                // Week days header
	                var weekHeaderHTML = '';
	                if (p.params.weekHeader) {
	                    for (i = 0; i < 7; i++) {
	                        var weekDayIndex = (i + p.params.firstDay > 6) ? (i - 7 + p.params.firstDay) : (i + p.params.firstDay);
	                        var dayName = p.params.dayNamesShort[weekDayIndex];
	                        weekHeaderHTML += '<div class="picker-calendar-week-day ' + ((p.params.weekendDays.indexOf(weekDayIndex) >= 0) ? 'picker-calendar-week-day-weekend' : '') + '"> ' + dayName + '</div>';
	        
	                    }
	                    weekHeaderHTML = '<div class="picker-calendar-week-days">' + weekHeaderHTML + '</div>';
	                }
	                pickerClass = 'picker-modal picker-calendar' +
	                            (p.params.rangePicker ? ' picker-calendar-range' : '') +
	                            (p.params.cssClass ? ' ' + p.params.cssClass : '');
	                var toolbarHTML = p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
	                if (p.params.toolbar) {
	                    toolbarHTML = p.params.toolbarTemplate
	                        .replace(/{{closeText}}/g, p.params.toolbarCloseText)
	                        .replace(/{{monthPicker}}/g, (p.params.monthPicker ? p.params.monthPickerTemplate : ''))
	                        .replace(/{{yearPicker}}/g, (p.params.yearPicker ? p.params.yearPickerTemplate : ''));
	                }
	                var headerHTML = p.params.header ? p.params.headerTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText).replace(/{{placeholder}}/g, p.params.headerPlaceholder) : '';
	                var footerHTML = p.params.footer ? p.params.footerTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
	        
	                pickerHTML =
	                    '<div class="' + (pickerClass) + '">' +
	                        headerHTML +
	                        footerHTML +
	                        toolbarHTML +
	                        '<div class="picker-modal-inner">' +
	                            weekHeaderHTML +
	                            monthsHTML +
	                        '</div>' +
	                    '</div>';
	        
	        
	                p.pickerHTML = pickerHTML;
	            };
	        
	            // Input Events
	            function openOnInput(e) {
	                e.preventDefault();
	                if (p.opened) return;
	                p.open();
	                if (p.params.scrollToInput && !isPopover() && !app.params.material) {
	                    var pageContent = p.input.parents('.page-content');
	                    if (pageContent.length === 0) return;
	        
	                    var paddingTop = parseInt(pageContent.css('padding-top'), 10),
	                        paddingBottom = parseInt(pageContent.css('padding-bottom'), 10),
	                        pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(),
	                        pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(),
	                        newPaddingBottom;
	        
	                    var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                    if (inputTop > pageHeight) {
	                        var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                        if (scrollTop + pageHeight > pageScrollHeight) {
	                            newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                            if (pageHeight === pageScrollHeight) {
	                                newPaddingBottom = p.container.height();
	                            }
	                            pageContent.css({'padding-bottom': (newPaddingBottom) + 'px'});
	                        }
	                        pageContent.scrollTop(scrollTop, 300);
	                    }
	                }
	            }
	            function closeOnHTMLClick(e) {
	                if (inPopover()) return;
	                if (p.input && p.input.length > 0) {
	                    if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0) p.close();
	                }
	                else {
	                    if ($(e.target).parents('.picker-modal').length === 0) p.close();
	                }
	            }
	        
	            if (p.params.input) {
	                p.input = $(p.params.input);
	                if (p.input.length > 0) {
	                    if (p.params.inputReadOnly) p.input.prop('readOnly', true);
	                    if (!p.inline) {
	                        p.input.on('click', openOnInput);
	                    }
	                    if (p.params.inputReadOnly) {
	                        p.input.on('focus mousedown', function (e) {
	                            e.preventDefault();
	                        });
	                    }
	                }
	        
	            }
	        
	            if (!p.inline && p.params.closeByOutsideClick) $('html').on('click', closeOnHTMLClick);
	        
	            // Open
	            function onPickerClose() {
	                p.opened = false;
	                if (p.input && p.input.length > 0) {
	                    p.input.parents('.page-content').css({'padding-bottom': ''});
	                    if (app.params.material) p.input.trigger('blur');
	                }
	                if (p.params.onClose) p.params.onClose(p);
	        
	                // Destroy events
	                p.destroyCalendarEvents();
	            }
	        
	            p.opened = false;
	            p.open = function () {
	                var toPopover = isPopover();
	                var updateValue = false;
	                if (!p.opened) {
	                    // Set date value
	                    if (!p.value) {
	                        if (p.params.value) {
	                            p.value = p.params.value;
	                            updateValue = true;
	                        }
	                    }
	        
	                    // Layout
	                    p.layout();
	        
	                    // Append
	                    if (toPopover) {
	                        p.pickerHTML = '<div class="popover popover-picker-calendar"><div class="popover-inner">' + p.pickerHTML + '</div></div>';
	                        p.popover = app.popover(p.pickerHTML, p.params.input, true);
	                        p.container = $(p.popover).find('.picker-modal');
	                        $(p.popover).on('popover:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    else if (p.inline) {
	                        p.container = $(p.pickerHTML);
	                        p.container.addClass('picker-modal-inline');
	                        $(p.params.container).append(p.container);
	                    }
	                    else {
	                        p.container = $(app.pickerModal(p.pickerHTML));
	                        $(p.container)
	                        .on('picker:close', function () {
	                            onPickerClose();
	                        });
	                    }
	        
	                    // Store calendar instance
	                    p.container[0].f7Calendar = p;
	                    p.wrapper = p.container.find('.picker-calendar-months-wrapper');
	        
	                    // Months
	                    p.months = p.wrapper.find('.picker-calendar-month');
	        
	                    // Update current month and year
	                    p.updateCurrentMonthYear();
	        
	                    // Set initial translate
	                    p.monthsTranslate = 0;
	                    p.setMonthsTranslate();
	        
	                    // Init events
	                    p.initCalendarEvents();
	        
	                    // Update input value
	                    if (updateValue) p.updateValue();
	                    else if (app.params.material && p.value) p.updateValue(true);
	        
	                    // Material Focus
	                    if (p.input && p.input.length > 0 && app.params.material) {
	                        p.input.trigger('focus');
	                    }
	        
	                }
	        
	                // Set flag
	                p.opened = true;
	                p.initialized = true;
	                if (p.params.onMonthAdd) {
	                    p.months.each(function () {
	                        p.params.onMonthAdd(p, this);
	                    });
	                }
	                if (p.params.onOpen) p.params.onOpen(p);
	            };
	        
	            // Close
	            p.close = function () {
	                if (!p.opened || p.inline) return;
	                if (inPopover()) {
	                    app.closeModal(p.popover);
	                    return;
	                }
	                else {
	                    app.closeModal(p.container);
	                    return;
	                }
	            };
	        
	            // Destroy
	            p.destroy = function () {
	                p.close();
	                if (p.params.input && p.input.length > 0) {
	                    p.input.off('click focus', openOnInput);
	                }
	                $('html').off('click', closeOnHTMLClick);
	            };
	        
	            if (p.inline) {
	                p.open();
	            }
	            else {
	                if (!p.initialized && p.params.value) p.setValue(p.params.value);
	            }
	        
	            return p;
	        };
	        app.calendar = function (params) {
	            return new Calendar(params);
	        };
	        
	
	        /*======================================================
	        ************   Notifications   ************
	        ======================================================*/
	        var _tempNotificationElement;
	        app.addNotification = function (params) {
	            if (!params) return;
	            
	            if (typeof params.media === 'undefined') params.media = app.params.notificationMedia;
	            if (typeof params.title === 'undefined') params.title = app.params.notificationTitle;
	            if (typeof params.subtitle === 'undefined') params.subtitle = app.params.notificationSubtitle;
	            if (typeof params.closeIcon === 'undefined') params.closeIcon = app.params.notificationCloseIcon;
	            if (typeof params.hold === 'undefined') params.hold = app.params.notificationHold;
	            if (typeof params.closeOnClick === 'undefined') params.closeOnClick = app.params.notificationCloseOnClick;
	            if (typeof params.button === 'undefined') params.button = app.params.notificationCloseButtonText && {
	                text: app.params.notificationCloseButtonText,
	                close: true
	            };
	        
	            if (!_tempNotificationElement) _tempNotificationElement = document.createElement('div');
	        
	            params.material = app.params.material;
	        
	            var container = $('.notifications');
	            if (container.length === 0) {
	                app.root.append('<div class="notifications list-block' + (params.material ? '' : ' media-list') + '"><ul></ul></div>');
	                container = $('.notifications');
	            }
	            var list = container.children('ul');
	            
	            var notificationTemplate = app.params.notificationTemplate || 
	                '{{#if custom}}' +
	                '<li>{{custom}}</li>' +
	                '{{else}}' +
	                '<li class="notification-item notification-hidden">' +
	                    '<div class="item-content">' +
	                        '{{#if material}}' +
	                            '<div class="item-inner">' +
	                                '<div class="item-title">{{js "this.message || this.title || this.subtitle"}}</div>' +
	                                '{{#if ../button}}{{#button}}' +
	                                '<div class="item-after">' +
	                                    '<a href="#" class="button {{#if color}}color-{{color}}{{/if}} {{#js_compare "this.close !== false"}}close-notification{{/js_compare}}">{{text}}</a>' +
	                                '</div>' +
	                                '{{/button}}{{/if}}' +
	                            '</div>' +
	                        '{{else}}' +
	                            '{{#if media}}' +
	                            '<div class="item-media">{{media}}</div>' +
	                            '{{/if}}' +
	                            '<div class="item-inner">' +
	                                '<div class="item-title-row">' +
	                                    '{{#if title}}' +
	                                    '<div class="item-title">{{title}}</div>' +
	                                    '{{/if}}' +
	                                    '{{#if closeIcon}}' +
	                                    '<div class="item-after"><a href="#" class="close-notification"><span></span></a></div>' +
	                                    '{{/if}}' +
	                                '</div>' +
	                                '{{#if subtitle}}' +
	                                '<div class="item-subtitle">{{subtitle}}</div>' +
	                                '{{/if}}' +
	                                '{{#if message}}' +
	                                '<div class="item-text">{{message}}</div>' +
	                                '</div>' +
	                            '{{/if}}' +
	                        '{{/if}}' +
	                    '</div>' +
	                '</li>' +
	                '{{/if}}';
	            if (!app._compiledTemplates.notification) {
	                app._compiledTemplates.notification = t7.compile(notificationTemplate);
	            }
	            _tempNotificationElement.innerHTML = app._compiledTemplates.notification(params);
	        
	            var item = $(_tempNotificationElement).children();
	        
	            item.on('click', function (e) {
	                var close = false;
	                var target = $(e.target);
	                if (params.material && target.hasClass('button')) {
	                    if (params.button && params.button.onClick) params.button.onClick.call(target[0], e, item[0]);
	                }
	                if (target.is('.close-notification') || $(e.target).parents('.close-notification').length > 0) {
	                    close = true;
	                }
	                else {
	                    if (params.onClick) params.onClick(e, item[0]);
	                    if (params.closeOnClick) close = true;
	                }
	                if (close) app.closeNotification(item[0], e);
	            });
	            if (params.onClose) {
	                item.data('f7NotificationOnClose', function (e) {
	                    params.onClose(item[0], e);
	                });
	            }
	            if (params.additionalClass) {
	                item.addClass(params.additionalClass);
	            }
	            if (params.hold) {
	                setTimeout(function () {
	                    if (item.length > 0) app.closeNotification(item[0]);
	                }, params.hold);
	            }
	        
	            if (!app.params.material) {
	                app.closeNotification(list.children('li.notification-item:last-child'));
	            }
	            list.append(item[0]);
	            container.show();
	        
	            var itemHeight = item.outerHeight(), clientLeft;
	            if (params.material) {
	                container.transform('translate3d(0, '+itemHeight+'px, 0)');
	                container.transition(0);
	        
	                clientLeft = item[0].clientLeft;
	        
	                container.transform('translate3d(0, 0, 0)');
	                container.transition('');
	            }
	            else {
	                item.transform('translate3d(0,' + (-itemHeight) + 'px,0)');
	                item.transition(0);
	        
	                clientLeft = item[0].clientLeft;
	        
	                item.transition('');
	                item.transform('translate3d(0,0px,0)');
	            }
	        
	            container.transform('translate3d(0, 0,0)');
	            item.removeClass('notification-hidden');
	        
	            return item[0];
	        };
	        app.closeNotification = function (item, event) {
	            item = $(item);
	            if (item.length === 0) return;
	            if (item.hasClass('notification-item-removing')) return;
	            var container = $('.notifications');
	        
	            var itemHeight = item.outerHeight();
	            item.css('height', itemHeight + 'px').transition(0).addClass('notification-item-removing');
	            var clientLeft = item[0].clientLeft;
	        
	            item.css({
	                height: '0px',
	                marginBottom: '0px'
	            }).transition('');
	        
	            if (item.data('f7NotificationOnClose')) item.data('f7NotificationOnClose')(event);
	        
	            if (container.find('.notification-item:not(.notification-item-removing)').length === 0) {
	                container.transform('');
	            }
	        
	            item.addClass('notification-hidden').transitionEnd(function () {
	                item.remove();
	                if (container.find('.notification-item').length === 0) {
	                    container.hide();
	                }
	            });
	        };
	
	        /*===========================
	        Compile Template7 Templates On App Init
	        ===========================*/
	        app.initTemplate7Templates = function () {
	            if (!window.Template7) return;
	            Template7.templates = Template7.templates || app.params.templates || {};
	            Template7.data = Template7.data || app.params.template7Data || {};
	            Template7.cache = Template7.cache || {};
	        
	            app.templates = Template7.templates;
	            app.template7Data = Template7.data;
	            app.template7Cache = Template7.cache;
	        
	            // Precompile templates on app init
	            if (!app.params.precompileTemplates) return;
	            $('script[type="text/template7"]').each(function () {
	                var id = $(this).attr('id');
	                if (!id) return;
	                Template7.templates[id] = Template7.compile($(this).html());
	            });
	        };
	        
	
	        /*=======================================
	        ************   Plugins API   ************
	        =======================================*/
	        var _plugins = [];
	        app.initPlugins = function () {
	            // Initialize plugins
	            for (var plugin in app.plugins) {
	                var p = app.plugins[plugin](app, app.params[plugin]);
	                if (p) _plugins.push(p);
	            }
	        };
	        // Plugin Hooks
	        app.pluginHook = function (hook) {
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].hooks && hook in _plugins[i].hooks) {
	                    _plugins[i].hooks[hook](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	        // Prevented by plugin
	        app.pluginPrevent = function (action) {
	            var prevent = false;
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].prevents && action in _plugins[i].prevents) {
	                    if (_plugins[i].prevents[action](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5])) prevent = true;
	                }
	            }
	            return prevent;
	        };
	        // Preprocess content by plugin
	        app.pluginProcess = function (process, data) {
	            var processed = data;
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].preprocess && process in _plugins[i].preprocess) {
	                    processed = _plugins[i].preprocess[process](data, arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
	                }
	            }
	            return processed;
	        };
	        
	        
	
	        /*======================================================
	        ************   App Init   ************
	        ======================================================*/
	        app.init = function () {
	            // Compile Template7 templates on app load
	            if (app.initTemplate7Templates) app.initTemplate7Templates();
	        
	            // Init Plugins
	            if (app.initPlugins) app.initPlugins();
	        
	            // Init Device
	            if (app.getDeviceInfo) app.getDeviceInfo();
	        
	            // Init resize events and calc app sizes
	            if (app.initResize) app.initResize();
	        
	            // Init Panels Breakpoints
	            if (app.initPanelsBreakpoints && (app.params.panelLeftBreakpoint || app.params.panelRightBreakpoint)) app.initPanelsBreakpoints();
	        
	            // Init Click events
	            if (app.initFastClicks && app.params.fastClicks) app.initFastClicks();
	            if (app.initClickEvents) app.initClickEvents();
	        
	            // Init each page callbacks
	            $('.page:not(.cached)').each(function () {
	                app.initPageWithCallback(this);
	            });
	        
	            // Init each navbar callbacks
	            $('.navbar:not(.cached)').each(function () {
	                app.initNavbarWithCallback(this);
	            });
	        
	            // Init push state
	            if (app.initPushState && app.params.pushState) app.initPushState();
	        
	            // Init Live Swipeouts events
	            if (app.initSwipeout && app.params.swipeout) app.initSwipeout();
	        
	            // Init Live Sortable events
	            if (app.initSortable && app.params.sortable) app.initSortable();
	        
	            // Init Live Swipe Panels
	            if (app.initSwipePanels && (app.params.swipePanel || app.params.swipePanelOnlyClose)) app.initSwipePanels();
	        
	            // Init Material Inputs
	            if (app.params.material && app.initMaterialWatchInputs) app.initMaterialWatchInputs();
	        
	            // Init Material Tabbar
	            if (app.params.material) {
	                $('.tabbar').each(function (index, el) {
	                    if ($(el).parents('.page').length === 0) {
	                        app.initMaterialTabbar(el);
	                    }
	                });
	            }
	        
	            // App Init callback
	            if (app.params.onAppInit) app.params.onAppInit();
	        
	            // Plugin app init hook
	            app.pluginHook('appInit');
	        };
	        if (app.params.init) app.init();
	        
	
	        //Return instance        
	        return app;
	    };
	    
	
	    /*===========================
	    Dom7 Library
	    ===========================*/
	    var Dom7 = (function () {
	        var Dom7 = function (arr) {
	            var _this = this, i = 0;
	            // Create array-like object
	            for (i = 0; i < arr.length; i++) {
	                _this[i] = arr[i];
	            }
	            _this.length = arr.length;
	            // Return collection with methods
	            return this;
	        };
	        var $ = function (selector, context) {
	            var arr = [], i = 0;
	            if (selector && !context) {
	                if (selector instanceof Dom7) {
	                    return selector;
	                }
	            }
	            if (selector) {
	                // String
	                if (typeof selector === 'string') {
	                    var els, tempParent, html;
	                    selector = html = selector.trim();
	                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	                        var toCreate = 'div';
	                        if (html.indexOf('<li') === 0) toCreate = 'ul';
	                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
	                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
	                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
	                        if (html.indexOf('<option') === 0) toCreate = 'select';
	                        tempParent = document.createElement(toCreate);
	                        tempParent.innerHTML = html;
	                        for (i = 0; i < tempParent.childNodes.length; i++) {
	                            arr.push(tempParent.childNodes[i]);
	                        }
	                    }
	                    else {
	                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	                            // Pure ID selector
	                            els = [document.getElementById(selector.split('#')[1])];
	                        }
	                        else {
	                            // Other selectors
	                            els = (context || document).querySelectorAll(selector);
	                        }
	                        for (i = 0; i < els.length; i++) {
	                            if (els[i]) arr.push(els[i]);
	                        }
	                    }
	                }
	                // Node/element
	                else if (selector.nodeType || selector === window || selector === document) {
	                    arr.push(selector);
	                }
	                //Array of elements or instance of Dom
	                else if (selector.length > 0 && selector[0].nodeType) {
	                    for (i = 0; i < selector.length; i++) {
	                        arr.push(selector[i]);
	                    }
	                }
	            }
	            return new Dom7(arr);
	        };
	
	        Dom7.prototype = {
	            // Classes and attributes
	            addClass: function (className) {
	                if (typeof className === 'undefined') {
	                    return this;
	                }
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
	                    }
	                }
	                return this;
	            },
	            removeClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
	                    }
	                }
	                return this;
	            },
	            hasClass: function (className) {
	                if (!this[0]) return false;
	                else return this[0].classList.contains(className);
	            },
	            toggleClass: function (className) {
	                var classes = className.split(' ');
	                for (var i = 0; i < classes.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
	                    }
	                }
	                return this;
	            },
	            attr: function (attrs, value) {
	                if (arguments.length === 1 && typeof attrs === 'string') {
	                    // Get attr
	                    if (this[0]) return this[0].getAttribute(attrs);
	                    else return undefined;
	                }
	                else {
	                    // Set attrs
	                    for (var i = 0; i < this.length; i++) {
	                        if (arguments.length === 2) {
	                            // String
	                            this[i].setAttribute(attrs, value);
	                        }
	                        else {
	                            // Object
	                            for (var attrName in attrs) {
	                                this[i][attrName] = attrs[attrName];
	                                this[i].setAttribute(attrName, attrs[attrName]);
	                            }
	                        }
	                    }
	                    return this;
	                }
	            },
	            removeAttr: function (attr) {
	                for (var i = 0; i < this.length; i++) {
	                    this[i].removeAttribute(attr);
	                }
	                return this;
	            },
	            prop: function (props, value) {
	                if (arguments.length === 1 && typeof props === 'string') {
	                    // Get prop
	                    if (this[0]) return this[0][props];
	                }
	                else {
	                    // Set props
	                    for (var i = 0; i < this.length; i++) {
	                        if (arguments.length === 2) {
	                            // String
	                            this[i][props] = value;
	                        }
	                        else {
	                            // Object
	                            for (var propName in props) {
	                                this[i][propName] = props[propName];
	                            }
	                        }
	                    }
	                    return this;
	                }
	            },
	            data: function (key, value) {
	                var el;
	                if (typeof value === 'undefined') {
	                    el = this[0];
	                    // Get value
	                    if (el) {
	                        if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	                            return el.dom7ElementDataStorage[key];
	                        }
	                        else {
	                            var dataKey = el.getAttribute('data-' + key);
	                            if (dataKey) {
	                                return dataKey;
	                            }
	                            else return undefined;
	                        }
	                    }
	                    else return undefined;
	                }
	                else {
	                    // Set value
	                    for (var i = 0; i < this.length; i++) {
	                        el = this[i];
	                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
	                        el.dom7ElementDataStorage[key] = value;
	                    }
	                    return this;
	                }
	            },
	            removeData: function(key) {
	                for (var i = 0; i < this.length; i++) {
	                    var el = this[i];
	                    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	                        el.dom7ElementDataStorage[key] = null;
	                        delete el.dom7ElementDataStorage[key];
	                    }
	                }
	            },
	            dataset: function () {
	                var el = this[0];
	                if (el) {
	                    var dataset = {};
	                    if (el.dataset) {
	                        for (var dataKey in el.dataset) {
	                            dataset[dataKey] = el.dataset[dataKey];
	                        }
	                    }
	                    else {
	                        for (var i = 0; i < el.attributes.length; i++) {
	                            var attr = el.attributes[i];
	                            if (attr.name.indexOf('data-') >= 0) {
	                                dataset[$.toCamelCase(attr.name.split('data-')[1])] = attr.value;
	                            }
	                        }
	                    }
	                    for (var key in dataset) {
	                        if (dataset[key] === 'false') dataset[key] = false;
	                        else if (dataset[key] === 'true') dataset[key] = true;
	                        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] = dataset[key] * 1;
	                    }
	                    return dataset;
	                }
	            },
	            val: function (value) {
	                if (typeof value === 'undefined') {
	                    if (this[0]) {
	                        if (this[0].multiple && this[0].nodeName.toLowerCase() === 'select') {
	                            var values = [];
	                            for (var i = 0; i < this[0].selectedOptions.length; i++) {
	                                values.push(this[0].selectedOptions[i].value);
	                            }
	                            return values;
	                        }
	                        return this[0].value;
	                    }
	                    else return undefined;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].value = value;
	                    }
	                    return this;
	                }
	            },
	            // Transforms
	            transform : function (transform) {
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransform = elStyle.transform = transform;
	                }
	                return this;
	            },
	            transition: function (duration) {
	                if (typeof duration !== 'string') {
	                    duration = duration + 'ms';
	                }
	                for (var i = 0; i < this.length; i++) {
	                    var elStyle = this[i].style;
	                    elStyle.webkitTransitionDuration = elStyle.transitionDuration = duration;
	                }
	                return this;
	            },
	            //Events
	            on: function (eventName, targetSelector, listener, capture) {
	                function handleLiveEvent(e) {
	                    var target = e.target;
	                    if ($(target).is(targetSelector)) listener.call(target, e);
	                    else {
	                        var parents = $(target).parents();
	                        for (var k = 0; k < parents.length; k++) {
	                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
	                        }
	                    }
	                }
	                var events = eventName.split(' ');
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof targetSelector === 'function' || targetSelector === false) {
	                        // Usual events
	                        if (typeof targetSelector === 'function') {
	                            listener = arguments[1];
	                            capture = arguments[2] || false;
	                        }
	                        for (j = 0; j < events.length; j++) {
	                            this[i].addEventListener(events[j], listener, capture);
	                        }
	                    }
	                    else {
	                        //Live events
	                        for (j = 0; j < events.length; j++) {
	                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
	                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
	                            this[i].addEventListener(events[j], handleLiveEvent, capture);
	                        }
	                    }
	                }
	        
	                return this;
	            },
	            off: function (eventName, targetSelector, listener, capture) {
	                var events = eventName.split(' ');
	                for (var i = 0; i < events.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        if (typeof targetSelector === 'function' || targetSelector === false) {
	                            // Usual events
	                            if (typeof targetSelector === 'function') {
	                                listener = arguments[1];
	                                capture = arguments[2] || false;
	                            }
	                            this[j].removeEventListener(events[i], listener, capture);
	                        }
	                        else {
	                            // Live event
	                            if (this[j].dom7LiveListeners) {
	                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
	                                    if (this[j].dom7LiveListeners[k].listener === listener) {
	                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                return this;
	            },
	            once: function (eventName, targetSelector, listener, capture) {
	                var dom = this;
	                if (typeof targetSelector === 'function') {
	                    listener = arguments[1];
	                    capture = arguments[2];
	                    targetSelector = false;
	                }
	                function proxy(e) {
	                    listener.call(e.target, e);
	                    dom.off(eventName, targetSelector, proxy, capture);
	                }
	                return dom.on(eventName, targetSelector, proxy, capture);
	            },
	            trigger: function (eventName, eventData) {
	                var events = eventName.split(' ');
	                for (var i = 0; i < events.length; i++) {
	                    for (var j = 0; j < this.length; j++) {
	                        var evt;
	                        try {
	                            evt = new CustomEvent(events[i], {detail: eventData, bubbles: true, cancelable: true});
	                        }
	                        catch (e) {
	                            evt = document.createEvent('Event');
	                            evt.initEvent(events[i], true, true);
	                            evt.detail = eventData;
	                        }
	                        this[j].dispatchEvent(evt);
	                    }
	                }
	                return this;
	            },
	            transitionEnd: function (callback) {
	                var events = ['webkitTransitionEnd', 'transitionend'],
	                    i, dom = this;
	                function fireCallBack(e) {
	                    /*jshint validthis:true */
	                    if (e.target !== this) return;
	                    callback.call(this, e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            },
	            animationEnd: function (callback) {
	                var events = ['webkitAnimationEnd', 'animationend'],
	                    i, dom = this;
	                function fireCallBack(e) {
	                    callback(e);
	                    for (i = 0; i < events.length; i++) {
	                        dom.off(events[i], fireCallBack);
	                    }
	                }
	                if (callback) {
	                    for (i = 0; i < events.length; i++) {
	                        dom.on(events[i], fireCallBack);
	                    }
	                }
	                return this;
	            },
	            // Sizing/Styles
	            width: function () {
	                if (this[0] === window) {
	                    return window.innerWidth;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('width'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerWidth: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins) {
	                        var styles = this.styles();
	                        return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	                    }
	                    else
	                        return this[0].offsetWidth;
	                }
	                else return null;
	            },
	            height: function () {
	                if (this[0] === window) {
	                    return window.innerHeight;
	                }
	                else {
	                    if (this.length > 0) {
	                        return parseFloat(this.css('height'));
	                    }
	                    else {
	                        return null;
	                    }
	                }
	            },
	            outerHeight: function (includeMargins) {
	                if (this.length > 0) {
	                    if (includeMargins) {
	                        var styles = this.styles();
	                        return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	                    }
	                    else
	                        return this[0].offsetHeight;
	                }
	                else return null;
	            },
	            offset: function () {
	                if (this.length > 0) {
	                    var el = this[0];
	                    var box = el.getBoundingClientRect();
	                    var body = document.body;
	                    var clientTop  = el.clientTop  || body.clientTop  || 0;
	                    var clientLeft = el.clientLeft || body.clientLeft || 0;
	                    var scrollTop  = el === window ? window.scrollY : el.scrollTop;
	                    var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	                    return {
	                        top: box.top  + scrollTop  - clientTop,
	                        left: box.left + scrollLeft - clientLeft
	                    };
	                }
	                else {
	                    return null;
	                }
	            },
	            hide: function () {
	                for (var i = 0; i < this.length; i++) {
	                    this[i].style.display = 'none';
	                }
	                return this;
	            },
	            show: function () {
	                for (var i = 0; i < this.length; i++) {
	                    this[i].style.display = 'block';
	                }
	                return this;
	            },
	            styles: function () {
	                if (this[0]) return window.getComputedStyle(this[0], null);
	            },
	            css: function (props, value) {
	                var i;
	                if (arguments.length === 1) {
	                    if (typeof props === 'string') {
	                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
	                    }
	                    else {
	                        for (i = 0; i < this.length; i++) {
	                            for (var prop in props) {
	                                this[i].style[prop] = props[prop];
	                            }
	                        }
	                        return this;
	                    }
	                }
	                if (arguments.length === 2 && typeof props === 'string') {
	                    for (i = 0; i < this.length; i++) {
	                        this[i].style[props] = value;
	                    }
	                    return this;
	                }
	                return this;
	            },
	        
	            //Dom manipulation
	            // Iterate over the collection passing elements to `callback`
	            each: function (callback) {
	                // Don't bother continuing without a callback
	                if (!callback) return this;
	                // Iterate over the current collection
	                for (var i = 0; i < this.length; i++) {
	                    // If the callback returns false
	                    if (callback.call(this[i], i, this[i]) === false) {
	                        // End the loop early
	                        return this;
	                    }
	                }
	                // Return `this` to allow chained DOM operations
	                return this;
	            },
	            filter: function (callback) {
	                var matchedItems = [];
	                var dom = this;
	                for (var i = 0; i < dom.length; i++) {
	                    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
	                }
	                return new Dom7(matchedItems);
	            },
	            html: function (html) {
	                if (typeof html === 'undefined') {
	                    return this[0] ? this[0].innerHTML : undefined;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].innerHTML = html;
	                    }
	                    return this;
	                }
	            },
	            text: function (text) {
	                if (typeof text === 'undefined') {
	                    if (this[0]) {
	                        return this[0].textContent.trim();
	                    }
	                    else return null;
	                }
	                else {
	                    for (var i = 0; i < this.length; i++) {
	                        this[i].textContent = text;
	                    }
	                    return this;
	                }
	            },
	            is: function (selector) {
	                var compareWith, i, el = this[0];
	                if (!el || typeof selector === 'undefined') return false;
	                if (typeof selector === 'string') {
	                    if (el.matches) return el.matches(selector);
	                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
	                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
	                    else {
	                        compareWith = $(selector);
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === el) return true;
	                        }
	                        return false;
	                    }
	                }
	                else if (selector === document) return el === document;
	                else if (selector === window) return el === window;
	                else {
	                    if (selector.nodeType || selector instanceof Dom7) {
	                        compareWith = selector.nodeType ? [selector] : selector;
	                        for (i = 0; i < compareWith.length; i++) {
	                            if (compareWith[i] === el) return true;
	                        }
	                        return false;
	                    }
	                    return false;
	                }
	        
	            },
	            indexOf: function (el) {
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i] === el) return i;
	                }
	            },
	            index: function () {
	                var i, child = this[0];
	                if (child) {
	                    i = 0;
	                    while ((child = child.previousSibling) !== null) {
	                        if (child.nodeType === 1) i++;
	                    }
	                    return i;
	                }
	            },
	            eq: function (index) {
	                if (typeof index === 'undefined') return this;
	                var length = this.length;
	                var returnIndex;
	                if (index > length - 1) {
	                    return new Dom7([]);
	                }
	                if (index < 0) {
	                    returnIndex = length + index;
	                    if (returnIndex < 0) return new Dom7([]);
	                    else return new Dom7([this[returnIndex]]);
	                }
	                return new Dom7([this[index]]);
	            },
	            append: function () {
	                var i, j, k, newChild;
	        
	                for (k = 0; k < arguments.length; k++) {
	                  newChild = arguments[k];
	        
	                  for (i = 0; i < this.length; i++) {
	                      if (typeof newChild === 'string') {
	                          var tempDiv = document.createElement('div');
	                          tempDiv.innerHTML = newChild;
	                          while (tempDiv.firstChild) {
	                              this[i].appendChild(tempDiv.firstChild);
	                          }
	                      }
	                      else if (newChild instanceof Dom7) {
	                          for (j = 0; j < newChild.length; j++) {
	                              this[i].appendChild(newChild[j]);
	                          }
	                      }
	                      else {
	                          this[i].appendChild(newChild);
	                      }
	                  }
	                }
	        
	                return this;
	            },
	            appendTo: function (parent) {
	                $(parent).append(this);
	                return this;
	            },
	            prepend: function (newChild) {
	                var i, j;
	                for (i = 0; i < this.length; i++) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
	                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
	                        }
	                        // this[i].insertAdjacentHTML('afterbegin', newChild);
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (j = 0; j < newChild.length; j++) {
	                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
	                        }
	                    }
	                    else {
	                        this[i].insertBefore(newChild, this[i].childNodes[0]);
	                    }
	                }
	                return this;
	            },
	            prependTo: function (parent) {
	                $(parent).prepend(this);
	                return this;
	            },
	            insertBefore: function (selector) {
	                var before = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (before.length === 1) {
	                        before[0].parentNode.insertBefore(this[i], before[0]);
	                    }
	                    else if (before.length > 1) {
	                        for (var j = 0; j < before.length; j++) {
	                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
	                        }
	                    }
	                }
	            },
	            insertAfter: function (selector) {
	                var after = $(selector);
	                for (var i = 0; i < this.length; i++) {
	                    if (after.length === 1) {
	                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
	                    }
	                    else if (after.length > 1) {
	                        for (var j = 0; j < after.length; j++) {
	                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
	                        }
	                    }
	                }
	            },
	            next: function (selector) {
	                if (this.length > 0) {
	                    if (selector) {
	                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            nextAll: function (selector) {
	                var nextEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.nextElementSibling) {
	                    var next = el.nextElementSibling;
	                    if (selector) {
	                        if($(next).is(selector)) nextEls.push(next);
	                    }
	                    else nextEls.push(next);
	                    el = next;
	                }
	                return new Dom7(nextEls);
	            },
	            prev: function (selector) {
	                if (this.length > 0) {
	                    var el = this[0];
	                    if (selector) {
	                        if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return new Dom7([el.previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                    else {
	                        if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
	                        else return new Dom7([]);
	                    }
	                }
	                else return new Dom7([]);
	            },
	            prevAll: function (selector) {
	                var prevEls = [];
	                var el = this[0];
	                if (!el) return new Dom7([]);
	                while (el.previousElementSibling) {
	                    var prev = el.previousElementSibling;
	                    if (selector) {
	                        if($(prev).is(selector)) prevEls.push(prev);
	                    }
	                    else prevEls.push(prev);
	                    el = prev;
	                }
	                return new Dom7(prevEls);
	            },
	            siblings: function (selector) {
	                return this.nextAll(selector).add(this.prevAll(selector));
	            },
	            parent: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i].parentNode !== null) {
	                        if (selector) {
	                            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
	                        }
	                        else {
	                           parents.push(this[i].parentNode);
	                        }
	                    }
	                }
	                return $($.unique(parents));
	            },
	            parents: function (selector) {
	                var parents = [];
	                for (var i = 0; i < this.length; i++) {
	                    var parent = this[i].parentNode;
	                    while (parent) {
	                        if (selector) {
	                            if ($(parent).is(selector)) parents.push(parent);
	                        }
	                        else {
	                            parents.push(parent);
	                        }
	                        parent = parent.parentNode;
	                    }
	                }
	                return $($.unique(parents));
	            },
	            closest: function (selector) {
	                var closest = this;
	                if (typeof selector === 'undefined') {
	                    return new Dom7([]);
	                }
	                if (!closest.is(selector)) {
	                    closest = closest.parents(selector).eq(0);
	                }
	                return closest;
	            },
	            find : function (selector) {
	                var foundElements = [];
	                for (var i = 0; i < this.length; i++) {
	                    var found = this[i].querySelectorAll(selector);
	                    for (var j = 0; j < found.length; j++) {
	                        foundElements.push(found[j]);
	                    }
	                }
	                return new Dom7(foundElements);
	            },
	            children: function (selector) {
	                var children = [];
	                for (var i = 0; i < this.length; i++) {
	                    var childNodes = this[i].childNodes;
	        
	                    for (var j = 0; j < childNodes.length; j++) {
	                        if (!selector) {
	                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
	                        }
	                        else {
	                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
	                        }
	                    }
	                }
	                return new Dom7($.unique(children));
	            },
	            remove: function () {
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
	                }
	                return this;
	            },
	            detach: function () {
	                return this.remove();
	            },
	            add: function () {
	                var dom = this;
	                var i, j;
	                for (i = 0; i < arguments.length; i++) {
	                    var toAdd = $(arguments[i]);
	                    for (j = 0; j < toAdd.length; j++) {
	                        dom[dom.length] = toAdd[j];
	                        dom.length++;
	                    }
	                }
	                return dom;
	            },
	            empty: function () {
	                for (var i = 0; i < this.length; i++) {
	                    var el = this[i];
	                    if (el.nodeType === 1) {
	                        for (var j = 0; j < el.childNodes.length; j++) {
	                            if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	                        }
	                        el.textContent = '';
	                    }
	                }
	                return this;
	            }
	        };
	        
	        // Shortcuts
	        (function () {
	            var shortcuts = ('click blur focus focusin focusout keyup keydown keypress submit change mousedown mousemove mouseup mouseenter mouseleave mouseout mouseover touchstart touchend touchmove resize scroll').split(' ');
	            var notTrigger = ('resize scroll').split(' ');
	            function createMethod(name) {
	                Dom7.prototype[name] = function (targetSelector, listener, capture) {
	                    var i;
	                    if (typeof targetSelector === 'undefined') {
	                        for (i = 0; i < this.length; i++) {
	                            if (notTrigger.indexOf(name) < 0) {
	                                if (name in this[i]) this[i][name]();
	                                else {
	                                    $(this[i]).trigger(name);
	                                }
	                            }
	                        }
	                        return this;
	                    }
	                    else {
	                        return this.on(name, targetSelector, listener, capture);
	                    }
	                };
	            }
	            for (var i = 0; i < shortcuts.length; i++) {
	                createMethod(shortcuts[i]);
	            }
	        })();
	        
	
	        // Global Ajax Setup
	        var globalAjaxOptions = {};
	        $.ajaxSetup = function (options) {
	            if (options.type) options.method = options.type;
	            $.each(options, function (optionName, optionValue) {
	                globalAjaxOptions[optionName]  = optionValue;
	            });
	        };
	        
	        // Ajax
	        var _jsonpRequests = 0;
	        $.ajax = function (options) {
	            var defaults = {
	                method: 'GET',
	                data: false,
	                async: true,
	                cache: true,
	                user: '',
	                password: '',
	                headers: {},
	                xhrFields: {},
	                statusCode: {},
	                processData: true,
	                dataType: 'text',
	                contentType: 'application/x-www-form-urlencoded',
	                timeout: 0
	            };
	            var callbacks = ['beforeSend', 'error', 'complete', 'success', 'statusCode'];
	        
	        
	            //For jQuery guys
	            if (options.type) options.method = options.type;
	        
	            // Merge global and defaults
	            $.each(globalAjaxOptions, function (globalOptionName, globalOptionValue) {
	                if (callbacks.indexOf(globalOptionName) < 0) defaults[globalOptionName] = globalOptionValue;
	            });
	        
	            // Function to run XHR callbacks and events
	            function fireAjaxCallback (eventName, eventData, callbackName) {
	                var a = arguments;
	                if (eventName) $(document).trigger(eventName, eventData);
	                if (callbackName) {
	                    // Global callback
	                    if (callbackName in globalAjaxOptions) globalAjaxOptions[callbackName](a[3], a[4], a[5], a[6]);
	                    // Options callback
	                    if (options[callbackName]) options[callbackName](a[3], a[4], a[5], a[6]);
	                }
	            }
	        
	            // Merge options and defaults
	            $.each(defaults, function (prop, defaultValue) {
	                if (!(prop in options)) options[prop] = defaultValue;
	            });
	        
	            // Default URL
	            if (!options.url) {
	                options.url = window.location.toString();
	            }
	            // Parameters Prefix
	            var paramsPrefix = options.url.indexOf('?') >= 0 ? '&' : '?';
	        
	            // UC method
	            var _method = options.method.toUpperCase();
	            // Data to modify GET URL
	            if ((_method === 'GET' || _method === 'HEAD' || _method === 'OPTIONS' || _method === 'DELETE') && options.data) {
	                var stringData;
	                if (typeof options.data === 'string') {
	                    // Should be key=value string
	                    if (options.data.indexOf('?') >= 0) stringData = options.data.split('?')[1];
	                    else stringData = options.data;
	                }
	                else {
	                    // Should be key=value object
	                    stringData = $.serializeObject(options.data);
	                }
	                if (stringData.length) {
	                    options.url += paramsPrefix + stringData;
	                    if (paramsPrefix === '?') paramsPrefix = '&';
	                }
	            }
	            // JSONP
	            if (options.dataType === 'json' && options.url.indexOf('callback=') >= 0) {
	        
	                var callbackName = 'f7jsonp_' + Date.now() + (_jsonpRequests++);
	                var abortTimeout;
	                var callbackSplit = options.url.split('callback=');
	                var requestUrl = callbackSplit[0] + 'callback=' + callbackName;
	                if (callbackSplit[1].indexOf('&') >= 0) {
	                    var addVars = callbackSplit[1].split('&').filter(function (el) { return el.indexOf('=') > 0; }).join('&');
	                    if (addVars.length > 0) requestUrl += '&' + addVars;
	                }
	        
	                // Create script
	                var script = document.createElement('script');
	                script.type = 'text/javascript';
	                script.onerror = function() {
	                    clearTimeout(abortTimeout);
	                    fireAjaxCallback(undefined, undefined, 'error', null, 'scripterror');
	                    fireAjaxCallback('ajaxComplete ajax:complete', {scripterror: true}, 'complete', null, 'scripterror');
	                };
	                script.src = requestUrl;
	        
	                // Handler
	                window[callbackName] = function (data) {
	                    clearTimeout(abortTimeout);
	                    fireAjaxCallback(undefined, undefined, 'success', data);
	                    script.parentNode.removeChild(script);
	                    script = null;
	                    delete window[callbackName];
	                };
	                document.querySelector('head').appendChild(script);
	        
	                if (options.timeout > 0) {
	                    abortTimeout = setTimeout(function () {
	                        script.parentNode.removeChild(script);
	                        script = null;
	                        fireAjaxCallback(undefined, undefined, 'error', null, 'timeout');
	                    }, options.timeout);
	                }
	        
	                return;
	            }
	        
	            // Cache for GET/HEAD requests
	            if (_method === 'GET' || _method === 'HEAD' || _method === 'OPTIONS' || _method === 'DELETE') {
	                if (options.cache === false) {
	                    options.url += (paramsPrefix + '_nocache=' + Date.now());
	                }
	            }
	        
	            // Create XHR
	            var xhr = new XMLHttpRequest();
	        
	            // Save Request URL
	            xhr.requestUrl = options.url;
	            xhr.requestParameters = options;
	        
	            // Open XHR
	            xhr.open(_method, options.url, options.async, options.user, options.password);
	        
	            // Create POST Data
	            var postData = null;
	        
	            if ((_method === 'POST' || _method === 'PUT' || _method === 'PATCH') && options.data) {
	                if (options.processData) {
	                    var postDataInstances = [ArrayBuffer, Blob, Document, FormData];
	                    // Post Data
	                    if (postDataInstances.indexOf(options.data.constructor) >= 0) {
	                        postData = options.data;
	                    }
	                    else {
	                        // POST Headers
	                        var boundary = '---------------------------' + Date.now().toString(16);
	        
	                        if (options.contentType === 'multipart\/form-data') {
	                            xhr.setRequestHeader('Content-Type', 'multipart\/form-data; boundary=' + boundary);
	                        }
	                        else {
	                            xhr.setRequestHeader('Content-Type', options.contentType);
	                        }
	                        postData = '';
	                        var _data = $.serializeObject(options.data);
	                        if (options.contentType === 'multipart\/form-data') {
	                            boundary = '---------------------------' + Date.now().toString(16);
	                            _data = _data.split('&');
	                            var _newData = [];
	                            for (var i = 0; i < _data.length; i++) {
	                                _newData.push('Content-Disposition: form-data; name="' + _data[i].split('=')[0] + '"\r\n\r\n' + _data[i].split('=')[1] + '\r\n');
	                            }
	                            postData = '--' + boundary + '\r\n' + _newData.join('--' + boundary + '\r\n') + '--' + boundary + '--\r\n';
	                        }
	                        else {
	                            postData = _data;
	                        }
	                    }
	                }
	                else {
	                    postData = options.data;
	                }
	        
	            }
	        
	            // Additional headers
	            if (options.headers) {
	                $.each(options.headers, function (headerName, headerCallback) {
	                    xhr.setRequestHeader(headerName, headerCallback);
	                });
	            }
	        
	            // Check for crossDomain
	            if (typeof options.crossDomain === 'undefined') {
	                options.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(options.url) && RegExp.$2 !== window.location.host;
	            }
	        
	            if (!options.crossDomain) {
	                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	            }
	        
	            if (options.xhrFields) {
	                $.each(options.xhrFields, function (fieldName, fieldValue) {
	                    xhr[fieldName] = fieldValue;
	                });
	            }
	        
	            var xhrTimeout;
	            // Handle XHR
	            xhr.onload = function (e) {
	                if (xhrTimeout) clearTimeout(xhrTimeout);
	                if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	                    var responseData;
	                    if (options.dataType === 'json') {
	                        try {
	                            responseData = JSON.parse(xhr.responseText);
	                            fireAjaxCallback('ajaxSuccess ajax:success', {xhr: xhr}, 'success', responseData, xhr.status, xhr);
	                        }
	                        catch (err) {
	                            fireAjaxCallback('ajaxError ajax:error', {xhr: xhr, parseerror: true}, 'error', xhr, 'parseerror');
	                        }
	                    }
	                    else {
	                        responseData = xhr.responseType === 'text' || xhr.responseType === '' ? xhr.responseText : xhr.response;
	                        fireAjaxCallback('ajaxSuccess ajax:success', {xhr: xhr}, 'success', responseData, xhr.status, xhr);
	                    }
	                }
	                else {
	                    fireAjaxCallback('ajaxError ajax:error', {xhr: xhr}, 'error', xhr, xhr.status);
	                }
	                if (options.statusCode) {
	                    if (globalAjaxOptions.statusCode && globalAjaxOptions.statusCode[xhr.status]) globalAjaxOptions.statusCode[xhr.status](xhr);
	                    if (options.statusCode[xhr.status]) options.statusCode[xhr.status](xhr);
	                }
	                fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr}, 'complete', xhr, xhr.status);
	            };
	        
	            xhr.onerror = function (e) {
	                if (xhrTimeout) clearTimeout(xhrTimeout);
	                fireAjaxCallback('ajaxError ajax:error', {xhr: xhr}, 'error', xhr, xhr.status);
	                fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr}, 'complete', xhr, xhr.status);
	            };
	        
	            // Ajax start callback
	            fireAjaxCallback('ajaxStart ajax:start', {xhr: xhr}, 'start', xhr);
	            fireAjaxCallback(undefined, undefined, 'beforeSend', xhr);
	        
	            // Timeout
	            if (options.timeout > 0) {
	                xhr.onabort = function () {
	                    if (xhrTimeout) clearTimeout(xhrTimeout);
	                };
	                xhrTimeout = setTimeout(function () {
	                    xhr.abort();
	                    fireAjaxCallback('ajaxError ajax:error', {xhr: xhr, timeout: true}, 'error', xhr, 'timeout');
	                    fireAjaxCallback('ajaxComplete ajax:complete', {xhr: xhr, timeout: true}, 'complete', xhr, 'timeout');
	                }, options.timeout);
	            }
	        
	            // Send XHR
	            xhr.send(postData);
	        
	            // Return XHR object
	            return xhr;
	        };
	        // Shrotcuts
	        (function () {
	            var methods = ('get post getJSON').split(' ');
	            function createMethod(method) {
	                $[method] = function (url, data, success, error) {
	                    return $.ajax({
	                        url: url,
	                        method: method === 'post' ? 'POST' : 'GET',
	                        data: typeof data === 'function' ? undefined : data,
	                        success: typeof data === 'function' ? data : success,
	                        error: typeof data === 'function' ? success : error,
	                        dataType: method === 'getJSON' ? 'json' : undefined
	                    });
	                };
	            }
	            for (var i = 0; i < methods.length; i++) {
	                createMethod(methods[i]);
	            }
	        })();
	        
	
	        // DOM Library Utilities
	        $.parseUrlQuery= function (url) {
	            url = url || location.href;
	            var query = {},i, params, param, length;
	            if (typeof url === 'string' && url.length)  {
	                url = url.indexOf('?')>-1 ? url.replace(/\S*\?/,'') : '';
	                params = url.split('&'), length = params.length;
	        
	                for (i = 0; i < length; i++) {
	                    param = params[i].replace(/#\S+/g,'').split('=');
	                    query[decodeURIComponent(param[0])] = decodeURIComponent(param[1]) || '';
	                }
	            }
	        
	            return query;
	        };
	        $.isArray = function (arr) {
	            return Array.isArray(arr);
	        };
	        $.each = function (obj, callback) {
	            // Check it's iterable
	            // TODO: Should probably raise a value error here
	            if (typeof obj !== 'object') return;
	            // Don't bother continuing without a callback
	            if (!callback) return;
	            if (Array.isArray(obj) || obj instanceof Dom7) {
	                var i;
	                // Array
	                for (i = 0; i < obj.length; i++) {
	                    // If callback returns false
	                    if (callback(i, obj[i]) === false) {
	                        // Break out of the loop
	                        return;
	                    }
	                }
	            }
	            else {
	                var prop;
	                // Object
	                for (prop in obj) {
	                    // Check the propertie belongs to the object
	                    // not it's prototype
	                    if (obj.hasOwnProperty(prop)) {
	                        // If the callback returns false
	                        if (callback(prop, obj[prop]) === false) {
	                            // Break out of the loop;
	                            return;
	                        }
	                    }
	                }
	            }
	        };
	        $.unique = function (arr) {
	            var unique = [];
	            for (var i = 0; i < arr.length; i++) {
	                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
	            }
	            return unique;
	        };
	        $.serializeObject = $.param = function (obj, parents) {
	            if (typeof obj === 'string') return obj;
	            var resultArray = [];
	            var separator = '&';
	            parents = parents || [];
	            var newParents;
	            function var_name(name) {
	                if (parents.length > 0) {
	                    var _parents = '';
	                    for (var j = 0; j < parents.length; j++) {
	                        if (j === 0) _parents += parents[j];
	                        else _parents += '[' + encodeURIComponent(parents[j]) + ']';
	                    }
	                    return _parents + '[' + encodeURIComponent(name) + ']';
	                }
	                else {
	                    return encodeURIComponent(name);
	                }
	            }
	            function var_value(value) {
	                return encodeURIComponent(value);
	            }
	            for (var prop in obj) {
	                if (obj.hasOwnProperty(prop)) {
	                    var toPush;
	                    if (Array.isArray(obj[prop])) {
	                        toPush = [];
	                        for (var i = 0; i < obj[prop].length; i ++) {
	                            if (!Array.isArray(obj[prop][i]) && typeof obj[prop][i] === 'object') {
	                                newParents = parents.slice();
	                                newParents.push(prop);
	                                newParents.push(i + '');
	                                toPush.push($.serializeObject(obj[prop][i], newParents));
	                            }
	                            else {
	                                toPush.push(var_name(prop) + '[]=' + var_value(obj[prop][i]));
	                            }
	        
	                        }
	                        if (toPush.length > 0) resultArray.push(toPush.join(separator));
	                    }
	                    else if (obj[prop] === null) {
	                        resultArray.push(var_name(prop) + '=');
	                    }
	                    else if (typeof obj[prop] === 'object') {
	                        // Object, convert to named array
	                        newParents = parents.slice();
	                        newParents.push(prop);
	                        toPush = $.serializeObject(obj[prop], newParents);
	                        if (toPush !== '') resultArray.push(toPush);
	                    }
	                    else if (typeof obj[prop] !== 'undefined' && obj[prop] !== '') {
	                        // Should be string or plain value
	                        resultArray.push(var_name(prop) + '=' + var_value(obj[prop]));
	                    }
	                    else if (obj[prop] === '') resultArray.push(var_name(prop));
	                }
	            }
	            return resultArray.join(separator);
	        };
	        $.toCamelCase = function (string) {
	            return string.toLowerCase().replace(/-(.)/g, function(match, group1) {
	                return group1.toUpperCase();
	            });
	        };
	        $.dataset = function (el) {
	            return $(el).dataset();
	        };
	        $.getTranslate = function (el, axis) {
	            var matrix, curTransform, curStyle, transformMatrix;
	        
	            // automatic axis detection
	            if (typeof axis === 'undefined') {
	                axis = 'x';
	            }
	        
	            curStyle = window.getComputedStyle(el, null);
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function(a){
	                        return a.replace(',','.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	        
	            if (axis === 'x') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m41;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[12]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[4]);
	            }
	            if (axis === 'y') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m42;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[13]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[5]);
	            }
	        
	            return curTransform || 0;
	        };
	        
	        $.requestAnimationFrame = function (callback) {
	            if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
	            else if (window.webkitRequestAnimationFrame) return window.webkitRequestAnimationFrame(callback);
	            else {
	                return window.setTimeout(callback, 1000 / 60);
	            }
	        };
	        $.cancelAnimationFrame = function (id) {
	            if (window.cancelAnimationFrame) return window.cancelAnimationFrame(id);
	            else if (window.webkitCancelAnimationFrame) return window.webkitCancelAnimationFrame(id);
	            else {
	                return window.clearTimeout(id);
	            }
	        };
	        $.supportTouch = !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	        
	        // Remove Diacritics
	        var defaultDiacriticsRemovalap = [
	            {base:'A', letters:'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	            {base:'AA',letters:'\uA732'},
	            {base:'AE',letters:'\u00C6\u01FC\u01E2'},
	            {base:'AO',letters:'\uA734'},
	            {base:'AU',letters:'\uA736'},
	            {base:'AV',letters:'\uA738\uA73A'},
	            {base:'AY',letters:'\uA73C'},
	            {base:'B', letters:'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	            {base:'C', letters:'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	            {base:'D', letters:'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	            {base:'DZ',letters:'\u01F1\u01C4'},
	            {base:'Dz',letters:'\u01F2\u01C5'},
	            {base:'E', letters:'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	            {base:'F', letters:'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	            {base:'G', letters:'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	            {base:'H', letters:'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	            {base:'I', letters:'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	            {base:'J', letters:'\u004A\u24BF\uFF2A\u0134\u0248'},
	            {base:'K', letters:'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	            {base:'L', letters:'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	            {base:'LJ',letters:'\u01C7'},
	            {base:'Lj',letters:'\u01C8'},
	            {base:'M', letters:'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	            {base:'N', letters:'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	            {base:'NJ',letters:'\u01CA'},
	            {base:'Nj',letters:'\u01CB'},
	            {base:'O', letters:'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	            {base:'OI',letters:'\u01A2'},
	            {base:'OO',letters:'\uA74E'},
	            {base:'OU',letters:'\u0222'},
	            {base:'OE',letters:'\u008C\u0152'},
	            {base:'oe',letters:'\u009C\u0153'},
	            {base:'P', letters:'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	            {base:'Q', letters:'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	            {base:'R', letters:'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	            {base:'S', letters:'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	            {base:'T', letters:'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	            {base:'TZ',letters:'\uA728'},
	            {base:'U', letters:'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	            {base:'V', letters:'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	            {base:'VY',letters:'\uA760'},
	            {base:'W', letters:'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	            {base:'X', letters:'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	            {base:'Y', letters:'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	            {base:'Z', letters:'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	            {base:'a', letters:'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	            {base:'aa',letters:'\uA733'},
	            {base:'ae',letters:'\u00E6\u01FD\u01E3'},
	            {base:'ao',letters:'\uA735'},
	            {base:'au',letters:'\uA737'},
	            {base:'av',letters:'\uA739\uA73B'},
	            {base:'ay',letters:'\uA73D'},
	            {base:'b', letters:'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	            {base:'c', letters:'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	            {base:'d', letters:'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	            {base:'dz',letters:'\u01F3\u01C6'},
	            {base:'e', letters:'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	            {base:'f', letters:'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	            {base:'g', letters:'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	            {base:'h', letters:'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	            {base:'hv',letters:'\u0195'},
	            {base:'i', letters:'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	            {base:'j', letters:'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	            {base:'k', letters:'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	            {base:'l', letters:'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	            {base:'lj',letters:'\u01C9'},
	            {base:'m', letters:'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	            {base:'n', letters:'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	            {base:'nj',letters:'\u01CC'},
	            {base:'o', letters:'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	            {base:'oi',letters:'\u01A3'},
	            {base:'ou',letters:'\u0223'},
	            {base:'oo',letters:'\uA74F'},
	            {base:'p',letters:'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	            {base:'q',letters:'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	            {base:'r',letters:'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	            {base:'s',letters:'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	            {base:'t',letters:'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	            {base:'tz',letters:'\uA729'},
	            {base:'u',letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	            {base:'v',letters:'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	            {base:'vy',letters:'\uA761'},
	            {base:'w',letters:'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	            {base:'x',letters:'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	            {base:'y',letters:'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	            {base:'z',letters:'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	        ];
	        
	        var diacriticsMap = {};
	        for (var i=0; i < defaultDiacriticsRemovalap.length; i++){
	            var letters = defaultDiacriticsRemovalap[i].letters;
	            for (var j=0; j < letters.length ; j++){
	                diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	            }
	        }
	        
	        $.removeDiacritics = function (str) {
	            return str.replace(/[^\u0000-\u007E]/g, function(a){
	               return diacriticsMap[a] || a;
	            });
	        };
	        // Link to prototype
	        $.fn = Dom7.prototype;
	        
	        // Plugins
	        $.fn.scrollTo = function (left, top, duration, easing, callback) {
	            if (arguments.length === 4 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            return this.each(function () {
	                var el = this;
	                var currentTop, currentLeft, maxTop, maxLeft, newTop, newLeft, scrollTop, scrollLeft;
	                var animateTop = top > 0 || top === 0;
	                var animateLeft = left > 0 || left === 0;
	                if (typeof easing === 'undefined') {
	                    easing = 'swing';
	                }
	                if (animateTop) {
	                    currentTop = el.scrollTop;
	                    if (!duration) {
	                        el.scrollTop = top;
	                    }
	                }
	                if (animateLeft) {
	                    currentLeft = el.scrollLeft;
	                    if (!duration) {
	                        el.scrollLeft = left;
	                    }
	                }
	                if (!duration) return;
	                if (animateTop) {
	                    maxTop = el.scrollHeight - el.offsetHeight;
	                    newTop = Math.max(Math.min(top, maxTop), 0);
	                }
	                if (animateLeft) {
	                    maxLeft = el.scrollWidth - el.offsetWidth;
	                    newLeft = Math.max(Math.min(left, maxLeft), 0);
	                }
	                var startTime = null;
	                if (animateTop && newTop === currentTop) animateTop = false;
	                if (animateLeft && newLeft === currentLeft) animateLeft = false;
	                function render(time) {
	                    if (time === undefined) {
	                        time = new Date().getTime();
	                    }
	                    if (startTime === null) {
	                        startTime = time;
	                    }
	                    var done;
	                    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	                    var easeProgress = easing === 'linear' ? progress : (0.5 - Math.cos( progress * Math.PI ) / 2);
	                    if (animateTop) scrollTop = currentTop + (easeProgress * (newTop - currentTop));
	                    if (animateLeft) scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
	                    if (animateTop && newTop > currentTop && scrollTop >= newTop)  {
	                        el.scrollTop = newTop;
	                        done = true;
	                    }
	                    if (animateTop && newTop < currentTop && scrollTop <= newTop)  {
	                        el.scrollTop = newTop;
	                        done = true;
	                    }
	        
	                    if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft)  {
	                        el.scrollLeft = newLeft;
	                        done = true;
	                    }
	                    if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft)  {
	                        el.scrollLeft = newLeft;
	                        done = true;
	                    }
	        
	                    if (done) {
	                        if (callback) callback();
	                        return;
	                    }
	                    if (animateTop) el.scrollTop = scrollTop;
	                    if (animateLeft) el.scrollLeft = scrollLeft;
	                    $.requestAnimationFrame(render);
	                }
	                $.requestAnimationFrame(render);
	            });
	        };
	        $.fn.scrollTop = function (top, duration, easing, callback) {
	            if (arguments.length === 3 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            var dom = this;
	            if (typeof top === 'undefined') {
	                if (dom.length > 0) return dom[0].scrollTop;
	                else return null;
	            }
	            return dom.scrollTo(undefined, top, duration, easing, callback);
	        };
	        $.fn.scrollLeft = function (left, duration, easing, callback) {
	            if (arguments.length === 3 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            var dom = this;
	            if (typeof left === 'undefined') {
	                if (dom.length > 0) return dom[0].scrollLeft;
	                else return null;
	            }
	            return dom.scrollTo(left, undefined, duration, easing, callback);
	        };
	        
	
	        return $;
	    })();
	    
	    // Export Dom7 to Framework7
	    Framework7.$ = Dom7;
	    
	    // Export to local scope
	    var $ = Dom7;
	    
	    // Export to Window
	    window.Dom7 = Dom7;
	    
	
	    /*========================
	    Animate7 Animate Engine
	    ==========================*/
	    var Animate7 = function (elements, props, params) {
	        props = props || {};
	        params = params || {};
	        var defaults = {
	            duration: 300,
	            easing: 'swing', // or 'linear'
	            /* Callbacks
	            begin(elements)
	            complete(elements)
	            progress(elements, complete, remaining, start, tweenValue)
	            */
	        };
	    
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	        }
	    
	        var a = this;
	        a.params = params;
	        a.props = props;
	        a.elements = $(elements);
	        if (a.elements.length === 0) {
	            return a;
	        }
	    
	        a.easingProgress = function (easing, progress) {
	            if (easing === 'swing') {
	                return 0.5 - Math.cos( progress * Math.PI ) / 2;
	            }
	            if (typeof easing === 'function') {
	                return easing(progress);
	            }
	            return progress;
	        };
	    
	        a.stop = function () {
	            if (a.frameId) {
	                $.cancelAnimationFrame(a.frameId);
	            }
	            a.animating = false;
	            a.elements.each(function (index, el) {
	                delete el.animate7Instance;
	            });
	            a.que = [];
	        };
	        a.done = function (complete) {
	            a.animating = false;
	            a.elements.each(function (index, el) {
	                delete el.animate7Instance;
	            });
	            if (complete) complete(elements);
	            if (a.que.length > 0) {
	                var que = a.que.shift();
	                a.animate(que[0], que[1]);
	            }
	        };
	        a.animating = false;
	        a.que = [];
	        a.animate = function (props, params) {
	            if (a.animating) {
	                a.que.push([props, params]);
	                return a;
	            }
	            a.params = params;
	    
	            var _elements = [];
	    
	            // Define & Cache Initials & Units
	            a.elements.each(function (index, el) {
	                var initialFullValue, initialValue, unit, finalValue, finalFullValue;
	    
	                _elements[index] = {
	                    _container: el
	                };
	    
	                for (var prop in props) {
	                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	                    initialValue = parseFloat(initialFullValue);
	                    unit = initialFullValue.replace(initialValue, '');
	                    finalValue = props[prop];
	                    finalFullValue = props[prop] + unit;
	                    _elements[index][prop] = {
	                        initialFullValue: initialFullValue,
	                        initialValue: initialValue,
	                        unit: unit,
	                        finalValue: finalValue,
	                        finalFullValue: finalFullValue,
	                        currentValue: initialValue
	                    };
	    
	                }
	            });
	    
	            var startTime = null,
	                time,
	                elementsDone = 0,
	                propsDone = 0,
	                done,
	                began = false;
	    
	            a.animating = true;
	    
	            function render() {
	                time = new Date().getTime();
	                var progress, easeProgress, el;
	                if (!began) {
	                    began = true;
	                    if (params.begin) params.begin(elements);
	                }
	                if (startTime === null) {
	                    startTime = time;
	                }
	                if (params.progress) {
	                    params.progress(
	                        a.elements,
	                        Math.max(Math.min((time - startTime) / params.duration, 1), 0),
	                        ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time),
	                        startTime
	                    );
	                }
	    
	                for (var i = 0; i < _elements.length; i++) {
	                    if (done) continue;
	                    el = _elements[i];
	                    if (el.done) continue;
	    
	                    for (var prop in props) {
	                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	                        easeProgress = a.easingProgress(params.easing, progress);
	    
	                        el[prop].currentValue = el[prop].initialValue + easeProgress * (el[prop].finalValue - el[prop].initialValue);
	    
	                        if (el[prop].finalValue > el[prop].initialValue && el[prop].currentValue >= el[prop].finalValue || el[prop].finalValue < el[prop].initialValue && el[prop].currentValue <= el[prop].finalValue)  {
	                            el._container.style[prop] = el[prop].finalValue + el[prop].unit;
	                            propsDone ++;
	                            if (propsDone === Object.keys(props).length) {
	                                el.done = true;
	                                elementsDone++;
	                            }
	                            if (elementsDone === _elements.length) {
	                                done = true;
	                            }
	                        }
	                        if (done) {
	                            a.done(params.complete);
	                            return a;
	                        }
	                        el._container.style[prop] = el[prop].currentValue + el[prop].unit;
	                    }
	                }
	    
	                // Then call
	                a.frameId = $.requestAnimationFrame(render);
	            }
	            a.frameId = $.requestAnimationFrame(render);
	            return a;
	        };
	        var foundInstance;
	        for (var i = 0; i < a.elements.length; i++) {
	            if (a.elements[i].animate7Instance) {
	                foundInstance = a.elements[i].animate7Instance;
	            }
	            else a.elements[i].animate7Instance = a;
	        }
	        if (foundInstance) {
	            return foundInstance.animate(props, params);
	        }
	        else a.animate(props, params);
	        return a;
	    };
	    window.Animate7 = function (elements, props, params){
	        return new Animate7(elements, props, params);
	    };
	    Dom7.fn.animate = function (props, params) {
	        new Animate7(this, props, params);
	        return this;
	    };
	
	    /*===========================
	    Features Support Detection
	    ===========================*/
	    Framework7.prototype.support = (function () {
	        var support = {
	            touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch),
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function() {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                } catch (e) {}
	                return supportsPassive;
	            })()
	        };
	    
	        // Export object
	        return support;
	    })();
	    
	
	    /*===========================
	    Device/OS Detection
	    ===========================*/
	    Framework7.prototype.device = (function () {
	        var device = {};
	        var ua = navigator.userAgent;
	        var $ = Dom7;
	    
	        var windows = /windows phone/i.test(ua);
	        var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	        var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	        var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	        var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	    
	        device.ios = device.android = device.windows = device.iphone = device.ipod = device.ipad = device.androidChrome = false;
	    
	        // Windows
	        if (windows) {
	            device.os = 'windows';
	            device.windows = true;
	        }
	        // Android
	        if (android && !windows) {
	            device.os = 'android';
	            device.osVersion = android[2];
	            device.android = true;
	            device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	        }
	        if (ipad || iphone || ipod) {
	            device.os = 'ios';
	            device.ios = true;
	        }
	        // iOS
	        if (iphone && !ipod) {
	            device.osVersion = iphone[2].replace(/_/g, '.');
	            device.iphone = true;
	        }
	        if (ipad) {
	            device.osVersion = ipad[2].replace(/_/g, '.');
	            device.ipad = true;
	        }
	        if (ipod) {
	            device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	            device.iphone = true;
	        }
	        // iOS 8+ changed UA
	        if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	            if (device.osVersion.split('.')[0] === '10') {
	                device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	            }
	        }
	    
	        // Webview
	        device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	    
	        // Minimal UI
	        if (device.os && device.os === 'ios') {
	            var osVersionArr = device.osVersion.split('.');
	            device.minimalUi = !device.webView &&
	                                (ipod || iphone) &&
	                                (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	                                $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0;
	        }
	    
	        // Check for status bar and fullscreen app mode
	        var windowWidth = $(window).width();
	        var windowHeight = $(window).height();
	    
	        device.needsStatusBar = function () {
	            if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
	                return true;
	            }
	            return false;
	        };
	        device.statusBar = device.needsStatusBar();
	    
	        // Classes
	        var classNames = [];
	    
	        // Pixel Ratio
	        device.pixelRatio = window.devicePixelRatio || 1;
	        classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
	        if (device.pixelRatio >= 2) {
	            classNames.push('retina');
	        }
	    
	        // OS classes
	        if (device.os) {
	            classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
	            if (device.os === 'ios') {
	                var major = parseInt(device.osVersion.split('.')[0], 10);
	                for (var i = major - 1; i >= 6; i--) {
	                    classNames.push('ios-gt-' + i);
	                }
	            }
	    
	        }
	        // Status bar classes
	        if (device.statusBar) {
	            classNames.push('with-statusbar-overlay');
	        }
	        else {
	            $('html').removeClass('with-statusbar-overlay');
	        }
	    
	        // Add html classes
	        if (classNames.length > 0) $('html').addClass(classNames.join(' '));
	    
	        // Export object
	        return device;
	    })();
	    
	
	    /*===========================
	    Plugins prototype
	    ===========================*/
	    Framework7.prototype.plugins = {};
	    
	
	    /*===========================
	    Template7 Template engine
	    ===========================*/
	    window.Template7 = (function () {
	        function isArray(arr) {
	            return Object.prototype.toString.apply(arr) === '[object Array]';
	        }
	        function isObject(obj) {
	            return obj instanceof Object;
	        }
	        function isFunction(func) {
	            return typeof func === 'function';
	        }
	        function _escape(string) {
	            return typeof window !== 'undefined' && window.escape ? window.escape(string) : string
	                .replace(/&/g, '&amp;')
	                .replace(/</g, '&lt;')
	                .replace(/>/g, '&gt;')
	                .replace(/"/g, '&quot;');
	        }
	        var cache = {};
	        var quoteSingleRexExp = new RegExp('\'', 'g');
	        var quoteDoubleRexExp = new RegExp('"', 'g');
	        function helperToSlices(string) {
	            var helperParts = string.replace(/[{}#}]/g, '').split(' ');
	            var slices = [];
	            var shiftIndex, i, j;
	            for (i = 0; i < helperParts.length; i++) {
	                var part = helperParts[i];
	                var blockQuoteRegExp, openingQuote;
	                if (i === 0) slices.push(part);
	                else {
	                    if (part.indexOf('"') === 0 || part.indexOf('\'') === 0) {
	                        blockQuoteRegExp = part.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                        openingQuote = part.indexOf('"') === 0 ? '"' : '\'';
	                        // Plain String
	                        if (part.match(blockQuoteRegExp).length === 2) {
	                            // One word string
	                            slices.push(part);
	                        }
	                        else {
	                            // Find closed Index
	                            shiftIndex = 0;
	                            for (j = i + 1; j < helperParts.length; j++) {
	                                part += ' ' + helperParts[j];
	                                if (helperParts[j].indexOf(openingQuote) >= 0) {
	                                    shiftIndex = j;
	                                    slices.push(part);
	                                    break;
	                                }
	                            }
	                            if (shiftIndex) i = shiftIndex;
	                        }
	                    }
	                    else {
	                        if (part.indexOf('=') > 0) {
	                            // Hash
	                            var hashParts = part.split('=');
	                            var hashName = hashParts[0];
	                            var hashContent = hashParts[1];
	                            if (!blockQuoteRegExp) {
	                                blockQuoteRegExp = hashContent.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                                openingQuote = hashContent.indexOf('"') === 0 ? '"' : '\'';
	                            }
	                            if (hashContent.match(blockQuoteRegExp).length !== 2) {
	                                shiftIndex = 0;
	                                for (j = i + 1; j < helperParts.length; j++) {
	                                    hashContent += ' ' + helperParts[j];
	                                    if (helperParts[j].indexOf(openingQuote) >= 0) {
	                                        shiftIndex = j;
	                                        break;
	                                    }
	                                }
	                                if (shiftIndex) i = shiftIndex;
	                            }
	                            var hash = [hashName, hashContent.replace(blockQuoteRegExp,'')];
	                            slices.push(hash);
	                        }
	                        else {
	                            // Plain variable
	                            slices.push(part);
	                        }
	                    }
	                }
	            }
	            return slices;
	        }
	        function stringToBlocks(string) {
	            var blocks = [], i, j, k;
	            if (!string) return [];
	            var _blocks = string.split(/({{[^{^}]*}})/);
	            for (i = 0; i < _blocks.length; i++) {
	                var block = _blocks[i];
	                if (block === '') continue;
	                if (block.indexOf('{{') < 0) {
	                    blocks.push({
	                        type: 'plain',
	                        content: block
	                    });
	                }
	                else {
	                    if (block.indexOf('{/') >= 0) {
	                        continue;
	                    }
	                    if (block.indexOf('{#') < 0 && block.indexOf(' ') < 0 && block.indexOf('else') < 0) {
	                        // Simple variable
	                        blocks.push({
	                            type: 'variable',
	                            contextName: block.replace(/[{}]/g, '')
	                        });
	                        continue;
	                    }
	                    // Helpers
	                    var helperSlices = helperToSlices(block);
	                    var helperName = helperSlices[0];
	                    var isPartial = helperName === '>';
	                    var helperContext = [];
	                    var helperHash = {};
	                    for (j = 1; j < helperSlices.length; j++) {
	                        var slice = helperSlices[j];
	                        if (isArray(slice)) {
	                            // Hash
	                            helperHash[slice[0]] = slice[1] === 'false' ? false : slice[1];
	                        }
	                        else {
	                            helperContext.push(slice);
	                        }
	                    }
	    
	                    if (block.indexOf('{#') >= 0) {
	                        // Condition/Helper
	                        var helperStartIndex = i;
	                        var helperContent = '';
	                        var elseContent = '';
	                        var toSkip = 0;
	                        var shiftIndex;
	                        var foundClosed = false, foundElse = false, foundClosedElse = false, depth = 0;
	                        for (j = i + 1; j < _blocks.length; j++) {
	                            if (_blocks[j].indexOf('{{#') >= 0) {
	                                depth ++;
	                            }
	                            if (_blocks[j].indexOf('{{/') >= 0) {
	                                depth --;
	                            }
	                            if (_blocks[j].indexOf('{{#' + helperName) >= 0) {
	                                helperContent += _blocks[j];
	                                if (foundElse) elseContent += _blocks[j];
	                                toSkip ++;
	                            }
	                            else if (_blocks[j].indexOf('{{/' + helperName) >= 0) {
	                                if (toSkip > 0) {
	                                    toSkip--;
	                                    helperContent += _blocks[j];
	                                    if (foundElse) elseContent += _blocks[j];
	                                }
	                                else {
	                                    shiftIndex = j;
	                                    foundClosed = true;
	                                    break;
	                                }
	                            }
	                            else if (_blocks[j].indexOf('else') >= 0 && depth === 0) {
	                                foundElse = true;
	                            }
	                            else {
	                                if (!foundElse) helperContent += _blocks[j];
	                                if (foundElse) elseContent += _blocks[j];
	                            }
	    
	                        }
	                        if (foundClosed) {
	                            if (shiftIndex) i = shiftIndex;
	                            blocks.push({
	                                type: 'helper',
	                                helperName: helperName,
	                                contextName: helperContext,
	                                content: helperContent,
	                                inverseContent: elseContent,
	                                hash: helperHash
	                            });
	                        }
	                    }
	                    else if (block.indexOf(' ') > 0) {
	                        if (isPartial) {
	                            helperName = '_partial';
	                            if (helperContext[0]) helperContext[0] = '"' + helperContext[0].replace(/"|'/g, '') + '"';
	                        }
	                        blocks.push({
	                            type: 'helper',
	                            helperName: helperName,
	                            contextName: helperContext,
	                            hash: helperHash
	                        });
	                    }
	                }
	            }
	            return blocks;
	        }
	        var Template7 = function (template, options) {
	            var t = this;
	            t.template = template;
	    
	            function getCompileFn(block, depth) {
	                if (block.content) return compile(block.content, depth);
	                else return function () {return ''; };
	            }
	            function getCompileInverse(block, depth) {
	                if (block.inverseContent) return compile(block.inverseContent, depth);
	                else return function () {return ''; };
	            }
	            function getCompileVar(name, ctx) {
	                var variable, parts, levelsUp = 0, initialCtx = ctx;
	                if (name.indexOf('../') === 0) {
	                    levelsUp = name.split('../').length - 1;
	                    var newDepth = ctx.split('_')[1] - levelsUp;
	                    ctx = 'ctx_' + (newDepth >= 1 ? newDepth : 1);
	                    parts = name.split('../')[levelsUp].split('.');
	                }
	                else if (name.indexOf('@global') === 0) {
	                    ctx = 'Template7.global';
	                    parts = name.split('@global.')[1].split('.');
	                }
	                else if (name.indexOf('@root') === 0) {
	                    ctx = 'root';
	                    parts = name.split('@root.')[1].split('.');
	                }
	                else {
	                    parts = name.split('.');
	                }
	                variable = ctx;
	                for (var i = 0; i < parts.length; i++) {
	                    var part = parts[i];
	                    if (part.indexOf('@') === 0) {
	                        if (i > 0) {
	                            variable += '[(data && data.' + part.replace('@', '') + ')]';
	                        }
	                        else {
	                            variable = '(data && data.' + name.replace('@', '') + ')';
	                        }
	                    }
	                    else {
	                        if (isFinite(part)) {
	                            variable += '[' + part + ']';
	                        }
	                        else {
	                            if (part === 'this' || part.indexOf('this.') >= 0 || part.indexOf('this[') >= 0 || part.indexOf('this(') >= 0) {
	                                variable = part.replace('this', ctx);
	                            }
	                            else {
	                                variable += '.' + part;
	                            }
	                        }
	                    }
	                }
	    
	                return variable;
	            }
	            function getCompiledArguments(contextArray, ctx) {
	                var arr = [];
	                for (var i = 0; i < contextArray.length; i++) {
	                    if (/^['"]/.test(contextArray[i])) arr.push(contextArray[i]);
	                    else if (/^(true|false|\d+)$/.test(contextArray[i])) arr.push(contextArray[i]);
	                    else {
	                        arr.push(getCompileVar(contextArray[i], ctx));
	                    }
	                }
	    
	                return arr.join(', ');
	            }
	            function compile(template, depth) {
	                depth = depth || 1;
	                template = template || t.template;
	                if (typeof template !== 'string') {
	                    throw new Error('Template7: Template must be a string');
	                }
	                var blocks = stringToBlocks(template);
	                if (blocks.length === 0) {
	                    return function () { return ''; };
	                }
	                var ctx = 'ctx_' + depth;
	                var resultString = '';
	                if (depth === 1) {
	                    resultString += '(function (' + ctx + ', data, root) {\n';
	                }
	                else {
	                    resultString += '(function (' + ctx + ', data) {\n';
	                }
	                if (depth === 1) {
	                    resultString += 'function isArray(arr){return Object.prototype.toString.apply(arr) === \'[object Array]\';}\n';
	                    resultString += 'function isFunction(func){return (typeof func === \'function\');}\n';
	                    resultString += 'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n';
	                    resultString += 'root = root || ctx_1 || {};\n';
	                }
	                resultString += 'var r = \'\';\n';
	                var i, j, context;
	                for (i = 0; i < blocks.length; i++) {
	                    var block = blocks[i];
	                    // Plain block
	                    if (block.type === 'plain') {
	                        resultString += 'r +=\'' + (block.content).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/'/g, '\\' + '\'') + '\';';
	                        continue;
	                    }
	                    var variable, compiledArguments;
	                    // Variable block
	                    if (block.type === 'variable') {
	                        variable = getCompileVar(block.contextName, ctx);
	                        resultString += 'r += c(' + variable + ', ' + ctx + ');';
	                    }
	                    // Helpers block
	                    if (block.type === 'helper') {
	                        if (block.helperName in t.helpers) {
	                            compiledArguments = getCompiledArguments(block.contextName, ctx);
	    
	                            resultString += 'r += (Template7.helpers.' + block.helperName + ').call(' + ctx + ', ' + (compiledArguments && (compiledArguments + ', ')) +'{hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth + 1) + ', inverse: ' + getCompileInverse(block, depth + 1) + ', root: root});';
	    
	                        }
	                        else {
	                            if (block.contextName.length > 0) {
	                                throw new Error('Template7: Missing helper: "' + block.helperName + '"');
	                            }
	                            else {
	                                variable = getCompileVar(block.helperName, ctx);
	                                resultString += 'if (' + variable + ') {';
	                                resultString += 'if (isArray(' + variable + ')) {';
	                                resultString += 'r += (Template7.helpers.each).call(' + ctx + ', ' + variable + ', {hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth+1) + ', inverse: ' + getCompileInverse(block, depth+1) + ', root: root});';
	                                resultString += '}else {';
	                                resultString += 'r += (Template7.helpers.with).call(' + ctx + ', ' + variable + ', {hash:' + JSON.stringify(block.hash) + ', data: data || {}, fn: ' + getCompileFn(block, depth+1) + ', inverse: ' + getCompileInverse(block, depth+1) + ', root: root});';
	                                resultString += '}}';
	                            }
	                        }
	                    }
	                }
	                resultString += '\nreturn r;})';
	                return eval.call(window, resultString);
	            }
	            t.compile = function (template) {
	                if (!t.compiled) {
	                    t.compiled = compile(template);
	                }
	                return t.compiled;
	            };
	        };
	        Template7.prototype = {
	            options: {},
	            partials: {},
	            helpers: {
	                '_partial' : function (partialName, options) {
	                    var p = Template7.prototype.partials[partialName];
	                    if (!p || (p && !p.template)) return '';
	                    if (!p.compiled) {
	                        p.compiled = new Template7(p.template).compile();
	                    }
	                    var ctx = this;
	                    for (var hashName in options.hash) {
	                        ctx[hashName] = options.hash[hashName];
	                    }
	                    return p.compiled(ctx, options.data, options.root);
	                },
	                'escape': function (context, options) {
	                    if (typeof context !== 'string') {
	                        throw new Error('Template7: Passed context to "escape" helper should be a string');
	                    }
	                    return _escape(context);
	                },
	                'if': function (context, options) {
	                    if (isFunction(context)) { context = context.call(this); }
	                    if (context) {
	                        return options.fn(this, options.data);
	                    }
	                    else {
	                        return options.inverse(this, options.data);
	                    }
	                },
	                'unless': function (context, options) {
	                    if (isFunction(context)) { context = context.call(this); }
	                    if (!context) {
	                        return options.fn(this, options.data);
	                    }
	                    else {
	                        return options.inverse(this, options.data);
	                    }
	                },
	                'each': function (context, options) {
	                    var ret = '', i = 0;
	                    if (isFunction(context)) { context = context.call(this); }
	                    if (isArray(context)) {
	                        if (options.hash.reverse) {
	                            context = context.reverse();
	                        }
	                        for (i = 0; i < context.length; i++) {
	                            ret += options.fn(context[i], {first: i === 0, last: i === context.length - 1, index: i});
	                        }
	                        if (options.hash.reverse) {
	                            context = context.reverse();
	                        }
	                    }
	                    else {
	                        for (var key in context) {
	                            i++;
	                            ret += options.fn(context[key], {key: key});
	                        }
	                    }
	                    if (i > 0) return ret;
	                    else return options.inverse(this);
	                },
	                'with': function (context, options) {
	                    if (isFunction(context)) { context = context.call(this); }
	                    return options.fn(context);
	                },
	                'join': function (context, options) {
	                    if (isFunction(context)) { context = context.call(this); }
	                    return context.join(options.hash.delimiter || options.hash.delimeter);
	                },
	                'js': function (expression, options) {
	                    var func;
	                    if (expression.indexOf('return')>=0) {
	                        func = '(function(){'+expression+'})';
	                    }
	                    else {
	                        func = '(function(){return ('+expression+')})';
	                    }
	                    return eval.call(this, func).call(this);
	                },
	                'js_compare': function (expression, options) {
	                    var func;
	                    if (expression.indexOf('return')>=0) {
	                        func = '(function(){'+expression+'})';
	                    }
	                    else {
	                        func = '(function(){return ('+expression+')})';
	                    }
	                    var condition = eval.call(this, func).call(this);
	                    if (condition) {
	                        return options.fn(this, options.data);
	                    }
	                    else {
	                        return options.inverse(this, options.data);
	                    }
	                }
	            }
	        };
	        var t7 = function (template, data) {
	            if (arguments.length === 2) {
	                var instance = new Template7(template);
	                var rendered = instance.compile()(data);
	                instance = null;
	                return (rendered);
	            }
	            else return new Template7(template);
	        };
	        t7.registerHelper = function (name, fn) {
	            Template7.prototype.helpers[name] = fn;
	        };
	        t7.unregisterHelper = function (name) {
	            Template7.prototype.helpers[name] = undefined;
	            delete Template7.prototype.helpers[name];
	        };
	        t7.registerPartial = function (name, template) {
	            Template7.prototype.partials[name] = {template: template};
	        };
	        t7.unregisterPartial = function (name, template) {
	            if (Template7.prototype.partials[name]) {
	                Template7.prototype.partials[name] = undefined;
	                delete Template7.prototype.partials[name];
	            }
	        };
	        t7.compile = function (template, options) {
	            var instance = new Template7(template, options);
	            return instance.compile();
	        };
	    
	        t7.options = Template7.prototype.options;
	        t7.helpers = Template7.prototype.helpers;
	        t7.partials = Template7.prototype.partials;
	        return t7;
	    })();
	    
	
	    /*===========================
	    Swiper
	    ===========================*/
	    window.Swiper = function (container, params) {
	        if (!(this instanceof Swiper)) return new Swiper(container, params);
	    
	        var defaults = {
	            direction: 'horizontal',
	            touchEventsTarget: 'container',
	            initialSlide: 0,
	            speed: 300,
	            // autoplay
	            autoplay: false,
	            autoplayDisableOnInteraction: true,
	            autoplayStopOnLast: false,
	            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	            iOSEdgeSwipeDetection: false,
	            iOSEdgeSwipeThreshold: 20,
	            // Free mode
	            freeMode: false,
	            freeModeMomentum: true,
	            freeModeMomentumRatio: 1,
	            freeModeMomentumBounce: true,
	            freeModeMomentumBounceRatio: 1,
	            freeModeMomentumVelocityRatio: 1,
	            freeModeSticky: false,
	            freeModeMinimumVelocity: 0.02,
	            // Autoheight
	            autoHeight: false,
	            // Set wrapper width
	            setWrapperSize: false,
	            // Virtual Translate
	            virtualTranslate: false,
	            // Effects
	            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
	            coverflow: {
	                rotate: 50,
	                stretch: 0,
	                depth: 100,
	                modifier: 1,
	                slideShadows : true
	            },
	            flip: {
	                slideShadows : true,
	                limitRotation: true
	            },
	            cube: {
	                slideShadows: true,
	                shadow: true,
	                shadowOffset: 20,
	                shadowScale: 0.94
	            },
	            fade: {
	                crossFade: false
	            },
	            // Parallax
	            parallax: false,
	            // Zoom
	            zoom: false,
	            zoomMax: 3,
	            zoomMin: 1,
	            zoomToggle: true,
	            // Scrollbar
	            scrollbar: null,
	            scrollbarHide: true,
	            scrollbarDraggable: false,
	            scrollbarSnapOnRelease: false,
	            // Keyboard Mousewheel
	            keyboardControl: false,
	            mousewheelControl: false,
	            mousewheelReleaseOnEdges: false,
	            mousewheelInvert: false,
	            mousewheelForceToAxis: false,
	            mousewheelSensitivity: 1,
	            mousewheelEventsTarged: 'container',
	            // Hash Navigation
	            hashnav: false,
	            hashnavWatchState: false,
	            // History
	            history: false,
	            // Commong Nav State
	            replaceState: false,
	            // Breakpoints
	            breakpoints: undefined,
	            // Slides grid
	            spaceBetween: 0,
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerColumnFill: 'column',
	            slidesPerGroup: 1,
	            centeredSlides: false,
	            slidesOffsetBefore: 0, // in px
	            slidesOffsetAfter: 0, // in px
	            // Round length
	            roundLengths: false,
	            // Touches
	            touchRatio: 1,
	            touchAngle: 45,
	            simulateTouch: true,
	            shortSwipes: true,
	            longSwipes: true,
	            longSwipesRatio: 0.5,
	            longSwipesMs: 300,
	            followFinger: true,
	            onlyExternal: false,
	            threshold: 0,
	            touchMoveStopPropagation: true,
	            touchReleaseOnEdges: false,
	            // Unique Navigation Elements
	            uniqueNavElements: true,
	            // Pagination
	            pagination: null,
	            paginationElement: 'span',
	            paginationClickable: false,
	            paginationHide: false,
	            paginationBulletRender: null,
	            paginationProgressRender: null,
	            paginationFractionRender: null,
	            paginationCustomRender: null,
	            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
	            // Resistance
	            resistance: true,
	            resistanceRatio: 0.85,
	            // Next/prev buttons
	            nextButton: null,
	            prevButton: null,
	            // Progress
	            watchSlidesProgress: false,
	            watchSlidesVisibility: false,
	            // Cursor
	            grabCursor: false,
	            // Clicks
	            preventClicks: true,
	            preventClicksPropagation: true,
	            slideToClickedSlide: false,
	            // Lazy Loading
	            lazyLoading: false,
	            lazyLoadingInPrevNext: false,
	            lazyLoadingInPrevNextAmount: 1,
	            lazyLoadingOnTransitionStart: false,
	            // Images
	            preloadImages: true,
	            updateOnImagesReady: true,
	            // loop
	            loop: false,
	            loopAdditionalSlides: 0,
	            loopedSlides: null,
	            // Control
	            control: undefined,
	            controlInverse: false,
	            controlBy: 'slide', //or 'container'
	            normalizeSlideIndex: true,
	            // Swiping/no swiping
	            allowSwipeToPrev: true,
	            allowSwipeToNext: true,
	            swipeHandler: null, //'.swipe-handler',
	            noSwiping: true,
	            noSwipingClass: 'swiper-no-swiping',
	            // Passive Listeners
	            passiveListeners: true,
	            // NS
	            containerModifierClass: 'swiper-container-', // NEW
	            slideClass: 'swiper-slide',
	            slideActiveClass: 'swiper-slide-active',
	            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	            slideVisibleClass: 'swiper-slide-visible',
	            slideDuplicateClass: 'swiper-slide-duplicate',
	            slideNextClass: 'swiper-slide-next',
	            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	            slidePrevClass: 'swiper-slide-prev',
	            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	            wrapperClass: 'swiper-wrapper',
	            bulletClass: 'swiper-pagination-bullet',
	            bulletActiveClass: 'swiper-pagination-bullet-active',
	            buttonDisabledClass: 'swiper-button-disabled',
	            paginationCurrentClass: 'swiper-pagination-current',
	            paginationTotalClass: 'swiper-pagination-total',
	            paginationHiddenClass: 'swiper-pagination-hidden',
	            paginationProgressbarClass: 'swiper-pagination-progressbar',
	            paginationClickableClass: 'swiper-pagination-clickable', // NEW
	            paginationModifierClass: 'swiper-pagination-', // NEW
	            lazyLoadingClass: 'swiper-lazy',
	            lazyStatusLoadingClass: 'swiper-lazy-loading',
	            lazyStatusLoadedClass: 'swiper-lazy-loaded',
	            lazyPreloaderClass: 'swiper-lazy-preloader',
	            notificationClass: 'swiper-notification',
	            preloaderClass: 'preloader',
	            zoomContainerClass: 'swiper-zoom-container',
	    
	            // Observer
	            observer: false,
	            observeParents: false,
	            // Accessibility
	            a11y: false,
	            prevSlideMessage: 'Previous slide',
	            nextSlideMessage: 'Next slide',
	            firstSlideMessage: 'This is the first slide',
	            lastSlideMessage: 'This is the last slide',
	            paginationBulletMessage: 'Go to slide {{index}}',
	            // Callbacks
	            runCallbacksOnInit: true
	            /*
	            Callbacks:
	            onInit: function (swiper)
	            onDestroy: function (swiper)
	            onBeforeResize: function (swiper)
	            onAfterResize: function (swiper)
	            onClick: function (swiper, e)
	            onTap: function (swiper, e)
	            onDoubleTap: function (swiper, e)
	            onSliderMove: function (swiper, e)
	            onSlideChangeStart: function (swiper)
	            onSlideChangeEnd: function (swiper)
	            onTransitionStart: function (swiper)
	            onTransitionEnd: function (swiper)
	            onImagesReady: function (swiper)
	            onProgress: function (swiper, progress)
	            onTouchStart: function (swiper, e)
	            onTouchMove: function (swiper, e)
	            onTouchMoveOpposite: function (swiper, e)
	            onTouchEnd: function (swiper, e)
	            onReachBeginning: function (swiper)
	            onReachEnd: function (swiper)
	            onSetTransition: function (swiper, duration)
	            onSetTranslate: function (swiper, translate)
	            onAutoplayStart: function (swiper)
	            onAutoplayStop: function (swiper),
	            onLazyImageLoad: function (swiper, slide, image)
	            onLazyImageReady: function (swiper, slide, image)
	            onKeyPress: function (swiper, keyCode)
	            */
	    
	        };
	        var initialVirtualTranslate = params && params.virtualTranslate;
	    
	        params = params || {};
	        var originalParams = {};
	        for (var param in params) {
	            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
	                originalParams[param] = {};
	                for (var deepParam in params[param]) {
	                    originalParams[param][deepParam] = params[param][deepParam];
	                }
	            }
	            else {
	                originalParams[param] = params[param];
	            }
	        }
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	            else if (typeof params[def] === 'object') {
	                for (var deepDef in defaults[def]) {
	                    if (typeof params[def][deepDef] === 'undefined') {
	                        params[def][deepDef] = defaults[def][deepDef];
	                    }
	                }
	            }
	        }
	    
	        // Swiper
	        var s = this;
	    
	        // Params
	        s.params = params;
	        s.originalParams = originalParams;
	    
	        // Classname
	        s.classNames = [];
	        /*=========================
	          Dom Library and plugins
	          ===========================*/
	        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
	            $ = Dom7;
	        }
	        if (typeof $ === 'undefined') {
	            if (typeof Dom7 === 'undefined') {
	                $ = window.Dom7 || window.Zepto || window.jQuery;
	            }
	            else {
	                $ = Dom7;
	            }
	            if (!$) return;
	        }
	        // Export it to Swiper instance
	        s.$ = $;
	    
	        /*=========================
	          Breakpoints
	          ===========================*/
	        s.currentBreakpoint = undefined;
	        s.getActiveBreakpoint = function () {
	            //Get breakpoint for window width
	            if (!s.params.breakpoints) return false;
	            var breakpoint = false;
	            var points = [], point;
	            for ( point in s.params.breakpoints ) {
	                if (s.params.breakpoints.hasOwnProperty(point)) {
	                    points.push(point);
	                }
	            }
	            points.sort(function (a, b) {
	                return parseInt(a, 10) > parseInt(b, 10);
	            });
	            for (var i = 0; i < points.length; i++) {
	                point = points[i];
	                if (point >= window.innerWidth && !breakpoint) {
	                    breakpoint = point;
	                }
	            }
	            return breakpoint || 'max';
	        };
	        s.setBreakpoint = function () {
	            //Set breakpoint for window width and update parameters
	            var breakpoint = s.getActiveBreakpoint();
	            if (breakpoint && s.currentBreakpoint !== breakpoint) {
	                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
	                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
	                for ( var param in breakPointsParams ) {
	                    s.params[param] = breakPointsParams[param];
	                }
	                s.currentBreakpoint = breakpoint;
	                if(needsReLoop && s.destroyLoop) {
	                    s.reLoop(true);
	                }
	            }
	        };
	        // Set breakpoint on load
	        if (s.params.breakpoints) {
	            s.setBreakpoint();
	        }
	    
	        /*=========================
	          Preparation - Define Container, Wrapper and Pagination
	          ===========================*/
	        s.container = $(container);
	        if (s.container.length === 0) return;
	        if (s.container.length > 1) {
	            var swipers = [];
	            s.container.each(function () {
	                var container = this;
	                swipers.push(new Swiper(this, params));
	            });
	            return swipers;
	        }
	    
	        // Save instance in container HTML Element and in data
	        s.container[0].swiper = s;
	        s.container.data('swiper', s);
	    
	        s.classNames.push(s.params.containerModifierClass + s.params.direction);
	    
	        if (s.params.freeMode) {
	            s.classNames.push(s.params.containerModifierClass + 'free-mode');
	        }
	        if (!s.support.flexbox) {
	            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
	            s.params.slidesPerColumn = 1;
	        }
	        if (s.params.autoHeight) {
	            s.classNames.push(s.params.containerModifierClass + 'autoheight');
	        }
	        // Enable slides progress when required
	        if (s.params.parallax || s.params.watchSlidesVisibility) {
	            s.params.watchSlidesProgress = true;
	        }
	        // Max resistance when touchReleaseOnEdges
	        if (s.params.touchReleaseOnEdges) {
	            s.params.resistanceRatio = 0;
	        }
	        // Coverflow / 3D
	        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
	            if (s.support.transforms3d) {
	                s.params.watchSlidesProgress = true;
	                s.classNames.push(s.params.containerModifierClass + '3d');
	            }
	            else {
	                s.params.effect = 'slide';
	            }
	        }
	        if (s.params.effect !== 'slide') {
	            s.classNames.push(s.params.containerModifierClass + s.params.effect);
	        }
	        if (s.params.effect === 'cube') {
	            s.params.resistanceRatio = 0;
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.centeredSlides = false;
	            s.params.spaceBetween = 0;
	            s.params.virtualTranslate = true;
	        }
	        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.watchSlidesProgress = true;
	            s.params.spaceBetween = 0;
	            if (typeof initialVirtualTranslate === 'undefined') {
	                s.params.virtualTranslate = true;
	            }
	        }
	    
	        // Grab Cursor
	        if (s.params.grabCursor && s.support.touch) {
	            s.params.grabCursor = false;
	        }
	    
	        // Wrapper
	        s.wrapper = s.container.children('.' + s.params.wrapperClass);
	    
	        // Pagination
	        if (s.params.pagination) {
	            s.paginationContainer = $(s.params.pagination);
	            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
	                s.paginationContainer = s.container.find(s.params.pagination);
	            }
	    
	            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
	                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
	            }
	            else {
	                s.params.paginationClickable = false;
	            }
	            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
	        }
	        // Next/Prev Buttons
	        if (s.params.nextButton || s.params.prevButton) {
	            if (s.params.nextButton) {
	                s.nextButton = $(s.params.nextButton);
	                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
	                    s.nextButton = s.container.find(s.params.nextButton);
	                }
	            }
	            if (s.params.prevButton) {
	                s.prevButton = $(s.params.prevButton);
	                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
	                    s.prevButton = s.container.find(s.params.prevButton);
	                }
	            }
	        }
	    
	        // Is Horizontal
	        s.isHorizontal = function () {
	            return s.params.direction === 'horizontal';
	        };
	        // s.isH = isH;
	    
	        // RTL
	        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
	        if (s.rtl) {
	            s.classNames.push(s.params.containerModifierClass + 'rtl');
	        }
	    
	        // Wrong RTL support
	        if (s.rtl) {
	            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
	        }
	    
	        // Columns
	        if (s.params.slidesPerColumn > 1) {
	            s.classNames.push(s.params.containerModifierClass + 'multirow');
	        }
	    
	        // Check for Android
	        if (s.device.android) {
	            s.classNames.push(s.params.containerModifierClass + 'android');
	        }
	    
	        // Add classes
	        s.container.addClass(s.classNames.join(' '));
	    
	        // Translate
	        s.translate = 0;
	    
	        // Progress
	        s.progress = 0;
	    
	        // Velocity
	        s.velocity = 0;
	    
	        /*=========================
	          Locks, unlocks
	          ===========================*/
	        s.lockSwipeToNext = function () {
	            s.params.allowSwipeToNext = false;
	            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = false;
	            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
	            if (s.params.grabCursor) s.unsetGrabCursor();
	        };
	        s.unlockSwipeToNext = function () {
	            s.params.allowSwipeToNext = true;
	            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = true;
	            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
	            if (s.params.grabCursor) s.setGrabCursor();
	        };
	    
	        /*=========================
	          Round helper
	          ===========================*/
	        function round(a) {
	            return Math.floor(a);
	        }
	        /*=========================
	          Set grab cursor
	          ===========================*/
	        s.setGrabCursor = function(moving) {
	            s.container[0].style.cursor = 'move';
	            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
	        };
	        s.unsetGrabCursor = function () {
	            s.container[0].style.cursor = '';
	        };
	        if (s.params.grabCursor) {
	            s.setGrabCursor();
	        }
	        /*=========================
	          Update on Images Ready
	          ===========================*/
	        s.imagesToLoad = [];
	        s.imagesLoaded = 0;
	    
	        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
	            var image;
	            function onReady () {
	                if (callback) callback();
	            }
	            if (!imgElement.complete || !checkForComplete) {
	                if (src) {
	                    image = new window.Image();
	                    image.onload = onReady;
	                    image.onerror = onReady;
	                    if (sizes) {
	                        image.sizes = sizes;
	                    }
	                    if (srcset) {
	                        image.srcset = srcset;
	                    }
	                    if (src) {
	                        image.src = src;
	                    }
	                } else {
	                    onReady();
	                }
	    
	            } else {//image already loaded...
	                onReady();
	            }
	        };
	        s.preloadImages = function () {
	            s.imagesToLoad = s.container.find('img');
	            function _onReady() {
	                if (typeof s === 'undefined' || s === null || !s) return;
	                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
	                if (s.imagesLoaded === s.imagesToLoad.length) {
	                    if (s.params.updateOnImagesReady) s.update();
	                    s.emit('onImagesReady', s);
	                }
	            }
	            for (var i = 0; i < s.imagesToLoad.length; i++) {
	                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
	            }
	        };
	    
	        /*=========================
	          Autoplay
	          ===========================*/
	        s.autoplayTimeoutId = undefined;
	        s.autoplaying = false;
	        s.autoplayPaused = false;
	        function autoplay() {
	            var autoplayDelay = s.params.autoplay;
	            var activeSlide = s.slides.eq(s.activeIndex);
	            if (activeSlide.attr('data-swiper-autoplay')) {
	                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
	            }
	            s.autoplayTimeoutId = setTimeout(function () {
	                if (s.params.loop) {
	                    s.fixLoop();
	                    s._slideNext();
	                    s.emit('onAutoplay', s);
	                }
	                else {
	                    if (!s.isEnd) {
	                        s._slideNext();
	                        s.emit('onAutoplay', s);
	                    }
	                    else {
	                        if (!params.autoplayStopOnLast) {
	                            s._slideTo(0);
	                            s.emit('onAutoplay', s);
	                        }
	                        else {
	                            s.stopAutoplay();
	                        }
	                    }
	                }
	            }, autoplayDelay);
	        }
	        s.startAutoplay = function () {
	            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
	            if (!s.params.autoplay) return false;
	            if (s.autoplaying) return false;
	            s.autoplaying = true;
	            s.emit('onAutoplayStart', s);
	            autoplay();
	        };
	        s.stopAutoplay = function (internal) {
	            if (!s.autoplayTimeoutId) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplaying = false;
	            s.autoplayTimeoutId = undefined;
	            s.emit('onAutoplayStop', s);
	        };
	        s.pauseAutoplay = function (speed) {
	            if (s.autoplayPaused) return;
	            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
	            s.autoplayPaused = true;
	            if (speed === 0) {
	                s.autoplayPaused = false;
	                autoplay();
	            }
	            else {
	                s.wrapper.transitionEnd(function () {
	                    if (!s) return;
	                    s.autoplayPaused = false;
	                    if (!s.autoplaying) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        autoplay();
	                    }
	                });
	            }
	        };
	        /*=========================
	          Min/Max Translate
	          ===========================*/
	        s.minTranslate = function () {
	            return (-s.snapGrid[0]);
	        };
	        s.maxTranslate = function () {
	            return (-s.snapGrid[s.snapGrid.length - 1]);
	        };
	        /*=========================
	          Slider/slides sizes
	          ===========================*/
	        s.updateAutoHeight = function () {
	            var activeSlides = [];
	            var newHeight = 0;
	            var i;
	    
	            // Find slides currently in view
	            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
	                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
	                    var index = s.activeIndex + i;
	                    if(index > s.slides.length) break;
	                    activeSlides.push(s.slides.eq(index)[0]);
	                }
	            } else {
	                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
	            }
	    
	            // Find new height from heighest slide in view
	            for (i = 0; i < activeSlides.length; i++) {
	                if (typeof activeSlides[i] !== 'undefined') {
	                    var height = activeSlides[i].offsetHeight;
	                    newHeight = height > newHeight ? height : newHeight;
	                }
	            }
	    
	            // Update Height
	            if (newHeight) s.wrapper.css('height', newHeight + 'px');
	        };
	        s.updateContainerSize = function () {
	            var width, height;
	            if (typeof s.params.width !== 'undefined') {
	                width = s.params.width;
	            }
	            else {
	                width = s.container[0].clientWidth;
	            }
	            if (typeof s.params.height !== 'undefined') {
	                height = s.params.height;
	            }
	            else {
	                height = s.container[0].clientHeight;
	            }
	            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
	                return;
	            }
	    
	            //Subtract paddings
	            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
	            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
	    
	            // Store values
	            s.width = width;
	            s.height = height;
	            s.size = s.isHorizontal() ? s.width : s.height;
	        };
	    
	        s.updateSlidesSize = function () {
	            s.slides = s.wrapper.children('.' + s.params.slideClass);
	            s.snapGrid = [];
	            s.slidesGrid = [];
	            s.slidesSizesGrid = [];
	    
	            var spaceBetween = s.params.spaceBetween,
	                slidePosition = -s.params.slidesOffsetBefore,
	                i,
	                prevSlideSize = 0,
	                index = 0;
	            if (typeof s.size === 'undefined') return;
	            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
	            }
	    
	            s.virtualSize = -spaceBetween;
	            // reset margins
	            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
	            else s.slides.css({marginRight: '', marginBottom: ''});
	    
	            var slidesNumberEvenToRows;
	            if (s.params.slidesPerColumn > 1) {
	                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
	                    slidesNumberEvenToRows = s.slides.length;
	                }
	                else {
	                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
	                }
	                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
	                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
	                }
	            }
	    
	            // Calc slides
	            var slideSize;
	            var slidesPerColumn = s.params.slidesPerColumn;
	            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
	            for (i = 0; i < s.slides.length; i++) {
	                slideSize = 0;
	                var slide = s.slides.eq(i);
	                if (s.params.slidesPerColumn > 1) {
	                    // Set slides order
	                    var newSlideOrderIndex;
	                    var column, row;
	                    if (s.params.slidesPerColumnFill === 'column') {
	                        column = Math.floor(i / slidesPerColumn);
	                        row = i - column * slidesPerColumn;
	                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
	                            if (++row >= slidesPerColumn) {
	                                row = 0;
	                                column++;
	                            }
	                        }
	                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	                        slide
	                            .css({
	                                '-webkit-box-ordinal-group': newSlideOrderIndex,
	                                '-moz-box-ordinal-group': newSlideOrderIndex,
	                                '-ms-flex-order': newSlideOrderIndex,
	                                '-webkit-order': newSlideOrderIndex,
	                                'order': newSlideOrderIndex
	                            });
	                    }
	                    else {
	                        row = Math.floor(i / slidesPerRow);
	                        column = i - row * slidesPerRow;
	                    }
	                    slide
	                        .css(
	                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
	                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
	                        )
	                        .attr('data-swiper-column', column)
	                        .attr('data-swiper-row', row);
	    
	                }
	                if (slide.css('display') === 'none') continue;
	                if (s.params.slidesPerView === 'auto') {
	                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	                }
	                else {
	                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
	                    if (s.params.roundLengths) slideSize = round(slideSize);
	    
	                    if (s.isHorizontal()) {
	                        s.slides[i].style.width = slideSize + 'px';
	                    }
	                    else {
	                        s.slides[i].style.height = slideSize + 'px';
	                    }
	                }
	                s.slides[i].swiperSlideSize = slideSize;
	                s.slidesSizesGrid.push(slideSize);
	    
	    
	                if (s.params.centeredSlides) {
	                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	                    if(prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                }
	                else {
	                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                    slidePosition = slidePosition + slideSize + spaceBetween;
	                }
	    
	                s.virtualSize += slideSize + spaceBetween;
	    
	                prevSlideSize = slideSize;
	    
	                index ++;
	            }
	            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
	            var newSlidesGrid;
	    
	            if (
	                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
	                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	            if (!s.support.flexbox || s.params.setWrapperSize) {
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	            }
	    
	            if (s.params.slidesPerColumn > 1) {
	                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
	                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
	                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
	                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
	                if (s.params.centeredSlides) {
	                    newSlidesGrid = [];
	                    for (i = 0; i < s.snapGrid.length; i++) {
	                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                    s.snapGrid = newSlidesGrid;
	                }
	            }
	    
	            // Remove last grid elements depending on width
	            if (!s.params.centeredSlides) {
	                newSlidesGrid = [];
	                for (i = 0; i < s.snapGrid.length; i++) {
	                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
	                        newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                }
	                s.snapGrid = newSlidesGrid;
	                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
	                    s.snapGrid.push(s.virtualSize - s.size);
	                }
	            }
	            if (s.snapGrid.length === 0) s.snapGrid = [0];
	    
	            if (s.params.spaceBetween !== 0) {
	                if (s.isHorizontal()) {
	                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
	                    else s.slides.css({marginRight: spaceBetween + 'px'});
	                }
	                else s.slides.css({marginBottom: spaceBetween + 'px'});
	            }
	            if (s.params.watchSlidesProgress) {
	                s.updateSlidesOffset();
	            }
	        };
	        s.updateSlidesOffset = function () {
	            for (var i = 0; i < s.slides.length; i++) {
	                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
	            }
	        };
	    
	        /*=========================
	          Dynamic Slides Per View
	          ===========================*/
	        s.currentSlidesPerView = function () {
	            var spv = 1, i, j;
	            if (s.params.centeredSlides) {
	                var size = s.slides[s.activeIndex].swiperSlideSize;
	                var breakLoop;
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slides[i] && !breakLoop) {
	                        size += s.slides[i].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	                for (j = s.activeIndex - 1; j >= 0; j--) {
	                    if (s.slides[j] && !breakLoop) {
	                        size += s.slides[j].swiperSlideSize;
	                        spv ++;
	                        if (size > s.size) breakLoop = true;
	                    }
	                }
	            }
	            else {
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
	                        spv++;
	                    }
	                }
	            }
	            return spv;
	        };
	        /*=========================
	          Slider/slides progress
	          ===========================*/
	        s.updateSlidesProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            if (s.slides.length === 0) return;
	            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
	    
	            var offsetCenter = -translate;
	            if (s.rtl) offsetCenter = translate;
	    
	            // Visible Slides
	            s.slides.removeClass(s.params.slideVisibleClass);
	            for (var i = 0; i < s.slides.length; i++) {
	                var slide = s.slides[i];
	                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
	                if (s.params.watchSlidesVisibility) {
	                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
	                    var isVisible =
	                        (slideBefore >= 0 && slideBefore < s.size) ||
	                        (slideAfter > 0 && slideAfter <= s.size) ||
	                        (slideBefore <= 0 && slideAfter >= s.size);
	                    if (isVisible) {
	                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
	                    }
	                }
	                slide.progress = s.rtl ? -slideProgress : slideProgress;
	            }
	        };
	        s.updateProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            var wasBeginning = s.isBeginning;
	            var wasEnd = s.isEnd;
	            if (translatesDiff === 0) {
	                s.progress = 0;
	                s.isBeginning = s.isEnd = true;
	            }
	            else {
	                s.progress = (translate - s.minTranslate()) / (translatesDiff);
	                s.isBeginning = s.progress <= 0;
	                s.isEnd = s.progress >= 1;
	            }
	            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
	            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
	    
	            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
	            s.emit('onProgress', s, s.progress);
	        };
	        s.updateActiveIndex = function () {
	            var translate = s.rtl ? s.translate : -s.translate;
	            var newActiveIndex, i, snapIndex;
	            for (i = 0; i < s.slidesGrid.length; i ++) {
	                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
	                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
	                        newActiveIndex = i;
	                    }
	                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
	                        newActiveIndex = i + 1;
	                    }
	                }
	                else {
	                    if (translate >= s.slidesGrid[i]) {
	                        newActiveIndex = i;
	                    }
	                }
	            }
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
	            }
	            // for (i = 0; i < s.slidesGrid.length; i++) {
	                // if (- translate >= s.slidesGrid[i]) {
	                    // newActiveIndex = i;
	                // }
	            // }
	            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
	            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
	    
	            if (newActiveIndex === s.activeIndex) {
	                return;
	            }
	            s.snapIndex = snapIndex;
	            s.previousIndex = s.activeIndex;
	            s.activeIndex = newActiveIndex;
	            s.updateClasses();
	            s.updateRealIndex();
	        };
	        s.updateRealIndex = function(){
	            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
	        };
	    
	        /*=========================
	          Classes
	          ===========================*/
	        s.updateClasses = function () {
	            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
	            var activeSlide = s.slides.eq(s.activeIndex);
	            // Active classes
	            activeSlide.addClass(s.params.slideActiveClass);
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	            }
	            // Next Slide
	            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
	            if (s.params.loop && nextSlide.length === 0) {
	                nextSlide = s.slides.eq(0);
	                nextSlide.addClass(s.params.slideNextClass);
	            }
	            // Prev Slide
	            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
	            if (s.params.loop && prevSlide.length === 0) {
	                prevSlide = s.slides.eq(-1);
	                prevSlide.addClass(s.params.slidePrevClass);
	            }
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	            }
	    
	            // Pagination
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                // Current/Total
	                var current,
	                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                if (s.params.loop) {
	                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
	                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
	                        current = current - (s.slides.length - s.loopedSlides * 2);
	                    }
	                    if (current > total - 1) current = current - total;
	                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
	                }
	                else {
	                    if (typeof s.snapIndex !== 'undefined') {
	                        current = s.snapIndex;
	                    }
	                    else {
	                        current = s.activeIndex || 0;
	                    }
	                }
	                // Types
	                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
	                    s.bullets.removeClass(s.params.bulletActiveClass);
	                    if (s.paginationContainer.length > 1) {
	                        s.bullets.each(function () {
	                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
	                        });
	                    }
	                    else {
	                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
	                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
	                }
	                if (s.params.paginationType === 'progress') {
	                    var scale = (current + 1) / total,
	                        scaleX = scale,
	                        scaleY = 1;
	                    if (!s.isHorizontal()) {
	                        scaleY = scale;
	                        scaleX = 1;
	                    }
	                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
	                }
	                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
	                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	    
	            // Next/active buttons
	            if (!s.params.loop) {
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    if (s.isBeginning) {
	                        s.prevButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
	                    }
	                    else {
	                        s.prevButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
	                    }
	                }
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    if (s.isEnd) {
	                        s.nextButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
	                    }
	                    else {
	                        s.nextButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
	                    }
	                }
	            }
	        };
	    
	        /*=========================
	          Pagination
	          ===========================*/
	        s.updatePagination = function () {
	            if (!s.params.pagination) return;
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                var paginationHTML = '';
	                if (s.params.paginationType === 'bullets') {
	                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                    for (var i = 0; i < numberOfBullets; i++) {
	                        if (s.params.paginationBulletRender) {
	                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
	                        }
	                        else {
	                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
	                        }
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
	                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
	                        s.a11y.initPagination();
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    if (s.params.paginationFractionRender) {
	                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
	                    }
	                    else {
	                        paginationHTML =
	                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
	                            ' / ' +
	                            '<span class="' + s.params.paginationTotalClass+'"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType === 'progress') {
	                    if (s.params.paginationProgressRender) {
	                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
	                    }
	                    else {
	                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType !== 'custom') {
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        };
	        /*=========================
	          Common update method
	          ===========================*/
	        s.update = function (updateTranslate) {
	            if (!s) return;
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updateProgress();
	            s.updatePagination();
	            s.updateClasses();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            var newTranslate;
	            function forceSetTranslate() {
	                var translate = s.rtl ? -s.translate : s.translate;
	                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	            }
	            if (updateTranslate) {
	                var translated;
	                if (s.controller && s.controller.spline) {
	                    s.controller.spline = undefined;
	                }
	                if (s.params.freeMode) {
	                    forceSetTranslate();
	                    if (s.params.autoHeight) {
	                        s.updateAutoHeight();
	                    }
	                }
	                else {
	                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
	                    }
	                    else {
	                        translated = s.slideTo(s.activeIndex, 0, false, true);
	                    }
	                    if (!translated) {
	                        forceSetTranslate();
	                    }
	                }
	            }
	            else if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	        };
	    
	        /*=========================
	          Resize Handler
	          ===========================*/
	        s.onResize = function (forceUpdatePagination) {
	            if (s.params.onBeforeResize) s.params.onBeforeResize(s);
	            //Breakpoints
	            if (s.params.breakpoints) {
	                s.setBreakpoint();
	            }
	    
	            // Disable locks on resize
	            var allowSwipeToPrev = s.params.allowSwipeToPrev;
	            var allowSwipeToNext = s.params.allowSwipeToNext;
	            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
	    
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            if (s.controller && s.controller.spline) {
	                s.controller.spline = undefined;
	            }
	            var slideChangedBySlideTo = false;
	            if (s.params.freeMode) {
	                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	    
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	            }
	            else {
	                s.updateClasses();
	                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
	                }
	                else {
	                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
	                }
	            }
	            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
	                s.lazy.load();
	            }
	            // Return locks after resize
	            s.params.allowSwipeToPrev = allowSwipeToPrev;
	            s.params.allowSwipeToNext = allowSwipeToNext;
	            if (s.params.onAfterResize) s.params.onAfterResize(s);
	        };
	    
	        /*=========================
	          Events
	          ===========================*/
	    
	        //Define Touch Events
	        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
	        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
	        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
	        s.touchEvents = {
	            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
	            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
	            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
	        };
	    
	    
	        // WP8 Touch Events Fix
	        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
	            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
	        }
	    
	        // Attach/detach events
	        s.initEvents = function (detach) {
	            var actionDom = detach ? 'off' : 'on';
	            var action = detach ? 'removeEventListener' : 'addEventListener';
	            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
	            var target = s.support.touch ? touchEventsTarget : document;
	    
	            var moveCapture = s.params.nested ? true : false;
	    
	            //Touch Events
	            if (s.browser.ie) {
	                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
	                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                target[action](s.touchEvents.end, s.onTouchEnd, false);
	            }
	            else {
	                if (s.support.touch) {
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
	                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
	                }
	                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
	                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
	                    document[action]('mousemove', s.onTouchMove, moveCapture);
	                    document[action]('mouseup', s.onTouchEnd, false);
	                }
	            }
	            window[action]('resize', s.onResize);
	    
	            // Next, Prev, Index
	            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                s.nextButton[actionDom]('click', s.onClickNext);
	                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                s.prevButton[actionDom]('click', s.onClickPrev);
	                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.pagination && s.params.paginationClickable) {
	                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
	                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
	            }
	    
	            // Prevent Links Clicks
	            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
	        };
	        s.attachEvents = function () {
	            s.initEvents();
	        };
	        s.detachEvents = function () {
	            s.initEvents(true);
	        };
	    
	        /*=========================
	          Handle Clicks
	          ===========================*/
	        // Prevent Clicks
	        s.allowClick = true;
	        s.preventClicks = function (e) {
	            if (!s.allowClick) {
	                if (s.params.preventClicks) e.preventDefault();
	                if (s.params.preventClicksPropagation && s.animating) {
	                    e.stopPropagation();
	                    e.stopImmediatePropagation();
	                }
	            }
	        };
	        // Clicks
	        s.onClickNext = function (e) {
	            e.preventDefault();
	            if (s.isEnd && !s.params.loop) return;
	            s.slideNext();
	        };
	        s.onClickPrev = function (e) {
	            e.preventDefault();
	            if (s.isBeginning && !s.params.loop) return;
	            s.slidePrev();
	        };
	        s.onClickIndex = function (e) {
	            e.preventDefault();
	            var index = $(this).index() * s.params.slidesPerGroup;
	            if (s.params.loop) index = index + s.loopedSlides;
	            s.slideTo(index);
	        };
	    
	        /*=========================
	          Handle Touches
	          ===========================*/
	        function findElementInEvent(e, selector) {
	            var el = $(e.target);
	            if (!el.is(selector)) {
	                if (typeof selector === 'string') {
	                    el = el.parents(selector);
	                }
	                else if (selector.nodeType) {
	                    var found;
	                    el.parents().each(function (index, _el) {
	                        if (_el === selector) found = selector;
	                    });
	                    if (!found) return undefined;
	                    else return selector;
	                }
	            }
	            if (el.length === 0) {
	                return undefined;
	            }
	            return el[0];
	        }
	        s.updateClickedSlide = function (e) {
	            var slide = findElementInEvent(e, '.' + s.params.slideClass);
	            var slideFound = false;
	            if (slide) {
	                for (var i = 0; i < s.slides.length; i++) {
	                    if (s.slides[i] === slide) slideFound = true;
	                }
	            }
	    
	            if (slide && slideFound) {
	                s.clickedSlide = slide;
	                s.clickedIndex = $(slide).index();
	            }
	            else {
	                s.clickedSlide = undefined;
	                s.clickedIndex = undefined;
	                return;
	            }
	            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
	                var slideToIndex = s.clickedIndex,
	                    realIndex,
	                    duplicatedSlides,
	                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
	                if (s.params.loop) {
	                    if (s.animating) return;
	                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
	                    if (s.params.centeredSlides) {
	                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                    else {
	                        if (slideToIndex > s.slides.length - slidesPerView) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                }
	                else {
	                    s.slideTo(slideToIndex);
	                }
	            }
	        };
	    
	        var isTouched,
	            isMoved,
	            allowTouchCallbacks,
	            touchStartTime,
	            isScrolling,
	            currentTranslate,
	            startTranslate,
	            allowThresholdMove,
	            // Form elements to match
	            formElements = 'input, select, textarea, button, video',
	            // Last click time
	            lastClickTime = Date.now(), clickTimeout,
	            //Velocities
	            velocities = [],
	            allowMomentumBounce;
	    
	        // Animating Flag
	        s.animating = false;
	    
	        // Touches information
	        s.touches = {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0
	        };
	    
	        // Touch handlers
	        var isTouchEvent, startMoving;
	        s.onTouchStart = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            isTouchEvent = e.type === 'touchstart';
	            if (!isTouchEvent && 'which' in e && e.which === 3) return;
	            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
	                s.allowClick = true;
	                return;
	            }
	            if (s.params.swipeHandler) {
	                if (!findElementInEvent(e, s.params.swipeHandler)) return;
	            }
	    
	            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	    
	            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
	                return;
	            }
	    
	            isTouched = true;
	            isMoved = false;
	            allowTouchCallbacks = true;
	            isScrolling = undefined;
	            startMoving = undefined;
	            s.touches.startX = startX;
	            s.touches.startY = startY;
	            touchStartTime = Date.now();
	            s.allowClick = true;
	            s.updateContainerSize();
	            s.swipeDirection = undefined;
	            if (s.params.threshold > 0) allowThresholdMove = false;
	            if (e.type !== 'touchstart') {
	                var preventDefault = true;
	                if ($(e.target).is(formElements)) preventDefault = false;
	                if (document.activeElement && $(document.activeElement).is(formElements)) {
	                    document.activeElement.blur();
	                }
	                if (preventDefault) {
	                    e.preventDefault();
	                }
	            }
	            s.emit('onTouchStart', s, e);
	        };
	    
	        s.onTouchMove = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (isTouchEvent && e.type === 'mousemove') return;
	            if (e.preventedByNestedSwiper) {
	                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                return;
	            }
	            if (s.params.onlyExternal) {
	                // isMoved = true;
	                s.allowClick = false;
	                if (isTouched) {
	                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = Date.now();
	                }
	                return;
	            }
	            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
	                if (!s.isHorizontal()) {
	                    // Vertical
	                    if (
	                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	                else {
	                    if (
	                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
	                        ) {
	                        return;
	                    }
	                }
	            }
	            if (isTouchEvent && document.activeElement) {
	                if (e.target === document.activeElement && $(e.target).is(formElements)) {
	                    isMoved = true;
	                    s.allowClick = false;
	                    return;
	                }
	            }
	            if (allowTouchCallbacks) {
	                s.emit('onTouchMove', s, e);
	            }
	            if (e.targetTouches && e.targetTouches.length > 1) return;
	    
	            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    
	            if (typeof isScrolling === 'undefined') {
	                var touchAngle;
	                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
	                    isScrolling = false;
	                }
	                else {
	                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
	                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
	                }
	            }
	            if (isScrolling) {
	                s.emit('onTouchMoveOpposite', s, e);
	            }
	            if (typeof startMoving === 'undefined') {
	                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
	                    startMoving = true;
	                }
	            }
	            if (!isTouched) return;
	            if (isScrolling)  {
	                isTouched = false;
	                return;
	            }
	            if (!startMoving) {
	                return;
	            }
	            s.allowClick = false;
	            s.emit('onSliderMove', s, e);
	            e.preventDefault();
	            if (s.params.touchMoveStopPropagation && !s.params.nested) {
	                e.stopPropagation();
	            }
	    
	            if (!isMoved) {
	                if (params.loop) {
	                    s.fixLoop();
	                }
	                startTranslate = s.getWrapperTranslate();
	                s.setWrapperTransition(0);
	                if (s.animating) {
	                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
	                }
	                if (s.params.autoplay && s.autoplaying) {
	                    if (s.params.autoplayDisableOnInteraction) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        s.pauseAutoplay();
	                    }
	                }
	                allowMomentumBounce = false;
	                //Grab Cursor
	                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                    s.setGrabCursor(true);
	                }
	            }
	            isMoved = true;
	    
	            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	    
	            diff = diff * s.params.touchRatio;
	            if (s.rtl) diff = -diff;
	    
	            s.swipeDirection = diff > 0 ? 'prev' : 'next';
	            currentTranslate = diff + startTranslate;
	    
	            var disableParentSwiper = true;
	            if ((diff > 0 && currentTranslate > s.minTranslate())) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
	            }
	            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
	                disableParentSwiper = false;
	                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
	            }
	    
	            if (disableParentSwiper) {
	                e.preventedByNestedSwiper = true;
	            }
	    
	            // Directions locks
	            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
	                currentTranslate = startTranslate;
	            }
	            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
	                currentTranslate = startTranslate;
	            }
	    
	    
	            // Threshold
	            if (s.params.threshold > 0) {
	                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
	                    if (!allowThresholdMove) {
	                        allowThresholdMove = true;
	                        s.touches.startX = s.touches.currentX;
	                        s.touches.startY = s.touches.currentY;
	                        currentTranslate = startTranslate;
	                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	                        return;
	                    }
	                }
	                else {
	                    currentTranslate = startTranslate;
	                    return;
	                }
	            }
	    
	            if (!s.params.followFinger) return;
	    
	            // Update active index in free mode
	            if (s.params.freeMode || s.params.watchSlidesProgress) {
	                s.updateActiveIndex();
	            }
	            if (s.params.freeMode) {
	                //Velocity
	                if (velocities.length === 0) {
	                    velocities.push({
	                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
	                        time: touchStartTime
	                    });
	                }
	                velocities.push({
	                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
	                    time: (new window.Date()).getTime()
	                });
	            }
	            // Update progress
	            s.updateProgress(currentTranslate);
	            // Update translate
	            s.setWrapperTranslate(currentTranslate);
	        };
	        s.onTouchEnd = function (e) {
	            if (e.originalEvent) e = e.originalEvent;
	            if (allowTouchCallbacks) {
	                s.emit('onTouchEnd', s, e);
	            }
	            allowTouchCallbacks = false;
	            if (!isTouched) return;
	            //Return Grab Cursor
	            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                s.setGrabCursor(false);
	            }
	    
	            // Time diff
	            var touchEndTime = Date.now();
	            var timeDiff = touchEndTime - touchStartTime;
	    
	            // Tap, doubleTap, Click
	            if (s.allowClick) {
	                s.updateClickedSlide(e);
	                s.emit('onTap', s, e);
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    clickTimeout = setTimeout(function () {
	                        if (!s) return;
	                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
	                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
	                        }
	                        s.emit('onClick', s, e);
	                    }, 300);
	    
	                }
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
	                    if (clickTimeout) clearTimeout(clickTimeout);
	                    s.emit('onDoubleTap', s, e);
	                }
	            }
	    
	            lastClickTime = Date.now();
	            setTimeout(function () {
	                if (s) s.allowClick = true;
	            }, 0);
	    
	            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
	                isTouched = isMoved = false;
	                return;
	            }
	            isTouched = isMoved = false;
	    
	            var currentPos;
	            if (s.params.followFinger) {
	                currentPos = s.rtl ? s.translate : -s.translate;
	            }
	            else {
	                currentPos = -currentTranslate;
	            }
	            if (s.params.freeMode) {
	                if (currentPos < -s.minTranslate()) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                else if (currentPos > -s.maxTranslate()) {
	                    if (s.slides.length < s.snapGrid.length) {
	                        s.slideTo(s.snapGrid.length - 1);
	                    }
	                    else {
	                        s.slideTo(s.slides.length - 1);
	                    }
	                    return;
	                }
	    
	                if (s.params.freeModeMomentum) {
	                    if (velocities.length > 1) {
	                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
	    
	                        var distance = lastMoveEvent.position - velocityEvent.position;
	                        var time = lastMoveEvent.time - velocityEvent.time;
	                        s.velocity = distance / time;
	                        s.velocity = s.velocity / 2;
	                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
	                            s.velocity = 0;
	                        }
	                        // this implies that the user stopped moving a finger then released.
	                        // There would be no events with distance zero, so the last event is stale.
	                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
	                            s.velocity = 0;
	                        }
	                    } else {
	                        s.velocity = 0;
	                    }
	                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
	    
	                    velocities.length = 0;
	                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
	                    var momentumDistance = s.velocity * momentumDuration;
	    
	                    var newPosition = s.translate + momentumDistance;
	                    if (s.rtl) newPosition = - newPosition;
	                    var doBounce = false;
	                    var afterBouncePosition;
	                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
	                    if (newPosition < s.maxTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition + s.maxTranslate() < -bounceAmount) {
	                                newPosition = s.maxTranslate() - bounceAmount;
	                            }
	                            afterBouncePosition = s.maxTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.maxTranslate();
	                        }
	                    }
	                    else if (newPosition > s.minTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition - s.minTranslate() > bounceAmount) {
	                                newPosition = s.minTranslate() + bounceAmount;
	                            }
	                            afterBouncePosition = s.minTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.minTranslate();
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        var j = 0,
	                            nextSlide;
	                        for (j = 0; j < s.snapGrid.length; j += 1) {
	                            if (s.snapGrid[j] > -newPosition) {
	                                nextSlide = j;
	                                break;
	                            }
	    
	                        }
	                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
	                            newPosition = s.snapGrid[nextSlide];
	                        } else {
	                            newPosition = s.snapGrid[nextSlide - 1];
	                        }
	                        if (!s.rtl) newPosition = - newPosition;
	                    }
	                    //Fix duration
	                    if (s.velocity !== 0) {
	                        if (s.rtl) {
	                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
	                        }
	                        else {
	                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        s.slideReset();
	                        return;
	                    }
	    
	                    if (s.params.freeModeMomentumBounce && doBounce) {
	                        s.updateProgress(afterBouncePosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        s.animating = true;
	                        s.wrapper.transitionEnd(function () {
	                            if (!s || !allowMomentumBounce) return;
	                            s.emit('onMomentumBounce', s);
	    
	                            s.setWrapperTransition(s.params.speed);
	                            s.setWrapperTranslate(afterBouncePosition);
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        });
	                    } else if (s.velocity) {
	                        s.updateProgress(newPosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        if (!s.animating) {
	                            s.animating = true;
	                            s.wrapper.transitionEnd(function () {
	                                if (!s) return;
	                                s.onTransitionEnd();
	                            });
	                        }
	    
	                    } else {
	                        s.updateProgress(newPosition);
	                    }
	    
	                    s.updateActiveIndex();
	                }
	                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
	                    s.updateProgress();
	                    s.updateActiveIndex();
	                }
	                return;
	            }
	    
	            // Find current slide
	            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
	            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
	                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
	                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
	                    }
	                }
	                else {
	                    if (currentPos >= s.slidesGrid[i]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
	                    }
	                }
	            }
	    
	            // Find current slide size
	            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
	    
	            if (timeDiff > s.params.longSwipesMs) {
	                // Long touches
	                if (!s.params.longSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	    
	                }
	                if (s.swipeDirection === 'prev') {
	                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else s.slideTo(stopIndex);
	                }
	            }
	            else {
	                // Short swipes
	                if (!s.params.shortSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    s.slideTo(stopIndex + s.params.slidesPerGroup);
	    
	                }
	                if (s.swipeDirection === 'prev') {
	                    s.slideTo(stopIndex);
	                }
	            }
	        };
	        /*=========================
	          Transitions
	          ===========================*/
	        s._slideTo = function (slideIndex, speed) {
	            return s.slideTo(slideIndex, speed, true, true);
	        };
	        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (typeof slideIndex === 'undefined') slideIndex = 0;
	            if (slideIndex < 0) slideIndex = 0;
	            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
	            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
	    
	            var translate = - s.snapGrid[s.snapIndex];
	            // Stop autoplay
	            if (s.params.autoplay && s.autoplaying) {
	                if (internal || !s.params.autoplayDisableOnInteraction) {
	                    s.pauseAutoplay(speed);
	                }
	                else {
	                    s.stopAutoplay();
	                }
	            }
	            // Update progress
	            s.updateProgress(translate);
	    
	            // Normalize slideIndex
	            if(s.params.normalizeSlideIndex){
	                for (var i = 0; i < s.slidesGrid.length; i++) {
	                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
	                        slideIndex = i;
	                    }
	                }
	            }
	    
	            // Directions locks
	            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
	                if ((s.activeIndex || 0) !== slideIndex ) return false;
	            }
	    
	            // Update Index
	            if (typeof speed === 'undefined') speed = s.params.speed;
	            s.previousIndex = s.activeIndex || 0;
	            s.activeIndex = slideIndex;
	            s.updateRealIndex();
	            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
	                // Update Height
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	                s.updateClasses();
	                if (s.params.effect !== 'slide') {
	                    s.setWrapperTranslate(translate);
	                }
	                return false;
	            }
	            s.updateClasses();
	            s.onTransitionStart(runCallbacks);
	    
	            if (speed === 0 || s.browser.lteIE9) {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(0);
	                s.onTransitionEnd(runCallbacks);
	            }
	            else {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(speed);
	                if (!s.animating) {
	                    s.animating = true;
	                    s.wrapper.transitionEnd(function () {
	                        if (!s) return;
	                        s.onTransitionEnd(runCallbacks);
	                    });
	                }
	    
	            }
	    
	            return true;
	        };
	    
	        s.onTransitionStart = function (runCallbacks) {
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	            if (s.lazy) s.lazy.onTransitionStart();
	            if (runCallbacks) {
	                s.emit('onTransitionStart', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeStart', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextStart', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevStart', s);
	                    }
	                }
	    
	            }
	        };
	        s.onTransitionEnd = function (runCallbacks) {
	            s.animating = false;
	            s.setWrapperTransition(0);
	            if (typeof runCallbacks === 'undefined') runCallbacks = true;
	            if (s.lazy) s.lazy.onTransitionEnd();
	            if (runCallbacks) {
	                s.emit('onTransitionEnd', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeEnd', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextEnd', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevEnd', s);
	                    }
	                }
	            }
	            if (s.params.history && s.history) {
	                s.history.setHistory(s.params.history, s.activeIndex);
	            }
	            if (s.params.hashnav && s.hashnav) {
	                s.hashnav.setHash();
	            }
	    
	        };
	        s.slideNext = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	        };
	        s._slideNext = function (speed) {
	            return s.slideNext(true, speed, true);
	        };
	        s.slidePrev = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating) return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	            }
	            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	        };
	        s._slidePrev = function (speed) {
	            return s.slidePrev(true, speed, true);
	        };
	        s.slideReset = function (runCallbacks, speed, internal) {
	            return s.slideTo(s.activeIndex, speed, runCallbacks);
	        };
	    
	        s.disableTouchControl = function () {
	            s.params.onlyExternal = true;
	            return true;
	        };
	        s.enableTouchControl = function () {
	            s.params.onlyExternal = false;
	            return true;
	        };
	    
	        /*=========================
	          Translate/transition helpers
	          ===========================*/
	        s.setWrapperTransition = function (duration, byController) {
	            s.wrapper.transition(duration);
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTransition(duration);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTransition(duration);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTransition(duration);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTransition(duration, byController);
	            }
	            s.emit('onSetTransition', s, duration);
	        };
	        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
	            var x = 0, y = 0, z = 0;
	            if (s.isHorizontal()) {
	                x = s.rtl ? -translate : translate;
	            }
	            else {
	                y = translate;
	            }
	    
	            if (s.params.roundLengths) {
	                x = round(x);
	                y = round(y);
	            }
	    
	            if (!s.params.virtualTranslate) {
	                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
	                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
	            }
	    
	            s.translate = s.isHorizontal() ? x : y;
	    
	            // Check if we need to update progress
	            var progress;
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            if (translatesDiff === 0) {
	                progress = 0;
	            }
	            else {
	                progress = (translate - s.minTranslate()) / (translatesDiff);
	            }
	            if (progress !== s.progress) {
	                s.updateProgress(translate);
	            }
	    
	            if (updateActiveIndex) s.updateActiveIndex();
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTranslate(s.translate);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTranslate(s.translate);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTranslate(s.translate);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTranslate(s.translate, byController);
	            }
	            s.emit('onSetTranslate', s, s.translate);
	        };
	    
	        s.getTranslate = function (el, axis) {
	            var matrix, curTransform, curStyle, transformMatrix;
	    
	            // automatic axis detection
	            if (typeof axis === 'undefined') {
	                axis = 'x';
	            }
	    
	            if (s.params.virtualTranslate) {
	                return s.rtl ? -s.translate : s.translate;
	            }
	    
	            curStyle = window.getComputedStyle(el, null);
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function(a){
	                        return a.replace(',','.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	    
	            if (axis === 'x') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m41;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[12]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[4]);
	            }
	            if (axis === 'y') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m42;
	                //Crazy IE10 Matrix
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[13]);
	                //Normal Browsers
	                else
	                    curTransform = parseFloat(matrix[5]);
	            }
	            if (s.rtl && curTransform) curTransform = -curTransform;
	            return curTransform || 0;
	        };
	        s.getWrapperTranslate = function (axis) {
	            if (typeof axis === 'undefined') {
	                axis = s.isHorizontal() ? 'x' : 'y';
	            }
	            return s.getTranslate(s.wrapper[0], axis);
	        };
	    
	        /*=========================
	          Observer
	          ===========================*/
	        s.observers = [];
	        function initObserver(target, options) {
	            options = options || {};
	            // create an observer instance
	            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	            var observer = new ObserverFunc(function (mutations) {
	                mutations.forEach(function (mutation) {
	                    s.onResize(true);
	                    s.emit('onObserverUpdate', s, mutation);
	                });
	            });
	    
	            observer.observe(target, {
	                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	                childList: typeof options.childList === 'undefined' ? true : options.childList,
	                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	            });
	    
	            s.observers.push(observer);
	        }
	        s.initObservers = function () {
	            if (s.params.observeParents) {
	                var containerParents = s.container.parents();
	                for (var i = 0; i < containerParents.length; i++) {
	                    initObserver(containerParents[i]);
	                }
	            }
	    
	            // Observe container
	            initObserver(s.container[0], {childList: false});
	    
	            // Observe wrapper
	            initObserver(s.wrapper[0], {attributes: false});
	        };
	        s.disconnectObservers = function () {
	            for (var i = 0; i < s.observers.length; i++) {
	                s.observers[i].disconnect();
	            }
	            s.observers = [];
	        };
	        /*=========================
	          Loop
	          ===========================*/
	        // Create looped slides
	        s.createLoop = function () {
	            // Remove duplicated slides
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	    
	            var slides = s.wrapper.children('.' + s.params.slideClass);
	    
	            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
	    
	            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
	            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
	            if (s.loopedSlides > slides.length) {
	                s.loopedSlides = slides.length;
	            }
	    
	            var prependSlides = [], appendSlides = [], i;
	            slides.each(function (index, el) {
	                var slide = $(this);
	                if (index < s.loopedSlides) appendSlides.push(el);
	                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
	                slide.attr('data-swiper-slide-index', index);
	            });
	            for (i = 0; i < appendSlides.length; i++) {
	                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	            for (i = prependSlides.length - 1; i >= 0; i--) {
	                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	        };
	        s.destroyLoop = function () {
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	            s.slides.removeAttr('data-swiper-slide-index');
	        };
	        s.reLoop = function (updatePosition) {
	            var oldIndex = s.activeIndex - s.loopedSlides;
	            s.destroyLoop();
	            s.createLoop();
	            s.updateSlidesSize();
	            if (updatePosition) {
	                s.slideTo(oldIndex + s.loopedSlides, 0, false);
	            }
	    
	        };
	        s.fixLoop = function () {
	            var newIndex;
	            //Fix For Negative Oversliding
	            if (s.activeIndex < s.loopedSlides) {
	                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	            //Fix For Positive Oversliding
	            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
	                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	        };
	        /*=========================
	          Append/Prepend/Remove Slides
	          ===========================*/
	        s.appendSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.append(slides[i]);
	                }
	            }
	            else {
	                s.wrapper.append(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	        };
	        s.prependSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            var newActiveIndex = s.activeIndex + 1;
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i]) s.wrapper.prepend(slides[i]);
	                }
	                newActiveIndex = s.activeIndex + slides.length;
	            }
	            else {
	                s.wrapper.prepend(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            s.slideTo(newActiveIndex, 0, false);
	        };
	        s.removeSlide = function (slidesIndexes) {
	            if (s.params.loop) {
	                s.destroyLoop();
	                s.slides = s.wrapper.children('.' + s.params.slideClass);
	            }
	            var newActiveIndex = s.activeIndex,
	                indexToRemove;
	            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
	                for (var i = 0; i < slidesIndexes.length; i++) {
	                    indexToRemove = slidesIndexes[i];
	                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                    if (indexToRemove < newActiveIndex) newActiveIndex--;
	                }
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	            else {
	                indexToRemove = slidesIndexes;
	                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
	                if (indexToRemove < newActiveIndex) newActiveIndex--;
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	    
	            if (s.params.loop) {
	                s.createLoop();
	            }
	    
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            if (s.params.loop) {
	                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
	            }
	            else {
	                s.slideTo(newActiveIndex, 0, false);
	            }
	    
	        };
	        s.removeAllSlides = function () {
	            var slidesIndexes = [];
	            for (var i = 0; i < s.slides.length; i++) {
	                slidesIndexes.push(i);
	            }
	            s.removeSlide(slidesIndexes);
	        };
	    
	    
	        /*=========================
	          Effects
	          ===========================*/
	        s.effects = {
	            fade: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var offset = slide[0].swiperSlideOffset;
	                        var tx = -offset;
	                        if (!s.params.virtualTranslate) tx = tx - s.translate;
	                        var ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	                        var slideOpacity = s.params.fade.crossFade ?
	                                Math.max(1 - Math.abs(slide[0].progress), 0) :
	                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
	                        slide
	                            .css({
	                                opacity: slideOpacity
	                            })
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
	    
	                    }
	    
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            flip: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var progress = slide[0].progress;
	                        if (s.params.flip.limitRotation) {
	                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        }
	                        var offset = slide[0].swiperSlideOffset;
	                        var rotate = -180 * progress,
	                            rotateY = rotate,
	                            rotateX = 0,
	                            tx = -offset,
	                            ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                            rotateX = -rotateY;
	                            rotateY = 0;
	                        }
	                        else if (s.rtl) {
	                            rotateY = -rotateY;
	                        }
	    
	                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
	    
	                        if (s.params.flip.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	    
	                        slide
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.eq(s.activeIndex).transitionEnd(function () {
	                            if (eventTriggered) return;
	                            if (!s) return;
	                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            cube: {
	                setTranslate: function () {
	                    var wrapperRotate = 0, cubeShadow;
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.wrapper.append(cubeShadow);
	                            }
	                            cubeShadow.css({height: s.width + 'px'});
	                        }
	                        else {
	                            cubeShadow = s.container.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.container.append(cubeShadow);
	                            }
	                        }
	                    }
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideAngle = i * 90;
	                        var round = Math.floor(slideAngle / 360);
	                        if (s.rtl) {
	                            slideAngle = -slideAngle;
	                            round = Math.floor(-slideAngle / 360);
	                        }
	                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        var tx = 0, ty = 0, tz = 0;
	                        if (i % 4 === 0) {
	                            tx = - round * 4 * s.size;
	                            tz = 0;
	                        }
	                        else if ((i - 1) % 4 === 0) {
	                            tx = 0;
	                            tz = - round * 4 * s.size;
	                        }
	                        else if ((i - 2) % 4 === 0) {
	                            tx = s.size + round * 4 * s.size;
	                            tz = s.size;
	                        }
	                        else if ((i - 3) % 4 === 0) {
	                            tx = - s.size;
	                            tz = 3 * s.size + s.size * 4 * round;
	                        }
	                        if (s.rtl) {
	                            tx = -tx;
	                        }
	    
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	    
	                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
	                        if (progress <= 1 && progress > -1) {
	                            wrapperRotate = i * 90 + progress * 90;
	                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
	                        }
	                        slide.transform(transform);
	                        if (s.params.cube.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	                    }
	                    s.wrapper.css({
	                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
	                    });
	    
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
	                        }
	                        else {
	                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	                            var scale1 = s.params.cube.shadowScale,
	                                scale2 = s.params.cube.shadowScale / multiplier,
	                                offset = s.params.cube.shadowOffset;
	                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
	                        }
	                    }
	                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
	                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.cube.shadow && !s.isHorizontal()) {
	                        s.container.find('.swiper-cube-shadow').transition(duration);
	                    }
	                }
	            },
	            coverflow: {
	                setTranslate: function () {
	                    var transform = s.translate;
	                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
	                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
	                    var translate = s.params.coverflow.depth;
	                    //Each slide offset from center
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideSize = s.slidesSizesGrid[i];
	                        var slideOffset = slide[0].swiperSlideOffset;
	                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
	    
	                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
	                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
	                        // var rotateZ = 0
	                        var translateZ = -translate * Math.abs(offsetMultiplier);
	    
	                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
	                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
	    
	                        //Fix for ultra small values
	                        if (Math.abs(translateX) < 0.001) translateX = 0;
	                        if (Math.abs(translateY) < 0.001) translateY = 0;
	                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
	                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
	                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
	    
	                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
	    
	                        slide.transform(slideTransform);
	                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	                        if (s.params.coverflow.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
	                        }
	                    }
	    
	                    //Set correct perspective for IE10
	                    if (s.browser.ie) {
	                        var ws = s.wrapper[0].style;
	                        ws.perspectiveOrigin = center + 'px 50%';
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                }
	            }
	        };
	    
	    
	        /*=========================
	          Images Lazy Loading
	          ===========================*/
	        s.lazy = {
	            initialImageLoaded: false,
	            loadImageInSlide: function (index, loadInDuplicate) {
	                if (typeof index === 'undefined') return;
	                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
	                if (s.slides.length === 0) return;
	    
	                var slide = s.slides.eq(index);
	                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
	                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
	                    img = img.add(slide[0]);
	                }
	                if (img.length === 0) return;
	    
	                img.each(function () {
	                    var _img = $(this);
	                    _img.addClass(s.params.lazyStatusLoadingClass);
	                    var background = _img.attr('data-background');
	                    var src = _img.attr('data-src'),
	                        srcset = _img.attr('data-srcset'),
	                        sizes = _img.attr('data-sizes');
	                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
	                        if (typeof s === 'undefined' || s === null || !s) return;
	                        if (background) {
	                            _img.css('background-image', 'url("' + background + '")');
	                            _img.removeAttr('data-background');
	                        }
	                        else {
	                            if (srcset) {
	                                _img.attr('srcset', srcset);
	                                _img.removeAttr('data-srcset');
	                            }
	                            if (sizes) {
	                                _img.attr('sizes', sizes);
	                                _img.removeAttr('data-sizes');
	                            }
	                            if (src) {
	                                _img.attr('src', src);
	                                _img.removeAttr('data-src');
	                            }
	    
	                        }
	    
	                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
	                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
	                        if (s.params.loop && loadInDuplicate) {
	                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
	                            if (slide.hasClass(s.params.slideDuplicateClass)) {
	                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
	                                s.lazy.loadImageInSlide(originalSlide.index(), false);
	                            }
	                            else {
	                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
	                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
	                            }
	                        }
	                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
	                    });
	    
	                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
	                });
	    
	            },
	            load: function () {
	                var i;
	                var slidesPerView = s.params.slidesPerView;
	                if (slidesPerView === 'auto') {
	                    slidesPerView = 0;
	                }
	                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
	                if (s.params.watchSlidesVisibility) {
	                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
	                        s.lazy.loadImageInSlide($(this).index());
	                    });
	                }
	                else {
	                    if (slidesPerView > 1) {
	                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        s.lazy.loadImageInSlide(s.activeIndex);
	                    }
	                }
	                if (s.params.lazyLoadingInPrevNext) {
	                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
	                        var amount = s.params.lazyLoadingInPrevNextAmount;
	                        var spv = slidesPerView;
	                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
	                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
	                        // Next Slides
	                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                        // Prev Slides
	                        for (i = minIndex; i < s.activeIndex ; i++) {
	                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
	                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
	    
	                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
	                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
	                    }
	                }
	            },
	            onTransitionStart: function () {
	                if (s.params.lazyLoading) {
	                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
	                        s.lazy.load();
	                    }
	                }
	            },
	            onTransitionEnd: function () {
	                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
	                    s.lazy.load();
	                }
	            }
	        };
	    
	    
	        /*=========================
	          Scrollbar
	          ===========================*/
	        s.scrollbar = {
	            isTouched: false,
	            setDragPosition: function (e) {
	                var sb = s.scrollbar;
	                var x = 0, y = 0;
	                var translate;
	                var pointerPosition = s.isHorizontal() ?
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
	                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
	                var positionMin = -s.minTranslate() * sb.moveDivider;
	                var positionMax = -s.maxTranslate() * sb.moveDivider;
	                if (position < positionMin) {
	                    position = positionMin;
	                }
	                else if (position > positionMax) {
	                    position = positionMax;
	                }
	                position = -position / sb.moveDivider;
	                s.updateProgress(position);
	                s.setWrapperTranslate(position, true);
	            },
	            dragStart: function (e) {
	                var sb = s.scrollbar;
	                sb.isTouched = true;
	                e.preventDefault();
	                e.stopPropagation();
	    
	                sb.setDragPosition(e);
	                clearTimeout(sb.dragTimeout);
	    
	                sb.track.transition(0);
	                if (s.params.scrollbarHide) {
	                    sb.track.css('opacity', 1);
	                }
	                s.wrapper.transition(100);
	                sb.drag.transition(100);
	                s.emit('onScrollbarDragStart', s);
	            },
	            dragMove: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                if (e.preventDefault) e.preventDefault();
	                else e.returnValue = false;
	                sb.setDragPosition(e);
	                s.wrapper.transition(0);
	                sb.track.transition(0);
	                sb.drag.transition(0);
	                s.emit('onScrollbarDragMove', s);
	            },
	            dragEnd: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched) return;
	                sb.isTouched = false;
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.dragTimeout);
	                    sb.dragTimeout = setTimeout(function () {
	                        sb.track.css('opacity', 0);
	                        sb.track.transition(400);
	                    }, 1000);
	    
	                }
	                s.emit('onScrollbarDragEnd', s);
	                if (s.params.scrollbarSnapOnRelease) {
	                    s.slideReset();
	                }
	            },
	            draggableEvents: (function () {
	                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
	                else return s.touchEvents;
	            })(),
	            enableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
	                $(target).on(sb.draggableEvents.move, sb.dragMove);
	                $(target).on(sb.draggableEvents.end, sb.dragEnd);
	            },
	            disableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
	                $(target).off(sb.draggableEvents.move, sb.dragMove);
	                $(target).off(sb.draggableEvents.end, sb.dragEnd);
	            },
	            set: function () {
	                if (!s.params.scrollbar) return;
	                var sb = s.scrollbar;
	                sb.track = $(s.params.scrollbar);
	                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
	                    sb.track = s.container.find(s.params.scrollbar);
	                }
	                sb.drag = sb.track.find('.swiper-scrollbar-drag');
	                if (sb.drag.length === 0) {
	                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
	                    sb.track.append(sb.drag);
	                }
	                sb.drag[0].style.width = '';
	                sb.drag[0].style.height = '';
	                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
	    
	                sb.divider = s.size / s.virtualSize;
	                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
	                sb.dragSize = sb.trackSize * sb.divider;
	    
	                if (s.isHorizontal()) {
	                    sb.drag[0].style.width = sb.dragSize + 'px';
	                }
	                else {
	                    sb.drag[0].style.height = sb.dragSize + 'px';
	                }
	    
	                if (sb.divider >= 1) {
	                    sb.track[0].style.display = 'none';
	                }
	                else {
	                    sb.track[0].style.display = '';
	                }
	                if (s.params.scrollbarHide) {
	                    sb.track[0].style.opacity = 0;
	                }
	            },
	            setTranslate: function () {
	                if (!s.params.scrollbar) return;
	                var diff;
	                var sb = s.scrollbar;
	                var translate = s.translate || 0;
	                var newPos;
	    
	                var newSize = sb.dragSize;
	                newPos = (sb.trackSize - sb.dragSize) * s.progress;
	                if (s.rtl && s.isHorizontal()) {
	                    newPos = -newPos;
	                    if (newPos > 0) {
	                        newSize = sb.dragSize - newPos;
	                        newPos = 0;
	                    }
	                    else if (-newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize + newPos;
	                    }
	                }
	                else {
	                    if (newPos < 0) {
	                        newSize = sb.dragSize + newPos;
	                        newPos = 0;
	                    }
	                    else if (newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize - newPos;
	                    }
	                }
	                if (s.isHorizontal()) {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateX(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.width = newSize + 'px';
	                }
	                else {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateY(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.height = newSize + 'px';
	                }
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.timeout);
	                    sb.track[0].style.opacity = 1;
	                    sb.timeout = setTimeout(function () {
	                        sb.track[0].style.opacity = 0;
	                        sb.track.transition(400);
	                    }, 1000);
	                }
	            },
	            setTransition: function (duration) {
	                if (!s.params.scrollbar) return;
	                s.scrollbar.drag.transition(duration);
	            }
	        };
	    
	    
	        /*=========================
	          Controller
	          ===========================*/
	        s.controller = {
	            LinearSpline: function (x, y) {
	                var binarySearch = (function() {
	                    var maxIndex, minIndex, guess;
	                    return function(array, val) {
	                        minIndex = -1;
	                        maxIndex = array.length;
	                        while (maxIndex - minIndex > 1)
	                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
	                                minIndex = guess;
	                            } else {
	                                maxIndex = guess;
	                            }
	                        return maxIndex;
	                    };
	                })();
	                this.x = x;
	                this.y = y;
	                this.lastIndex = x.length - 1;
	                // Given an x value (x2), return the expected y2 value:
	                // (x1,y1) is the known point before given value,
	                // (x3,y3) is the known point after given value.
	                var i1, i3;
	                var l = this.x.length;
	    
	                this.interpolate = function (x2) {
	                    if (!x2) return 0;
	    
	                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	                    i3 = binarySearch(this.x, x2);
	                    i1 = i3 - 1;
	    
	                    // We have our indexes i1 & i3, so we can calculate already:
	                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
	                };
	            },
	            //xxx: for now i will just save one spline function to to
	            getInterpolateFunction: function(c){
	                if(!s.controller.spline) s.controller.spline = s.params.loop ?
	                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
	                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
	            },
	            setTranslate: function (translate, byController) {
	               var controlled = s.params.control;
	               var multiplier, controlledTranslate;
	               function setControlledTranslate(c) {
	                    // this will create an Interpolate function based on the snapGrids
	                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
	                    // it makes sense to create this only once and recall it for the interpolation
	                    // the function does a lot of value caching for performance
	                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
	                    if (s.params.controlBy === 'slide') {
	                        s.controller.getInterpolateFunction(c);
	                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	                        // but it did not work out
	                        controlledTranslate = -s.controller.spline.interpolate(-translate);
	                    }
	    
	                    if(!controlledTranslate || s.params.controlBy === 'container'){
	                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
	                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
	                    }
	    
	                    if (s.params.controlInverse) {
	                        controlledTranslate = c.maxTranslate() - controlledTranslate;
	                    }
	                    c.updateProgress(controlledTranslate);
	                    c.setWrapperTranslate(controlledTranslate, false, s);
	                    c.updateActiveIndex();
	               }
	               if (Array.isArray(controlled)) {
	                   for (var i = 0; i < controlled.length; i++) {
	                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                           setControlledTranslate(controlled[i]);
	                       }
	                   }
	               }
	               else if (controlled instanceof Swiper && byController !== controlled) {
	    
	                   setControlledTranslate(controlled);
	               }
	            },
	            setTransition: function (duration, byController) {
	                var controlled = s.params.control;
	                var i;
	                function setControlledTransition(c) {
	                    c.setWrapperTransition(duration, s);
	                    if (duration !== 0) {
	                        c.onTransitionStart();
	                        c.wrapper.transitionEnd(function(){
	                            if (!controlled) return;
	                            if (c.params.loop && s.params.controlBy === 'slide') {
	                                c.fixLoop();
	                            }
	                            c.onTransitionEnd();
	    
	                        });
	                    }
	                }
	                if (Array.isArray(controlled)) {
	                    for (i = 0; i < controlled.length; i++) {
	                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                            setControlledTransition(controlled[i]);
	                        }
	                    }
	                }
	                else if (controlled instanceof Swiper && byController !== controlled) {
	                    setControlledTransition(controlled);
	                }
	            }
	        };
	    
	    
	        /*=========================
	          Parallax
	          ===========================*/
	        function setParallaxTransform(el, progress) {
	            el = $(el);
	            var p, pX, pY;
	            var rtlFactor = s.rtl ? -1 : 1;
	    
	            p = el.attr('data-swiper-parallax') || '0';
	            pX = el.attr('data-swiper-parallax-x');
	            pY = el.attr('data-swiper-parallax-y');
	            if (pX || pY) {
	                pX = pX || '0';
	                pY = pY || '0';
	            }
	            else {
	                if (s.isHorizontal()) {
	                    pX = p;
	                    pY = '0';
	                }
	                else {
	                    pY = p;
	                    pX = '0';
	                }
	            }
	    
	            if ((pX).indexOf('%') >= 0) {
	                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
	            }
	            else {
	                pX = pX * progress * rtlFactor + 'px' ;
	            }
	            if ((pY).indexOf('%') >= 0) {
	                pY = parseInt(pY, 10) * progress + '%';
	            }
	            else {
	                pY = pY * progress + 'px' ;
	            }
	    
	            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
	        }
	        s.parallax = {
	            setTranslate: function () {
	                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    setParallaxTransform(this, s.progress);
	    
	                });
	                s.slides.each(function () {
	                    var slide = $(this);
	                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
	                        setParallaxTransform(this, progress);
	                    });
	                });
	            },
	            setTransition: function (duration) {
	                if (typeof duration === 'undefined') duration = s.params.speed;
	                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
	                    var el = $(this);
	                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
	                    if (duration === 0) parallaxDuration = 0;
	                    el.transition(parallaxDuration);
	                });
	            }
	        };
	    
	    
	        /*=========================
	          Zoom
	          ===========================*/
	        s.zoom = {
	            // "Global" Props
	            scale: 1,
	            currentScale: 1,
	            isScaling: false,
	            gesture: {
	                slide: undefined,
	                slideWidth: undefined,
	                slideHeight: undefined,
	                image: undefined,
	                imageWrap: undefined,
	                zoomMax: s.params.zoomMax
	            },
	            image: {
	                isTouched: undefined,
	                isMoved: undefined,
	                currentX: undefined,
	                currentY: undefined,
	                minX: undefined,
	                minY: undefined,
	                maxX: undefined,
	                maxY: undefined,
	                width: undefined,
	                height: undefined,
	                startX: undefined,
	                startY: undefined,
	                touchesStart: {},
	                touchesCurrent: {}
	            },
	            velocity: {
	                x: undefined,
	                y: undefined,
	                prevPositionX: undefined,
	                prevPositionY: undefined,
	                prevTime: undefined
	            },
	            // Calc Scale From Multi-touches
	            getDistanceBetweenTouches: function (e) {
	                if (e.targetTouches.length < 2) return 1;
	                var x1 = e.targetTouches[0].pageX,
	                    y1 = e.targetTouches[0].pageY,
	                    x2 = e.targetTouches[1].pageX,
	                    y2 = e.targetTouches[1].pageY;
	                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	                return distance;
	            },
	            // Events
	            onGestureStart: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.slide || !z.gesture.slide.length) {
	                    z.gesture.slide = $(this);
	                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
	                    if (z.gesture.imageWrap.length === 0) {
	                        z.gesture.image = undefined;
	                        return;
	                    }
	                }
	                z.gesture.image.transition(0);
	                z.isScaling = true;
	            },
	            onGestureChange: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (s.support.gestures) {
	                    z.scale = e.scale * z.currentScale;
	                }
	                else {
	                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
	                }
	                if (z.scale > z.gesture.zoomMax) {
	                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
	                }
	                if (z.scale < s.params.zoomMin) {
	                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
	                }
	                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
	            },
	            onGestureEnd: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
	                        return;
	                    }
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
	                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                z.currentScale = z.scale;
	                z.isScaling = false;
	                if (z.scale === 1) z.gesture.slide = undefined;
	            },
	            onTouchStart: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (z.image.isTouched) return;
	                if (s.device.os === 'android') e.preventDefault();
	                z.image.isTouched = true;
	                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            },
	            onTouchMove: function (e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                s.allowClick = false;
	                if (!z.image.isTouched || !z.gesture.slide) return;
	    
	                if (!z.image.isMoved) {
	                    z.image.width = z.gesture.image[0].offsetWidth;
	                    z.image.height = z.gesture.image[0].offsetHeight;
	                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
	                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
	                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
	                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
	                    z.gesture.imageWrap.transition(0);
	                    if (s.rtl) z.image.startX = -z.image.startX;
	                    if (s.rtl) z.image.startY = -z.image.startY;
	                }
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	    
	                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
	    
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	    
	                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	    
	                if (!z.image.isMoved && !z.isScaling) {
	                    if (s.isHorizontal() &&
	                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
	                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                    else if (!s.isHorizontal() &&
	                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
	                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
	                        ) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                }
	                e.preventDefault();
	                e.stopPropagation();
	    
	                z.image.isMoved = true;
	                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
	                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
	    
	                if (z.image.currentX < z.image.minX) {
	                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
	                }
	                if (z.image.currentX > z.image.maxX) {
	                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
	                }
	    
	                if (z.image.currentY < z.image.minY) {
	                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
	                }
	                if (z.image.currentY > z.image.maxY) {
	                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
	                }
	    
	                //Velocity
	                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
	                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
	                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
	                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
	                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
	                z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                z.velocity.prevTime = Date.now();
	    
	                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTouchEnd: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	                if (!z.image.isTouched || !z.image.isMoved) {
	                    z.image.isTouched = false;
	                    z.image.isMoved = false;
	                    return;
	                }
	                z.image.isTouched = false;
	                z.image.isMoved = false;
	                var momentumDurationX = 300;
	                var momentumDurationY = 300;
	                var momentumDistanceX = z.velocity.x * momentumDurationX;
	                var newPositionX = z.image.currentX + momentumDistanceX;
	                var momentumDistanceY = z.velocity.y * momentumDurationY;
	                var newPositionY = z.image.currentY + momentumDistanceY;
	    
	                //Fix duration
	                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
	                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
	                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	    
	                z.image.currentX = newPositionX;
	                z.image.currentY = newPositionY;
	    
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
	                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
	    
	                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTransitionEnd: function (s) {
	                var z = s.zoom;
	                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
	                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
	                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
	                    z.scale = z.currentScale = 1;
	                }
	            },
	            // Toggle Zoom
	            toggleZoom: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.slide) {
	                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0) return;
	    
	                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
	    
	                if (typeof z.image.touchesStart.x === 'undefined' && e) {
	                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	                }
	                else {
	                    touchX = z.image.touchesStart.x;
	                    touchY = z.image.touchesStart.y;
	                }
	    
	                if (z.scale && z.scale !== 1) {
	                    // Zoom Out
	                    z.scale = z.currentScale = 1;
	                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.slide = undefined;
	                }
	                else {
	                    // Zoom In
	                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
	                    if (e) {
	                        slideWidth = z.gesture.slide[0].offsetWidth;
	                        slideHeight = z.gesture.slide[0].offsetHeight;
	                        offsetX = z.gesture.slide.offset().left;
	                        offsetY = z.gesture.slide.offset().top;
	                        diffX = offsetX + slideWidth/2 - touchX;
	                        diffY = offsetY + slideHeight/2 - touchY;
	    
	                        imageWidth = z.gesture.image[0].offsetWidth;
	                        imageHeight = z.gesture.image[0].offsetHeight;
	                        scaledWidth = imageWidth * z.scale;
	                        scaledHeight = imageHeight * z.scale;
	    
	                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
	                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
	                        translateMaxX = -translateMinX;
	                        translateMaxY = -translateMinY;
	    
	                        translateX = diffX * z.scale;
	                        translateY = diffY * z.scale;
	    
	                        if (translateX < translateMinX) {
	                            translateX =  translateMinX;
	                        }
	                        if (translateX > translateMaxX) {
	                            translateX = translateMaxX;
	                        }
	    
	                        if (translateY < translateMinY) {
	                            translateY =  translateMinY;
	                        }
	                        if (translateY > translateMaxY) {
	                            translateY = translateMaxY;
	                        }
	                    }
	                    else {
	                        translateX = 0;
	                        translateY = 0;
	                    }
	                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                }
	            },
	            // Attach/Detach Events
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	    
	                if (s.params.zoom) {
	                    var target = s.slides;
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
	                    // Scale image
	                    if (s.support.gestures) {
	                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
	                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
	                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
	                    }
	                    else if (s.touchEvents.start === 'touchstart') {
	                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
	                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
	                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
	                    }
	    
	                    // Move image
	                    s[action]('touchStart', s.zoom.onTouchStart);
	                    s.slides.each(function (index, slide){
	                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
	                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
	                        }
	                    });
	                    s[action]('touchEnd', s.zoom.onTouchEnd);
	    
	                    // Scale Out
	                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
	                    if (s.params.zoomToggle) {
	                        s.on('doubleTap', s.zoom.toggleZoom);
	                    }
	                }
	            },
	            init: function () {
	                s.zoom.attachEvents();
	            },
	            destroy: function () {
	                s.zoom.attachEvents(true);
	            }
	        };
	    
	    
	        /*=========================
	          Plugins API. Collect all and init all plugins
	          ===========================*/
	        s._plugins = [];
	        for (var plugin in s.plugins) {
	            var p = s.plugins[plugin](s, s.params[plugin]);
	            if (p) s._plugins.push(p);
	        }
	        // Method to call all plugins event/method
	        s.callPlugins = function (eventName) {
	            for (var i = 0; i < s._plugins.length; i++) {
	                if (eventName in s._plugins[i]) {
	                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	    
	    
	        /*=========================
	          Events/Callbacks/Plugins Emitter
	          ===========================*/
	        function normalizeEventName (eventName) {
	            if (eventName.indexOf('on') !== 0) {
	                if (eventName[0] !== eventName[0].toUpperCase()) {
	                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
	                }
	                else {
	                    eventName = 'on' + eventName;
	                }
	            }
	            return eventName;
	        }
	        s.emitterEventListeners = {
	    
	        };
	        s.emit = function (eventName) {
	            // Trigger callbacks
	            if (s.params[eventName]) {
	                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	            }
	            var i;
	            // Trigger events
	            if (s.emitterEventListeners[eventName]) {
	                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	            // Trigger plugins
	            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        };
	        s.on = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
	            s.emitterEventListeners[eventName].push(handler);
	            return s;
	        };
	        s.off = function (eventName, handler) {
	            var i;
	            eventName = normalizeEventName(eventName);
	            if (typeof handler === 'undefined') {
	                // Remove all handlers for such event
	                s.emitterEventListeners[eventName] = [];
	                return s;
	            }
	            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
	            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
	            }
	            return s;
	        };
	        s.once = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            var _handler = function () {
	                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
	                s.off(eventName, _handler);
	            };
	            s.on(eventName, _handler);
	            return s;
	        };
	    
	    
	        // Accessibility tools
	        s.a11y = {
	            makeFocusable: function ($el) {
	                $el.attr('tabIndex', '0');
	                return $el;
	            },
	            addRole: function ($el, role) {
	                $el.attr('role', role);
	                return $el;
	            },
	    
	            addLabel: function ($el, label) {
	                $el.attr('aria-label', label);
	                return $el;
	            },
	    
	            disable: function ($el) {
	                $el.attr('aria-disabled', true);
	                return $el;
	            },
	    
	            enable: function ($el) {
	                $el.attr('aria-disabled', false);
	                return $el;
	            },
	    
	            onEnterKey: function (event) {
	                if (event.keyCode !== 13) return;
	                if ($(event.target).is(s.params.nextButton)) {
	                    s.onClickNext(event);
	                    if (s.isEnd) {
	                        s.a11y.notify(s.params.lastSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.nextSlideMessage);
	                    }
	                }
	                else if ($(event.target).is(s.params.prevButton)) {
	                    s.onClickPrev(event);
	                    if (s.isBeginning) {
	                        s.a11y.notify(s.params.firstSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.prevSlideMessage);
	                    }
	                }
	                if ($(event.target).is('.' + s.params.bulletClass)) {
	                    $(event.target)[0].click();
	                }
	            },
	    
	            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
	    
	            notify: function (message) {
	                var notification = s.a11y.liveRegion;
	                if (notification.length === 0) return;
	                notification.html('');
	                notification.html(message);
	            },
	            init: function () {
	                // Setup accessibility
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    s.a11y.makeFocusable(s.nextButton);
	                    s.a11y.addRole(s.nextButton, 'button');
	                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
	                }
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    s.a11y.makeFocusable(s.prevButton);
	                    s.a11y.addRole(s.prevButton, 'button');
	                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
	                }
	    
	                $(s.container).append(s.a11y.liveRegion);
	            },
	            initPagination: function () {
	                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
	                    s.bullets.each(function () {
	                        var bullet = $(this);
	                        s.a11y.makeFocusable(bullet);
	                        s.a11y.addRole(bullet, 'button');
	                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
	                    });
	                }
	            },
	            destroy: function () {
	                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
	            }
	        };
	    
	    
	        /*=========================
	          Init/Destroy
	          ===========================*/
	        s.init = function () {
	            if (s.params.loop) s.createLoop();
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.enableDraggable();
	                }
	            }
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                if (!s.params.loop) s.updateProgress();
	                s.effects[s.params.effect].setTranslate();
	            }
	            if (s.params.loop) {
	                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
	            }
	            else {
	                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
	                if (s.params.initialSlide === 0) {
	                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
	                    if (s.lazy && s.params.lazyLoading) {
	                        s.lazy.load();
	                        s.lazy.initialImageLoaded = true;
	                    }
	                }
	            }
	            s.attachEvents();
	            if (s.params.observer && s.support.observer) {
	                s.initObservers();
	            }
	            if (s.params.preloadImages && !s.params.lazyLoading) {
	                s.preloadImages();
	            }
	            if (s.params.zoom && s.zoom) {
	                s.zoom.init();
	            }
	            if (s.params.autoplay) {
	                s.startAutoplay();
	            }
	            if (s.params.keyboardControl) {
	                if (s.enableKeyboardControl) s.enableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.enableMousewheelControl) s.enableMousewheelControl();
	            }
	            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
	            if (s.params.hashnavReplaceState) {
	                s.params.replaceState = s.params.hashnavReplaceState;
	            }
	            if (s.params.history) {
	                if (s.history) s.history.init();
	            }
	            if (s.params.hashnav) {
	                if (s.hashnav) s.hashnav.init();
	            }
	            if (s.params.a11y && s.a11y) s.a11y.init();
	            s.emit('onInit', s);
	        };
	    
	        // Cleanup dynamic styles
	        s.cleanupStyles = function () {
	            // Container
	            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
	    
	            // Wrapper
	            s.wrapper.removeAttr('style');
	    
	            // Slides
	            if (s.slides && s.slides.length) {
	                s.slides
	                    .removeClass([
	                      s.params.slideVisibleClass,
	                      s.params.slideActiveClass,
	                      s.params.slideNextClass,
	                      s.params.slidePrevClass
	                    ].join(' '))
	                    .removeAttr('style')
	                    .removeAttr('data-swiper-column')
	                    .removeAttr('data-swiper-row');
	            }
	    
	            // Pagination/Bullets
	            if (s.paginationContainer && s.paginationContainer.length) {
	                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
	            }
	            if (s.bullets && s.bullets.length) {
	                s.bullets.removeClass(s.params.bulletActiveClass);
	            }
	    
	            // Buttons
	            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
	            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
	    
	            // Scrollbar
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
	                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
	            }
	        };
	    
	        // Destroy
	        s.destroy = function (deleteInstance, cleanupStyles) {
	            // Detach evebts
	            s.detachEvents();
	            // Stop autoplay
	            s.stopAutoplay();
	            // Disable draggable
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.disableDraggable();
	                }
	            }
	            // Destroy loop
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            // Cleanup styles
	            if (cleanupStyles) {
	                s.cleanupStyles();
	            }
	            // Disconnect observer
	            s.disconnectObservers();
	    
	            // Destroy zoom
	            if (s.params.zoom && s.zoom) {
	                s.zoom.destroy();
	            }
	            // Disable keyboard/mousewheel
	            if (s.params.keyboardControl) {
	                if (s.disableKeyboardControl) s.disableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.disableMousewheelControl) s.disableMousewheelControl();
	            }
	            // Disable a11y
	            if (s.params.a11y && s.a11y) s.a11y.destroy();
	            // Delete history popstate
	            if (s.params.history && !s.params.replaceState) {
	                window.removeEventListener('popstate', s.history.setHistoryPopState);
	            }
	            if (s.params.hashnav && s.hashnav)  {
	                s.hashnav.destroy();
	            }
	            // Destroy callback
	            s.emit('onDestroy');
	            // Delete instance
	            if (deleteInstance !== false) s = null;
	        };
	    
	        s.init();
	    
	    
	    
	        // Return swiper instance
	        return s;
	    };
	    
	    /*==================================================
	        Prototype
	    ====================================================*/
	    Swiper.prototype = {
	        isSafari: (function () {
	            var ua = window.navigator.userAgent.toLowerCase();
	            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	        })(),
	        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
	        isArray: function (arr) {
	            return Object.prototype.toString.apply(arr) === '[object Array]';
	        },
	        /*==================================================
	        Browser
	        ====================================================*/
	        browser: {
	            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
	            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
	            lteIE9: (function() {
	                // create temporary DIV
	                var div = document.createElement('div');
	                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
	                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
	                // return true / false value based on what will browser render
	                return div.getElementsByTagName('i').length === 1;
	            })()
	        },
	        /*==================================================
	        Devices
	        ====================================================*/
	        device: (function () {
	            var ua = window.navigator.userAgent;
	            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	            return {
	                ios: ipad || iphone || ipod,
	                android: android
	            };
	        })(),
	        /*==================================================
	        Feature Detection
	        ====================================================*/
	        support: {
	            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
	                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	            })(),
	    
	            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
	                var div = document.createElement('div').style;
	                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
	            })(),
	    
	            flexbox: (function () {
	                var div = document.createElement('div').style;
	                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	                for (var i = 0; i < styles.length; i++) {
	                    if (styles[i] in div) return true;
	                }
	            })(),
	    
	            observer: (function () {
	                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
	            })(),
	    
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function() {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                } catch (e) {}
	                return supportsPassive;
	            })(),
	    
	            gestures: (function () {
	                return 'ongesturestart' in window;
	            })()
	        },
	        /*==================================================
	        Plugins
	        ====================================================*/
	        plugins: {}
	    };
	    
	
	})();
	
	//# sourceMappingURL=framework7.js.map


/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Vue.js v2.3.3
	 * (c) 2014-2017 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	/*  */
	
	// these helpers produces better vm code in JS engines due to their
	// explicitness and function inlining
	function isUndef (v) {
	  return v === undefined || v === null
	}
	
	function isDef (v) {
	  return v !== undefined && v !== null
	}
	
	function isTrue (v) {
	  return v === true
	}
	
	function isFalse (v) {
	  return v === false
	}
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return typeof value === 'string' || typeof value === 'number'
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	var _toString = Object.prototype.toString;
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}
	
	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Remove an item from an array
	 */
	function remove (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /([^-])([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str
	    .replace(hyphenateRE, '$1-$2')
	    .replace(hyphenateRE, '$1-$2')
	    .toLowerCase()
	});
	
	/**
	 * Simple bind, faster than native
	 */
	function bind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	  // record original fn length
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 */
	function noop () {}
	
	/**
	 * Always return false.
	 */
	var no = function () { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    try {
	      return JSON.stringify(a) === JSON.stringify(b)
	    } catch (e) {
	      // possible circular reference
	      return a === b
	    }
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(this, arguments);
	    }
	  }
	}
	
	var SSR_ATTR = 'data-server-rendered';
	
	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];
	
	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated'
	];
	
	/*  */
	
	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: ("production") !== 'production',
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: ("production") !== 'production',
	
	  /**
	   * Whether to record perf
	   */
	  performance: false,
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	});
	
	/*  */
	
	var emptyObject = Object.freeze({});
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  }
	  var segments = path.split('.');
	  return function (obj) {
	    for (var i = 0; i < segments.length; i++) {
	      if (!obj) { return }
	      obj = obj[segments[i]];
	    }
	    return obj
	  }
	}
	
	/*  */
	
	var warn = noop;
	var tip = noop;
	var formatComponentName = (null); // work around flow check
	
	if (false) {
	  var hasConsole = typeof console !== 'undefined';
	  var classifyRE = /(?:^|[-_])(\w)/g;
	  var classify = function (str) { return str
	    .replace(classifyRE, function (c) { return c.toUpperCase(); })
	    .replace(/[-_]/g, ''); };
	
	  warn = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.error("[Vue warn]: " + msg + (
	        vm ? generateComponentTrace(vm) : ''
	      ));
	    }
	  };
	
	  tip = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.warn("[Vue tip]: " + msg + (
	        vm ? generateComponentTrace(vm) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm, includeFile) {
	    if (vm.$root === vm) {
	      return '<Root>'
	    }
	    var name = typeof vm === 'string'
	      ? vm
	      : typeof vm === 'function' && vm.options
	        ? vm.options.name
	        : vm._isVue
	          ? vm.$options.name || vm.$options._componentTag
	          : vm.name;
	
	    var file = vm._isVue && vm.$options.__file;
	    if (!name && file) {
	      var match = file.match(/([^/\\]+)\.vue$/);
	      name = match && match[1];
	    }
	
	    return (
	      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
	      (file && includeFile !== false ? (" at " + file) : '')
	    )
	  };
	
	  var repeat = function (str, n) {
	    var res = '';
	    while (n) {
	      if (n % 2 === 1) { res += str; }
	      if (n > 1) { str += str; }
	      n >>= 1;
	    }
	    return res
	  };
	
	  var generateComponentTrace = function (vm) {
	    if (vm._isVue && vm.$parent) {
	      var tree = [];
	      var currentRecursiveSequence = 0;
	      while (vm) {
	        if (tree.length > 0) {
	          var last = tree[tree.length - 1];
	          if (last.constructor === vm.constructor) {
	            currentRecursiveSequence++;
	            vm = vm.$parent;
	            continue
	          } else if (currentRecursiveSequence > 0) {
	            tree[tree.length - 1] = [last, currentRecursiveSequence];
	            currentRecursiveSequence = 0;
	          }
	        }
	        tree.push(vm);
	        vm = vm.$parent;
	      }
	      return '\n\nfound in\n\n' + tree
	        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
	            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
	            : formatComponentName(vm))); })
	        .join('\n')
	    } else {
	      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
	    }
	  };
	}
	
	/*  */
	
	function handleError (err, vm, info) {
	  if (config.errorHandler) {
	    config.errorHandler.call(null, err, vm, info);
	  } else {
	    if (false) {
	      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
	    }
	    /* istanbul ignore else */
	    if (inBrowser && typeof console !== 'undefined') {
	      console.error(err);
	    } else {
	      throw err
	    }
	  }
	}
	
	/*  */
	/* globals MutationObserver */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = UA && UA.indexOf('android') > 0;
	var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	
	var supportsPassive = false;
	if (inBrowser) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', ({
	      get: function get () {
	        /* istanbul ignore next */
	        supportsPassive = true;
	      }
	    } )); // https://github.com/facebook/flow/issues/285
	    window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}
	
	var hasSymbol =
	  typeof Symbol !== 'undefined' && isNative(Symbol) &&
	  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
	
	/**
	 * Defer a task to execute it asynchronously.
	 */
	var nextTick = (function () {
	  var callbacks = [];
	  var pending = false;
	  var timerFunc;
	
	  function nextTickHandler () {
	    pending = false;
	    var copies = callbacks.slice(0);
	    callbacks.length = 0;
	    for (var i = 0; i < copies.length; i++) {
	      copies[i]();
	    }
	  }
	
	  // the nextTick behavior leverages the microtask queue, which can be accessed
	  // via either native Promise.then or MutationObserver.
	  // MutationObserver has wider support, however it is seriously bugged in
	  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
	  // completely stops working after triggering a few times... so, if native
	  // Promise is available, we will use it:
	  /* istanbul ignore if */
	  if (typeof Promise !== 'undefined' && isNative(Promise)) {
	    var p = Promise.resolve();
	    var logError = function (err) { console.error(err); };
	    timerFunc = function () {
	      p.then(nextTickHandler).catch(logError);
	      // in problematic UIWebViews, Promise.then doesn't completely break, but
	      // it can get stuck in a weird state where callbacks are pushed into the
	      // microtask queue but the queue isn't being flushed, until the browser
	      // needs to do some other work, e.g. handle a timer. Therefore we can
	      // "force" the microtask queue to be flushed by adding an empty timer.
	      if (isIOS) { setTimeout(noop); }
	    };
	  } else if (typeof MutationObserver !== 'undefined' && (
	    isNative(MutationObserver) ||
	    // PhantomJS and iOS 7.x
	    MutationObserver.toString() === '[object MutationObserverConstructor]'
	  )) {
	    // use MutationObserver where native Promise is not available,
	    // e.g. PhantomJS IE11, iOS7, Android 4.4
	    var counter = 1;
	    var observer = new MutationObserver(nextTickHandler);
	    var textNode = document.createTextNode(String(counter));
	    observer.observe(textNode, {
	      characterData: true
	    });
	    timerFunc = function () {
	      counter = (counter + 1) % 2;
	      textNode.data = String(counter);
	    };
	  } else {
	    // fallback to setTimeout
	    /* istanbul ignore next */
	    timerFunc = function () {
	      setTimeout(nextTickHandler, 0);
	    };
	  }
	
	  return function queueNextTick (cb, ctx) {
	    var _resolve;
	    callbacks.push(function () {
	      if (cb) {
	        try {
	          cb.call(ctx);
	        } catch (e) {
	          handleError(e, ctx, 'nextTick');
	        }
	      } else if (_resolve) {
	        _resolve(ctx);
	      }
	    });
	    if (!pending) {
	      pending = true;
	      timerFunc();
	    }
	    if (!cb && typeof Promise !== 'undefined') {
	      return new Promise(function (resolve, reject) {
	        _resolve = resolve;
	      })
	    }
	  }
	})();
	
	var _Set;
	/* istanbul ignore if */
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	/*  */
	
	
	var uid = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);[
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	]
	.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var arguments$1 = arguments;
	
	    // avoid leaking arguments:
	    // http://jsperf.com/closure-with-arguments
	    var i = arguments.length;
	    var args = new Array(i);
	    while (i--) {
	      args[i] = arguments$1[i];
	    }
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	        inserted = args;
	        break
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * By default, when a reactive property is set, the new value is
	 * also converted to become reactive. However when passing down props,
	 * we don't want to force conversion because the value may be a nested value
	 * under a frozen data structure. Converting it would defeat the optimization.
	 */
	var observerState = {
	  shouldConvert: true,
	  isSettingProps: false
	};
	
	/**
	 * Observer class that are attached to each observed
	 * object. Once attached, the observer converts target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatches updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive$$1(obj, keys[i], obj[keys[i]]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value)) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    observerState.shouldConvert &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive$$1 (
	  obj,
	  key,
	  val,
	  customSetter
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  var setter = property && property.set;
	
	  var childOb = observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	        }
	        if (Array.isArray(value)) {
	          dependArray(value);
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if (false) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (Array.isArray(target) && typeof key === 'number') {
	    target.length = Math.max(target.length, key);
	    target.splice(key, 1, val);
	    return val
	  }
	  if (hasOwn(target, key)) {
	    target[key] = val;
	    return val
	  }
	  var ob = (target ).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return val
	  }
	  if (!ob) {
	    target[key] = val;
	    return val
	  }
	  defineReactive$$1(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (Array.isArray(target) && typeof key === 'number') {
	    target.splice(key, 1);
	    return
	  }
	  var ob = (target ).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(target, key)) {
	    return
	  }
	  delete target[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	if (false) {
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (typeof childVal !== 'function') {
	      ("production") !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        childVal.call(this),
	        parentVal.call(this)
	      )
	    }
	  } else if (parentVal || childVal) {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm)
	        : undefined;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	};
	
	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (parentVal, childVal) {
	  var res = Object.create(parentVal || null);
	  return childVal
	    ? extend(res, childVal)
	    : res
	}
	
	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (parentVal, childVal) {
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key in childVal) {
	    var parent = ret[key];
	    var child = childVal[key];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key] = parent
	      ? parent.concat(child)
	      : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.computed = function (parentVal, childVal) {
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  extend(ret, childVal);
	  return ret
	};
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    var lower = key.toLowerCase();
	    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
	      warn(
	        'Do not use built-in or reserved HTML elements as component ' +
	        'id: ' + key
	      );
	    }
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else if (false) {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  if (false) {
	    checkComponents(child);
	  }
	
	  if (typeof child === 'function') {
	    child = child.options;
	  }
	
	  normalizeProps(child);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      parent = mergeOptions(parent, child.mixins[i], vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // handle boolean props
	  if (isType(Boolean, prop.type)) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
	      value = true;
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldConvert = observerState.shouldConvert;
	    observerState.shouldConvert = true;
	    observe(value);
	    observerState.shouldConvert = prevShouldConvert;
	  }
	  if (false) {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (false) {
	    warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm._props[key] !== undefined
	  ) {
	    return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      'Invalid prop: type check failed for prop "' + name + '".' +
	      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
	      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
	
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (simpleCheckRE.test(expectedType)) {
	    valid = typeof value === expectedType.toLowerCase();
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match ? match[1] : ''
	}
	
	function isType (type, fn) {
	  if (!Array.isArray(fn)) {
	    return getType(fn) === getType(type)
	  }
	  for (var i = 0, len = fn.length; i < len; i++) {
	    if (getType(fn[i]) === getType(type)) {
	      return true
	    }
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	/*  */
	
	var mark;
	var measure;
	
	if (false) {
	  var perf = inBrowser && window.performance;
	  /* istanbul ignore if */
	  if (
	    perf &&
	    perf.mark &&
	    perf.measure &&
	    perf.clearMarks &&
	    perf.clearMeasures
	  ) {
	    mark = function (tag) { return perf.mark(tag); };
	    measure = function (name, startTag, endTag) {
	      perf.measure(name, startTag, endTag);
	      perf.clearMarks(startTag);
	      perf.clearMarks(endTag);
	      perf.clearMeasures(name);
	    };
	  }
	}
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	if (false) {
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      "referenced during render. Make sure to declare reactive data " +
	      "properties in the data option.",
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' &&
	    Proxy.toString().match(/native code/);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.functionalContext = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	};
	
	var prototypeAccessors = { child: {} };
	
	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};
	
	Object.defineProperties( VNode.prototype, prototypeAccessors );
	
	var createEmptyVNode = function () {
	  var node = new VNode();
	  node.text = '';
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.isCloned = true;
	  return cloned
	}
	
	function cloneVNodes (vnodes) {
	  var len = vnodes.length;
	  var res = new Array(len);
	  for (var i = 0; i < len; i++) {
	    res[i] = cloneVNode(vnodes[i]);
	  }
	  return res
	}
	
	/*  */
	
	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once$$1,
	    capture: capture,
	    passive: passive
	  }
	});
	
	function createFnInvoker (fns) {
	  function invoker () {
	    var arguments$1 = arguments;
	
	    var fns = invoker.fns;
	    if (Array.isArray(fns)) {
	      for (var i = 0; i < fns.length; i++) {
	        fns[i].apply(null, arguments$1);
	      }
	    } else {
	      // return handler return value for single handlers
	      return fns.apply(null, arguments)
	    }
	  }
	  invoker.fns = fns;
	  return invoker
	}
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, cur, old, event;
	  for (name in on) {
	    cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    if (isUndef(cur)) {
	      ("production") !== 'production' && warn(
	        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
	        vm
	      );
	    } else if (isUndef(old)) {
	      if (isUndef(cur.fns)) {
	        cur = on[name] = createFnInvoker(cur);
	      }
	      add(event.name, cur, event.once, event.capture, event.passive);
	    } else if (cur !== old) {
	      old.fns = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (isUndef(on[name])) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name], event.capture);
	    }
	  }
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook) {
	  var invoker;
	  var oldHook = def[hookKey];
	
	  function wrappedHook () {
	    hook.apply(this, arguments);
	    // important: remove merged hook to ensure it's called only once
	    // and prevent memory leak
	    remove(invoker.fns, wrappedHook);
	  }
	
	  if (isUndef(oldHook)) {
	    // no existing hook
	    invoker = createFnInvoker([wrappedHook]);
	  } else {
	    /* istanbul ignore if */
	    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	      // already a merged invoker
	      invoker = oldHook;
	      invoker.fns.push(wrappedHook);
	    } else {
	      // existing plain hook
	      invoker = createFnInvoker([oldHook, wrappedHook]);
	    }
	  }
	
	  invoker.merged = true;
	  def[hookKey] = invoker;
	}
	
	/*  */
	
	function extractPropsFromVNodeData (
	  data,
	  Ctor,
	  tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      if (false) {
	        var keyInLowerCase = key.toLowerCase();
	        if (
	          key !== keyInLowerCase &&
	          attrs && hasOwn(attrs, keyInLowerCase)
	        ) {
	          tip(
	            "Prop \"" + keyInLowerCase + "\" is passed to component " +
	            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
	            " \"" + key + "\". " +
	            "Note that HTML attributes are case-insensitive and camelCased " +
	            "props need to use their kebab-case equivalents when using in-DOM " +
	            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
	          );
	        }
	      }
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey, false);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (isDef(hash)) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (isUndef(c) || typeof c === 'boolean') { continue }
	    last = res[res.length - 1];
	    //  nested
	    if (Array.isArray(c)) {
	      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
	    } else if (isPrimitive(c)) {
	      if (isTextNode(last)) {
	        // merge adjacent text nodes
	        // this is necessary for SSR hydration because text nodes are
	        // essentially merged when rendered to HTML strings
	        (last).text += String(c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (isTextNode(c) && isTextNode(last)) {
	        // merge adjacent text nodes
	        res[res.length - 1] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (isTrue(children._isVList) &&
	          isDef(c.tag) &&
	          isUndef(c.key) &&
	          isDef(nestedIndex)) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function ensureCtor (comp, base) {
	  return isObject(comp)
	    ? base.extend(comp)
	    : comp
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  context
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
	    return factory.errorComp
	  }
	
	  if (isDef(factory.resolved)) {
	    return factory.resolved
	  }
	
	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	    return factory.loadingComp
	  }
	
	  if (isDef(factory.contexts)) {
	    // already pending
	    factory.contexts.push(context);
	  } else {
	    var contexts = factory.contexts = [context];
	    var sync = true;
	
	    var forceRender = function () {
	      for (var i = 0, l = contexts.length; i < l; i++) {
	        contexts[i].$forceUpdate();
	      }
	    };
	
	    var resolve = once(function (res) {
	      // cache resolved
	      factory.resolved = ensureCtor(res, baseCtor);
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        forceRender();
	      }
	    });
	
	    var reject = once(function (reason) {
	      ("production") !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	      if (isDef(factory.errorComp)) {
	        factory.error = true;
	        forceRender();
	      }
	    });
	
	    var res = factory(resolve, reject);
	
	    if (isObject(res)) {
	      if (typeof res.then === 'function') {
	        // () => Promise
	        if (isUndef(factory.resolved)) {
	          res.then(resolve, reject);
	        }
	      } else if (isDef(res.component) && typeof res.component.then === 'function') {
	        res.component.then(resolve, reject);
	
	        if (isDef(res.error)) {
	          factory.errorComp = ensureCtor(res.error, baseCtor);
	        }
	
	        if (isDef(res.loading)) {
	          factory.loadingComp = ensureCtor(res.loading, baseCtor);
	          if (res.delay === 0) {
	            factory.loading = true;
	          } else {
	            setTimeout(function () {
	              if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                factory.loading = true;
	                forceRender();
	              }
	            }, res.delay || 200);
	          }
	        }
	
	        if (isDef(res.timeout)) {
	          setTimeout(function () {
	            if (isUndef(factory.resolved)) {
	              reject(
	                 false
	                  ? ("timeout (" + (res.timeout) + "ms)")
	                  : null
	              );
	            }
	          }, res.timeout);
	        }
	      }
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.loading
	      ? factory.loadingComp
	      : factory.resolved
	  }
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      var c = children[i];
	      if (isDef(c) && isDef(c.componentOptions)) {
	        return c
	      }
	    }
	  }
	}
	
	/*  */
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add (event, fn, once$$1) {
	  if (once$$1) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$on(event[i], fn);
	      }
	    } else {
	      (vm._events[event] || (vm._events[event] = [])).push(fn);
	      // optimize hook:event cost by using a boolean flag marked at registration
	      // instead of a hash lookup
	      if (hookRE.test(event)) {
	        vm._hasHookEvent = true;
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // array of events
	    if (Array.isArray(event)) {
	      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
	        this$1.$off(event[i$1], fn);
	      }
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (arguments.length === 1) {
	      vm._events[event] = null;
	      return vm
	    }
	    // specific handler
	    var cb;
	    var i = cbs.length;
	    while (i--) {
	      cb = cbs[i];
	      if (cb === fn || cb.fn === fn) {
	        cbs.splice(i, 1);
	        break
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    if (false) {
	      var lowerCaseEvent = event.toLowerCase();
	      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
	        tip(
	          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
	          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
	          "Note that HTML attributes are case-insensitive and you cannot use " +
	          "v-on to listen to camelCase events when using in-DOM templates. " +
	          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
	        );
	      }
	    }
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        cbs[i].apply(vm, args);
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  var defaultSlot = [];
	  for (var i = 0, l = children.length; i < l; i++) {
	    var child = children[i];
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.functionalContext === context) &&
	      child.data && child.data.slot != null
	    ) {
	      var name = child.data.slot;
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      defaultSlot.push(child);
	    }
	  }
	  // ignore whitespace
	  if (!defaultSlot.every(isWhitespace)) {
	    slots.default = defaultSlot;
	  }
	  return slots
	}
	
	function isWhitespace (node) {
	  return node.isComment || node.text === ' '
	}
	
	function resolveScopedSlots (
	  fns, // see flow/vnode
	  res
	) {
	  res = res || {};
	  for (var i = 0; i < fns.length; i++) {
	    if (Array.isArray(fns[i])) {
	      resolveScopedSlots(fns[i], res);
	    } else {
	      res[fns[i].key] = fns[i].fn;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var activeInstance = null;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	    // fire destroyed hook
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // remove reference to DOM nodes (prevents leak)
	    vm.$options._parentElm = vm.$options._refElm = null;
	  };
	}
	
	function mountComponent (
	  vm,
	  el,
	  hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
	    vm.$options.render = createEmptyVNode;
	    if (false) {
	      /* istanbul ignore if */
	      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
	        vm.$options.el || el) {
	        warn(
	          'You are using the runtime-only build of Vue where the template ' +
	          'compiler is not available. Either pre-compile the templates into ' +
	          'render functions, or use the compiler-included build.',
	          vm
	        );
	      } else {
	        warn(
	          'Failed to mount component: template or render function not defined.',
	          vm
	        );
	      }
	    }
	  }
	  callHook(vm, 'beforeMount');
	
	  var updateComponent;
	  /* istanbul ignore if */
	  if (false) {
	    updateComponent = function () {
	      var name = vm._name;
	      var id = vm._uid;
	      var startTag = "vue-perf-start:" + id;
	      var endTag = "vue-perf-end:" + id;
	
	      mark(startTag);
	      var vnode = vm._render();
	      mark(endTag);
	      measure((name + " render"), startTag, endTag);
	
	      mark(startTag);
	      vm._update(vnode, hydrating);
	      mark(endTag);
	      measure((name + " patch"), startTag, endTag);
	    };
	  } else {
	    updateComponent = function () {
	      vm._update(vm._render(), hydrating);
	    };
	  }
	
	  vm._watcher = new Watcher(vm, updateComponent, noop);
	  hydrating = false;
	
	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
	    vm._isMounted = true;
	    callHook(vm, 'mounted');
	  }
	  return vm
	}
	
	function updateChildComponent (
	  vm,
	  propsData,
	  listeners,
	  parentVnode,
	  renderChildren
	) {
	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren
	  var hasChildren = !!(
	    renderChildren ||               // has new static slots
	    vm.$options._renderChildren ||  // has old static slots
	    parentVnode.data.scopedSlots || // has new scoped slots
	    vm.$scopedSlots !== emptyObject // has old scoped slots
	  );
	
	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	  if (vm._vnode) { // update child tree's parent
	    vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;
	
	  // update props
	  if (propsData && vm.$options.props) {
	    observerState.shouldConvert = false;
	    if (false) {
	      observerState.isSettingProps = true;
	    }
	    var props = vm._props;
	    var propKeys = vm.$options._propKeys || [];
	    for (var i = 0; i < propKeys.length; i++) {
	      var key = propKeys[i];
	      props[key] = validateProp(key, vm.$options.props, propsData, vm);
	    }
	    observerState.shouldConvert = true;
	    if (false) {
	      observerState.isSettingProps = false;
	    }
	    // keep a copy of raw propsData
	    vm.$options.propsData = propsData;
	  }
	  // update listeners
	  if (listeners) {
	    var oldListeners = vm.$options._parentListeners;
	    vm.$options._parentListeners = listeners;
	    updateComponentListeners(vm, listeners, oldListeners);
	  }
	  // resolve slots + force update if has children
	  if (hasChildren) {
	    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	    vm.$forceUpdate();
	  }
	}
	
	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
	    if (vm._inactive) { return true }
	  }
	  return false
	}
	
	function activateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = false;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  } else if (vm._directInactive) {
	    return
	  }
	  if (vm._inactive || vm._inactive === null) {
	    vm._inactive = false;
	    for (var i = 0; i < vm.$children.length; i++) {
	      activateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'activated');
	  }
	}
	
	function deactivateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = true;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  }
	  if (!vm._inactive) {
	    vm._inactive = true;
	    for (var i = 0; i < vm.$children.length; i++) {
	      deactivateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'deactivated');
	  }
	}
	
	function callHook (vm, hook) {
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      try {
	        handlers[i].call(vm);
	      } catch (e) {
	        handleError(e, vm, (hook + " hook"));
	      }
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	}
	
	/*  */
	
	
	var MAX_UPDATE_COUNT = 100;
	
	var queue = [];
	var activatedChildren = [];
	var has = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  if (false) {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	  var watcher, id;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > MAX_UPDATE_COUNT) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();
	
	  resetSchedulerState();
	
	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdateHooks(updatedQueue);
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	}
	
	function callUpdateHooks (queue) {
	  var i = queue.length;
	  while (i--) {
	    var watcher = queue[i];
	    var vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  }
	}
	
	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}
	
	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
	    queue[i]._inactive = true;
	    activateChildComponent(queue[i], true /* true */);
	  }
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    has[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i > index && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$2 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options
	) {
	  this.vm = vm;
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$2; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
	    ? expOrFn.toString()
	    : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      ("production") !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  if (this.user) {
	    try {
	      value = this.getter.call(vm, vm);
	    } catch (e) {
	      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
	    }
	  } else {
	    value = this.getter.call(vm, vm);
	  }
	  // "touch" every property so they are all tracked as
	  // dependencies for deep watching
	  if (this.deep) {
	    traverse(value);
	  }
	  popTarget();
	  this.cleanupDeps();
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	var seenObjects = new _Set();
	function traverse (val) {
	  seenObjects.clear();
	  _traverse(val, seenObjects);
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
	    return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
	    this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch) { initWatch(vm, opts.watch); }
	}
	
	var isReservedProp = {
	  key: 1,
	  ref: 1,
	  slot: 1
	};
	
	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  observerState.shouldConvert = isRoot;
	  var loop = function ( key ) {
	    keys.push(key);
	    var value = validateProp(key, propsOptions, propsData, vm);
	    /* istanbul ignore else */
	    if (false) {
	      if (isReservedProp[key] || config.isReservedAttr(key)) {
	        warn(
	          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive$$1(props, key, value, function () {
	        if (vm.$parent && !observerState.isSettingProps) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    } else {
	      defineReactive$$1(props, key, value);
	    }
	    // static props are already proxied on the component's prototype
	    // during Vue.extend(). We only need to proxy props defined at
	    // instantiation here.
	    if (!(key in vm)) {
	      proxy(vm, "_props", key);
	    }
	  };
	
	  for (var key in propsOptions) loop( key );
	  observerState.shouldConvert = true;
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? getData(data, vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    ("production") !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var i = keys.length;
	  while (i--) {
	    if (props && hasOwn(props, keys[i])) {
	      ("production") !== 'production' && warn(
	        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else if (!isReserved(keys[i])) {
	      proxy(vm, "_data", keys[i]);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	function getData (data, vm) {
	  try {
	    return data.call(vm)
	  } catch (e) {
	    handleError(e, vm, "data()");
	    return {}
	  }
	}
	
	var computedWatcherOptions = { lazy: true };
	
	function initComputed (vm, computed) {
	  var watchers = vm._computedWatchers = Object.create(null);
	
	  for (var key in computed) {
	    var userDef = computed[key];
	    var getter = typeof userDef === 'function' ? userDef : userDef.get;
	    if (false) {
	      if (getter === undefined) {
	        warn(
	          ("No getter function has been defined for computed property \"" + key + "\"."),
	          vm
	        );
	        getter = noop;
	      }
	    }
	    // create internal watcher for the computed property.
	    watchers[key] = new Watcher(vm, getter, noop, computedWatcherOptions);
	
	    // component-defined computed properties are already defined on the
	    // component prototype. We only need to define computed properties defined
	    // at instantiation here.
	    if (!(key in vm)) {
	      defineComputed(vm, key, userDef);
	    } else if (false) {
	      if (key in vm.$data) {
	        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
	      } else if (vm.$options.props && key in vm.$options.props) {
	        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
	      }
	    }
	  }
	}
	
	function defineComputed (target, key, userDef) {
	  if (typeof userDef === 'function') {
	    sharedPropertyDefinition.get = createComputedGetter(key);
	    sharedPropertyDefinition.set = noop;
	  } else {
	    sharedPropertyDefinition.get = userDef.get
	      ? userDef.cache !== false
	        ? createComputedGetter(key)
	        : userDef.get
	      : noop;
	    sharedPropertyDefinition.set = userDef.set
	      ? userDef.set
	      : noop;
	  }
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function createComputedGetter (key) {
	  return function computedGetter () {
	    var watcher = this._computedWatchers && this._computedWatchers[key];
	    if (watcher) {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value
	    }
	  }
	}
	
	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
	    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
	    if (false) {
	      if (methods[key] == null) {
	        warn(
	          "method \"" + key + "\" has an undefined value in the component definition. " +
	          "Did you reference the function correctly?",
	          vm
	        );
	      }
	      if (props && hasOwn(props, key)) {
	        warn(
	          ("method \"" + key + "\" has already been defined as a prop."),
	          vm
	        );
	      }
	    }
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (vm, key, handler) {
	  var options;
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  vm.$watch(key, handler, options);
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  if (false) {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	    propsDef.set = function () {
	      warn("$props is readonly.", this);
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);
	
	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	/*  */
	
	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
	    vm._provided = typeof provide === 'function'
	      ? provide.call(vm)
	      : provide;
	  }
	}
	
	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
	    Object.keys(result).forEach(function (key) {
	      /* istanbul ignore else */
	      if (false) {
	        defineReactive$$1(vm, key, result[key], function () {
	          warn(
	            "Avoid mutating an injected value directly since the changes will be " +
	            "overwritten whenever the provided component re-renders. " +
	            "injection being mutated: \"" + key + "\"",
	            vm
	          );
	        });
	      } else {
	        defineReactive$$1(vm, key, result[key]);
	      }
	    });
	  }
	}
	
	function resolveInject (inject, vm) {
	  if (inject) {
	    // inject is :any because flow is not smart enough to figure out cached
	    // isArray here
	    var isArray = Array.isArray(inject);
	    var result = Object.create(null);
	    var keys = isArray
	      ? inject
	      : hasSymbol
	        ? Reflect.ownKeys(inject)
	        : Object.keys(inject);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var provideKey = isArray ? key : inject[key];
	      var source = vm;
	      while (source) {
	        if (source._provided && provideKey in source._provided) {
	          result[key] = source._provided[provideKey];
	          break
	        }
	        source = source.$parent;
	      }
	    }
	    return result
	  }
	}
	
	/*  */
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  context,
	  children
	) {
	  var props = {};
	  var propOptions = Ctor.options.props;
	  if (isDef(propOptions)) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData || {});
	    }
	  } else {
	    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
	    if (isDef(data.props)) { mergeProps(props, data.props); }
	  }
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var _context = Object.create(context);
	  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
	  var vnode = Ctor.options.render.call(null, h, {
	    data: data,
	    props: props,
	    children: children,
	    parent: context,
	    listeners: data.on || {},
	    injections: resolveInject(Ctor.options.inject, context),
	    slots: function () { return resolveSlots(children, context); }
	  });
	  if (vnode instanceof VNode) {
	    vnode.functionalContext = context;
	    vnode.functionalOptions = Ctor.options;
	    if (data.slot) {
	      (vnode.data || (vnode.data = {})).slot = data.slot;
	    }
	  }
	  return vnode
	}
	
	function mergeProps (to, from) {
	  for (var key in from) {
	    to[camelize(key)] = from[key];
	  }
	}
	
	/*  */
	
	// hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (
	    vnode,
	    hydrating,
	    parentElm,
	    refElm
	  ) {
	    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
	      var child = vnode.componentInstance = createComponentInstanceForVnode(
	        vnode,
	        activeInstance,
	        parentElm,
	        refElm
	      );
	      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	    } else if (vnode.data.keepAlive) {
	      // kept-alive components, treat as a patch
	      var mountedNode = vnode; // work around flow
	      componentVNodeHooks.prepatch(mountedNode, mountedNode);
	    }
	  },
	
	  prepatch: function prepatch (oldVnode, vnode) {
	    var options = vnode.componentOptions;
	    var child = vnode.componentInstance = oldVnode.componentInstance;
	    updateChildComponent(
	      child,
	      options.propsData, // updated props
	      options.listeners, // updated listeners
	      vnode, // new parent vnode
	      options.children // new children
	    );
	  },
	
	  insert: function insert (vnode) {
	    var context = vnode.context;
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isMounted) {
	      componentInstance._isMounted = true;
	      callHook(componentInstance, 'mounted');
	    }
	    if (vnode.data.keepAlive) {
	      if (context._isMounted) {
	        // vue-router#1212
	        // During updates, a kept-alive component's child components may
	        // change, so directly walking the tree here may call activated hooks
	        // on incorrect children. Instead we push them into a queue which will
	        // be processed after the whole patch process ended.
	        queueActivatedComponent(componentInstance);
	      } else {
	        activateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  },
	
	  destroy: function destroy (vnode) {
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isDestroyed) {
	      if (!vnode.data.keepAlive) {
	        componentInstance.$destroy();
	      } else {
	        deactivateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  }
	};
	
	var hooksToMerge = Object.keys(componentVNodeHooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (isUndef(Ctor)) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	
	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
	    if (false) {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  if (isUndef(Ctor.cid)) {
	    Ctor = resolveAsyncComponent(Ctor, baseCtor, context);
	    if (Ctor === undefined) {
	      // return nothing if this is indeed an async component
	      // wait for the callback to trigger parent update.
	      return
	    }
	  }
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  data = data || {};
	
	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
	    transformModel(Ctor.options, data);
	  }
	
	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);
	
	  // functional component
	  if (isTrue(Ctor.options.functional)) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  data.on = data.nativeOn;
	
	  if (isTrue(Ctor.options.abstract)) {
	    // abstract components do not keep anything
	    // other than props & listeners
	    data = {};
	  }
	
	  // merge component management hooks onto the placeholder node
	  mergeHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
	  );
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var vnodeComponentOptions = vnode.componentOptions;
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    propsData: vnodeComponentOptions.propsData,
	    _componentTag: vnodeComponentOptions.tag,
	    _parentVnode: vnode,
	    _parentListeners: vnodeComponentOptions.listeners,
	    _renderChildren: vnodeComponentOptions.children,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnodeComponentOptions.Ctor(options)
	}
	
	function mergeHooks (data) {
	  if (!data.hook) {
	    data.hook = {};
	  }
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    var fromParent = data.hook[key];
	    var ours = componentVNodeHooks[key];
	    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
	  }
	}
	
	function mergeHook$1 (one, two) {
	  return function (a, b, c, d) {
	    one(a, b, c, d);
	    two(a, b, c, d);
	  }
	}
	
	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  if (isDef(on[event])) {
	    on[event] = [data.model.callback].concat(on[event]);
	  } else {
	    on[event] = data.model.callback;
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
	    normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
	    ("production") !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	    typeof children[0] === 'function'
	  ) {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (isDef(vnode)) {
	    if (ns) { applyNS(vnode, ns); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    return
	  }
	  if (isDef(vnode.children)) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (isDef(child.tag) && isUndef(child.ns)) {
	        applyNS(child, ns);
	      }
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
	  val,
	  render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
	    ret = new Array(val.length);
	    for (i = 0, l = val.length; i < l; i++) {
	      ret[i] = render(val[i], i);
	    }
	  } else if (typeof val === 'number') {
	    ret = new Array(val);
	    for (i = 0; i < val; i++) {
	      ret[i] = render(i + 1, i);
	    }
	  } else if (isObject(val)) {
	    keys = Object.keys(val);
	    ret = new Array(keys.length);
	    for (i = 0, l = keys.length; i < l; i++) {
	      key = keys[i];
	      ret[i] = render(val[key], key, i);
	    }
	  }
	  if (isDef(ret)) {
	    (ret)._isVList = true;
	  }
	  return ret
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
	  name,
	  fallback,
	  props,
	  bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  if (scopedSlotFn) { // scoped slot
	    props = props || {};
	    if (bindObject) {
	      extend(props, bindObject);
	    }
	    return scopedSlotFn(props) || fallback
	  } else {
	    var slotNodes = this.$slots[name];
	    // warn duplicate slot usage
	    if (slotNodes && ("production") !== 'production') {
	      slotNodes._rendered && warn(
	        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	        "- this will likely cause render errors.",
	        this
	      );
	      slotNodes._rendered = true;
	    }
	    return slotNodes || fallback
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}
	
	/*  */
	
	/**
	 * Runtime helper for checking keyCodes from config.
	 */
	function checkKeyCodes (
	  eventKeyCode,
	  key,
	  builtInAlias
	) {
	  var keyCodes = config.keyCodes[key] || builtInAlias;
	  if (Array.isArray(keyCodes)) {
	    return keyCodes.indexOf(eventKeyCode) === -1
	  } else {
	    return keyCodes !== eventKeyCode
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
	  data,
	  tag,
	  value,
	  asProp
	) {
	  if (value) {
	    if (!isObject(value)) {
	      ("production") !== 'production' && warn(
	        'v-bind without argument expects an Object or Array value',
	        this
	      );
	    } else {
	      if (Array.isArray(value)) {
	        value = toObject(value);
	      }
	      var hash;
	      for (var key in value) {
	        if (key === 'class' || key === 'style') {
	          hash = data;
	        } else {
	          var type = data.attrs && data.attrs.type;
	          hash = asProp || config.mustUseProp(tag, type, key)
	            ? data.domProps || (data.domProps = {})
	            : data.attrs || (data.attrs = {});
	        }
	        if (!(key in hash)) {
	          hash[key] = value[key];
	        }
	      }
	    }
	  }
	  return data
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
	  index,
	  isInFor
	) {
	  var tree = this._staticTrees[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree by doing a shallow clone.
	  if (tree && !isInFor) {
	    return Array.isArray(tree)
	      ? cloneVNodes(tree)
	      : cloneVNode(tree)
	  }
	  // otherwise, render a fresh tree.
	  tree = this._staticTrees[index] =
	    this.$options.staticRenderFns[index].call(this._renderProxy);
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}
	
	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
	  tree,
	  index,
	  key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}
	
	function markStatic (
	  tree,
	  key,
	  isOnce
	) {
	  if (Array.isArray(tree)) {
	    for (var i = 0; i < tree.length; i++) {
	      if (tree[i] && typeof tree[i] !== 'string') {
	        markStaticNode(tree[i], (key + "_" + i), isOnce);
	      }
	    }
	  } else {
	    markStaticNode(tree, key, isOnce);
	  }
	}
	
	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}
	
	/*  */
	
	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null;
	  var parentVnode = vm.$vnode = vm.$options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	}
	
	function renderMixin (Vue) {
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var staticRenderFns = ref.staticRenderFns;
	    var _parentVnode = ref._parentVnode;
	
	    if (vm._isMounted) {
	      // clone slot nodes on re-renders
	      for (var key in vm.$slots) {
	        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
	      }
	    }
	
	    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;
	
	    if (staticRenderFns && !vm._staticTrees) {
	      vm._staticTrees = [];
	    }
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      handleError(e, vm, "render function");
	      // return error render result,
	      // or previous vnode to prevent render error causing blank component
	      /* istanbul ignore else */
	      if (false) {
	        vnode = vm.$options.renderError
	          ? vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e)
	          : vm._vnode;
	      } else {
	        vnode = vm._vnode;
	      }
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if (false) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	
	  // internal render helpers.
	  // these are exposed on the instance prototype to reduce generated render
	  // code size.
	  Vue.prototype._o = markOnce;
	  Vue.prototype._n = toNumber;
	  Vue.prototype._s = toString;
	  Vue.prototype._l = renderList;
	  Vue.prototype._t = renderSlot;
	  Vue.prototype._q = looseEqual;
	  Vue.prototype._i = looseIndexOf;
	  Vue.prototype._m = renderStatic;
	  Vue.prototype._f = resolveFilter;
	  Vue.prototype._k = checkKeyCodes;
	  Vue.prototype._b = bindObjectProps;
	  Vue.prototype._v = createTextVNode;
	  Vue.prototype._e = createEmptyVNode;
	  Vue.prototype._u = resolveScopedSlots;
	}
	
	/*  */
	
	var uid$1 = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid$1++;
	
	    var startTag, endTag;
	    /* istanbul ignore if */
	    if (false) {
	      startTag = "vue-perf-init:" + (vm._uid);
	      endTag = "vue-perf-end:" + (vm._uid);
	      mark(startTag);
	    }
	
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    if (false) {
	      initProxy(vm);
	    } else {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initInjections(vm); // resolve injections before data/props
	    initState(vm);
	    initProvide(vm); // resolve provide after data/props
	    callHook(vm, 'created');
	
	    /* istanbul ignore if */
	    if (false) {
	      vm._name = formatComponentName(vm, false);
	      mark(endTag);
	      measure(((vm._name) + " init"), startTag, endTag);
	    }
	
	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  opts.parent = options.parent;
	  opts.propsData = options.propsData;
	  opts._parentVnode = options._parentVnode;
	  opts._parentListeners = options._parentListeners;
	  opts._renderChildren = options._renderChildren;
	  opts._componentTag = options._componentTag;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = resolveConstructorOptions(Ctor.super);
	    var cachedSuperOptions = Ctor.superOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed,
	      // need to resolve new options.
	      Ctor.superOptions = superOptions;
	      // check if there are any late-modified/attached options (#4976)
	      var modifiedOptions = resolveModifiedOptions(Ctor);
	      // update base extend options
	      if (modifiedOptions) {
	        extend(Ctor.extendOptions, modifiedOptions);
	      }
	      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var extended = Ctor.extendOptions;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
	    if (latest[key] !== sealed[key]) {
	      if (!modified) { modified = {}; }
	      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
	    }
	  }
	  return modified
	}
	
	function dedupe (latest, extended, sealed) {
	  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
	  // between merges
	  if (Array.isArray(latest)) {
	    var res = [];
	    sealed = Array.isArray(sealed) ? sealed : [sealed];
	    extended = Array.isArray(extended) ? extended : [extended];
	    for (var i = 0; i < latest.length; i++) {
	      // push original options and not sealed options to exclude duplicated options
	      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
	        res.push(latest[i]);
	      }
	    }
	    return res
	  } else {
	    return latest
	  }
	}
	
	function Vue$3 (options) {
	  if (false
	  ) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue$3);
	stateMixin(Vue$3);
	eventsMixin(Vue$3);
	lifecycleMixin(Vue$3);
	renderMixin(Vue$3);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    /* istanbul ignore if */
	    if (plugin.installed) {
	      return this
	    }
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else if (typeof plugin === 'function') {
	      plugin.apply(null, args);
	    }
	    plugin.installed = true;
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	    return this
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	        warn(
	          'Invalid component name: "' + name + '". Component names ' +
	          'can only contain alphanumeric characters and the hyphen, ' +
	          'and must start with a letter.'
	        );
	      }
	    }
	
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	
	    // For props and computed properties, we define the proxy getters on
	    // the Vue instances at extension time, on the extended prototype. This
	    // avoids Object.defineProperty calls for each instance created.
	    if (Sub.options.props) {
	      initProps$1(Sub);
	    }
	    if (Sub.options.computed) {
	      initComputed$1(Sub);
	    }
	
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    ASSET_TYPES.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    Sub.sealedOptions = extend({}, Sub.options);
	
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
	    proxy(Comp.prototype, "_props", key);
	  }
	}
	
	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
	    defineComputed(Comp.prototype, key, computed[key]);
	  }
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          if (type === 'component' && config.isReservedTag(id)) {
	            warn(
	              'Do not use built-in or reserved HTML elements as component ' +
	              'id: ' + id
	            );
	          }
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	var patternTypes = [String, RegExp];
	
	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}
	
	function matches (pattern, name) {
	  if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
	    return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	function pruneCache (cache, current, filter) {
	  for (var key in cache) {
	    var cachedNode = cache[key];
	    if (cachedNode) {
	      var name = getComponentName(cachedNode.componentOptions);
	      if (name && !filter(name)) {
	        if (cachedNode !== current) {
	          pruneCacheEntry(cachedNode);
	        }
	        cache[key] = null;
	      }
	    }
	  }
	}
	
	function pruneCacheEntry (vnode) {
	  if (vnode) {
	    vnode.componentInstance.$destroy();
	  }
	}
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	
	  props: {
	    include: patternTypes,
	    exclude: patternTypes
	  },
	
	  created: function created () {
	    this.cache = Object.create(null);
	  },
	
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this$1.cache) {
	      pruneCacheEntry(this$1.cache[key]);
	    }
	  },
	
	  watch: {
	    include: function include (val) {
	      pruneCache(this.cache, this._vnode, function (name) { return matches(val, name); });
	    },
	    exclude: function exclude (val) {
	      pruneCache(this.cache, this._vnode, function (name) { return !matches(val, name); });
	    }
	  },
	
	  render: function render () {
	    var vnode = getFirstComponentChild(this.$slots.default);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      if (name && (
	        (this.include && !matches(this.include, name)) ||
	        (this.exclude && matches(this.exclude, name))
	      )) {
	        return vnode
	      }
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (this.cache[key]) {
	        vnode.componentInstance = this.cache[key].componentInstance;
	      } else {
	        this.cache[key] = vnode;
	      }
	      vnode.data.keepAlive = true;
	    }
	    return vnode
	  }
	};
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	};
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	
	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
	    warn: warn,
	    extend: extend,
	    mergeOptions: mergeOptions,
	    defineReactive: defineReactive$$1
	  };
	
	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue$3);
	
	Object.defineProperty(Vue$3.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Object.defineProperty(Vue$3.prototype, '$ssrContext', {
	  get: function get () {
	    /* istanbul ignore next */
	    return this.$vnode.ssrContext
	  }
	});
	
	Vue$3.version = '2.3.3';
	
	/*  */
	
	// these are reserved for web because they are directly compiled away
	// during template compilation
	var isReservedAttr = makeMap('style,class');
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while (isDef(parentNode = parentNode.parent)) {
	    if (parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return genClassFromData(data)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: isDef(child.class)
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function genClassFromData (data) {
	  var dynamicClass = data.class;
	  var staticClass = data.staticClass;
	  if (isDef(staticClass) || isDef(dynamicClass)) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  if (isUndef(value)) {
	    return ''
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  var res = '';
	  if (Array.isArray(value)) {
	    var stringified;
	    for (var i = 0, l = value.length; i < l; i++) {
	      if (isDef(value[i])) {
	        if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
	          res += stringified + ' ';
	        }
	      }
	    }
	    return res.slice(0, -1)
	  }
	  if (isObject(value)) {
	    for (var key in value) {
	      if (value[key]) { res += key + ' '; }
	    }
	    return res.slice(0, -1)
	  }
	  /* istanbul ignore next */
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	var isPreTag = function (tag) { return tag === 'pre'; };
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selected = document.querySelector(el);
	    if (!selected) {
	      ("production") !== 'production' && warn(
	        'Cannot find element: ' + el
	      );
	      return document.createElement('div')
	    }
	    return selected
	  } else {
	    return el
	  }
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setAttribute (node, key, val) {
	  node.setAttribute(key, val);
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setAttribute: setAttribute
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	};
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!key) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
	        refs[key].push(ref);
	      } else {
	        refs[key] = [ref];
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	
	/*
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function sameVnode (a, b) {
	  return (
	    a.key === b.key &&
	    a.tag === b.tag &&
	    a.isComment === b.isComment &&
	    isDef(a.data) === isDef(b.data) &&
	    sameInputType(a, b)
	  )
	}
	
	// Some browsers do not support dynamically changing type for <input>
	// so they need to be treated as different nodes
	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (isDef(modules[j][hooks[i]])) {
	        cbs[hooks[i]].push(modules[j][hooks[i]]);
	      }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove$$1 () {
	      if (--remove$$1.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove$$1.listeners = listeners;
	    return remove$$1
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (isDef(parent)) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  var inPre = 0;
	  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      if (false) {
	        if (data && data.pre) {
	          inPre++;
	        }
	        if (
	          !inPre &&
	          !vnode.ns &&
	          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
	          config.isUnknownElement(tag)
	        ) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if (false) {
	        inPre--;
	      }
	    } else if (isTrue(vnode.isComment)) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isTrue(isReactivated)) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (isDef(vnode.data.pendingInsert)) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref) {
	    if (isDef(parent)) {
	      if (isDef(ref)) {
	        if (ref.parentNode === parent) {
	          nodeOps.insertBefore(parent, elm, ref);
	        }
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (isDef(i.create)) { i.create(emptyNode, vnode); }
	      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    var ancestor = vnode;
	    while (ancestor) {
	      if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
	        nodeOps.setAttribute(vnode.elm, i, '');
	      }
	      ancestor = ancestor.parent;
	    }
	    // for slot content they should also get the scopeId from the host instance.
	    if (isDef(i = activeInstance) &&
	      i !== vnode.context &&
	      isDef(i = i.$options._scopeId)
	    ) {
	      nodeOps.setAttribute(vnode.elm, i, '');
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (isDef(rm) || isDef(vnode.data)) {
	      var i;
	      var listeners = cbs.remove.length + 1;
	      if (isDef(rm)) {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      } else {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, elmToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	          newStartVnode = newCh[++newStartIdx];
	        } else {
	          elmToMove = oldCh[idxInOld];
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              'It seems there are duplicate keys that is causing an update error. ' +
	              'Make sure each v-for item has a unique key.'
	            );
	          }
	          if (sameVnode(elmToMove, newStartVnode)) {
	            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
	            newStartVnode = newCh[++newStartIdx];
	          }
	        }
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (isTrue(vnode.isStatic) &&
	      isTrue(oldVnode.isStatic) &&
	      vnode.key === oldVnode.key &&
	      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
	    ) {
	      vnode.elm = oldVnode.elm;
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }
	    var i;
	    var data = vnode.data;
	    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	    var elm = vnode.elm = oldVnode.elm;
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (isDef(data) && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (isTrue(initial) && isDef(vnode.parent)) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var bailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue) {
	    if (false) {
	      if (!assertNodeMatch(elm, vnode)) {
	        return false
	      }
	    }
	    vnode.elm = elm;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          var childrenMatch = true;
	          var childNode = elm.firstChild;
	          for (var i$1 = 0; i$1 < children.length; i$1++) {
	            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
	              childrenMatch = false;
	              break
	            }
	            childNode = childNode.nextSibling;
	          }
	          // if childNode is not null, it means the actual childNodes list is
	          // longer than the virtual children list.
	          if (!childrenMatch || childNode) {
	            if (false
	            ) {
	              bailed = true;
	              console.warn('Parent: ', elm);
	              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	            }
	            return false
	          }
	        }
	      }
	      if (isDef(data)) {
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode) {
	    if (isDef(vnode.tag)) {
	      return (
	        vnode.tag.indexOf('vue-component') === 0 ||
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (isUndef(vnode)) {
	      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (isUndef(oldVnode)) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	            oldVnode.removeAttribute(SSR_ATTR);
	            hydrating = true;
	          }
	          if (isTrue(hydrating)) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else if (false) {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm$1 = nodeOps.parentNode(oldElm);
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm$1,
	          nodeOps.nextSibling(oldElm)
	        );
	
	        if (isDef(vnode.parent)) {
	          // component root element replaced.
	          // update parent placeholder node element, recursively
	          var ancestor = vnode.parent;
	          while (ancestor) {
	            ancestor.elm = vnode.elm;
	            ancestor = ancestor.parent;
	          }
	          if (isPatchable(vnode)) {
	            for (var i = 0; i < cbs.create.length; ++i) {
	              cbs.create[i](emptyNode, vnode.parent);
	            }
	          }
	        }
	
	        if (isDef(parentElm$1)) {
	          removeVnodes(parentElm$1, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	};
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    });
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    try {
	      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	    } catch (e) {
	      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
	    }
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	];
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  /* istanbul ignore if */
	  if (isIE9 && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (isUndef(attrs[key])) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, key);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      el.setAttribute(key, value);
	    }
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	};
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
	    isUndef(data.staticClass) &&
	    isUndef(data.class) && (
	      isUndef(oldData) || (
	        isUndef(oldData.staticClass) &&
	        isUndef(oldData.class)
	      )
	    )
	  ) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	};
	
	/*  */
	
	var validDivisionCharRE = /[\w).+\-_$\]]/;
	
	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;
	
	  for (i = 0; i < exp.length; i++) {
	    prev = c;
	    c = exp.charCodeAt(i);
	    if (inSingle) {
	      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
	    } else if (inDouble) {
	      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
	    } else if (inTemplateString) {
	      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
	    } else if (inRegex) {
	      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
	    } else if (
	      c === 0x7C && // pipe
	      exp.charCodeAt(i + 1) !== 0x7C &&
	      exp.charCodeAt(i - 1) !== 0x7C &&
	      !curly && !square && !paren
	    ) {
	      if (expression === undefined) {
	        // first filter, end of expression
	        lastFilterIndex = i + 1;
	        expression = exp.slice(0, i).trim();
	      } else {
	        pushFilter();
	      }
	    } else {
	      switch (c) {
	        case 0x22: inDouble = true; break         // "
	        case 0x27: inSingle = true; break         // '
	        case 0x60: inTemplateString = true; break // `
	        case 0x28: paren++; break                 // (
	        case 0x29: paren--; break                 // )
	        case 0x5B: square++; break                // [
	        case 0x5D: square--; break                // ]
	        case 0x7B: curly++; break                 // {
	        case 0x7D: curly--; break                 // }
	      }
	      if (c === 0x2f) { // /
	        var j = i - 1;
	        var p = (void 0);
	        // find first non-whitespace prev char
	        for (; j >= 0; j--) {
	          p = exp.charAt(j);
	          if (p !== ' ') { break }
	        }
	        if (!p || !validDivisionCharRE.test(p)) {
	          inRegex = true;
	        }
	      }
	    }
	  }
	
	  if (expression === undefined) {
	    expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
	    pushFilter();
	  }
	
	  function pushFilter () {
	    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
	    lastFilterIndex = i + 1;
	  }
	
	  if (filters) {
	    for (i = 0; i < filters.length; i++) {
	      expression = wrapFilter(expression, filters[i]);
	    }
	  }
	
	  return expression
	}
	
	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
	    // _f: resolveFilter
	    return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
	    var name = filter.slice(0, i);
	    var args = filter.slice(i + 1);
	    return ("_f(\"" + name + "\")(" + exp + "," + args)
	  }
	}
	
	/*  */
	
	function baseWarn (msg) {
	  console.error(("[Vue compiler]: " + msg));
	}
	
	function pluckModuleFunction (
	  modules,
	  key
	) {
	  return modules
	    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
	    : []
	}
	
	function addProp (el, name, value) {
	  (el.props || (el.props = [])).push({ name: name, value: value });
	}
	
	function addAttr (el, name, value) {
	  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
	}
	
	function addDirective (
	  el,
	  name,
	  rawName,
	  value,
	  arg,
	  modifiers
	) {
	  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
	}
	
	function addHandler (
	  el,
	  name,
	  value,
	  modifiers,
	  important,
	  warn
	) {
	  // warn prevent and passive modifier
	  /* istanbul ignore if */
	  if (
	    false
	  ) {
	    warn(
	      'passive and prevent can\'t be used together. ' +
	      'Passive handler can\'t prevent default event.'
	    );
	  }
	  // check capture modifier
	  if (modifiers && modifiers.capture) {
	    delete modifiers.capture;
	    name = '!' + name; // mark the event as captured
	  }
	  if (modifiers && modifiers.once) {
	    delete modifiers.once;
	    name = '~' + name; // mark the event as once
	  }
	  /* istanbul ignore if */
	  if (modifiers && modifiers.passive) {
	    delete modifiers.passive;
	    name = '&' + name; // mark the event as passive
	  }
	  var events;
	  if (modifiers && modifiers.native) {
	    delete modifiers.native;
	    events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
	    events = el.events || (el.events = {});
	  }
	  var newHandler = { value: value, modifiers: modifiers };
	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
	    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
	    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
	    events[name] = newHandler;
	  }
	}
	
	function getBindingAttr (
	  el,
	  name,
	  getStatic
	) {
	  var dynamicValue =
	    getAndRemoveAttr(el, ':' + name) ||
	    getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
	    return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
	    var staticValue = getAndRemoveAttr(el, name);
	    if (staticValue != null) {
	      return JSON.stringify(staticValue)
	    }
	  }
	}
	
	function getAndRemoveAttr (el, name) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
	    var list = el.attrsList;
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].name === name) {
	        list.splice(i, 1);
	        break
	      }
	    }
	  }
	  return val
	}
	
	/*  */
	
	/**
	 * Cross-platform code generation for component v-model
	 */
	function genComponentModel (
	  el,
	  value,
	  modifiers
	) {
	  var ref = modifiers || {};
	  var number = ref.number;
	  var trim = ref.trim;
	
	  var baseValueExpression = '$$v';
	  var valueExpression = baseValueExpression;
	  if (trim) {
	    valueExpression =
	      "(typeof " + baseValueExpression + " === 'string'" +
	        "? " + baseValueExpression + ".trim()" +
	        ": " + baseValueExpression + ")";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	  var assignment = genAssignmentCode(value, valueExpression);
	
	  el.model = {
	    value: ("(" + value + ")"),
	    expression: ("\"" + value + "\""),
	    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
	  };
	}
	
	/**
	 * Cross-platform codegen helper for generating v-model value assignment code.
	 */
	function genAssignmentCode (
	  value,
	  assignment
	) {
	  var modelRs = parseModel(value);
	  if (modelRs.idx === null) {
	    return (value + "=" + assignment)
	  } else {
	    return "var $$exp = " + (modelRs.exp) + ", $$idx = " + (modelRs.idx) + ";" +
	      "if (!Array.isArray($$exp)){" +
	        value + "=" + assignment + "}" +
	      "else{$$exp.splice($$idx, 1, " + assignment + ")}"
	  }
	}
	
	/**
	 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
	 *
	 * for loop possible cases:
	 *
	 * - test
	 * - test[idx]
	 * - test[test1[idx]]
	 * - test["a"][idx]
	 * - xxx.test[a[a].test1[idx]]
	 * - test.xxx.a["asa"][test1[idx]]
	 *
	 */
	
	var len;
	var str;
	var chr;
	var index$1;
	var expressionPos;
	var expressionEndPos;
	
	function parseModel (val) {
	  str = val;
	  len = str.length;
	  index$1 = expressionPos = expressionEndPos = 0;
	
	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
	    return {
	      exp: val,
	      idx: null
	    }
	  }
	
	  while (!eof()) {
	    chr = next();
	    /* istanbul ignore if */
	    if (isStringStart(chr)) {
	      parseString(chr);
	    } else if (chr === 0x5B) {
	      parseBracket(chr);
	    }
	  }
	
	  return {
	    exp: val.substring(0, expressionPos),
	    idx: val.substring(expressionPos + 1, expressionEndPos)
	  }
	}
	
	function next () {
	  return str.charCodeAt(++index$1)
	}
	
	function eof () {
	  return index$1 >= len
	}
	
	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}
	
	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
	    chr = next();
	    if (isStringStart(chr)) {
	      parseString(chr);
	      continue
	    }
	    if (chr === 0x5B) { inBracket++; }
	    if (chr === 0x5D) { inBracket--; }
	    if (inBracket === 0) {
	      expressionEndPos = index$1;
	      break
	    }
	  }
	}
	
	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
	    chr = next();
	    if (chr === stringQuote) {
	      break
	    }
	  }
	}
	
	/*  */
	
	var warn$1;
	
	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';
	
	function model (
	  el,
	  dir,
	  _warn
	) {
	  warn$1 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;
	
	  if (false) {
	    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
	    if (tag === 'input' && dynamicType) {
	      warn$1(
	        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
	        "v-model does not support dynamic input types. Use v-if branches instead."
	      );
	    }
	    // inputs with type="file" are read only and setting the input's
	    // value will throw an error.
	    if (tag === 'input' && type === 'file') {
	      warn$1(
	        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
	        "File inputs are read only. Use a v-on:change listener instead."
	      );
	    }
	  }
	
	  if (tag === 'select') {
	    genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
	    genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
	    genRadioModel(el, value, modifiers);
	  } else if (tag === 'input' || tag === 'textarea') {
	    genDefaultModel(el, value, modifiers);
	  } else if (!config.isReservedTag(tag)) {
	    genComponentModel(el, value, modifiers);
	    // component v-model doesn't need extra runtime
	    return false
	  } else if (false) {
	    warn$1(
	      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	      "v-model is not supported on this element type. " +
	      'If you are working with contenteditable, it\'s recommended to ' +
	      'wrap a library dedicated for that purpose inside a custom component.'
	    );
	  }
	
	  // ensure runtime directive metadata
	  return true
	}
	
	function genCheckboxModel (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
	    "Array.isArray(" + value + ")" +
	      "?_i(" + value + "," + valueBinding + ")>-1" + (
	        trueValueBinding === 'true'
	          ? (":(" + value + ")")
	          : (":_q(" + value + "," + trueValueBinding + ")")
	      )
	  );
	  addHandler(el, CHECKBOX_RADIO_TOKEN,
	    "var $$a=" + value + "," +
	        '$$el=$event.target,' +
	        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
	    'if(Array.isArray($$a)){' +
	      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
	          '$$i=_i($$a,$$v);' +
	      "if($$c){$$i<0&&(" + value + "=$$a.concat($$v))}" +
	      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
	    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
	    null, true
	  );
	}
	
	function genRadioModel (
	    el,
	    value,
	    modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, CHECKBOX_RADIO_TOKEN, genAssignmentCode(value, valueBinding), null, true);
	}
	
	function genSelect (
	    el,
	    value,
	    modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var selectedVal = "Array.prototype.filter" +
	    ".call($event.target.options,function(o){return o.selected})" +
	    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
	    "return " + (number ? '_n(val)' : 'val') + "})";
	
	  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
	  var code = "var $$selectedVal = " + selectedVal + ";";
	  code = code + " " + (genAssignmentCode(value, assignment));
	  addHandler(el, 'change', code, null, true);
	}
	
	function genDefaultModel (
	  el,
	  value,
	  modifiers
	) {
	  var type = el.attrsMap.type;
	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var needCompositionGuard = !lazy && type !== 'range';
	  var event = lazy
	    ? 'change'
	    : type === 'range'
	      ? RANGE_TOKEN
	      : 'input';
	
	  var valueExpression = '$event.target.value';
	  if (trim) {
	    valueExpression = "$event.target.value.trim()";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	
	  var code = genAssignmentCode(value, valueExpression);
	  if (needCompositionGuard) {
	    code = "if($event.target.composing)return;" + code;
	  }
	
	  addProp(el, 'value', ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number || type === 'number') {
	    addHandler(el, 'blur', '$forceUpdate()');
	  }
	}
	
	/*  */
	
	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents (on) {
	  var event;
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
	    // IE input[type=range] only supports `change` event
	    event = isIE ? 'change' : 'input';
	    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	    delete on[RANGE_TOKEN];
	  }
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	    // Chrome fires microtasks in between click/change, leads to #4521
	    event = isChrome ? 'click' : 'change';
	    on[event] = [].concat(on[CHECKBOX_RADIO_TOKEN], on[event] || []);
	    delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}
	
	var target$1;
	
	function add$1 (
	  event,
	  handler,
	  once$$1,
	  capture,
	  passive
	) {
	  if (once$$1) {
	    var oldHandler = handler;
	    var _target = target$1; // save current target element in closure
	    handler = function (ev) {
	      var res = arguments.length === 1
	        ? oldHandler(ev)
	        : oldHandler.apply(null, arguments);
	      if (res !== null) {
	        remove$2(event, handler, capture, _target);
	      }
	    };
	  }
	  target$1.addEventListener(
	    event,
	    handler,
	    supportsPassive
	      ? { capture: capture, passive: passive }
	      : capture
	  );
	}
	
	function remove$2 (
	  event,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(event, handler, capture);
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	};
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (isUndef(props[key])) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	    }
	
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = isUndef(cur) ? '' : String(cur);
	      if (shouldUpdateValue(elm, vnode, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (
	  elm,
	  vnode,
	  checkVal
	) {
	  return (!elm.composing && (
	    vnode.tag === 'option' ||
	    isDirty(elm, checkVal) ||
	    isInputChanged(elm, checkVal)
	  ))
	}
	
	function isDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is not equal to the updated value
	  return document.activeElement !== elm && elm.value !== checkVal
	}
	
	function isInputChanged (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if ((isDef(modifiers) && modifiers.number) || elm.type === 'number') {
	    return toNumber(value) !== toNumber(newVal)
	  }
	  if (isDef(modifiers) && modifiers.trim) {
	    return value.trim() !== newVal.trim()
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	};
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    var normalizedName = normalize(name);
	    if (Array.isArray(val)) {
	      // Support values array created by autoprefixer, e.g.
	      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	      // Set them one by one, and the browser will only set those it can recognize
	      for (var i = 0, len = val.length; i < len; i++) {
	        el.style[normalizedName] = val[i];
	      }
	    } else {
	      el.style[normalizedName] = val;
	    }
	  }
	};
	
	var prefixes = ['Webkit', 'Moz', 'ms'];
	
	var testEl;
	var normalize = cached(function (prop) {
	  testEl = testEl || document.createElement('div');
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in testEl.style)) {
	    return prop
	  }
	  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefixed = prefixes[i] + upper;
	    if (prefixed in testEl.style) {
	      return prefixed
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
	    isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likley wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
	    ? extend({}, style)
	    : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (isUndef(newStyle[name])) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	};
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    el.setAttribute('class', cur.trim());
	  }
	}
	
	/*  */
	
	function resolveTransition (def$$1) {
	  if (!def$$1) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def$$1 === 'object') {
	    var res = {};
	    if (def$$1.css !== false) {
	      extend(res, autoCssTransition(def$$1.name || 'v'));
	    }
	    extend(res, def$$1);
	    return res
	  } else if (typeof def$$1 === 'string') {
	    return autoCssTransition(def$$1)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveClass: (name + "-leave"),
	    leaveToClass: (name + "-leave-to"),
	    leaveActiveClass: (name + "-leave-active")
	  }
	});
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined
	  ) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined
	  ) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser && window.requestAnimationFrame
	  ? window.requestAnimationFrame.bind(window)
	  : setTimeout;
	
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
	  addClass(el, cls);
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (isDef(el._leaveCb)) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear && appearClass
	    ? appearClass
	    : enterClass;
	  var activeClass = isAppear && appearActiveClass
	    ? appearActiveClass
	    : enterActiveClass;
	  var toClass = isAppear && appearToClass
	    ? appearToClass
	    : enterToClass;
	
	  var beforeEnterHook = isAppear
	    ? (beforeAppear || beforeEnter)
	    : beforeEnter;
	  var enterHook = isAppear
	    ? (typeof appear === 'function' ? appear : enter)
	    : enter;
	  var afterEnterHook = isAppear
	    ? (afterAppear || afterEnter)
	    : afterEnter;
	  var enterCancelledHook = isAppear
	    ? (appearCancelled || enterCancelled)
	    : enterCancelled;
	
	  var explicitEnterDuration = toNumber(
	    isObject(duration)
	      ? duration.enter
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitEnterDuration, 'enter', vnode);
	  }
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	        pendingNode.tag === vnode.tag &&
	        pendingNode.elm._leaveCb
	      ) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    });
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      addTransitionClass(el, toClass);
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled && !userWantsControl) {
	        if (isValidDuration(explicitEnterDuration)) {
	          setTimeout(cb, explicitEnterDuration);
	        } else {
	          whenTransitionEnds(el, type, cb);
	        }
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (isDef(el._enterCb)) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._leaveCb) || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);
	
	  var explicitLeaveDuration = toNumber(
	    isObject(duration)
	      ? duration.leave
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitLeaveDuration, 'leave', vnode);
	  }
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        addTransitionClass(el, leaveToClass);
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled && !userWantsControl) {
	          if (isValidDuration(explicitLeaveDuration)) {
	            setTimeout(cb, explicitLeaveDuration);
	          } else {
	            whenTransitionEnds(el, type, cb);
	          }
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	// only used in dev mode
	function checkDuration (val, name, vnode) {
	  if (typeof val !== 'number') {
	    warn(
	      "<transition> explicit " + name + " duration is not a valid number - " +
	      "got " + (JSON.stringify(val)) + ".",
	      vnode.context
	    );
	  } else if (isNaN(val)) {
	    warn(
	      "<transition> explicit " + name + " duration is NaN - " +
	      'the duration expression might be incorrect.',
	      vnode.context
	    );
	  }
	}
	
	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}
	
	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
	    return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
	    // invoker
	    return getHookArgumentsLength(
	      Array.isArray(invokerFns)
	        ? invokerFns[0]
	        : invokerFns
	    )
	  } else {
	    return (fn._length || fn.length) > 1
	  }
	}
	
	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
	    /* istanbul ignore else */
	    if (vnode.data.show !== true) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {};
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	];
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var model$1 = {
	  inserted: function inserted (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      var cb = function () {
	        setSelected(el, binding, vnode.context);
	      };
	      cb();
	      /* istanbul ignore if */
	      if (isIE || isEdge) {
	        setTimeout(cb, 0);
	      }
	    } else if (vnode.tag === 'textarea' || el.type === 'text' || el.type === 'password') {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        // Safari < 10.2 & UIWebView doesn't fire compositionend when
	        // switching focus before confirming composition choice
	        // this also fixes the issue where some browsers e.g. iOS Chrome
	        // fires "change" instead of "input" on autocomplete.
	        el.addEventListener('change', onCompositionEnd);
	        if (!isAndroid) {
	          el.addEventListener('compositionstart', onCompositionStart);
	          el.addEventListener('compositionend', onCompositionEnd);
	        }
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var needReset = el.multiple
	        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
	        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
	      if (needReset) {
	        trigger(el, 'change');
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    ("production") !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  for (var i = 0, l = options.length; i < l; i++) {
	    if (looseEqual(getValue(options[i]), value)) {
	      return false
	    }
	  }
	  return true
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition && !isIE9) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (value === oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition = vnode.data && vnode.data.transition;
	    if (transition && !isIE9) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	};
	
	var platformDirectives = {
	  model: model$1,
	  show: show
	};
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
	    return h('keep-alive', {
	      props: rawChild.componentOptions.propsData
	    })
	  }
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag; });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if (false) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if (false
	    ) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    child.key = child.key == null
	      ? id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;
	
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        });
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave);
	        mergeVNodeHook(data, 'enterCancelled', performLeave);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
	      }
	    }
	
	    return rawChild
	  }
	};
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final desired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else if (false) {
	          var opts = c.componentOptions;
	          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    var body = document.body;
	    var f = body.offsetHeight; // eslint-disable-line
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      if (this._hasMove != null) {
	        return this._hasMove
	      }
	      // Detect whether an element with the move class applied has
	      // CSS transitions. Since the element may be inside an entering
	      // transition at this very moment, we make a clone of it and remove
	      // all other transition classes applied to ensure only the move class
	      // is applied.
	      var clone = el.cloneNode();
	      if (el._transitionClasses) {
	        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
	      }
	      addClass(clone, moveClass);
	      clone.style.display = 'none';
	      this.$el.appendChild(clone);
	      var info = getTransitionInfo(clone);
	      this.$el.removeChild(clone);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	};
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	};
	
	/*  */
	
	// install platform specific utils
	Vue$3.config.mustUseProp = mustUseProp;
	Vue$3.config.isReservedTag = isReservedTag;
	Vue$3.config.isReservedAttr = isReservedAttr;
	Vue$3.config.getTagNamespace = getTagNamespace;
	Vue$3.config.isUnknownElement = isUnknownElement;
	
	// install platform runtime directives & components
	extend(Vue$3.options.directives, platformDirectives);
	extend(Vue$3.options.components, platformComponents);
	
	// install platform patch function
	Vue$3.prototype.__patch__ = inBrowser ? patch : noop;
	
	// public mount method
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};
	
	// devtools global hook
	/* istanbul ignore next */
	setTimeout(function () {
	  if (config.devtools) {
	    if (devtools) {
	      devtools.emit('init', Vue$3);
	    } else if (false) {
	      console[console.info ? 'info' : 'log'](
	        'Download the Vue Devtools extension for a better development experience:\n' +
	        'https://github.com/vuejs/vue-devtools'
	      );
	    }
	  }
	  if (false
	  ) {
	    console[console.info ? 'info' : 'log'](
	      "You are running Vue in development mode.\n" +
	      "Make sure to turn on production mode when deploying for production.\n" +
	      "See more tips at https://vuejs.org/guide/deployment.html"
	    );
	  }
	}, 0);
	
	/*  */
	
	// check whether current browser encodes a char inside attribute values
	function shouldDecode (content, encoded) {
	  var div = document.createElement('div');
	  div.innerHTML = "<div a=\"" + content + "\">";
	  return div.innerHTML.indexOf(encoded) > 0
	}
	
	// #3663
	// IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;
	
	/*  */
	
	var isUnaryTag = makeMap(
	  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
	  'link,meta,param,source,track,wbr'
	);
	
	// Elements that you can, intentionally, leave open
	// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
	  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
	);
	
	// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
	// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
	  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
	  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
	  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
	  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
	  'title,tr,track'
	);
	
	/*  */
	
	var decoder;
	
	function decode (html) {
	  decoder = decoder || document.createElement('div');
	  decoder.innerHTML = html;
	  return decoder.textContent
	}
	
	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */
	
	/*!
	 * HTML Parser By John Resig (ejohn.org)
	 * Modified by Juriy "kangax" Zaytsev
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 */
	
	// Regular Expressions for parsing tags and attributes
	var singleAttrIdentifier = /([^\s"'<>/=]+)/;
	var singleAttrAssign = /(?:=)/;
	var singleAttrValues = [
	  // attr value double quotes
	  /"([^"]*)"+/.source,
	  // attr value, single quotes
	  /'([^']*)'+/.source,
	  // attr value, no quotes
	  /([^\s"'=<>`]+)/.source
	];
	var attribute = new RegExp(
	  '^\\s*' + singleAttrIdentifier.source +
	  '(?:\\s*(' + singleAttrAssign.source + ')' +
	  '\\s*(?:' + singleAttrValues.join('|') + '))?'
	);
	
	// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
	// but for Vue templates we can enforce a simple charset
	var ncname = '[a-zA-Z_][\\w\\-\\.]*';
	var qnameCapture = '((?:' + ncname + '\\:)?' + ncname + ')';
	var startTagOpen = new RegExp('^<' + qnameCapture);
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp('^<\\/' + qnameCapture + '[^>]*>');
	var doctype = /^<!DOCTYPE [^>]+>/i;
	var comment = /^<!--/;
	var conditionalComment = /^<!\[/;
	
	var IS_REGEX_CAPTURING_BROKEN = false;
	'x'.replace(/x(.)?/g, function (m, g) {
	  IS_REGEX_CAPTURING_BROKEN = g === '';
	});
	
	// Special Elements (can contain anything)
	var isPlainTextElement = makeMap('script,style,textarea', true);
	var reCache = {};
	
	var decodingMap = {
	  '&lt;': '<',
	  '&gt;': '>',
	  '&quot;': '"',
	  '&amp;': '&',
	  '&#10;': '\n'
	};
	var encodedAttr = /&(?:lt|gt|quot|amp);/g;
	var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10);/g;
	
	function decodeAttr (value, shouldDecodeNewlines) {
	  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
	  return value.replace(re, function (match) { return decodingMap[match]; })
	}
	
	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
	    last = html;
	    // Make sure we're not in a plaintext content element like script/style
	    if (!lastTag || !isPlainTextElement(lastTag)) {
	      var textEnd = html.indexOf('<');
	      if (textEnd === 0) {
	        // Comment:
	        if (comment.test(html)) {
	          var commentEnd = html.indexOf('-->');
	
	          if (commentEnd >= 0) {
	            advance(commentEnd + 3);
	            continue
	          }
	        }
	
	        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
	        if (conditionalComment.test(html)) {
	          var conditionalEnd = html.indexOf(']>');
	
	          if (conditionalEnd >= 0) {
	            advance(conditionalEnd + 2);
	            continue
	          }
	        }
	
	        // Doctype:
	        var doctypeMatch = html.match(doctype);
	        if (doctypeMatch) {
	          advance(doctypeMatch[0].length);
	          continue
	        }
	
	        // End tag:
	        var endTagMatch = html.match(endTag);
	        if (endTagMatch) {
	          var curIndex = index;
	          advance(endTagMatch[0].length);
	          parseEndTag(endTagMatch[1], curIndex, index);
	          continue
	        }
	
	        // Start tag:
	        var startTagMatch = parseStartTag();
	        if (startTagMatch) {
	          handleStartTag(startTagMatch);
	          continue
	        }
	      }
	
	      var text = (void 0), rest$1 = (void 0), next = (void 0);
	      if (textEnd >= 0) {
	        rest$1 = html.slice(textEnd);
	        while (
	          !endTag.test(rest$1) &&
	          !startTagOpen.test(rest$1) &&
	          !comment.test(rest$1) &&
	          !conditionalComment.test(rest$1)
	        ) {
	          // < in plain text, be forgiving and treat it as text
	          next = rest$1.indexOf('<', 1);
	          if (next < 0) { break }
	          textEnd += next;
	          rest$1 = html.slice(textEnd);
	        }
	        text = html.substring(0, textEnd);
	        advance(textEnd);
	      }
	
	      if (textEnd < 0) {
	        text = html;
	        html = '';
	      }
	
	      if (options.chars && text) {
	        options.chars(text);
	      }
	    } else {
	      var stackedTag = lastTag.toLowerCase();
	      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
	      var endTagLength = 0;
	      var rest = html.replace(reStackedTag, function (all, text, endTag) {
	        endTagLength = endTag.length;
	        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
	          text = text
	            .replace(/<!--([\s\S]*?)-->/g, '$1')
	            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
	        }
	        if (options.chars) {
	          options.chars(text);
	        }
	        return ''
	      });
	      index += html.length - rest.length;
	      html = rest;
	      parseEndTag(stackedTag, index - endTagLength, index);
	    }
	
	    if (html === last) {
	      options.chars && options.chars(html);
	      if (false) {
	        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
	      }
	      break
	    }
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function advance (n) {
	    index += n;
	    html = html.substring(n);
	  }
	
	  function parseStartTag () {
	    var start = html.match(startTagOpen);
	    if (start) {
	      var match = {
	        tagName: start[1],
	        attrs: [],
	        start: index
	      };
	      advance(start[0].length);
	      var end, attr;
	      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
	        advance(attr[0].length);
	        match.attrs.push(attr);
	      }
	      if (end) {
	        match.unarySlash = end[1];
	        advance(end[0].length);
	        match.end = index;
	        return match
	      }
	    }
	  }
	
	  function handleStartTag (match) {
	    var tagName = match.tagName;
	    var unarySlash = match.unarySlash;
	
	    if (expectHTML) {
	      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
	        parseEndTag(lastTag);
	      }
	      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
	        parseEndTag(tagName);
	      }
	    }
	
	    var unary = isUnaryTag$$1(tagName) || tagName === 'html' && lastTag === 'head' || !!unarySlash;
	
	    var l = match.attrs.length;
	    var attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      var args = match.attrs[i];
	      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
	      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
	        if (args[3] === '') { delete args[3]; }
	        if (args[4] === '') { delete args[4]; }
	        if (args[5] === '') { delete args[5]; }
	      }
	      var value = args[3] || args[4] || args[5] || '';
	      attrs[i] = {
	        name: args[1],
	        value: decodeAttr(
	          value,
	          options.shouldDecodeNewlines
	        )
	      };
	    }
	
	    if (!unary) {
	      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
	      lastTag = tagName;
	    }
	
	    if (options.start) {
	      options.start(tagName, attrs, unary, match.start, match.end);
	    }
	  }
	
	  function parseEndTag (tagName, start, end) {
	    var pos, lowerCasedTagName;
	    if (start == null) { start = index; }
	    if (end == null) { end = index; }
	
	    if (tagName) {
	      lowerCasedTagName = tagName.toLowerCase();
	    }
	
	    // Find the closest opened tag of the same type
	    if (tagName) {
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
	          break
	        }
	      }
	    } else {
	      // If no tag name is provided, clean shop
	      pos = 0;
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (var i = stack.length - 1; i >= pos; i--) {
	        if (false
	        ) {
	          options.warn(
	            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
	          );
	        }
	        if (options.end) {
	          options.end(stack[i].tag, start, end);
	        }
	      }
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	      lastTag = pos && stack[pos - 1].tag;
	    } else if (lowerCasedTagName === 'br') {
	      if (options.start) {
	        options.start(tagName, [], true, start, end);
	      }
	    } else if (lowerCasedTagName === 'p') {
	      if (options.start) {
	        options.start(tagName, [], false, start, end);
	      }
	      if (options.end) {
	        options.end(tagName, start, end);
	      }
	    }
	  }
	}
	
	/*  */
	
	var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	
	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});
	
	function parseText (
	  text,
	  delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
	    return
	  }
	  var tokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index;
	  while ((match = tagRE.exec(text))) {
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
	    }
	    // tag token
	    var exp = parseFilters(match[1].trim());
	    tokens.push(("_s(" + exp + ")"));
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    tokens.push(JSON.stringify(text.slice(lastIndex)));
	  }
	  return tokens.join('+')
	}
	
	/*  */
	
	var onRE = /^@|^v-on:/;
	var dirRE = /^v-|^@|^:/;
	var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
	var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;
	
	var argRE = /:(.*)$/;
	var bindRE = /^:|^v-bind:/;
	var modifierRE = /\.[^.]+/g;
	
	var decodeHTMLCached = cached(decode);
	
	// configurable state
	var warn$2;
	var delimiters;
	var transforms;
	var preTransforms;
	var postTransforms;
	var platformIsPreTag;
	var platformMustUseProp;
	var platformGetTagNamespace;
	
	/**
	 * Convert HTML string to AST.
	 */
	function parse (
	  template,
	  options
	) {
	  warn$2 = options.warn || baseWarn;
	  platformGetTagNamespace = options.getTagNamespace || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformIsPreTag = options.isPreTag || no;
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
	  delimiters = options.delimiters;
	
	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;
	
	  function warnOnce (msg) {
	    if (!warned) {
	      warned = true;
	      warn$2(msg);
	    }
	  }
	
	  function endPre (element) {
	    // check pre state
	    if (element.pre) {
	      inVPre = false;
	    }
	    if (platformIsPreTag(element.tag)) {
	      inPre = false;
	    }
	  }
	
	  parseHTML(template, {
	    warn: warn$2,
	    expectHTML: options.expectHTML,
	    isUnaryTag: options.isUnaryTag,
	    canBeLeftOpenTag: options.canBeLeftOpenTag,
	    shouldDecodeNewlines: options.shouldDecodeNewlines,
	    start: function start (tag, attrs, unary) {
	      // check namespace.
	      // inherit parent ns if there is one
	      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
	
	      // handle IE svg bug
	      /* istanbul ignore if */
	      if (isIE && ns === 'svg') {
	        attrs = guardIESVGBug(attrs);
	      }
	
	      var element = {
	        type: 1,
	        tag: tag,
	        attrsList: attrs,
	        attrsMap: makeAttrsMap(attrs),
	        parent: currentParent,
	        children: []
	      };
	      if (ns) {
	        element.ns = ns;
	      }
	
	      if (isForbiddenTag(element) && !isServerRendering()) {
	        element.forbidden = true;
	        ("production") !== 'production' && warn$2(
	          'Templates should only be responsible for mapping the state to the ' +
	          'UI. Avoid placing tags with side-effects in your templates, such as ' +
	          "<" + tag + ">" + ', as they will not be parsed.'
	        );
	      }
	
	      // apply pre-transforms
	      for (var i = 0; i < preTransforms.length; i++) {
	        preTransforms[i](element, options);
	      }
	
	      if (!inVPre) {
	        processPre(element);
	        if (element.pre) {
	          inVPre = true;
	        }
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = true;
	      }
	      if (inVPre) {
	        processRawAttrs(element);
	      } else {
	        processFor(element);
	        processIf(element);
	        processOnce(element);
	        processKey(element);
	
	        // determine whether this is a plain element after
	        // removing structural attributes
	        element.plain = !element.key && !attrs.length;
	
	        processRef(element);
	        processSlot(element);
	        processComponent(element);
	        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
	          transforms[i$1](element, options);
	        }
	        processAttrs(element);
	      }
	
	      function checkRootConstraints (el) {
	        if (false) {
	          if (el.tag === 'slot' || el.tag === 'template') {
	            warnOnce(
	              "Cannot use <" + (el.tag) + "> as component root element because it may " +
	              'contain multiple nodes.'
	            );
	          }
	          if (el.attrsMap.hasOwnProperty('v-for')) {
	            warnOnce(
	              'Cannot use v-for on stateful component root element because ' +
	              'it renders multiple elements.'
	            );
	          }
	        }
	      }
	
	      // tree management
	      if (!root) {
	        root = element;
	        checkRootConstraints(root);
	      } else if (!stack.length) {
	        // allow root elements with v-if, v-else-if and v-else
	        if (root.if && (element.elseif || element.else)) {
	          checkRootConstraints(element);
	          addIfCondition(root, {
	            exp: element.elseif,
	            block: element
	          });
	        } else if (false) {
	          warnOnce(
	            "Component template should contain exactly one root element. " +
	            "If you are using v-if on multiple elements, " +
	            "use v-else-if to chain them instead."
	          );
	        }
	      }
	      if (currentParent && !element.forbidden) {
	        if (element.elseif || element.else) {
	          processIfConditions(element, currentParent);
	        } else if (element.slotScope) { // scoped slot
	          currentParent.plain = false;
	          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
	        } else {
	          currentParent.children.push(element);
	          element.parent = currentParent;
	        }
	      }
	      if (!unary) {
	        currentParent = element;
	        stack.push(element);
	      } else {
	        endPre(element);
	      }
	      // apply post-transforms
	      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
	        postTransforms[i$2](element, options);
	      }
	    },
	
	    end: function end () {
	      // remove trailing whitespace
	      var element = stack[stack.length - 1];
	      var lastNode = element.children[element.children.length - 1];
	      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
	        element.children.pop();
	      }
	      // pop stack
	      stack.length -= 1;
	      currentParent = stack[stack.length - 1];
	      endPre(element);
	    },
	
	    chars: function chars (text) {
	      if (!currentParent) {
	        if (false) {
	          if (text === template) {
	            warnOnce(
	              'Component template requires a root element, rather than just text.'
	            );
	          } else if ((text = text.trim())) {
	            warnOnce(
	              ("text \"" + text + "\" outside root element will be ignored.")
	            );
	          }
	        }
	        return
	      }
	      // IE textarea placeholder bug
	      /* istanbul ignore if */
	      if (isIE &&
	        currentParent.tag === 'textarea' &&
	        currentParent.attrsMap.placeholder === text
	      ) {
	        return
	      }
	      var children = currentParent.children;
	      text = inPre || text.trim()
	        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
	        // only preserve whitespace if its not right after a starting tag
	        : preserveWhitespace && children.length ? ' ' : '';
	      if (text) {
	        var expression;
	        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
	          children.push({
	            type: 2,
	            expression: expression,
	            text: text
	          });
	        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
	          children.push({
	            type: 3,
	            text: text
	          });
	        }
	      }
	    }
	  });
	  return root
	}
	
	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
	    el.pre = true;
	  }
	}
	
	function processRawAttrs (el) {
	  var l = el.attrsList.length;
	  if (l) {
	    var attrs = el.attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      attrs[i] = {
	        name: el.attrsList[i].name,
	        value: JSON.stringify(el.attrsList[i].value)
	      };
	    }
	  } else if (!el.pre) {
	    // non root node in pre blocks with no attributes
	    el.plain = true;
	  }
	}
	
	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
	    if (false) {
	      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
	    }
	    el.key = exp;
	  }
	}
	
	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
	    el.ref = ref;
	    el.refInFor = checkInFor(el);
	  }
	}
	
	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
	    var inMatch = exp.match(forAliasRE);
	    if (!inMatch) {
	      ("production") !== 'production' && warn$2(
	        ("Invalid v-for expression: " + exp)
	      );
	      return
	    }
	    el.for = inMatch[2].trim();
	    var alias = inMatch[1].trim();
	    var iteratorMatch = alias.match(forIteratorRE);
	    if (iteratorMatch) {
	      el.alias = iteratorMatch[1].trim();
	      el.iterator1 = iteratorMatch[2].trim();
	      if (iteratorMatch[3]) {
	        el.iterator2 = iteratorMatch[3].trim();
	      }
	    } else {
	      el.alias = alias;
	    }
	  }
	}
	
	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
	    el.if = exp;
	    addIfCondition(el, {
	      exp: exp,
	      block: el
	    });
	  } else {
	    if (getAndRemoveAttr(el, 'v-else') != null) {
	      el.else = true;
	    }
	    var elseif = getAndRemoveAttr(el, 'v-else-if');
	    if (elseif) {
	      el.elseif = elseif;
	    }
	  }
	}
	
	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
	    addIfCondition(prev, {
	      exp: el.elseif,
	      block: el
	    });
	  } else if (false) {
	    warn$2(
	      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
	      "used on element <" + (el.tag) + "> without corresponding v-if."
	    );
	  }
	}
	
	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
	    if (children[i].type === 1) {
	      return children[i]
	    } else {
	      if (false) {
	        warn$2(
	          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
	          "will be ignored."
	        );
	      }
	      children.pop();
	    }
	  }
	}
	
	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
	    el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}
	
	function processOnce (el) {
	  var once$$1 = getAndRemoveAttr(el, 'v-once');
	  if (once$$1 != null) {
	    el.once = true;
	  }
	}
	
	function processSlot (el) {
	  if (el.tag === 'slot') {
	    el.slotName = getBindingAttr(el, 'name');
	    if (false) {
	      warn$2(
	        "`key` does not work on <slot> because slots are abstract outlets " +
	        "and can possibly expand into multiple elements. " +
	        "Use the key on a wrapping element instead."
	      );
	    }
	  } else {
	    var slotTarget = getBindingAttr(el, 'slot');
	    if (slotTarget) {
	      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
	    }
	    if (el.tag === 'template') {
	      el.slotScope = getAndRemoveAttr(el, 'scope');
	    }
	  }
	}
	
	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
	    el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
	    el.inlineTemplate = true;
	  }
	}
	
	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, modifiers, isProp;
	  for (i = 0, l = list.length; i < l; i++) {
	    name = rawName = list[i].name;
	    value = list[i].value;
	    if (dirRE.test(name)) {
	      // mark element as dynamic
	      el.hasBindings = true;
	      // modifiers
	      modifiers = parseModifiers(name);
	      if (modifiers) {
	        name = name.replace(modifierRE, '');
	      }
	      if (bindRE.test(name)) { // v-bind
	        name = name.replace(bindRE, '');
	        value = parseFilters(value);
	        isProp = false;
	        if (modifiers) {
	          if (modifiers.prop) {
	            isProp = true;
	            name = camelize(name);
	            if (name === 'innerHtml') { name = 'innerHTML'; }
	          }
	          if (modifiers.camel) {
	            name = camelize(name);
	          }
	          if (modifiers.sync) {
	            addHandler(
	              el,
	              ("update:" + (camelize(name))),
	              genAssignmentCode(value, "$event")
	            );
	          }
	        }
	        if (isProp || platformMustUseProp(el.tag, el.attrsMap.type, name)) {
	          addProp(el, name, value);
	        } else {
	          addAttr(el, name, value);
	        }
	      } else if (onRE.test(name)) { // v-on
	        name = name.replace(onRE, '');
	        addHandler(el, name, value, modifiers, false, warn$2);
	      } else { // normal directives
	        name = name.replace(dirRE, '');
	        // parse arg
	        var argMatch = name.match(argRE);
	        var arg = argMatch && argMatch[1];
	        if (arg) {
	          name = name.slice(0, -(arg.length + 1));
	        }
	        addDirective(el, name, rawName, value, arg, modifiers);
	        if (false) {
	          checkForAliasModel(el, value);
	        }
	      }
	    } else {
	      // literal attribute
	      if (false) {
	        var expression = parseText(value, delimiters);
	        if (expression) {
	          warn$2(
	            name + "=\"" + value + "\": " +
	            'Interpolation inside attributes has been removed. ' +
	            'Use v-bind or the colon shorthand instead. For example, ' +
	            'instead of <div id="{{ val }}">, use <div :id="val">.'
	          );
	        }
	      }
	      addAttr(el, name, JSON.stringify(value));
	    }
	  }
	}
	
	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
	    if (parent.for !== undefined) {
	      return true
	    }
	    parent = parent.parent;
	  }
	  return false
	}
	
	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
	    var ret = {};
	    match.forEach(function (m) { ret[m.slice(1)] = true; });
	    return ret
	  }
	}
	
	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
	    if (
	      false
	    ) {
	      warn$2('duplicate attribute: ' + attrs[i].name);
	    }
	    map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}
	
	// for script (e.g. type="x/template") or style, do not decode content
	function isTextTag (el) {
	  return el.tag === 'script' || el.tag === 'style'
	}
	
	function isForbiddenTag (el) {
	  return (
	    el.tag === 'style' ||
	    (el.tag === 'script' && (
	      !el.attrsMap.type ||
	      el.attrsMap.type === 'text/javascript'
	    ))
	  )
	}
	
	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;
	
	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
	    var attr = attrs[i];
	    if (!ieNSBug.test(attr.name)) {
	      attr.name = attr.name.replace(ieNSPrefix, '');
	      res.push(attr);
	    }
	  }
	  return res
	}
	
	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
	    if (_el.for && _el.alias === value) {
	      warn$2(
	        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	        "You are binding v-model directly to a v-for iteration alias. " +
	        "This will not be able to modify the v-for source array because " +
	        "writing to the alias is like modifying a function local variable. " +
	        "Consider using an array of objects and use v-model on an object property instead."
	      );
	    }
	    _el = _el.parent;
	  }
	}
	
	/*  */
	
	var isStaticKey;
	var isPlatformReservedTag;
	
	var genStaticKeysCached = cached(genStaticKeys$1);
	
	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic$1(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}
	
	function genStaticKeys$1 (keys) {
	  return makeMap(
	    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
	    (keys ? ',' + keys : '')
	  )
	}
	
	function markStatic$1 (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
	    // do not make component slot content static. this avoids
	    // 1. components not able to mutate slot nodes
	    // 2. static slot content fails for hot-reloading
	    if (
	      !isPlatformReservedTag(node.tag) &&
	      node.tag !== 'slot' &&
	      node.attrsMap['inline-template'] == null
	    ) {
	      return
	    }
	    for (var i = 0, l = node.children.length; i < l; i++) {
	      var child = node.children[i];
	      markStatic$1(child);
	      if (!child.static) {
	        node.static = false;
	      }
	    }
	  }
	}
	
	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
	    if (node.static || node.once) {
	      node.staticInFor = isInFor;
	    }
	    // For a node to qualify as a static root, it should have children that
	    // are not just static text. Otherwise the cost of hoisting out will
	    // outweigh the benefits and it's better off to just always render it fresh.
	    if (node.static && node.children.length && !(
	      node.children.length === 1 &&
	      node.children[0].type === 3
	    )) {
	      node.staticRoot = true;
	      return
	    } else {
	      node.staticRoot = false;
	    }
	    if (node.children) {
	      for (var i = 0, l = node.children.length; i < l; i++) {
	        markStaticRoots(node.children[i], isInFor || !!node.for);
	      }
	    }
	    if (node.ifConditions) {
	      walkThroughConditionsBlocks(node.ifConditions, isInFor);
	    }
	  }
	}
	
	function walkThroughConditionsBlocks (conditionBlocks, isInFor) {
	  for (var i = 1, len = conditionBlocks.length; i < len; i++) {
	    markStaticRoots(conditionBlocks[i].block, isInFor);
	  }
	}
	
	function isStatic (node) {
	  if (node.type === 2) { // expression
	    return false
	  }
	  if (node.type === 3) { // text
	    return true
	  }
	  return !!(node.pre || (
	    !node.hasBindings && // no dynamic bindings
	    !node.if && !node.for && // not v-if or v-for or v-else
	    !isBuiltInTag(node.tag) && // not a built-in
	    isPlatformReservedTag(node.tag) && // not a component
	    !isDirectChildOfTemplateFor(node) &&
	    Object.keys(node).every(isStaticKey)
	  ))
	}
	
	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
	    node = node.parent;
	    if (node.tag !== 'template') {
	      return false
	    }
	    if (node.for) {
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
	var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;
	
	// keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};
	
	// #4868: modifiers that prevent the execution of the listener
	// need to explicitly return null so that we can determine whether to remove
	// the listener for .once
	var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };
	
	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: genGuard("$event.target !== $event.currentTarget"),
	  ctrl: genGuard("!$event.ctrlKey"),
	  shift: genGuard("!$event.shiftKey"),
	  alt: genGuard("!$event.altKey"),
	  meta: genGuard("!$event.metaKey"),
	  left: genGuard("'button' in $event && $event.button !== 0"),
	  middle: genGuard("'button' in $event && $event.button !== 1"),
	  right: genGuard("'button' in $event && $event.button !== 2")
	};
	
	function genHandlers (
	  events,
	  isNative,
	  warn
	) {
	  var res = isNative ? 'nativeOn:{' : 'on:{';
	  for (var name in events) {
	    var handler = events[name];
	    // #5330: warn click.right, since right clicks do not actually fire click events.
	    if (false
	    ) {
	      warn(
	        "Use \"contextmenu\" instead of \"click.right\" since right clicks " +
	        "do not actually fire \"click\" events."
	      );
	    }
	    res += "\"" + name + "\":" + (genHandler(name, handler)) + ",";
	  }
	  return res.slice(0, -1) + '}'
	}
	
	function genHandler (
	  name,
	  handler
	) {
	  if (!handler) {
	    return 'function(){}'
	  }
	
	  if (Array.isArray(handler)) {
	    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
	  }
	
	  var isMethodPath = simplePathRE.test(handler.value);
	  var isFunctionExpression = fnExpRE.test(handler.value);
	
	  if (!handler.modifiers) {
	    return isMethodPath || isFunctionExpression
	      ? handler.value
	      : ("function($event){" + (handler.value) + "}") // inline statement
	  } else {
	    var code = '';
	    var genModifierCode = '';
	    var keys = [];
	    for (var key in handler.modifiers) {
	      if (modifierCode[key]) {
	        genModifierCode += modifierCode[key];
	        // left/right
	        if (keyCodes[key]) {
	          keys.push(key);
	        }
	      } else {
	        keys.push(key);
	      }
	    }
	    if (keys.length) {
	      code += genKeyFilter(keys);
	    }
	    // Make sure modifiers like prevent and stop get executed after key filtering
	    if (genModifierCode) {
	      code += genModifierCode;
	    }
	    var handlerCode = isMethodPath
	      ? handler.value + '($event)'
	      : isFunctionExpression
	        ? ("(" + (handler.value) + ")($event)")
	        : handler.value;
	    return ("function($event){" + code + handlerCode + "}")
	  }
	}
	
	function genKeyFilter (keys) {
	  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
	}
	
	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
	    return ("$event.keyCode!==" + keyVal)
	  }
	  var alias = keyCodes[key];
	  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
	}
	
	/*  */
	
	function bind$1 (el, dir) {
	  el.wrapData = function (code) {
	    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + (dir.modifiers && dir.modifiers.prop ? ',true' : '') + ")")
	  };
	}
	
	/*  */
	
	var baseDirectives = {
	  bind: bind$1,
	  cloak: noop
	};
	
	/*  */
	
	// configurable state
	var warn$3;
	var transforms$1;
	var dataGenFns;
	var platformDirectives$1;
	var isPlatformReservedTag$1;
	var staticRenderFns;
	var onceCount;
	var currentOptions;
	
	function generate (
	  ast,
	  options
	) {
	  // save previous staticRenderFns so generate calls can be nested
	  var prevStaticRenderFns = staticRenderFns;
	  var currentStaticRenderFns = staticRenderFns = [];
	  var prevOnceCount = onceCount;
	  onceCount = 0;
	  currentOptions = options;
	  warn$3 = options.warn || baseWarn;
	  transforms$1 = pluckModuleFunction(options.modules, 'transformCode');
	  dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  platformDirectives$1 = options.directives || {};
	  isPlatformReservedTag$1 = options.isReservedTag || no;
	  var code = ast ? genElement(ast) : '_c("div")';
	  staticRenderFns = prevStaticRenderFns;
	  onceCount = prevOnceCount;
	  return {
	    render: ("with(this){return " + code + "}"),
	    staticRenderFns: currentStaticRenderFns
	  }
	}
	
	function genElement (el) {
	  if (el.staticRoot && !el.staticProcessed) {
	    return genStatic(el)
	  } else if (el.once && !el.onceProcessed) {
	    return genOnce(el)
	  } else if (el.for && !el.forProcessed) {
	    return genFor(el)
	  } else if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.tag === 'template' && !el.slotTarget) {
	    return genChildren(el) || 'void 0'
	  } else if (el.tag === 'slot') {
	    return genSlot(el)
	  } else {
	    // component or element
	    var code;
	    if (el.component) {
	      code = genComponent(el.component, el);
	    } else {
	      var data = el.plain ? undefined : genData(el);
	
	      var children = el.inlineTemplate ? null : genChildren(el, true);
	      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
	    }
	    // module transforms
	    for (var i = 0; i < transforms$1.length; i++) {
	      code = transforms$1[i](el, code);
	    }
	    return code
	  }
	}
	
	// hoist static sub-trees out
	function genStatic (el) {
	  el.staticProcessed = true;
	  staticRenderFns.push(("with(this){return " + (genElement(el)) + "}"));
	  return ("_m(" + (staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}
	
	// v-once
	function genOnce (el) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
	    return genIf(el)
	  } else if (el.staticInFor) {
	    var key = '';
	    var parent = el.parent;
	    while (parent) {
	      if (parent.for) {
	        key = parent.key;
	        break
	      }
	      parent = parent.parent;
	    }
	    if (!key) {
	      ("production") !== 'production' && warn$3(
	        "v-once can only be used inside v-for that is keyed. "
	      );
	      return genElement(el)
	    }
	    return ("_o(" + (genElement(el)) + "," + (onceCount++) + (key ? ("," + key) : "") + ")")
	  } else {
	    return genStatic(el)
	  }
	}
	
	function genIf (el) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice())
	}
	
	function genIfConditions (conditions) {
	  if (!conditions.length) {
	    return '_e()'
	  }
	
	  var condition = conditions.shift();
	  if (condition.exp) {
	    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions)))
	  } else {
	    return ("" + (genTernaryExp(condition.block)))
	  }
	
	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
	    return el.once ? genOnce(el) : genElement(el)
	  }
	}
	
	function genFor (el) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	
	  if (
	    false
	  ) {
	    warn$3(
	      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
	      "v-for should have explicit keys. " +
	      "See https://vuejs.org/guide/list.html#key for more info.",
	      true /* tip */
	    );
	  }
	
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genElement(el)) +
	    '})'
	}
	
	function genData (el) {
	  var data = '{';
	
	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el);
	  if (dirs) { data += dirs + ','; }
	
	  // key
	  if (el.key) {
	    data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
	    data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
	    data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
	    data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
	    data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < dataGenFns.length; i++) {
	    data += dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
	    data += "attrs:{" + (genProps(el.attrs)) + "},";
	  }
	  // DOM props
	  if (el.props) {
	    data += "domProps:{" + (genProps(el.props)) + "},";
	  }
	  // event handlers
	  if (el.events) {
	    data += (genHandlers(el.events, false, warn$3)) + ",";
	  }
	  if (el.nativeEvents) {
	    data += (genHandlers(el.nativeEvents, true, warn$3)) + ",";
	  }
	  // slot target
	  if (el.slotTarget) {
	    data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
	    data += (genScopedSlots(el.scopedSlots)) + ",";
	  }
	  // component v-model
	  if (el.model) {
	    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
	    var inlineTemplate = genInlineTemplate(el);
	    if (inlineTemplate) {
	      data += inlineTemplate + ",";
	    }
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind data wrap
	  if (el.wrapData) {
	    data = el.wrapData(data);
	  }
	  return data
	}
	
	function genDirectives (el) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    dir = dirs[i];
	    needRuntime = true;
	    var gen = platformDirectives$1[dir.name] || baseDirectives[dir.name];
	    if (gen) {
	      // compile-time directive that manipulates AST.
	      // returns true if it also needs a runtime counterpart.
	      needRuntime = !!gen(el, dir, warn$3);
	    }
	    if (needRuntime) {
	      hasRuntime = true;
	      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
	    }
	  }
	  if (hasRuntime) {
	    return res.slice(0, -1) + ']'
	  }
	}
	
	function genInlineTemplate (el) {
	  var ast = el.children[0];
	  if (false) {
	    warn$3('Inline-template components must have exactly one child element.');
	  }
	  if (ast.type === 1) {
	    var inlineRenderFns = generate(ast, currentOptions);
	    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}
	
	function genScopedSlots (slots) {
	  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) { return genScopedSlot(key, slots[key]); }).join(',')) + "])")
	}
	
	function genScopedSlot (key, el) {
	  if (el.for && !el.forProcessed) {
	    return genForScopedSlot(key, el)
	  }
	  return "{key:" + key + ",fn:function(" + (String(el.attrsMap.scope)) + "){" +
	    "return " + (el.tag === 'template'
	      ? genChildren(el) || 'void 0'
	      : genElement(el)) + "}}"
	}
	
	function genForScopedSlot (key, el) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genScopedSlot(key, el)) +
	    '})'
	}
	
	function genChildren (el, checkSkip) {
	  var children = el.children;
	  if (children.length) {
	    var el$1 = children[0];
	    // optimize single v-for
	    if (children.length === 1 &&
	      el$1.for &&
	      el$1.tag !== 'template' &&
	      el$1.tag !== 'slot'
	    ) {
	      return genElement(el$1)
	    }
	    var normalizationType = checkSkip ? getNormalizationType(children) : 0;
	    return ("[" + (children.map(genNode).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
	  }
	}
	
	// determine the normalization needed for the children array.
	// 0: no normalization needed
	// 1: simple normalization needed (possible 1-level deep nested array)
	// 2: full normalization needed
	function getNormalizationType (children) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
	    var el = children[i];
	    if (el.type !== 1) {
	      continue
	    }
	    if (needsNormalization(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
	      res = 2;
	      break
	    }
	    if (maybeComponent(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
	      res = 1;
	    }
	  }
	  return res
	}
	
	function needsNormalization (el) {
	  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
	}
	
	function maybeComponent (el) {
	  return !isPlatformReservedTag$1(el.tag)
	}
	
	function genNode (node) {
	  if (node.type === 1) {
	    return genElement(node)
	  } else {
	    return genText(node)
	  }
	}
	
	function genText (text) {
	  return ("_v(" + (text.type === 2
	    ? text.expression // no need for () because already wrapped in _s()
	    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}
	
	function genSlot (el) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el);
	  var res = "_t(" + slotName + (children ? ("," + children) : '');
	  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
	    res += ",null";
	  }
	  if (attrs) {
	    res += "," + attrs;
	  }
	  if (bind$$1) {
	    res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}
	
	// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (componentName, el) {
	  var children = el.inlineTemplate ? null : genChildren(el, true);
	  return ("_c(" + componentName + "," + (genData(el)) + (children ? ("," + children) : '') + ")")
	}
	
	function genProps (props) {
	  var res = '';
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
	  }
	  return res.slice(0, -1)
	}
	
	// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
	    .replace(/\u2028/g, '\\u2028')
	    .replace(/\u2029/g, '\\u2029')
	}
	
	/*  */
	
	// these keywords should not appear inside expressions, but operators like
	// typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
	  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	  'super,throw,while,yield,delete,export,import,return,switch,default,' +
	  'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');
	
	// these unary operators should not be used as property/method names
	var unaryOperatorsRE = new RegExp('\\b' + (
	  'delete,typeof,void'
	).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
	
	// check valid identifier for v-for
	var identRE = /[A-Za-z_$][\w$]*/;
	
	// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	
	// detect problematic expressions in a template
	function detectErrors (ast) {
	  var errors = [];
	  if (ast) {
	    checkNode(ast, errors);
	  }
	  return errors
	}
	
	function checkNode (node, errors) {
	  if (node.type === 1) {
	    for (var name in node.attrsMap) {
	      if (dirRE.test(name)) {
	        var value = node.attrsMap[name];
	        if (value) {
	          if (name === 'v-for') {
	            checkFor(node, ("v-for=\"" + value + "\""), errors);
	          } else if (onRE.test(name)) {
	            checkEvent(value, (name + "=\"" + value + "\""), errors);
	          } else {
	            checkExpression(value, (name + "=\"" + value + "\""), errors);
	          }
	        }
	      }
	    }
	    if (node.children) {
	      for (var i = 0; i < node.children.length; i++) {
	        checkNode(node.children[i], errors);
	      }
	    }
	  } else if (node.type === 2) {
	    checkExpression(node.expression, node.text, errors);
	  }
	}
	
	function checkEvent (exp, text, errors) {
	  var stipped = exp.replace(stripStringRE, '');
	  var keywordMatch = stipped.match(unaryOperatorsRE);
	  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
	    errors.push(
	      "avoid using JavaScript unary operator as property name: " +
	      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
	    );
	  }
	  checkExpression(exp, text, errors);
	}
	
	function checkFor (node, text, errors) {
	  checkExpression(node.for || '', text, errors);
	  checkIdentifier(node.alias, 'v-for alias', text, errors);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
	}
	
	function checkIdentifier (ident, type, text, errors) {
	  if (typeof ident === 'string' && !identRE.test(ident)) {
	    errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
	  }
	}
	
	function checkExpression (exp, text, errors) {
	  try {
	    new Function(("return " + exp));
	  } catch (e) {
	    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
	    if (keywordMatch) {
	      errors.push(
	        "avoid using JavaScript keyword as property name: " +
	        "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
	      );
	    } else {
	      errors.push(("invalid expression: " + (text.trim())));
	    }
	  }
	}
	
	/*  */
	
	function baseCompile (
	  template,
	  options
	) {
	  var ast = parse(template.trim(), options);
	  optimize(ast, options);
	  var code = generate(ast, options);
	  return {
	    ast: ast,
	    render: code.render,
	    staticRenderFns: code.staticRenderFns
	  }
	}
	
	function makeFunction (code, errors) {
	  try {
	    return new Function(code)
	  } catch (err) {
	    errors.push({ err: err, code: code });
	    return noop
	  }
	}
	
	function createCompiler (baseOptions) {
	  var functionCompileCache = Object.create(null);
	
	  function compile (
	    template,
	    options
	  ) {
	    var finalOptions = Object.create(baseOptions);
	    var errors = [];
	    var tips = [];
	    finalOptions.warn = function (msg, tip$$1) {
	      (tip$$1 ? tips : errors).push(msg);
	    };
	
	    if (options) {
	      // merge custom modules
	      if (options.modules) {
	        finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
	      }
	      // merge custom directives
	      if (options.directives) {
	        finalOptions.directives = extend(
	          Object.create(baseOptions.directives),
	          options.directives
	        );
	      }
	      // copy other options
	      for (var key in options) {
	        if (key !== 'modules' && key !== 'directives') {
	          finalOptions[key] = options[key];
	        }
	      }
	    }
	
	    var compiled = baseCompile(template, finalOptions);
	    if (false) {
	      errors.push.apply(errors, detectErrors(compiled.ast));
	    }
	    compiled.errors = errors;
	    compiled.tips = tips;
	    return compiled
	  }
	
	  function compileToFunctions (
	    template,
	    options,
	    vm
	  ) {
	    options = options || {};
	
	    /* istanbul ignore if */
	    if (false) {
	      // detect possible CSP restriction
	      try {
	        new Function('return 1');
	      } catch (e) {
	        if (e.toString().match(/unsafe-eval|CSP/)) {
	          warn(
	            'It seems you are using the standalone build of Vue.js in an ' +
	            'environment with Content Security Policy that prohibits unsafe-eval. ' +
	            'The template compiler cannot work in this environment. Consider ' +
	            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
	            'templates into render functions.'
	          );
	        }
	      }
	    }
	
	    // check cache
	    var key = options.delimiters
	      ? String(options.delimiters) + template
	      : template;
	    if (functionCompileCache[key]) {
	      return functionCompileCache[key]
	    }
	
	    // compile
	    var compiled = compile(template, options);
	
	    // check compilation errors/tips
	    if (false) {
	      if (compiled.errors && compiled.errors.length) {
	        warn(
	          "Error compiling template:\n\n" + template + "\n\n" +
	          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
	          vm
	        );
	      }
	      if (compiled.tips && compiled.tips.length) {
	        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
	      }
	    }
	
	    // turn code into functions
	    var res = {};
	    var fnGenErrors = [];
	    res.render = makeFunction(compiled.render, fnGenErrors);
	    var l = compiled.staticRenderFns.length;
	    res.staticRenderFns = new Array(l);
	    for (var i = 0; i < l; i++) {
	      res.staticRenderFns[i] = makeFunction(compiled.staticRenderFns[i], fnGenErrors);
	    }
	
	    // check function generation errors.
	    // this should only happen if there is a bug in the compiler itself.
	    // mostly for codegen development use
	    /* istanbul ignore if */
	    if (false) {
	      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
	        warn(
	          "Failed to generate render function:\n\n" +
	          fnGenErrors.map(function (ref) {
	            var err = ref.err;
	            var code = ref.code;
	
	            return ((err.toString()) + " in\n\n" + code + "\n");
	        }).join('\n'),
	          vm
	        );
	      }
	    }
	
	    return (functionCompileCache[key] = res)
	  }
	
	  return {
	    compile: compile,
	    compileToFunctions: compileToFunctions
	  }
	}
	
	/*  */
	
	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if (false) {
	    var expression = parseText(staticClass, options.delimiters);
	    if (expression) {
	      warn(
	        "class=\"" + staticClass + "\": " +
	        'Interpolation inside attributes has been removed. ' +
	        'Use v-bind or the colon shorthand instead. For example, ' +
	        'instead of <div class="{{ val }}">, use <div :class="val">.'
	      );
	    }
	  }
	  if (staticClass) {
	    el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
	    el.classBinding = classBinding;
	  }
	}
	
	function genData$1 (el) {
	  var data = '';
	  if (el.staticClass) {
	    data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
	    data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}
	
	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData$1
	};
	
	/*  */
	
	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
	    /* istanbul ignore if */
	    if (false) {
	      var expression = parseText(staticStyle, options.delimiters);
	      if (expression) {
	        warn(
	          "style=\"" + staticStyle + "\": " +
	          'Interpolation inside attributes has been removed. ' +
	          'Use v-bind or the colon shorthand instead. For example, ' +
	          'instead of <div style="{{ val }}">, use <div :style="val">.'
	        );
	      }
	    }
	    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }
	
	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
	    el.styleBinding = styleBinding;
	  }
	}
	
	function genData$2 (el) {
	  var data = '';
	  if (el.staticStyle) {
	    data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
	    data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}
	
	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$2
	};
	
	var modules$1 = [
	  klass$1,
	  style$1
	];
	
	/*  */
	
	function text (el, dir) {
	  if (dir.value) {
	    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	/*  */
	
	function html (el, dir) {
	  if (dir.value) {
	    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	var directives$1 = {
	  model: model,
	  text: text,
	  html: html
	};
	
	/*  */
	
	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  directives: directives$1,
	  isPreTag: isPreTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  canBeLeftOpenTag: canBeLeftOpenTag,
	  isReservedTag: isReservedTag,
	  getTagNamespace: getTagNamespace,
	  staticKeys: genStaticKeys(modules$1)
	};
	
	var ref$1 = createCompiler(baseOptions);
	var compileToFunctions = ref$1.compileToFunctions;
	
	/*  */
	
	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});
	
	var mount = Vue$3.prototype.$mount;
	Vue$3.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && query(el);
	
	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
	    ("production") !== 'production' && warn(
	      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
	    );
	    return this
	  }
	
	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
	    var template = options.template;
	    if (template) {
	      if (typeof template === 'string') {
	        if (template.charAt(0) === '#') {
	          template = idToTemplate(template);
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              ("Template element not found or is empty: " + (options.template)),
	              this
	            );
	          }
	        }
	      } else if (template.nodeType) {
	        template = template.innerHTML;
	      } else {
	        if (false) {
	          warn('invalid template option:' + template, this);
	        }
	        return this
	      }
	    } else if (el) {
	      template = getOuterHTML(el);
	    }
	    if (template) {
	      /* istanbul ignore if */
	      if (false) {
	        mark('compile');
	      }
	
	      var ref = compileToFunctions(template, {
	        shouldDecodeNewlines: shouldDecodeNewlines,
	        delimiters: options.delimiters
	      }, this);
	      var render = ref.render;
	      var staticRenderFns = ref.staticRenderFns;
	      options.render = render;
	      options.staticRenderFns = staticRenderFns;
	
	      /* istanbul ignore if */
	      if (false) {
	        mark('compile end');
	        measure(((this._name) + " compile"), 'compile', 'compile end');
	      }
	    }
	  }
	  return mount.call(this, el, hydrating)
	};
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
	    return el.outerHTML
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML
	  }
	}
	
	Vue$3.compile = compileToFunctions;
	
	module.exports = Vue$3;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.482c14416185ffb0ddad.js